/* eslint-disable */
import { ObjectId } from "mongodb";
import { FileUpload } from "graphql-upload";
import { Resolver, SubscriptionResolver, ReturnTypeResolver } from "./resolvers";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Something with dates */
  Date: Date;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  HTML: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** Mongo ObjectId */
  ObjectId: ObjectId;
  /** HH:mm string */
  Time: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: Promise<FileUpload>;
};

export enum AbsenceType {
  ChildCare = "ChildCare",
  None = "None",
  Other = "Other",
  SickDay = "SickDay",
  Vaccation = "Vaccation"
}

export type Accommodation = {
  Address?: Maybe<Address>;
  CancellationPolicy?: Maybe<Scalars["String"]>;
  CheckIn?: Maybe<Scalars["String"]>;
  CheckOut?: Maybe<Scalars["String"]>;
  Email?: Maybe<Array<Scalars["String"]>>;
  ImgUrl?: Maybe<Scalars["String"]>;
  Instruction?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Offers?: Maybe<Array<AccommodationOffer>>;
  Phone?: Maybe<Array<Scalars["String"]>>;
  ResponsiblePersonRef?: Maybe<UserRef>;
  Site?: Maybe<Scalars["String"]>;
  Type?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
  documents?: Maybe<Array<Document>>;
  envCertification?: Maybe<Scalars["Boolean"]>;
  envCertificationName?: Maybe<Scalars["String"]>;
  preferredChoice?: Maybe<Scalars["Boolean"]>;
  unfit?: Maybe<AccommodationUnfit>;
};

export type AccommodationAlt = {
  MaxCost?: Maybe<ConsultantContractMaxCost>;
  PossibleSupplement?: Maybe<Scalars["String"]>;
  Type?: Maybe<ConsultantContractAccommodationAlt>;
};

export type AccommodationAltInput = {
  MaxCost?: InputMaybe<ConsultantContractMaxCostInput>;
  PossibleSupplement?: InputMaybe<Scalars["String"]>;
  Type?: InputMaybe<ConsultantContractAccommodationAlt>;
};

export type AccommodationBase = {
  Address?: Maybe<Address>;
  Email?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ImgUrl?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Offers?: Maybe<Array<Maybe<AccommodationOffer>>>;
  Phone?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResponsiblePersonRef?: Maybe<UserRef>;
  Site?: Maybe<Scalars["String"]>;
  Type?: Maybe<AccommodationType>;
  _id?: Maybe<Scalars["ObjectId"]>;
  envCertification?: Maybe<Scalars["Boolean"]>;
  envCertificationName?: Maybe<Scalars["String"]>;
  preferredChoice?: Maybe<Scalars["Boolean"]>;
};

export type AccommodationConfirmation = {
  _id: Scalars["ObjectId"];
  accommodationRef?: Maybe<AccommodationRef>;
  allWeeks: Array<AccommodationConfirmationWeek>;
  area?: Maybe<Scalars["Float"]>;
  city?: Maybe<Scalars["String"]>;
  confirmedBy?: Maybe<UserRef>;
  confirmedOn?: Maybe<Scalars["Date"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  documents: Array<Document>;
  offerId?: Maybe<Scalars["ObjectId"]>;
  source: Scalars["String"];
  squareFootageAttached?: Maybe<Scalars["Boolean"]>;
  syncedAt?: Maybe<Scalars["Date"]>;
  taxWeeks: Array<AccommodationConfirmationWeek>;
  taxationId?: Maybe<Scalars["String"]>;
  totalCost?: Maybe<Scalars["Float"]>;
  totalExVAT?: Maybe<Scalars["Boolean"]>;
  weeks: Array<Scalars["Date"]>;
};

export type AccommodationConfirmationDocumentsArgs = {
  week?: InputMaybe<WeekYearInput>;
};

export type AccommodationConfirmationLine = {
  accommodationName: Scalars["String"];
  area: Scalars["Float"];
  city: Scalars["String"];
  cost: Scalars["Float"];
  endDate?: Maybe<Scalars["Date"]>;
  extraCost: Scalars["Float"];
  extraDescription?: Maybe<Scalars["String"]>;
  nights: Scalars["Int"];
  paymentMethod: Scalars["String"];
  reservationId?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  stayedNights: Scalars["Int"];
  tax: Scalars["Float"];
};

export enum AccommodationConfirmationSource {
  Erp = "Erp",
  Legacy = "Legacy"
}

export type AccommodationConfirmationWeek = {
  cost: Scalars["Float"];
  endDate?: Maybe<Scalars["Date"]>;
  extraCost: Scalars["Float"];
  extraDescription?: Maybe<Scalars["String"]>;
  isTaxed: Scalars["Boolean"];
  lines: Array<AccommodationConfirmationLine>;
  nights: Scalars["Int"];
  note?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  tax: Scalars["Float"];
  weekYear: WeekYear;
};

export enum AccommodationDocumentType {
  GeneralRoutines = "GeneralRoutines",
  Other = "Other",
  Sqm = "Sqm"
}

export type AccommodationEvent = Event & {
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Scalars["String"]>>;
  Node: NodeRef;
  Sticky: Scalars["Boolean"];
  Type: AccommodationEventType;
  UpdatedBy: WeakUserRef;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum AccommodationEventType {
  Comment = "Comment",
  SystemLog = "SystemLog"
}

export type AccommodationFilter = {
  beds?: InputMaybe<Scalars["String"]>;
  location?: InputMaybe<LocationKlm>;
  options?: InputMaybe<Array<InputMaybe<AccommodationOfferOptions>>>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
  rooms?: InputMaybe<Scalars["String"]>;
  switches?: InputMaybe<Array<InputMaybe<AccommodationSwitches>>>;
  text?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<AccommodationType>;
};

export type AccommodationInput = {
  Address: AddressInput;
  CancellationPolicy?: InputMaybe<Scalars["String"]>;
  CheckIn?: InputMaybe<Scalars["String"]>;
  CheckOut?: InputMaybe<Scalars["String"]>;
  Email?: InputMaybe<Array<Scalars["String"]>>;
  Instruction?: InputMaybe<Scalars["String"]>;
  Name: Scalars["String"];
  Offers?: InputMaybe<Array<InputMaybe<AccommodationOfferInput>>>;
  Phone?: InputMaybe<Array<Scalars["String"]>>;
  ResponsiblePersonRef?: InputMaybe<UserRefInput>;
  Site?: InputMaybe<Scalars["String"]>;
  Type: AccommodationType;
  envCertification?: InputMaybe<Scalars["Boolean"]>;
  envCertificationName?: InputMaybe<Scalars["String"]>;
  preferredChoice?: InputMaybe<Scalars["Boolean"]>;
};

export type AccommodationListItem = AccommodationBase & {
  Address?: Maybe<Address>;
  Email?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ImgUrl?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Offers?: Maybe<Array<Maybe<AccommodationOffer>>>;
  Phone?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResponsiblePersonRef?: Maybe<UserRef>;
  Site?: Maybe<Scalars["String"]>;
  Type?: Maybe<AccommodationType>;
  _id: Scalars["ObjectId"];
  envCertification?: Maybe<Scalars["Boolean"]>;
  envCertificationName?: Maybe<Scalars["String"]>;
  preferredChoice?: Maybe<Scalars["Boolean"]>;
  unfit?: Maybe<AccommodationUnfit>;
};

export type AccommodationOffer = {
  Area?: Maybe<Scalars["Float"]>;
  Beds?: Maybe<Scalars["Float"]>;
  Name?: Maybe<Scalars["String"]>;
  Options?: Maybe<Array<Scalars["String"]>>;
  Price?: Maybe<Scalars["Float"]>;
  PriceType?: Maybe<Scalars["String"]>;
  Rooms?: Maybe<Scalars["Float"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
};

export type AccommodationOfferInput = {
  Area: Scalars["Int"];
  Beds: Scalars["Int"];
  Deleted?: InputMaybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  Options?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  Price: Scalars["Int"];
  PriceType: AccommodationPriceType;
  Rooms: Scalars["Int"];
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export enum AccommodationOfferOptions {
  Breakfast = "Breakfast",
  CleanOut = "CleanOut",
  Gym = "Gym",
  Internet = "Internet",
  NoKitchen = "NoKitchen",
  OwnKitchen = "OwnKitchen",
  Parking = "Parking",
  Pets = "Pets",
  SeparateBathroom = "SeparateBathroom",
  SharedKitchen = "SharedKitchen",
  SheetAndTowelsIncluded = "SheetAndTowelsIncluded"
}

export enum AccommodationPaymentMethod {
  BonlivaPays = "BonlivaPays",
  DeductFromSalary = "DeductFromSalary",
  InvoiceSubcontractor = "InvoiceSubcontractor",
  PayOnArrival = "PayOnArrival"
}

export type AccommodationPeriod = {
  end?: Maybe<Scalars["Date"]>;
  start?: Maybe<Scalars["Date"]>;
};

export type AccommodationPeriodInput = {
  end?: InputMaybe<Scalars["Date"]>;
  start?: InputMaybe<Scalars["Date"]>;
};

export enum AccommodationPriceType {
  PerMonth = "PerMonth",
  PerNight = "PerNight",
  PerWeek = "PerWeek"
}

export type AccommodationRef = {
  Name?: Maybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export type AccommodationRequest = {
  _id: Scalars["ObjectId"];
  acceptedOveragePercent?: Maybe<Scalars["String"]>;
  accommodationLink?: Maybe<Scalars["String"]>;
  accommodationPreferences?: Maybe<Scalars["String"]>;
  accommodationSuggestion?: Maybe<AccommodationTypeOf>;
  accommodationType?: Maybe<Array<Maybe<Scalars["String"]>>>;
  additionalInfo?: Maybe<Scalars["String"]>;
  bookingConfirmationFile?: Maybe<CrmDocument>;
  bookingGroup?: Maybe<Scalars["ObjectId"]>;
  bookingInformation?: Maybe<Scalars["String"]>;
  budget?: Maybe<Scalars["String"]>;
  budgetPeriod?: Maybe<AccommodationPriceType>;
  carAccess?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  commentAboutBooking?: Maybe<Scalars["String"]>;
  consultantId?: Maybe<Scalars["String"]>;
  costCenterId?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  createdById?: Maybe<Scalars["ObjectId"]>;
  createdByName?: Maybe<Scalars["String"]>;
  createdOn?: Maybe<Scalars["Date"]>;
  customerAddress?: Maybe<Scalars["String"]>;
  deadline?: Maybe<Scalars["Date"]>;
  differentCity?: Maybe<Scalars["Boolean"]>;
  endTime?: Maybe<Scalars["Date"]>;
  hasAccommodationSuggestion?: Maybe<Scalars["Boolean"]>;
  hasCarAccess?: Maybe<Scalars["Boolean"]>;
  hasOwnCar?: Maybe<Scalars["Boolean"]>;
  isProlongation?: Maybe<Scalars["Boolean"]>;
  isReschedule?: Maybe<Scalars["Boolean"]>;
  maxAllowedPerNight?: Maybe<Scalars["String"]>;
  paidBy?: Maybe<HospitalityPaidBy>;
  parkingMaxPrice?: Maybe<Scalars["String"]>;
  periodInput?: Maybe<Scalars["String"]>;
  periods?: Maybe<Array<Maybe<AccommodationPeriod>>>;
  projectId?: Maybe<Scalars["String"]>;
  rescheduleComment?: Maybe<Scalars["String"]>;
  sharedBathroom?: Maybe<Scalars["Boolean"]>;
  sharedConveniences?: Maybe<Scalars["String"]>;
  sharedKitchen?: Maybe<Scalars["Boolean"]>;
  shouldBeBookedDirectly?: Maybe<Scalars["String"]>;
  specifyCity?: Maybe<Scalars["String"]>;
  staffAccommodation?: Maybe<Scalars["String"]>;
  startTime?: Maybe<Scalars["Date"]>;
  ticketDifficultyLevel?: Maybe<TicketDifficultyLevel>;
  travelPreferences?: Maybe<Scalars["String"]>;
  walkingDistance?: Maybe<Scalars["String"]>;
  zzNumber?: Maybe<Scalars["String"]>;
};

export type AccommodationRequestInfo = {
  accommodationIsOk: Scalars["Boolean"];
  accommodationRequest: Array<AccommodationRequest>;
  accommodationRequested: Scalars["Boolean"];
  confirmations: Array<AccommodationConfirmation>;
};

export type AccommodationRequestInput = {
  acceptedOveragePercent?: InputMaybe<Scalars["String"]>;
  accommodationLink?: InputMaybe<Scalars["String"]>;
  accommodationPreferences?: InputMaybe<Scalars["String"]>;
  accommodationSuggestion?: InputMaybe<AccommodationTypeOf>;
  accommodationType?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  additionalInfo?: InputMaybe<Scalars["String"]>;
  bookingConfirmationFile?: InputMaybe<Scalars["String"]>;
  bookingInformation?: InputMaybe<Scalars["String"]>;
  budget?: InputMaybe<Scalars["String"]>;
  budgetPeriod?: InputMaybe<AccommodationPriceType>;
  carAccess?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  commentAboutBooking?: InputMaybe<Scalars["String"]>;
  consultantId?: InputMaybe<Scalars["String"]>;
  costCenterId?: InputMaybe<Scalars["String"]>;
  customerAddress?: InputMaybe<Scalars["String"]>;
  deadline?: InputMaybe<Scalars["Date"]>;
  differentCity?: InputMaybe<Scalars["Boolean"]>;
  hasAccommodationSuggestion?: InputMaybe<Scalars["Boolean"]>;
  hasCarAccess?: InputMaybe<Scalars["Boolean"]>;
  hasOwnCar?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["ObjectId"]>;
  isProlongation?: InputMaybe<Scalars["Boolean"]>;
  isReschedule?: InputMaybe<Scalars["Boolean"]>;
  paidBy?: InputMaybe<HospitalityPaidBy>;
  parkingMaxPrice?: InputMaybe<Scalars["String"]>;
  periodInput?: InputMaybe<Scalars["String"]>;
  periodType?: InputMaybe<AccommodationRequestPeriodType>;
  periods?: InputMaybe<Array<InputMaybe<AccommodationPeriodInput>>>;
  projectId?: InputMaybe<Scalars["String"]>;
  rescheduleComment?: InputMaybe<Scalars["String"]>;
  sharedBathroom?: InputMaybe<Scalars["Boolean"]>;
  sharedConveniences?: InputMaybe<Scalars["String"]>;
  sharedKitchen?: InputMaybe<Scalars["Boolean"]>;
  shouldBeBookedDirectly?: InputMaybe<Scalars["String"]>;
  specifyCity?: InputMaybe<Scalars["String"]>;
  staffAccommodation?: InputMaybe<Scalars["String"]>;
  ticketDifficultyLevel: TicketDifficultyLevel;
  travelPreferences?: InputMaybe<Scalars["String"]>;
  walkingDistance?: InputMaybe<Scalars["String"]>;
  zzNumber?: InputMaybe<Scalars["String"]>;
};

export enum AccommodationRequestPeriodType {
  Durations = "Durations",
  Text = "Text"
}

export type AccommodationRequestQueryInput = {
  cityText?: InputMaybe<Scalars["String"]>;
  consultantIds?: InputMaybe<Array<Scalars["String"]>>;
  from?: InputMaybe<Scalars["Date"]>;
  hospitalIds?: InputMaybe<Array<Scalars["String"]>>;
  responsibleUserIds?: InputMaybe<Array<Scalars["String"]>>;
  senderIds?: InputMaybe<Array<Scalars["String"]>>;
  status?: InputMaybe<Array<InputMaybe<AccommodationRequestStatusType>>>;
  text?: InputMaybe<Scalars["String"]>;
  to?: InputMaybe<Scalars["Date"]>;
};

export type AccommodationRequestSearch = {
  _id?: Maybe<Scalars["ObjectId"]>;
  city?: Maybe<Scalars["String"]>;
  consultantName?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<UserRef>;
  createdOn?: Maybe<Scalars["Date"]>;
  firstArrival?: Maybe<Scalars["Date"]>;
  status?: Maybe<AccommodationRequestStatus>;
  weeks?: Maybe<Array<Maybe<BookingLinks>>>;
};

export type AccommodationRequestSearchResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<AccommodationRequestSearch>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type AccommodationRequestSearchTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum AccommodationRequestSortBy {
  CreatedOn = "CreatedOn",
  FirstArrivalDate = "FirstArrivalDate"
}

export type AccommodationRequestStatus = {
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  status?: Maybe<AccommodationRequestStatusType>;
};

export enum AccommodationRequestStatusType {
  Closed = "Closed",
  Open = "Open"
}

export enum AccommodationRequestTableColumns {
  ArrivalDate = "ArrivalDate",
  City = "City",
  Consultant = "Consultant",
  CreatedOn = "CreatedOn",
  Sender = "Sender",
  Status = "Status",
  Week = "Week"
}

export enum AccommodationSwitches {
  EnvCertification = "EnvCertification",
  PreferredChoice = "PreferredChoice"
}

export type AccommodationTravelAudit = {
  approved?: Maybe<Scalars["Boolean"]>;
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
};

export enum AccommodationTravelStatus {
  ApprovedManually = "ApprovedManually",
  Blank = "Blank",
  Confirmed = "Confirmed",
  NotRequired = "NotRequired",
  Requested = "Requested",
  Required = "Required"
}

export enum AccommodationType {
  Apartment = "Apartment",
  BedAndBreakfast = "BedAndBreakfast",
  CorporateApartment = "CorporateApartment",
  Guest = "Guest",
  Hostels = "Hostels",
  Hotel = "Hotel",
  StaffAccommodation = "StaffAccommodation"
}

export enum AccommodationTypeOf {
  Consultant = "Consultant",
  Directly = "Directly",
  HBA = "HBA"
}

export type AccommodationUnfit = {
  comment?: Maybe<Scalars["String"]>;
  userRef?: Maybe<UserRef>;
  value?: Maybe<Scalars["Boolean"]>;
};

export enum ActionType {
  CompleteTodo = "CompleteTodo",
  ConsultantFormSubmit = "ConsultantFormSubmit",
  ConsultantProfileAccess = "ConsultantProfileAccess",
  CreateTodo = "CreateTodo",
  DownloadConsultantPresentation = "DownloadConsultantPresentation",
  SubmitConsultantReference = "SubmitConsultantReference",
  UpdateConsultantAvailability = "UpdateConsultantAvailability",
  UserChatAction = "UserChatAction",
  UserClearedQualityItemStatus = "UserClearedQualityItemStatus",
  UserCommentAction = "UserCommentAction",
  UserCreatedBookingGroupAction = "UserCreatedBookingGroupAction",
  UserCreatedContactPerson = "UserCreatedContactPerson",
  UserEmailAction = "UserEmailAction",
  UserMassEmailAction = "UserMassEmailAction",
  UserMetInPersonAction = "UserMetInPersonAction",
  UserSMSAction = "UserSMSAction",
  UserSetQualityItemStatusApproved = "UserSetQualityItemStatusApproved",
  UserUpdatedCustomer = "UserUpdatedCustomer"
}

export type ActivitiesRecord = {
  count: Scalars["Int"];
  date: Scalars["Date"];
};

export type AddBookingInput = {
  AreaOfExpertise: Scalars["String"];
  ConsultantId: Scalars["ObjectId"];
  ContractType?: InputMaybe<ContractType>;
  CostCenter?: InputMaybe<Scalars["String"]>;
  Invoices?: InputMaybe<Array<InputMaybe<BookingInvoiceInput>>>;
  ProjectId: Scalars["ObjectId"];
  Weeks: Array<Scalars["Date"]>;
};

export type AddEventInput = {
  Description?: InputMaybe<Scalars["String"]>;
  Sticky?: InputMaybe<Scalars["Boolean"]>;
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export type AddNoanswerEventResult = {
  event?: Maybe<ConsultantEvent>;
  todo?: Maybe<TodoItem>;
};

export type Address = {
  City: Scalars["String"];
  Country: Scalars["String"];
  Region: Scalars["String"];
  StreetName: Scalars["String"];
  ZipCode: Scalars["String"];
  formattedShort: Scalars["String"];
};

export type AddressInput = {
  City?: InputMaybe<Scalars["String"]>;
  Country?: InputMaybe<Scalars["String"]>;
  Region?: InputMaybe<Scalars["String"]>;
  StreetName?: InputMaybe<Scalars["String"]>;
  ZipCode?: InputMaybe<Scalars["String"]>;
};

export type AllConsultantTagsResult = {
  tags: Array<Scalars["String"]>;
};

export type AnsweredQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type AnyNode = Consultant | Customer | TodoItem;

export type ApiToken = {
  createdOn: Scalars["Date"];
  id: Scalars["ID"];
  lastUsedOn?: Maybe<Scalars["Date"]>;
  name: Scalars["String"];
  revoked: Scalars["Boolean"];
};

export enum ApprovedAuthorizationOption {
  All = "All",
  No = "No",
  Yes = "Yes"
}

export type ApprovedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  ExpiresInMonths: Scalars["Int"];
  ExpiresOn?: Maybe<Scalars["Date"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
  pausedState?: Maybe<PausedState>;
};

export type ApprovedWithCommentQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  ExpiresInMonths: Scalars["Int"];
  ExpiresOn?: Maybe<Scalars["Date"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
};

export type AssignContactPersonToCustomerResult = {
  ContactPerson: ContactPerson;
  Customer: Customer;
};

export type AttachDocumentInput = {
  documentId: Scalars["ObjectId"];
  type: BookingDocumentType;
  weeks: Array<Scalars["Date"]>;
};

export type Audit = {
  Created?: Maybe<AuditContent>;
  Deleted?: Maybe<AuditContent>;
  Updated?: Maybe<AuditContent>;
};

export type AuditContent = {
  Date: Scalars["Date"];
  User: UserRef;
};

export type AuditContentInput = {
  Date?: InputMaybe<Scalars["Date"]>;
  User?: InputMaybe<UserRefInput>;
};

export type AuditInput = {
  Created: AuditContentInput;
  Updated?: InputMaybe<AuditContentInput>;
};

export type AuditItem = {
  date: Scalars["Date"];
  type: AuditItemType;
  userRef: UserRef;
};

export enum AuditItemType {
  Created = "created",
  Deleted = "deleted",
  Restored = "restored",
  Updated = "updated"
}

export type AwaitingApprovalQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type BaseContract = {
  _id: Scalars["ObjectId"];
  name?: Maybe<Scalars["String"]>;
  variant: BookingContractVariantType;
};

export type BaseFormAddress = {
  city: Scalars["String"];
  country: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type BaseUser = {
  AzureGroups?: Maybe<Array<Scalars["String"]>>;
  AzureId?: Maybe<Scalars["String"]>;
  BirthDate?: Maybe<Scalars["Date"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  Deleted: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  Enabled: Scalars["Boolean"];
  ManagerId?: Maybe<Scalars["ObjectId"]>;
  Name?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  Teams: Array<Scalars["String"]>;
  Title?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
};

export type BasicPrice = {
  dates?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["String"]>;
};

export type BisnodePerson = {
  AddressCity?: Maybe<Scalars["String"]>;
  AddressCountry?: Maybe<Scalars["String"]>;
  AddressStreetName?: Maybe<Scalars["String"]>;
  AddressZipCode?: Maybe<Scalars["String"]>;
  BirthDate?: Maybe<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  Fax?: Maybe<Scalars["String"]>;
  FirstName?: Maybe<Scalars["String"]>;
  LastName?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
};

export type BonlivaCareInvoiceInput = {
  invoiceNumber: Scalars["String"];
  invoiceTotal: Scalars["Float"];
};

export type BookedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type Booking = {
  AccommodationRequired: Scalars["Boolean"];
  AdditionalWork: Scalars["Boolean"];
  AdditionalWorkNote: Scalars["String"];
  AdministrativeFee: Scalars["Float"];
  AreaOfExpertise: Scalars["String"];
  BookingAudit?: Maybe<BookingAudit>;
  BookingGroup: BookingGroup;
  Consultant?: Maybe<Consultant>;
  ConsultantSnapshot: BookingConsultantSnapshot;
  ContractType?: Maybe<ContractType>;
  CostCenter?: Maybe<CostCenter>;
  CustomerFine: Scalars["Float"];
  CustomerNumber: Scalars["String"];
  GroupInvoiceTotal?: Maybe<Scalars["Float"]>;
  GroupInvoicing: Scalars["Boolean"];
  InvoiceTotal: Scalars["Float"];
  Invoices: Array<Maybe<BookingCustomerInvoice>>;
  IsCanceled: Scalars["Boolean"];
  IsConsultantPayed: Scalars["Boolean"];
  IsCustomerBilled: Scalars["Boolean"];
  Note: Scalars["String"];
  PatientId: Scalars["String"];
  Project?: Maybe<Project>;
  SubcontractorDocuments: Array<Document>;
  TravelRequired: Scalars["Boolean"];
  Week: Scalars["Date"];
  _id: Scalars["ObjectId"];
  additionalPayoutAmount?: Maybe<Scalars["Float"]>;
  additionalPayoutDescription?: Maybe<Scalars["String"]>;
  attachments?: Maybe<Array<Document>>;
  bookingAssignedTo?: Maybe<Array<BookingAssignedTo>>;
  bookingIntro?: Maybe<BookingIntro>;
  bookingKits: Array<BookingKit>;
  bookingStatus: BookingStatus;
  bookingSupportTagComment?: Maybe<Scalars["String"]>;
  bookingSupportTagStatus?: Maybe<Array<BookingSupportTagStatus>>;
  callNumber: Scalars["String"];
  costs?: Maybe<BookingCosts>;
  createdBy?: Maybe<User>;
  createdOn?: Maybe<Scalars["Date"]>;
  customersWithNoApproval?: Maybe<BookingNoApprovalForTimeReport>;
  deletedBy?: Maybe<User>;
  deletedOn?: Maybe<Scalars["Date"]>;
  draftCosts?: Maybe<BookingCosts>;
  duplicateIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  erpExportUnitRef?: Maybe<Scalars["String"]>;
  externalRef?: Maybe<Scalars["String"]>;
  hasKits?: Maybe<Scalars["Boolean"]>;
  isCancellable: Scalars["Boolean"];
  isFirstWeek?: Maybe<Scalars["Boolean"]>;
  isOpen: Scalars["Boolean"];
  isSickPayed: Scalars["Boolean"];
  monthBreakSide?: Maybe<BookingMonthBreakSide>;
  profit?: Maybe<BookingProfit>;
  rejectedBookingKits: Array<BookingKit>;
  requireTravelInvoicing?: Maybe<Scalars["Boolean"]>;
  skipTimereportReminder: Scalars["Boolean"];
  specializations: Array<Scalars["String"]>;
  timeReportHasSickTime?: Maybe<Scalars["Boolean"]>;
  timeReportStatus?: Maybe<TimeReportStatus>;
  timeReportTypeSentToHBA?: Maybe<TimeReportTemplateType>;
  unlockForms: Scalars["Boolean"];
  updatedBy?: Maybe<User>;
  updatedOn?: Maybe<Scalars["Date"]>;
};

export type BookingAssignedTo = {
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  setTo?: Maybe<UserRef>;
};

export type BookingAssignedToResult = {
  bookingAssignedTo?: Maybe<Array<BookingAssignedTo>>;
  bookingId?: Maybe<Scalars["ObjectId"]>;
};

export type BookingAudit = {
  Approved?: Maybe<Scalars["Boolean"]>;
  Comment?: Maybe<Scalars["String"]>;
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export enum BookingCSVReportType {
  Bookings = "Bookings",
  ClosedBookingWeeks = "ClosedBookingWeeks",
  Continuity = "Continuity",
  HalfOpenRecords = "HalfOpenRecords",
  NationalProcurementStatistics = "NationalProcurementStatistics",
  OpenHalfOpenRecords = "OpenHalfOpenRecords",
  OpenPosts = "OpenPosts",
  ProfitabilityPerConsultant = "ProfitabilityPerConsultant",
  ProjectReconciliation = "ProjectReconciliation",
  SAHLRStatus = "SAHLRStatus"
}

export enum BookingCannotBeRemovedReason {
  AccommodationBenefitTax = "AccommodationBenefitTax",
  ConsultantPaid = "ConsultantPaid",
  CustomerBilled = "CustomerBilled",
  HasInvoiceNumber = "HasInvoiceNumber",
  TimereportNotBlank = "TimereportNotBlank"
}

export type BookingChecks = {
  accommodationSum?: Maybe<Scalars["String"]>;
  attachTimeReport?: Maybe<Scalars["String"]>;
  consultantContractId?: Maybe<Scalars["String"]>;
  contractNumber?: Maybe<Scalars["String"]>;
  costCenter?: Maybe<Scalars["String"]>;
  customerContractId?: Maybe<Scalars["String"]>;
  customerNumber?: Maybe<Scalars["String"]>;
  expenses?: Maybe<Scalars["String"]>;
  groupInvoicing?: Maybe<Scalars["String"]>;
  hours?: Maybe<Scalars["String"]>;
  mileage?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  project?: Maybe<Scalars["String"]>;
  requiredForm?: Maybe<Scalars["String"]>;
  totalInvoice?: Maybe<Scalars["String"]>;
  travelSum?: Maybe<Scalars["String"]>;
};

export type BookingConsultantSnapshot = {
  BusinessName?: Maybe<Scalars["String"]>;
  BusinessSocialSecurityNo?: Maybe<Scalars["String"]>;
  LegalPersonType?: Maybe<LegalPersonType>;
};

export type BookingContractInfo = {
  _id: Scalars["ObjectId"];
  name?: Maybe<Scalars["String"]>;
  variant: BookingContractVariantType;
};

export enum BookingContractVariantType {
  Consultant = "Consultant",
  ConsultantBookingConfirmation = "ConsultantBookingConfirmation",
  Customer = "Customer",
  CustomerSubversion = "CustomerSubversion"
}

export type BookingCosts = {
  accommodation: Scalars["Float"];
  employeeSalary: Scalars["Float"];
  invoiceTotal: Scalars["Float"];
  sickPayTotal: Scalars["Float"];
  travel: Scalars["Float"];
};

export type BookingCustomerInvoice = {
  invoice?: Maybe<Invoice>;
  invoiceNumber: Scalars["String"];
};

export type BookingDocument = {
  _id: Scalars["ObjectId"];
  name?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export enum BookingDocumentType {
  AccommodationConfirmation = "AccommodationConfirmation",
  Subcontractor = "Subcontractor",
  TravelConfirmation = "TravelConfirmation"
}

export type BookingEvent = {
  Audit: Audit;
  BookingId: Scalars["ObjectId"];
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResultOfAction?: Maybe<Scalars["String"]>;
  Sticky: Scalars["Boolean"];
  Type: BookingEventType;
  UpdatedBy: WeakUserRef;
  UserRef?: Maybe<UserRef>;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum BookingEventType {
  Comment = "Comment",
  SystemLog = "SystemLog"
}

export type BookingGroup = {
  _id: Scalars["ObjectId"];
  accommodationRequestedWeeks: Array<Scalars["Date"]>;
  authorizedOrderer?: Maybe<Scalars["String"]>;
  billingInstructions?: Maybe<Scalars["String"]>;
  bookings: Array<Booking>;
  consultant?: Maybe<Consultant>;
  consultantContractId?: Maybe<Scalars["ObjectId"]>;
  customerContract?: Maybe<CustomerContractListItem>;
  customerContractId?: Maybe<Scalars["ObjectId"]>;
  department?: Maybe<Customer>;
  externalId?: Maybe<Scalars["String"]>;
  hasClosedBooking: Scalars["Boolean"];
  hasOpenBookings: Scalars["Boolean"];
  hospital: Customer;
  isDiscount?: Maybe<Scalars["Boolean"]>;
  isNationalProcurement?: Maybe<Scalars["Boolean"]>;
  nationalProcurementTravelRequired?: Maybe<Scalars["Boolean"]>;
  subVersionId?: Maybe<Scalars["ObjectId"]>;
  travelTemplateLevel?: Maybe<Scalars["String"]>;
};

export type BookingGroupBookingsArgs = {
  includeCanceled?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
};

export type BookingGroupCancellableResult = {
  isCancellable: Scalars["Boolean"];
  nonCancellableReason?: Maybe<Scalars["String"]>;
};

export type BookingGroupInput = {
  AccommodationRequired?: InputMaybe<Scalars["Boolean"]>;
  AreaOfExpertise: Scalars["String"];
  BusinessName?: InputMaybe<Scalars["String"]>;
  BusinessSocialSecurityNo?: InputMaybe<Scalars["String"]>;
  ConsultantId: Scalars["ObjectId"];
  ContractType?: InputMaybe<ContractType>;
  CostCenter?: InputMaybe<Scalars["String"]>;
  DepartmentsRefs: Array<CustomerRefInput>;
  HospitalRef: CustomerRefInput;
  LegalPersonType?: InputMaybe<LegalPersonType>;
  ProjectId: Scalars["ObjectId"];
  Specializations: Array<Scalars["String"]>;
  TravelRequired?: InputMaybe<Scalars["Boolean"]>;
  UpdateConsultantWithSnapshotData?: InputMaybe<Scalars["Boolean"]>;
  Weeks: Array<Scalars["Date"]>;
  WorkRequestId?: InputMaybe<Scalars["ObjectId"]>;
  authorizedOrderer?: InputMaybe<Scalars["String"]>;
  bookingIntro?: InputMaybe<BookingIntroInput>;
  callNumber?: InputMaybe<Scalars["String"]>;
  consultantContractId?: InputMaybe<Scalars["ObjectId"]>;
  customerContractId?: InputMaybe<Scalars["ObjectId"]>;
  isDiscount?: InputMaybe<Scalars["Boolean"]>;
  isNationalProcurement: Scalars["Boolean"];
  nationalProcurementTravelRequired?: InputMaybe<Scalars["Boolean"]>;
  subVersionId?: InputMaybe<Scalars["ObjectId"]>;
  travelInvoicingWeeks?: InputMaybe<Array<Scalars["Date"]>>;
  travelZone?: InputMaybe<Scalars["String"]>;
};

export type BookingHospitality = {
  _id: Scalars["ObjectId"];
  accommodation: AccommodationRequestInfo;
  travel: TravelRequestInfo;
};

export type BookingIntro = {
  description?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["Date"]>;
  required?: Maybe<Scalars["Boolean"]>;
  startDate?: Maybe<Scalars["Date"]>;
};

export type BookingIntroInput = {
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["DateTime"]>;
  required?: InputMaybe<Scalars["Boolean"]>;
  startDate?: InputMaybe<Scalars["DateTime"]>;
};

export type BookingInvoiceInput = {
  invoiceNumber?: InputMaybe<Scalars["String"]>;
  invoicePartial?: InputMaybe<Scalars["Float"]>;
};

export type BookingInvoicePaymentStatusesResult = {
  invoicePaymentStatuses: Scalars["JSON"];
};

export enum BookingInvoiceType {
  Completion = "Completion",
  Introduction = "Introduction",
  OrderCreated = "OrderCreated",
  Other = "Other",
  SickPay = "SickPay"
}

export type BookingKit = {
  _id?: Maybe<Scalars["ObjectId"]>;
  assigned?: Maybe<KitAssignedTo>;
  booking: Booking;
  bookingId: Scalars["ObjectId"];
  bookingSupportCheckWasValid?: Maybe<Scalars["Boolean"]>;
  bookingSupportTagComment: Scalars["String"];
  bookingSupportTagStatus?: Maybe<Array<BookingSupportTagStatus>>;
  comments?: Maybe<Array<Scalars["String"]>>;
  consultant?: Maybe<Consultant>;
  consultantPayoutType?: Maybe<Scalars["String"]>;
  costCenter?: Maybe<CostCenter>;
  createdOn: Scalars["Date"];
  currentFinanceInvoiceStatus?: Maybe<BookingKitStatus>;
  currentFinancePaymentStatus?: Maybe<BookingKitStatus>;
  currentHBAStatus?: Maybe<BookingKitStatus>;
  currentOCStatus?: Maybe<BookingKitStatus>;
  customerBillingInstructions?: Maybe<Scalars["String"]>;
  customerContractType?: Maybe<Scalars["String"]>;
  deleted: Scalars["Boolean"];
  deletedByName?: Maybe<Scalars["String"]>;
  deletedOn?: Maybe<Scalars["Date"]>;
  department?: Maybe<Customer>;
  documents: Array<CrmDocument>;
  hospital?: Maybe<Customer>;
  isDone: Scalars["Boolean"];
  isGroupInvoicing?: Maybe<Scalars["Boolean"]>;
  isRejected: Scalars["Boolean"];
  manager?: Maybe<User>;
  name?: Maybe<Scalars["String"]>;
  profitNet: Scalars["Float"];
  profitRatio: Scalars["Float"];
  project?: Maybe<Project>;
  receipts?: Maybe<Array<BookingKitExpensesReceipt>>;
  responsible?: Maybe<User>;
  status?: Maybe<BookingKitStatusType>;
  statuses?: Maybe<Array<BookingKitStatus>>;
  timeReportType?: Maybe<TimeReportTemplateType>;
  type?: Maybe<BookingKitType>;
  week: Scalars["Date"];
  withConsultantInvoice?: Maybe<Scalars["Boolean"]>;
  withCustomerInvoice?: Maybe<Scalars["Boolean"]>;
  withSickPay?: Maybe<Scalars["Boolean"]>;
  withSubcontractorPay?: Maybe<Scalars["Boolean"]>;
  withTimeReport?: Maybe<Scalars["Boolean"]>;
};

export type BookingKitApprovalConfig = {
  canApprove: Scalars["Boolean"];
  canReject: Scalars["Boolean"];
  canRejectDone: Scalars["Boolean"];
};

export enum BookingKitAutomationType {
  Full = "Full",
  Semi = "Semi"
}

export type BookingKitDraft = {
  costCenterId?: Maybe<Scalars["String"]>;
  documents: Array<CrmDocument>;
  timereportTemplateType?: Maybe<TimeReportTemplateType>;
};

export type BookingKitEvent = {
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResultOfAction?: Maybe<Scalars["String"]>;
  Sticky: Scalars["Boolean"];
  Type: BookingKitEventType;
  UpdatedBy: WeakUserRef;
  UserRef?: Maybe<UserRef>;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
  kitId: Scalars["ObjectId"];
};

export enum BookingKitEventType {
  Comment = "Comment",
  SystemLog = "SystemLog"
}

export type BookingKitExpensesReceipt = {
  name: Scalars["String"];
  uri: Scalars["String"];
};

export type BookingKitExpensesReceiptInput = {
  name: Scalars["String"];
  uri: Scalars["String"];
};

export type BookingKitQueryInput = {
  areasOfExpertises?: InputMaybe<Array<Scalars["String"]>>;
  assignedUserIds?: InputMaybe<Array<Scalars["String"]>>;
  bookingKitStatuses?: InputMaybe<Array<BookingKitStatusType>>;
  bookingSupportTag?: InputMaybe<Array<Scalars["String"]>>;
  consultantIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  consultantPayoutType?: InputMaybe<ConsultantContractPayoutType>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  fromBookingDate?: InputMaybe<Scalars["Date"]>;
  isGroupInvoicing?: InputMaybe<Scalars["Boolean"]>;
  isNationalProcurement?: InputMaybe<Scalars["Boolean"]>;
  legalPersonType?: InputMaybe<LegalPersonType>;
  managerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  projectIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  projectResponsiblePersonIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  responsibleUserIds?: InputMaybe<Array<Scalars["String"]>>;
  text?: InputMaybe<Scalars["String"]>;
  toBookingDate?: InputMaybe<Scalars["Date"]>;
  types?: InputMaybe<Array<BookingKitType>>;
};

export type BookingKitSearch = {
  _id?: Maybe<Scalars["ObjectId"]>;
  areaOfExpertise: Scalars["String"];
  assignedByUserId?: Maybe<Scalars["String"]>;
  assignedByUserName?: Maybe<Scalars["String"]>;
  assignedOn?: Maybe<Scalars["Date"]>;
  assignedToUserId?: Maybe<Scalars["String"]>;
  assignedToUserName?: Maybe<Scalars["String"]>;
  bookingId: Scalars["ObjectId"];
  bookingSupportTagComment: Scalars["String"];
  bookingSupportTagStatus?: Maybe<Array<BookingSupportTagStatus>>;
  consultantId: Scalars["ObjectId"];
  consultantName: Scalars["String"];
  consultantPayoutType?: Maybe<Scalars["String"]>;
  costCenterId?: Maybe<Scalars["String"]>;
  costCenterName?: Maybe<Scalars["String"]>;
  createdOn: Scalars["Date"];
  customerBillingInstructions?: Maybe<Scalars["String"]>;
  customerContractType?: Maybe<Scalars["String"]>;
  departmentId?: Maybe<Scalars["ObjectId"]>;
  departmentName?: Maybe<Scalars["String"]>;
  hospitalId: Scalars["ObjectId"];
  hospitalName: Scalars["String"];
  isHighPriority?: Maybe<Scalars["Boolean"]>;
  isNationalProcurement?: Maybe<Scalars["Boolean"]>;
  lastStatusSetByUserId?: Maybe<Scalars["String"]>;
  lastStatusSetByUserName?: Maybe<Scalars["String"]>;
  lastStatusSetOn?: Maybe<Scalars["Date"]>;
  lastStatusType?: Maybe<BookingKitStatusType>;
  name?: Maybe<Scalars["String"]>;
  projectId?: Maybe<Scalars["String"]>;
  projectName?: Maybe<Scalars["String"]>;
  regionId: Scalars["ObjectId"];
  regionName: Scalars["String"];
  timereportApprovedOn?: Maybe<Scalars["Date"]>;
  type: BookingKitType;
  week: Scalars["Date"];
};

export type BookingKitSearchResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<BookingKitSearch>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type BookingKitSearchTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum BookingKitSortBy {
  BookingDate = "BookingDate",
  CreatedOn = "CreatedOn",
  TimereportApprovedOn = "TimereportApprovedOn",
  TimereportCreatedOn = "TimereportCreatedOn"
}

export type BookingKitStatus = {
  comment?: Maybe<Scalars["String"]>;
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  status?: Maybe<BookingKitStatusType>;
};

export enum BookingKitStatusType {
  ApprovedByFinance = "ApprovedByFinance",
  ApprovedByFinanceInvoicing = "ApprovedByFinanceInvoicing",
  ApprovedByFinancePayment = "ApprovedByFinancePayment",
  ApprovedByHBA = "ApprovedByHBA",
  ApprovedByOC = "ApprovedByOC",
  Created = "Created",
  Deleted = "Deleted",
  Done = "Done",
  RejectedByFinance = "RejectedByFinance",
  RejectedByFinanceInvoicing = "RejectedByFinanceInvoicing",
  RejectedByFinancePayment = "RejectedByFinancePayment",
  RejectedByHBA = "RejectedByHBA",
  RejectedByOC = "RejectedByOC",
  SentToFinance = "SentToFinance",
  SentToFinanceInvoicing = "SentToFinanceInvoicing",
  SentToFinancePayment = "SentToFinancePayment",
  SentToHBA = "SentToHBA",
  SentToOC = "SentToOC"
}

export enum BookingKitTableColumns {
  Alt = "Alt",
  Aoe = "Aoe",
  Assigned = "Assigned",
  Consultant = "Consultant",
  ConsultantPayoutType = "ConsultantPayoutType",
  CostCenter = "CostCenter",
  Customer = "Customer",
  IsNationalProcurement = "IsNationalProcurement",
  KitStatus = "KitStatus",
  LastEvent = "LastEvent",
  ManagementStatus = "ManagementStatus",
  Project = "Project",
  TimereportApprovedOn = "TimereportApprovedOn",
  Type = "Type",
  Week = "Week"
}

export enum BookingKitType {
  AccruedCost = "AccruedCost",
  AccruedIncome = "AccruedIncome",
  Compensation = "Compensation",
  Complete = "Complete",
  Credit = "Credit",
  PreviouslyAccruedCost = "PreviouslyAccruedCost",
  PreviouslyAccruedIncome = "PreviouslyAccruedIncome",
  SickPay = "SickPay"
}

export type BookingKitTypeFormConfig = {
  isAvailableForCreation: Scalars["Boolean"];
  requirements: BookingKitTypeFormRequirements;
  type: BookingKitType;
};

export type BookingKitTypeFormRequirements = {
  hbaApproval: Scalars["Boolean"];
  invoiceForm: Scalars["Boolean"];
  ocApproval: Scalars["Boolean"];
  payForm: Scalars["Boolean"];
  sickPayForm: Scalars["Boolean"];
  timeReport: Scalars["Boolean"];
};

export type BookingLinks = {
  link?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export enum BookingMonthBreakSide {
  FirstMonth = "FirstMonth",
  SecondMonth = "SecondMonth"
}

export type BookingNoApprovalForTimeReport = {
  needSignature: Array<CustomerRef>;
  needSignatureTROkInApp: Array<CustomerRef>;
  noApproval: Array<CustomerRef>;
  noApprovalMonthly: Array<CustomerRef>;
  noApprovalShortening: Array<CustomerRef>;
  noApprovalSpecial: Array<CustomerRef>;
};

export type BookingProfit = {
  invoiceTotal?: Maybe<Scalars["Float"]>;
  profitNet?: Maybe<Scalars["Float"]>;
  profitRatio?: Maybe<Scalars["Float"]>;
};

export enum BookingReportStatus {
  Billed = "Billed",
  BilledAndPaid = "BilledAndPaid",
  NotBilledNotPaid = "NotBilledNotPaid",
  NotBilledNotPaidNotPassed = "NotBilledNotPaidNotPassed",
  Paid = "Paid",
  Total = "Total"
}

export enum BookingReportType {
  ByConsultant = "ByConsultant",
  ByDepartment = "ByDepartment",
  ByHospital = "ByHospital",
  ByOrganization = "ByOrganization",
  ByProject = "ByProject",
  ByUser = "ByUser",
  ByWeek = "ByWeek"
}

export type BookingSkipTimereportReminderResults = {
  value?: Maybe<Scalars["Boolean"]>;
};

export type BookingStatus = {
  createdByUserId: Scalars["ObjectId"];
  createdByUserName: Scalars["String"];
  createdOn: Scalars["Date"];
  status: BookingStatusType;
};

export enum BookingStatusType {
  Billed = "Billed",
  Canceled = "Canceled",
  Closed = "Closed",
  Open = "Open",
  Paid = "Paid"
}

export type BookingSupportTagStatus = {
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  tag?: Maybe<Scalars["String"]>;
};

export type BookingSyncReport = {
  Groups: Array<BookingSyncReportGroup>;
  Items: Array<BookingSyncReportItem>;
  Total: Scalars["Float"];
};

export type BookingSyncReportGroup = {
  Total: Scalars["Float"];
  UserRef: UserRef;
};

export type BookingSyncReportItem = {
  ProjectName: Scalars["String"];
  Score: Scalars["Float"];
  UserRef: UserRef;
};

export enum BookingSystemEvents {
  AdditionalWorkOff = "AdditionalWorkOff",
  AdditionalWorkOn = "AdditionalWorkOn",
  Canceled = "Canceled",
  Created = "Created",
  EditCost = "EditCost",
  False = "False",
  InvoicePaidOff = "InvoicePaidOff",
  InvoicePaidOffEmp = "InvoicePaidOffEmp",
  InvoicePaidOn = "InvoicePaidOn",
  InvoicePaidOnEmp = "InvoicePaidOnEmp",
  RemoveAccConfirmation = "RemoveAccConfirmation",
  RemoveCustomerInvoice = "RemoveCustomerInvoice",
  RemoveSubcontractorDocument = "RemoveSubcontractorDocument",
  RemoveTravelConfirmation = "RemoveTravelConfirmation",
  RestoreAccConfirmation = "RestoreAccConfirmation",
  RestoreTravelConfirmation = "RestoreTravelConfirmation",
  Restored = "Restored",
  SaveInvoice = "SaveInvoice",
  True = "True",
  UpdateAccStatus = "UpdateAccStatus",
  UpdateFinanceStatus = "UpdateFinanceStatus",
  UpdatePatientId = "UpdatePatientId",
  UpdateSubContractorInvoice = "UpdateSubContractorInvoice",
  UpdateTravelStatus = "UpdateTravelStatus",
  UpdateWorkedHours = "UpdateWorkedHours",
  UploadSubCustomerInvoice = "UploadSubCustomerInvoice",
  UploadSubcontractorDocument = "UploadSubcontractorDocument",
  WriteNote = "WriteNote"
}

export type BookingTag = {
  booking: Scalars["Boolean"];
  bookingKit: Scalars["Boolean"];
  code: Scalars["String"];
  color: Scalars["String"];
  label?: Maybe<Scalars["String"]>;
};

export type BookingWeek = {
  AccommodationAudit?: Maybe<AccommodationTravelAudit>;
  AccommodationCost?: Maybe<Scalars["Float"]>;
  AccommodationDocuments: Array<Document>;
  AccommodationExpense: Scalars["Float"];
  AccommodationOK: Scalars["Boolean"];
  AccommodationRequired: Scalars["Boolean"];
  AccommodationStatus?: Maybe<AccommodationTravelStatus>;
  AdditionalWork: Scalars["Boolean"];
  AdditionalWorkNote: Scalars["String"];
  AreaOfExpertise: Scalars["String"];
  BookingAudit?: Maybe<BookingAudit>;
  BookingGroup: BookingGroup;
  BookingRef: NodeRef;
  Consultant?: Maybe<Consultant>;
  ConsultantRef: NodeRef;
  ConsultantSnapshot: BookingConsultantSnapshot;
  ContractType?: Maybe<ContractType>;
  ContractTypeAbbr: Scalars["String"];
  CostCenter?: Maybe<CostCenter>;
  CustomerFine: Scalars["Float"];
  CustomerNumber: Scalars["String"];
  Departments: Array<Customer>;
  DepartmentsRefs: Array<CustomerRef>;
  EmployeeSalary?: Maybe<Scalars["Float"]>;
  FinanceOK: Scalars["Boolean"];
  GroupInvoiceTotal?: Maybe<Scalars["Float"]>;
  Hospital?: Maybe<Customer>;
  HospitalRef: CustomerRef;
  InvoiceTotalGross: Scalars["Float"];
  InvoiceTotalGrossFmt: Scalars["String"];
  InvoiceTotalNet: Scalars["Float"];
  InvoiceTotalNetFmt: Scalars["String"];
  InvoicedTotal?: Maybe<Scalars["Float"]>;
  InvoicedTotalFmt?: Maybe<Scalars["String"]>;
  Invoices: Array<Maybe<BookingCustomerInvoice>>;
  IsCanceled: Scalars["Boolean"];
  IsConsultantPayed: Scalars["Boolean"];
  IsCustomerBilled: Scalars["Boolean"];
  IsDirect: Scalars["Boolean"];
  IsMarked: Scalars["Boolean"];
  Note: Scalars["String"];
  OrganizationRef: CustomerRef;
  OtherExpenses: Scalars["Float"];
  PatientId: Scalars["String"];
  ProfitNet?: Maybe<Scalars["Float"]>;
  ProfitNetFmt?: Maybe<Scalars["String"]>;
  ProfitRatio?: Maybe<Scalars["Float"]>;
  Project?: Maybe<Project>;
  Salary: Scalars["Float"];
  SubcontractorInvoiceTotal?: Maybe<Scalars["Float"]>;
  TimeReportStatus?: Maybe<TimeReportStatus>;
  TravelAudit?: Maybe<AccommodationTravelAudit>;
  TravelCost?: Maybe<Scalars["Float"]>;
  TravelDocuments: Array<Document>;
  TravelExpense: Scalars["Float"];
  TravelOK: Scalars["Boolean"];
  TravelRequired: Scalars["Boolean"];
  TravelStatus?: Maybe<AccommodationTravelStatus>;
  Week: Scalars["Date"];
  WorkRequestId: Scalars["ObjectId"];
  WorkRequestRef: NodeRef;
  _id: Scalars["ObjectId"];
  bookingAssignedTo?: Maybe<Array<Maybe<BookingAssignedTo>>>;
  bookingSupportTagStatus?: Maybe<Array<Maybe<BookingSupportTagStatus>>>;
};

export type BookingWeekCalendarItem = {
  Week: Scalars["Date"];
  _id: Scalars["ObjectId"];
};

export enum BookingWeekConsultantDocumentWithOutBookingType {
  AccTravelConfirmationsWithOutBooking = "AccTravelConfirmationsWithOutBooking",
  AccommodationInvoices = "AccommodationInvoices",
  BookingConfirmationToCustomer = "BookingConfirmationToCustomer",
  CallResponse = "CallResponse",
  Canceled = "Canceled",
  CreditUnderSupplierInvoice = "CreditUnderSupplierInvoice",
  OtherBookingWeekDocWithOutBookingType = "OtherBookingWeekDocWithOutBookingType",
  Receipts = "Receipts",
  RentalAdviceAgreement = "RentalAdviceAgreement"
}

export enum BookingWeekDocumentTypes {
  AccTravelConfirmationsWithOutBooking = "AccTravelConfirmationsWithOutBooking",
  AccommodationConfirmations = "AccommodationConfirmations",
  AccommodationTravelInvoices = "AccommodationTravelInvoices",
  BenefitTaxation = "BenefitTaxation",
  CallResponse = "CallResponse",
  CertifiedTimeReport = "CertifiedTimeReport",
  CreditUnderSupplierInvoice = "CreditUnderSupplierInvoice",
  ExpensesReceipts = "ExpensesReceipts",
  InvoiceDocs = "InvoiceDocs",
  InvoiceForm = "InvoiceForm",
  Other = "Other",
  PayForm = "PayForm",
  SalaryBasis = "SalaryBasis",
  SickPayBasis = "SickPayBasis",
  SickPayForm = "SickPayForm",
  StandingCertificateFromCustomer = "StandingCertificateFromCustomer",
  SubcontractorInvoices = "SubcontractorInvoices",
  SubcontractorPayForm = "SubcontractorPayForm",
  TimeReport = "TimeReport",
  TravelConfirmation = "TravelConfirmation",
  UncertifiedTimeReport = "UncertifiedTimeReport"
}

export type BookingWeekListItem = {
  AccommodationAudit?: Maybe<AccommodationTravelAudit>;
  AccommodationOK: Scalars["Boolean"];
  AccommodationRequired: Scalars["Boolean"];
  AccommodationStatus?: Maybe<AccommodationTravelStatus>;
  AreaOfExpertise: Scalars["String"];
  BookingAudit?: Maybe<BookingAudit>;
  BookingRef: NodeRef;
  ConsultantRef: NodeRef;
  ConsultantServicePreferences?: Maybe<Scalars["String"]>;
  ContractType?: Maybe<ContractType>;
  ContractTypeAbbr: Scalars["String"];
  CostCenterId?: Maybe<Scalars["String"]>;
  CostCenterName?: Maybe<Scalars["String"]>;
  CustomerNumber: Scalars["String"];
  DepartmentsRefs: Array<CustomerRef>;
  HospitalRef: CustomerRef;
  InvoiceNumbers?: Maybe<Array<Maybe<Scalars["String"]>>>;
  InvoiceTotalGrossFmt: Scalars["String"];
  InvoicedTotalFmt?: Maybe<Scalars["String"]>;
  IsCanceled: Scalars["Boolean"];
  IsConsultantPayed: Scalars["Boolean"];
  IsCustomerBilled: Scalars["Boolean"];
  IsMarked: Scalars["Boolean"];
  OrganizationRef: CustomerRef;
  ProfitNetFmt?: Maybe<Scalars["String"]>;
  ProfitRatio?: Maybe<Scalars["Float"]>;
  ProjectId?: Maybe<Scalars["String"]>;
  TimeReportStatus?: Maybe<TimeReportStatus>;
  TravelAudit?: Maybe<AccommodationTravelAudit>;
  TravelOK: Scalars["Boolean"];
  TravelRequired: Scalars["Boolean"];
  TravelStatus?: Maybe<AccommodationTravelStatus>;
  Week: Scalars["Date"];
  _id: Scalars["ObjectId"];
  bookingAssignedTo?: Maybe<Array<Maybe<BookingAssignedTo>>>;
  bookingStatus?: Maybe<BookingStatus>;
  bookingSupportTagComment?: Maybe<Scalars["String"]>;
  bookingSupportTagStatus?: Maybe<Array<Maybe<BookingSupportTagStatus>>>;
  callNumber?: Maybe<Scalars["String"]>;
  consultantContractId?: Maybe<Scalars["ObjectId"]>;
  customerContractId?: Maybe<Scalars["ObjectId"]>;
  /**
   * Where the demand for this week came from — the platform, e-mail or manual
   * work request it was won through. Set by the booking export queue; empty on
   * weeks created in the CRM and on weeks booked before it was recorded.
   */
  demandSource?: Maybe<Scalars["String"]>;
  /** Deep link into the platform the demand came from, where it has one. */
  demandSourceUrl?: Maybe<Scalars["String"]>;
  isHighPrior?: Maybe<Scalars["Int"]>;
  isNationalProcurement?: Maybe<Scalars["Boolean"]>;
  isTravelInvoiced?: Maybe<Scalars["Boolean"]>;
  lastKitCreationWfFailedAt?: Maybe<Scalars["Date"]>;
  projectName?: Maybe<Scalars["String"]>;
  projectNumber?: Maybe<Scalars["String"]>;
  requireTravelInvoicing?: Maybe<Scalars["Boolean"]>;
  /**
   * The channels this week's hours actually arrived on (ADR-0008), deduplicated.
   *
   * A different question from `demandSource`: a Bemlo-sourced week routinely has
   * its hours reported on paper. Empty when the week has no time report, no rows,
   * or only rows written before provenance was recorded.
   */
  timeReportRowSources: Array<TimeReportRowSource>;
  timeReportStatusSetBy?: Maybe<UserRef>;
  timeReportStatusSetOn?: Maybe<Scalars["Date"]>;
};

export type BookingWeekQueryInput = {
  accommodationStatus?: InputMaybe<Array<AccommodationTravelStatus>>;
  areasOfExpertise?: InputMaybe<Array<Scalars["String"]>>;
  assignedPersons?: InputMaybe<Array<Scalars["ObjectId"]>>;
  bookingStatus?: InputMaybe<Array<BookingStatusType>>;
  bookingSupportTag?: InputMaybe<Array<Scalars["String"]>>;
  callNumber?: InputMaybe<Scalars["String"]>;
  consultantIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  costCenter?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  country?: InputMaybe<Array<Scalars["String"]>>;
  customerGroup?: InputMaybe<Array<Scalars["String"]>>;
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  customerNumber?: InputMaybe<Scalars["String"]>;
  /**
   * Where the demand came from. Multi-select, because an HBA works one platform at
   * a time; the literal `Empty` selects the weeks nobody attributed, which is how
   * the gap in attribution is found rather than hidden.
   */
  demandSource?: InputMaybe<Array<Scalars["String"]>>;
  employeeId?: InputMaybe<Scalars["String"]>;
  from?: InputMaybe<Scalars["Date"]>;
  groupInvoicing?: InputMaybe<Scalars["String"]>;
  hasAccommodationBenefitTax?: InputMaybe<Scalars["String"]>;
  hasBookingKits?: InputMaybe<Scalars["String"]>;
  invoiceNumber?: InputMaybe<Scalars["String"]>;
  legalPersonType?: InputMaybe<LegalPersonTypeWithNoOption>;
  nationalProcurement?: InputMaybe<Scalars["String"]>;
  organizationType?: InputMaybe<Array<OrganizationType>>;
  patientId?: InputMaybe<Scalars["String"]>;
  projectId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  projectResponsiblePersonId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  region?: InputMaybe<Array<Scalars["String"]>>;
  responsiblePersonId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  specialization?: InputMaybe<Array<Scalars["String"]>>;
  systems?: InputMaybe<Array<Scalars["String"]>>;
  text?: InputMaybe<Scalars["String"]>;
  timeReportStatus?: InputMaybe<Array<TimeReportStatus>>;
  timeReportStatusSetBy?: InputMaybe<Array<Scalars["ObjectId"]>>;
  to?: InputMaybe<Scalars["Date"]>;
  travelStatus?: InputMaybe<Array<AccommodationTravelStatus>>;
};

export type BookingWeekQueryResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<BookingWeekListItem>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
  total?: Maybe<Scalars["Int"]>;
  totalDbTime?: Maybe<Scalars["Int"]>;
};

export type BookingWeeksCSVBackgroundResult = {
  result?: Maybe<Scalars["String"]>;
};

export type BookingWeeksCSVResult = {
  Filename: Scalars["String"];
  URL: Scalars["String"];
};

export type BookingWeeksTotalInput = {
  filter: BookingWeekQueryInput;
  singleMemberProjectIds: Array<Scalars["ObjectId"]>;
};

export type BookingWeeksTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum BulkActionCommunicationSubType {
  Information = "Information",
  JobMailing = "JobMailing",
  Marketing = "Marketing"
}

export type BulkActionInput = {
  payload: Scalars["JSON"];
  type: BulkActionType;
};

export type BulkActionResult = {
  actionId: Scalars["ObjectId"];
  error?: Maybe<Scalars["String"]>;
  status: BulkActionStatus;
};

export enum BulkActionStatus {
  Done = "Done",
  Error = "Error",
  Pending = "Pending",
  Running = "Running"
}

export enum BulkActionType {
  ConsultantAssignCallList = "ConsultantAssignCallList",
  ConsultantAssignTags = "ConsultantAssignTags",
  ConsultantDelete = "ConsultantDelete",
  ConsultantEmail = "ConsultantEmail",
  ConsultantExport = "ConsultantExport",
  ConsultantExportSsn = "ConsultantExportSsn",
  ConsultantOrderQualityDocuments = "ConsultantOrderQualityDocuments",
  ConsultantReassignBA = "ConsultantReassignBA",
  ConsultantSMS = "ConsultantSMS"
}

export type BulkUpdateResult = {
  consultants: Array<Consultant>;
  updated: Scalars["Int"];
};

export enum CacheControlScope {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC"
}

export type CallList = {
  _id: Scalars["ObjectId"];
  audit: Audit;
  deleted: Scalars["Boolean"];
  members: Array<UserRef>;
  name: Scalars["String"];
  nodes: Array<NodeRef>;
  type: NodeType;
};

export type CallListCreateInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  name: Scalars["String"];
  nodes: Array<NodeRefFullInput>;
  type: NodeType;
  userIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type CallListOpResult = {
  callList?: Maybe<CallList>;
};

export type CallListStats = {
  callListType?: Maybe<CallListType>;
  count?: Maybe<Scalars["Int"]>;
};

export enum CallListType {
  CallList = "CallList",
  ContactList = "ContactList"
}

export type CanDuplicateToTenantsResult = {
  items?: Maybe<Array<Maybe<CanDuplicateToTenantsResultItem>>>;
};

export type CanDuplicateToTenantsResultItem = {
  canDuplicate: Scalars["Boolean"];
  links?: Maybe<Array<Maybe<Scalars["String"]>>>;
  tenant: Scalars["String"];
};

export type CancelBookingResult = {
  Booking: Booking;
};

export enum CardType {
  OrdinaryCardBonliva = "OrdinaryCardBonliva",
  OrdinaryCardWCC = "OrdinaryCardWCC",
  OtherCard = "OtherCard",
  ReserveCardBonliva = "ReserveCardBonliva",
  ReserveCardWCC = "ReserveCardWCC"
}

export type CategoryBadge = {
  Category: TodoCategory;
  Done?: Maybe<Scalars["Int"]>;
  Read: Scalars["Int"];
  Unread: Scalars["Int"];
};

export type ChangeStatusConsultantReferenceInput = {
  adjustWorkRelationHistory?: InputMaybe<Scalars["Boolean"]>;
  status: ConsultantReferenceStatus;
  workRelation?: InputMaybe<ConsultantReferenceRelation>;
};

export type CheckContactExistsInput = {
  cellPhone?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  filterOut?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  ssn?: InputMaybe<Scalars["String"]>;
};

export type CheckContactExistsResult = {
  exact?: Maybe<Consultant>;
  similar: Array<Consultant>;
};

export type CityInhabitants = {
  city: Scalars["String"];
  inhabitants: Scalars["Int"];
  taxRegion: Scalars["String"];
};

export type Comment = {
  message?: Maybe<Scalars["String"]>;
};

export type CommentInput = {
  message: Scalars["String"];
};

export type Compensation = {
  Price?: Maybe<Scalars["Float"]>;
  Type?: Maybe<ConsultantContractPriceType>;
};

export type CompensationInput = {
  Price: Scalars["Float"];
  Type: ConsultantContractPriceType;
};

export type ConfigDoc = {
  blockBookingCreationForBemloCustomers: Scalars["Boolean"];
  bookingTags: Array<BookingTag>;
  cityInhabitants: Array<CityInhabitants>;
  competitors: Array<Scalars["String"]>;
  costCenters: Array<CostCenter>;
  countries: Array<Country>;
  customerGroups: Array<Scalars["String"]>;
  defaultTravelZones: Array<DefaultTravelZone>;
  expertises: Array<Expertise>;
  getSSKSpecializations: Array<Scalars["String"]>;
  languages: Array<Scalars["String"]>;
  nationalProcurementTravelRegions: Array<Scalars["String"]>;
  professionConfigs: Array<ProfessionConfig>;
  roles: Array<Role>;
  titles: Array<Scalars["String"]>;
  version: Scalars["Float"];
};

export type ConfirmAccommodationInput = {
  accommodationId?: InputMaybe<Scalars["ObjectId"]>;
  area: Scalars["Float"];
  bookingId: Scalars["ObjectId"];
  city?: InputMaybe<Scalars["String"]>;
  files: Array<Scalars["String"]>;
  offerId?: InputMaybe<Scalars["ObjectId"]>;
  squareFootageAttached?: InputMaybe<Scalars["Boolean"]>;
  totalCost: Scalars["Float"];
  totalExVAT?: InputMaybe<Scalars["Boolean"]>;
  weeks: Array<ConfirmAccommodationWeekInput>;
};

export type ConfirmAccommodationWeekInput = {
  cost: Scalars["Float"];
  endDate?: InputMaybe<Scalars["Date"]>;
  extraCost: Scalars["Float"];
  extraDescription?: InputMaybe<Scalars["String"]>;
  isTaxed: Scalars["Boolean"];
  nights: Scalars["Int"];
  note?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
  tax: Scalars["Float"];
  weekYear: WeekYearInput;
};

export type ConfirmTravelInput = {
  bookingId: Scalars["ObjectId"];
  end?: InputMaybe<Scalars["Date"]>;
  files: Array<Scalars["String"]>;
  start?: InputMaybe<Scalars["Date"]>;
  totalCost?: InputMaybe<Scalars["String"]>;
  totalExVAT?: InputMaybe<Scalars["Boolean"]>;
  weeks: Array<ConfirmTravelWeekInput>;
};

export type ConfirmTravelWeekInput = {
  cost: Scalars["Float"];
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["Date"]>;
  isTravel: Scalars["Boolean"];
  note?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
  weekYear: WeekYearInput;
};

export enum ConsentChannel {
  Email = "Email",
  Sms = "Sms"
}

export enum ConsentPurpose {
  JobMailing = "JobMailing",
  JobMailingCampaign = "JobMailingCampaign",
  Marketing = "Marketing",
  Transactional = "Transactional"
}

export type Consultant = IContact &
  INode & {
    AccommodationPreferences: Scalars["String"];
    Address?: Maybe<Address>;
    AreasOfExpertise: Array<Scalars["String"]>;
    Availability: ConsultantAvailability;
    AvailableForWorkInCountries: Array<Scalars["String"]>;
    AvatarPic?: Maybe<Scalars["String"]>;
    BirthDate?: Maybe<Scalars["Date"]>;
    BookingDocuments: Array<Document>;
    BusinessName?: Maybe<Scalars["String"]>;
    BusinessSocialSecurityNo?: Maybe<Scalars["String"]>;
    CellPhone?: Maybe<Scalars["String"]>;
    CellPhoneValid: Scalars["Boolean"];
    /** @deprecated Bad performance */
    ConsultantForm?: Maybe<ConsultantForm>;
    ContractSigned?: Maybe<Scalars["Boolean"]>;
    DocumentTypes: Array<Scalars["String"]>;
    Documents: Array<Document>;
    DocumentsShareable: Array<Document>;
    Email?: Maybe<Scalars["String"]>;
    EmailValid: Scalars["Boolean"];
    EmployeeNumber: Scalars["String"];
    Events: Array<ConsultantEvent>;
    FirstName?: Maybe<Scalars["String"]>;
    GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
    Intro?: Maybe<Scalars["String"]>;
    IsSocialSecurityNoExist?: Maybe<Scalars["Boolean"]>;
    IsValid?: Maybe<Scalars["Boolean"]>;
    KnownSystems: Array<Scalars["String"]>;
    LastContactDate?: Maybe<Scalars["Date"]>;
    LastMetInPerson?: Maybe<Scalars["Date"]>;
    LastName?: Maybe<Scalars["String"]>;
    LegalBasis?: Maybe<LegalBasis>;
    LegalPersonType?: Maybe<LegalPersonType>;
    Name?: Maybe<Scalars["String"]>;
    NodeName: Scalars["String"];
    NodeType: NodeType;
    Phone?: Maybe<Scalars["String"]>;
    PhoneValid: Scalars["Boolean"];
    PrescriptionCode?: Maybe<Scalars["String"]>;
    PresentationUrl: Scalars["String"];
    Professions?: Maybe<Array<Maybe<Scalars["String"]>>>;
    QualityPerCountry: Array<ConsultantQualityPerCountry>;
    ResponsiblePerson?: Maybe<UserRef>;
    Roles?: Maybe<Array<Scalars["String"]>>;
    SocialSecurityNo?: Maybe<Scalars["String"]>;
    Specializations: Array<Scalars["String"]>;
    Status?: Maybe<ConsultantStatus>;
    SubcontractorInfo?: Maybe<SubcontractorInfo>;
    Teams: Array<Scalars["String"]>;
    Title?: Maybe<Scalars["String"]>;
    TravelPreferences: Scalars["String"];
    Unfit: Scalars["Boolean"];
    UnfitComment: Scalars["String"];
    UnfitedBy?: Maybe<WeakUserRef>;
    UnfitedSetOn?: Maybe<Scalars["Date"]>;
    UserSettings: UserSettings;
    ValidationErrors: Array<NodeValidationError>;
    _id: Scalars["ObjectId"];
    availableCountries: Array<Scalars["String"]>;
    bookedPeriodEnd?: Maybe<Scalars["Date"]>;
    bookedPeriodStart?: Maybe<Scalars["Date"]>;
    bookingStatus: ConsultantBookingStatus;
    businessAddress?: Maybe<Address>;
    callListStats: Scalars["Int"];
    canCreateContractCheck: Array<Scalars["String"]>;
    canCreateSelfInvoicingContractCheck: Array<ConsultantContractSelfInvoicingCheck>;
    care: Scalars["String"];
    contactType?: Maybe<ConsultantContactTypeSection>;
    contracts: Array<ConsultantContractSnapshot>;
    createdAt?: Maybe<Scalars["Date"]>;
    drivingLicenceType?: Maybe<DrivingLicenceType>;
    expertise: ConsultantExpertise;
    generalInterest?: Maybe<ConsultantGeneralInterest>;
    hasDrivingLicence?: Maybe<Scalars["Boolean"]>;
    id?: Maybe<Scalars["ObjectId"]>;
    initialContact?: Maybe<InitialContact>;
    isCvDataAffected: Scalars["Boolean"];
    isNationalQualityApproved: Scalars["Boolean"];
    isNationalQualityExpired: Scalars["Boolean"];
    isPresentationReadyQualityApproved: Scalars["Boolean"];
    isPresentationReadyQualityExpired: Scalars["Boolean"];
    isQualityApproved: Scalars["Boolean"];
    isQualityExpired: Scalars["Boolean"];
    karens?: Maybe<Array<Maybe<ConsultantKarensItem>>>;
    leadStatus?: Maybe<ConsultantLeadStatusParams>;
    nationalQualification?: Maybe<NationalQualification>;
    nationalQualityApprovals: Array<QualityApproval>;
    nextContactDate?: Maybe<ConsultantNextContactDate>;
    pipelineStatus?: Maybe<ConsultantPipelineStatus>;
    pipelineStatusComment?: Maybe<Scalars["String"]>;
    preferredCommunication: Array<PreferredCommunication>;
    professions: Array<Maybe<ConsultantProfession>>;
    qualityApprovals: Array<QualityApproval>;
    qualityChecks: Array<ConsultantQualityCheck>;
    qualityNote?: Maybe<Scalars["String"]>;
    secondaryEmail?: Maybe<Scalars["String"]>;
    sithsCardNumber?: Maybe<Scalars["String"]>;
    tags: Array<Scalars["String"]>;
    type: NodeType;
    unfitType?: Maybe<ConsultantUnfitType>;
    updatedAt?: Maybe<Scalars["Date"]>;
    welcomeEmail?: Maybe<Scalars["Boolean"]>;
    welcomeEmailSetBy?: Maybe<Scalars["String"]>;
    welcomeEmailSetOn?: Maybe<Scalars["Date"]>;
    worksForCompetitors: Array<Scalars["String"]>;
  };

export type ConsultantEventsArgs = {
  text?: InputMaybe<Scalars["String"]>;
};

export type ConsultantContractsArgs = {
  params?: InputMaybe<ConsultantContractSnapshotParamsInput>;
};

export type ConsultantAvailability = {
  availableWeeksString: Scalars["String"];
  ranges: Array<ConsultantAvailabilityRange>;
  weeks: Array<Scalars["Date"]>;
};

export type ConsultantAvailabilityInput = {
  weeks: Array<Scalars["Date"]>;
};

export type ConsultantAvailabilityRange = {
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type ConsultantAvailableOnWeek = {
  Consultant: Consultant;
  Week: Scalars["Date"];
};

export type ConsultantBookingContract = {
  Address?: Maybe<Address>;
  AreaOfExpertise?: Maybe<Array<Maybe<Scalars["String"]>>>;
  BasicPrice?: Maybe<Scalars["Float"]>;
  Bonus?: Maybe<Array<Maybe<ConsultantContractBonus>>>;
  ConsultantId?: Maybe<Scalars["ObjectId"]>;
  ContactPerson?: Maybe<CustomerContactPerson>;
  ContractPriceTemplateId?: Maybe<Scalars["ObjectId"]>;
  DepartmentsRefs?: Maybe<CustomerRef>;
  EndDate?: Maybe<Scalars["String"]>;
  FileRef?: Maybe<FileRef>;
  HospitalRef?: Maybe<CustomerRef>;
  IntroductionPrice?: Maybe<Array<Maybe<ConsultantContractIntroductionPrice>>>;
  OtherInfo?: Maybe<Scalars["String"]>;
  Period?: Maybe<Scalars["String"]>;
  Price?: Maybe<Scalars["String"]>;
  PriceRecruitment?: Maybe<PriceRecruitment>;
  Profession?: Maybe<Scalars["String"]>;
  Recipients?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ResponsiblePersonId?: Maybe<Scalars["ObjectId"]>;
  SalaryRecords?: Maybe<Array<Maybe<ContractsPriceRecord>>>;
  Schedule?: Maybe<Scalars["String"]>;
  SignedBy?: Maybe<UserRef>;
  SignedOn?: Maybe<Scalars["Date"]>;
  SpecificPeriodPrices?: Maybe<Array<Maybe<SpecificPeriodPrice>>>;
  SpecificRequirements?: Maybe<Array<Maybe<Scalars["String"]>>>;
  StartDate?: Maybe<Scalars["String"]>;
  Type?: Maybe<ConsultantBookingContractType>;
  _id?: Maybe<Scalars["ObjectId"]>;
  callNumber?: Maybe<Scalars["String"]>;
  hideDeptName?: Maybe<Scalars["Boolean"]>;
  hideHospitalName?: Maybe<Scalars["Boolean"]>;
  highHolidays?: Maybe<Array<Maybe<HighHoliday>>>;
  sithsCardNumber?: Maybe<Scalars["String"]>;
};

export type ConsultantBookingContractBonusInput = {
  Amount: Scalars["Float"];
  Config: Scalars["JSON"];
  Currency: Currency;
  Type: Scalars["String"];
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export type ConsultantBookingContractFormInput = {
  Address?: InputMaybe<AddressInput>;
  AreaOfExpertise?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  BasicPrice?: InputMaybe<Scalars["Float"]>;
  Bonus?: InputMaybe<Array<InputMaybe<ConsultantBookingContractBonusInput>>>;
  ContactPerson?: InputMaybe<CustomerContactPersonInput>;
  ContractPriceTemplateId?: InputMaybe<Scalars["ObjectId"]>;
  ContractType?: InputMaybe<ConsultantBookingContractType>;
  DepartmentsRefs?: InputMaybe<CustomerRefInput>;
  EndDate?: InputMaybe<Scalars["Date"]>;
  HospitalRef?: InputMaybe<CustomerRefInput>;
  IntroductionPrice?: InputMaybe<
    Array<InputMaybe<ConsultantContractIntroductionPriceInput>>
  >;
  OtherInfo?: InputMaybe<Scalars["String"]>;
  Period?: InputMaybe<Scalars["String"]>;
  Price?: InputMaybe<Scalars["String"]>;
  PriceRecruitment?: InputMaybe<PriceRecruitmentInput>;
  Profession?: InputMaybe<Scalars["String"]>;
  Recipients?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  ResponsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
  SalaryRecords?: InputMaybe<Array<InputMaybe<ContractPriceTemplateRecordInput>>>;
  Schedule?: InputMaybe<Scalars["String"]>;
  SpecificPeriodPrices?: InputMaybe<Array<InputMaybe<SpecificPeriodPriceInput>>>;
  SpecificRequirements?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  StartDate?: InputMaybe<Scalars["Date"]>;
  callNumber?: InputMaybe<Scalars["String"]>;
  hideDeptName?: InputMaybe<Scalars["Boolean"]>;
  hideHospitalName?: InputMaybe<Scalars["Boolean"]>;
  highHolidays?: InputMaybe<Array<InputMaybe<HighHolidayInput>>>;
  sithsCardNumber?: InputMaybe<Scalars["String"]>;
};

export type ConsultantBookingContractListItem = {
  Attachment?: Maybe<Document>;
  ContactPerson?: Maybe<CustomerContactPerson>;
  CustomerCity?: Maybe<Scalars["String"]>;
  CustomerName?: Maybe<Scalars["String"]>;
  Dates?: Maybe<Scalars["String"]>;
  FileUrl?: Maybe<Scalars["String"]>;
  IsNullified?: Maybe<Scalars["Boolean"]>;
  IsSigned?: Maybe<Scalars["Boolean"]>;
  PublishedUrl?: Maybe<Scalars["String"]>;
  Recipients?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Type?: Maybe<ConsultantBookingContractType>;
  ViewUrl?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
  canDownload?: Maybe<Scalars["Boolean"]>;
  canDuplicate?: Maybe<Scalars["Boolean"]>;
  canEdit?: Maybe<Scalars["Boolean"]>;
  canPreview?: Maybe<Scalars["Boolean"]>;
};

export enum ConsultantBookingContractType {
  Confirmation = "Confirmation",
  Outsource = "Outsource"
}

export enum ConsultantBookingStatus {
  Booked = "Booked",
  BookedPreviously = "BookedPreviously",
  NeverBooked = "NeverBooked"
}

export type ConsultantByWorkExperienceItem = {
  consultant: Consultant;
  workExperience?: Maybe<ConsultantWorkExperienceItem>;
};

export type ConsultantByWorkExperienceResult = {
  items: Array<ConsultantByWorkExperienceItem>;
};

export type ConsultantCompetenceSection = {
  items: Array<ConsultantCompetenceSectionItem>;
};

export type ConsultantCompetenceSectionInput = {
  items: Array<ConsultantCompetenceSectionItemInput>;
};

export type ConsultantCompetenceSectionItem = {
  competenceName: Scalars["String"];
  fromYear?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  lastUsedYear?: Maybe<Scalars["String"]>;
};

export type ConsultantCompetenceSectionItemInput = {
  competenceName: Scalars["String"];
  fromYear?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  lastUsedYear?: InputMaybe<Scalars["String"]>;
};

export type ConsultantCompetitorsSection = {
  items: Array<Scalars["String"]>;
};

export type ConsultantCompetitorsSectionInput = {
  items: Array<Scalars["String"]>;
};

export type ConsultantContactTypeSection = {
  FTaxChecked?: Maybe<Scalars["Boolean"]>;
  VATChecked?: Maybe<Scalars["Boolean"]>;
  accountNumber?: Maybe<Scalars["String"]>;
  businessAddress?: Maybe<FormAddress>;
  clearingNumber?: Maybe<Scalars["String"]>;
  companyName: Scalars["String"];
  emailForSelfInvoicing?: Maybe<Scalars["String"]>;
  employeeContractType?: Maybe<ContractType>;
  employeeSalaryClaim?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["Date"]>;
  externalTaxNumber?: Maybe<Scalars["String"]>;
  increasedRate?: Maybe<Scalars["String"]>;
  rate?: Maybe<Scalars["String"]>;
  receiveWorkBreakdownByEmail?: Maybe<Scalars["Boolean"]>;
  ssn: Scalars["String"];
  startDate?: Maybe<Scalars["Date"]>;
  subcontractorSalaryClaim?: Maybe<Scalars["String"]>;
  type?: Maybe<LegalPersonType>;
};

export type ConsultantContactTypeSectionInput = {
  FTaxChecked?: InputMaybe<Scalars["Boolean"]>;
  VATChecked?: InputMaybe<Scalars["Boolean"]>;
  accountNumber?: InputMaybe<Scalars["String"]>;
  businessAddress?: InputMaybe<FormAddressInput>;
  clearingNumber?: InputMaybe<Scalars["String"]>;
  companyName?: InputMaybe<Scalars["String"]>;
  emailForSelfInvoicing?: InputMaybe<Scalars["String"]>;
  employeeContractType?: InputMaybe<ContractType>;
  employeeSalaryClaim?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["Date"]>;
  externalTaxNumber?: InputMaybe<Scalars["String"]>;
  increasedRate?: InputMaybe<Scalars["String"]>;
  rate?: InputMaybe<Scalars["String"]>;
  receiveWorkBreakdownByEmail?: InputMaybe<Scalars["Boolean"]>;
  ssn?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
  subcontractorSalaryClaim?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<LegalPersonType>;
};

export type ConsultantContactsSection = {
  cellPhone: Scalars["String"];
  email: Scalars["String"];
  initialContact?: Maybe<InitialContact>;
  phone: Scalars["String"];
  preferredCommunication: Array<PreferredCommunication>;
  recommendedByConsultant?: Maybe<OptionObjectIDType>;
  secondaryEmail: Scalars["String"];
  selfRegisterOption?: Maybe<SelfRegisterOption>;
};

export type ConsultantContactsSectionInput = {
  cellPhone: Scalars["String"];
  email: Scalars["String"];
  initialContact?: InputMaybe<InitialContact>;
  phone: Scalars["String"];
  preferredCommunication: Array<PreferredCommunication>;
  recommendedByConsultant?: InputMaybe<OptionObjectIDInput>;
  secondaryEmail: Scalars["String"];
  selfRegisterOption?: InputMaybe<SelfRegisterOption>;
};

export type ConsultantContract = {
  Accommodation?: Maybe<AccommodationAlt>;
  Address?: Maybe<Address>;
  AreaOfExpertise?: Maybe<Scalars["String"]>;
  BasicPrice?: Maybe<Scalars["Float"]>;
  Bonus?: Maybe<Array<Maybe<ConsultantContractBonus>>>;
  Compensation?: Maybe<Compensation>;
  ConsultantGetsPaidPer?: Maybe<ConsultantGetsPaidPer>;
  ConsultantId?: Maybe<Scalars["ObjectId"]>;
  ContractPriceTemplateId?: Maybe<Scalars["ObjectId"]>;
  Country?: Maybe<Scalars["String"]>;
  Currency?: Maybe<ConsultantContractCurrency>;
  CustomerName?: Maybe<Scalars["String"]>;
  DateFrameworkContractTypeIsSigned?: Maybe<Scalars["String"]>;
  Dates?: Maybe<Scalars["String"]>;
  DepartmentsRefs?: Maybe<Array<Maybe<CustomerRef>>>;
  DriverLicense?: Maybe<Scalars["Boolean"]>;
  Education?: Maybe<EducationCC>;
  EndDate?: Maybe<Scalars["String"]>;
  ExcludeAddress?: Maybe<Scalars["Boolean"]>;
  FileName?: Maybe<Scalars["String"]>;
  FileRef?: Maybe<FileRef>;
  HospitalRef?: Maybe<CustomerRef>;
  IntroductionPrice?: Maybe<Array<Maybe<ConsultantContractIntroductionPrice>>>;
  InvestigationsNumber?: Maybe<Scalars["String"]>;
  IsRegionDalarna?: Maybe<Scalars["Boolean"]>;
  Language?: Maybe<Scalars["String"]>;
  NotRelevantMonthlyWeeklyPayouts?: Maybe<Scalars["Boolean"]>;
  NullificationReason?: Maybe<Scalars["String"]>;
  NullifiedBy?: Maybe<UserRef>;
  NullifiedOn?: Maybe<Scalars["Date"]>;
  OtherRequirements?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Overtime?: Maybe<ConsultantContractOvertimeOpt>;
  ParentContractId?: Maybe<Scalars["ObjectId"]>;
  PatientVisits?: Maybe<Scalars["String"]>;
  PayoutType?: Maybe<ConsultantContractPayoutType>;
  Period?: Maybe<Scalars["String"]>;
  Profession?: Maybe<Scalars["String"]>;
  SalaryChoice?: Maybe<ContractType>;
  SalaryRecords?: Maybe<Array<Maybe<ContractsPriceRecord>>>;
  Schedule?: Maybe<Scalars["String"]>;
  SignedBy?: Maybe<UserRef>;
  SignedOn?: Maybe<Scalars["Date"]>;
  Specializations?: Maybe<Array<Maybe<Scalars["String"]>>>;
  SpecificPeriodPrices?: Maybe<Array<Maybe<SpecificPeriodPrice>>>;
  SpecificRequirements?: Maybe<Array<Maybe<Scalars["String"]>>>;
  StartDate?: Maybe<Scalars["String"]>;
  Travels?: Maybe<TravelsAlt>;
  Type?: Maybe<ConsultantContractType>;
  YoEx?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
  hideDeptName?: Maybe<Scalars["Boolean"]>;
  highHolidays?: Maybe<Array<Maybe<HighHoliday>>>;
  isNationalProcurementPriceStrategy?: Maybe<Scalars["Boolean"]>;
  pensionModel?: Maybe<ContractPensionModel>;
  pensionSolution?: Maybe<ConsultantContractPensionSolution>;
  showOrgName?: Maybe<Scalars["Boolean"]>;
};

export enum ConsultantContractAccommodationAlt {
  BonlivaPayAccommodation = "BonlivaPayAccommodation",
  BonlivaPayAccommodationAllowance = "BonlivaPayAccommodationAllowance",
  BonlivaPayAccommodationAllowanceAgainstReceipt = "BonlivaPayAccommodationAllowanceAgainstReceipt",
  SupplierPayAccommodation = "SupplierPayAccommodation"
}

export type ConsultantContractBonus = {
  Amount?: Maybe<Scalars["Float"]>;
  Config?: Maybe<Scalars["JSON"]>;
  Currency?: Maybe<Currency>;
  SalaryType?: Maybe<ConsultantContractBonusType>;
  Type?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
};

export type ConsultantContractBonusInput = {
  Amount: Scalars["Float"];
  Config: Scalars["JSON"];
  Currency: Currency;
  SalaryType: ConsultantContractBonusType;
  Type: Scalars["String"];
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export enum ConsultantContractBonusType {
  GrossSalaryBonus = "GrossSalaryBonus",
  OtherBonus = "OtherBonus"
}

export enum ConsultantContractCurrency {
  Percentage = "Percentage",
  SEK = "SEK"
}

export type ConsultantContractFormInput = {
  Accommodation?: InputMaybe<AccommodationAltInput>;
  Address?: InputMaybe<AddressInput>;
  AreaOfExpertise?: InputMaybe<Scalars["String"]>;
  BasicPrice?: InputMaybe<Scalars["Float"]>;
  Bonus?: InputMaybe<Array<InputMaybe<ConsultantContractBonusInput>>>;
  ConsultantGetsPaidPer?: InputMaybe<ConsultantGetsPaidPer>;
  ContractPriceTemplateId?: InputMaybe<Scalars["ObjectId"]>;
  ContractType: ConsultantContractType;
  Country?: InputMaybe<Scalars["String"]>;
  Currency?: InputMaybe<ConsultantContractCurrency>;
  DateFrameworkContractTypeIsSigned?: InputMaybe<Scalars["Date"]>;
  DepartmentsRefs?: InputMaybe<Array<InputMaybe<CustomerRefInput>>>;
  DriverLicense?: InputMaybe<Scalars["Boolean"]>;
  Education?: InputMaybe<EducationCCInput>;
  EndDate?: InputMaybe<Scalars["Date"]>;
  ExcludeAddress?: InputMaybe<Scalars["Boolean"]>;
  HospitalRef?: InputMaybe<CustomerRefInput>;
  IntroductionPrice?: InputMaybe<
    Array<InputMaybe<ConsultantContractIntroductionPriceInput>>
  >;
  InvestigationsNumber?: InputMaybe<Scalars["String"]>;
  IsRegionDalarna?: InputMaybe<Scalars["Boolean"]>;
  Language?: InputMaybe<Scalars["String"]>;
  NotRelevantMonthlyWeeklyPayouts?: InputMaybe<Scalars["Boolean"]>;
  OtherRequirements?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  Overtime?: InputMaybe<ConsultantContractOvertimeOpt>;
  ParentContractId?: InputMaybe<Scalars["ObjectId"]>;
  PatientVisits?: InputMaybe<Scalars["String"]>;
  PayoutType?: InputMaybe<ConsultantContractPayoutType>;
  Period?: InputMaybe<Scalars["String"]>;
  Profession?: InputMaybe<Scalars["String"]>;
  SalaryChoice?: InputMaybe<ContractType>;
  SalaryRecords?: InputMaybe<Array<InputMaybe<ContractPriceTemplateRecordInput>>>;
  Schedule?: InputMaybe<Scalars["String"]>;
  Specializations?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  SpecificPeriodPrices?: InputMaybe<Array<InputMaybe<SpecificPeriodPriceInput>>>;
  SpecificRequirements?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  StartDate?: InputMaybe<Scalars["Date"]>;
  Travels?: InputMaybe<TravelsAltInput>;
  YoEx?: InputMaybe<Scalars["String"]>;
  bankCounselling?: InputMaybe<Scalars["Boolean"]>;
  editsProofFileIds?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  hideDeptName?: InputMaybe<Scalars["Boolean"]>;
  highHolidays?: InputMaybe<Array<InputMaybe<HighHolidayInput>>>;
  isNationalProcurementPriceStrategy?: InputMaybe<Scalars["Boolean"]>;
  pensionModel?: InputMaybe<ContractPensionModel>;
  pensionSolution?: InputMaybe<ConsultantContractPensionSolution>;
  showOrgName?: InputMaybe<Scalars["Boolean"]>;
};

export type ConsultantContractIntroductionPrice = {
  Currency?: Maybe<Currency>;
  Description?: Maybe<Scalars["String"]>;
  Sum?: Maybe<Scalars["String"]>;
};

export type ConsultantContractIntroductionPriceInput = {
  Currency: Currency;
  Description: Scalars["String"];
  Sum: Scalars["Float"];
};

export type ConsultantContractListItem = {
  Attachment?: Maybe<Document>;
  ChildContracts?: Maybe<Array<Maybe<ConsultantContractListItem>>>;
  Consultant?: Maybe<Consultant>;
  CustomerCity?: Maybe<Scalars["String"]>;
  CustomerName?: Maybe<Scalars["String"]>;
  Dates?: Maybe<Scalars["String"]>;
  EndDate?: Maybe<Scalars["Date"]>;
  FileUrl?: Maybe<Scalars["String"]>;
  IsNullified?: Maybe<Scalars["Boolean"]>;
  IsSigned?: Maybe<Scalars["Boolean"]>;
  Name?: Maybe<Scalars["String"]>;
  NotRelevantMonthlyWeeklyPayouts?: Maybe<Scalars["Boolean"]>;
  NullificationReason?: Maybe<Scalars["String"]>;
  ParentContractId?: Maybe<Scalars["ObjectId"]>;
  ParentId?: Maybe<Scalars["String"]>;
  PayoutsAbbr?: Maybe<Scalars["String"]>;
  PdfUrl?: Maybe<Scalars["String"]>;
  Period?: Maybe<Scalars["String"]>;
  Profession?: Maybe<Scalars["String"]>;
  PublishedUrl?: Maybe<Scalars["String"]>;
  SalaryChoice?: Maybe<ContractType>;
  SalaryChoiceAbbr?: Maybe<Scalars["String"]>;
  StartDate?: Maybe<Scalars["Date"]>;
  Type?: Maybe<ConsultantContractType>;
  ViewUrl?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
  canDownload?: Maybe<Scalars["Boolean"]>;
  canDuplicate?: Maybe<Scalars["Boolean"]>;
  canEdit?: Maybe<Scalars["Boolean"]>;
  canNullify?: Maybe<Scalars["Boolean"]>;
  canPreview?: Maybe<Scalars["Boolean"]>;
  canPublishToOneFlowViaTicket?: Maybe<Scalars["Boolean"]>;
  canPublishToOneflowDirectly?: Maybe<Scalars["Boolean"]>;
  editsProof?: Maybe<Array<Maybe<EditProof>>>;
  pensionSolution?: Maybe<ConsultantContractPensionSolution>;
};

export type ConsultantContractMaxCost = {
  Currency?: Maybe<Currency>;
  Period?: Maybe<ConsultantContractPeriod>;
  Price?: Maybe<Scalars["Float"]>;
  SalaryType?: Maybe<ConsultantContractSalaryType>;
};

export type ConsultantContractMaxCostInput = {
  Currency?: InputMaybe<Currency>;
  Period?: InputMaybe<ConsultantContractPeriod>;
  Price?: InputMaybe<Scalars["Float"]>;
  SalaryType?: InputMaybe<ConsultantContractSalaryType>;
};

export enum ConsultantContractOvertimeOpt {
  NoSpecialOvertime = "NoSpecialOvertime",
  SKLBasedOvertime = "SKLBasedOvertime"
}

export enum ConsultantContractPayoutType {
  Monthly = "Monthly",
  Weekly = "Weekly"
}

export enum ConsultantContractPensionSolution {
  Full = "Full",
  Split = "Split"
}

export enum ConsultantContractPeriod {
  Day = "Day",
  Month = "Month",
  Week = "Week",
  WorkShift = "WorkShift"
}

export enum ConsultantContractPriceType {
  OfRevenue = "OfRevenue",
  PerDay = "PerDay",
  PerEmergencyCall = "PerEmergencyCall",
  PerHour = "PerHour",
  PerInquiry = "PerInquiry",
  PerMonth = "PerMonth",
  PerScreening = "PerScreening",
  PerShift = "PerShift",
  PerSurgery = "PerSurgery",
  PerWeek = "PerWeek"
}

export enum ConsultantContractSalaryType {
  GrossSalary = "GrossSalary",
  NetSalary = "NetSalary"
}

export enum ConsultantContractSelfInvoicingCheck {
  MustBeSubcontractor = "MustBeSubcontractor",
  MustBeSwedishResident = "MustBeSwedishResident",
  MustHaveBusinessAddress = "MustHaveBusinessAddress",
  MustHaveBusinessName = "MustHaveBusinessName",
  MustHaveBusinessSSN = "MustHaveBusinessSSN",
  MustHaveEmail = "MustHaveEmail",
  MustHaveFTaxChecked = "MustHaveFTaxChecked",
  MustHaveResponsiblePerson = "MustHaveResponsiblePerson",
  MustHaveSSN = "MustHaveSSN",
  MustHaveVATChecked = "MustHaveVATChecked"
}

export type ConsultantContractSnapshot = {
  endDate?: Maybe<Scalars["Date"]>;
  id: Scalars["ObjectId"];
  startDate?: Maybe<Scalars["Date"]>;
};

export type ConsultantContractSnapshotParamsInput = {
  isActive?: InputMaybe<Scalars["Boolean"]>;
  isSigned?: InputMaybe<Scalars["Boolean"]>;
};

export enum ConsultantContractTravelsAlt {
  BonlivaPayTravel = "BonlivaPayTravel",
  BonlivaPayTravelAllowance = "BonlivaPayTravelAllowance",
  BonlivaPayTravelAllowanceAgainstReceipt = "BonlivaPayTravelAllowanceAgainstReceipt",
  ConsultantTaxCompensationAllowance = "ConsultantTaxCompensationAllowance",
  SupplierPayTravel = "SupplierPayTravel",
  TravelTemplate = "TravelTemplate"
}

export type ConsultantContractTravelsMaxCost = {
  Currency?: Maybe<Currency>;
  Period?: Maybe<ConsultantContractTravelsPeriod>;
  Price?: Maybe<Scalars["Float"]>;
  SalaryType?: Maybe<ConsultantContractSalaryType>;
};

export type ConsultantContractTravelsMaxCostInput = {
  Currency?: InputMaybe<Currency>;
  Period?: InputMaybe<ConsultantContractTravelsPeriod>;
  Price?: InputMaybe<Scalars["Float"]>;
  SalaryType?: InputMaybe<ConsultantContractSalaryType>;
};

export enum ConsultantContractTravelsPeriod {
  Day = "Day",
  Mile = "Mile",
  Month = "Month",
  PerTravel = "PerTravel",
  Week = "Week",
  WorkShift = "WorkShift"
}

export enum ConsultantContractType {
  BC_Framework = "BC_Framework",
  BC_Framework_Confirmation = "BC_Framework_Confirmation",
  BC_Intermittent = "BC_Intermittent",
  BC_Intermittent_Confirmation = "BC_Intermittent_Confirmation",
  Confirmation = "Confirmation",
  ConfirmationForEmployees = "ConfirmationForEmployees",
  ConfirmationForEmployees_National = "ConfirmationForEmployees_National",
  Confirmation_National = "Confirmation_National",
  Employment = "Employment",
  Employment_National = "Employment_National",
  Framework = "Framework",
  Framework_National = "Framework_National",
  Intermittent = "Intermittent",
  Intermittent_National = "Intermittent_National",
  Outsource = "Outsource",
  Outsource_National = "Outsource_National",
  SelfInvoicing = "SelfInvoicing"
}

export type ConsultantEducationSection = {
  items: Array<ConsultantEducationSectionItem>;
};

export type ConsultantEducationSectionInput = {
  items: Array<ConsultantEducationSectionItemInput>;
};

export type ConsultantEducationSectionItem = {
  courseLocation: Scalars["String"];
  courseName: Scalars["String"];
  educationType?: Maybe<Scalars["String"]>;
  from?: Maybe<Scalars["Date"]>;
  fromMonth?: Maybe<Scalars["String"]>;
  fromYear?: Maybe<Scalars["String"]>;
  isCourse?: Maybe<Scalars["Boolean"]>;
  to?: Maybe<Scalars["Date"]>;
  toMonth?: Maybe<Scalars["String"]>;
  toYear?: Maybe<Scalars["String"]>;
};

export type ConsultantEducationSectionItemInput = {
  courseLocation?: InputMaybe<Scalars["String"]>;
  courseName?: InputMaybe<Scalars["String"]>;
  educationType?: InputMaybe<Scalars["String"]>;
  fromMonth?: InputMaybe<Scalars["String"]>;
  fromYear?: InputMaybe<Scalars["String"]>;
  isCourse?: InputMaybe<Scalars["Boolean"]>;
  toMonth?: InputMaybe<Scalars["String"]>;
  toYear?: InputMaybe<Scalars["String"]>;
};

export enum ConsultantEducationType {
  AHLR = "AHLR",
  HLR = "HLR",
  SHLR = "SHLR"
}

export type ConsultantEmergencyContactsSection = {
  items: Array<ConsultantEmergencyContactsSectionItem>;
};

export type ConsultantEmergencyContactsSectionInput = {
  items: Array<ConsultantEmergencyContactsSectionItemInput>;
};

export type ConsultantEmergencyContactsSectionItem = {
  name: Scalars["String"];
  phone: Scalars["String"];
  relation: Scalars["String"];
};

export type ConsultantEmergencyContactsSectionItemInput = {
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  relation?: InputMaybe<Scalars["String"]>;
};

export type ConsultantEmployeeNumberSection = {
  employeeNumber: Scalars["String"];
  employeeNumber2: Scalars["String"];
  employeeNumber3: Scalars["String"];
};

export type ConsultantEmployeeNumberSectionInput = {
  employeeNumber: Scalars["String"];
  employeeNumber2: Scalars["String"];
  employeeNumber3: Scalars["String"];
};

export type ConsultantEvaluateContactsSection = {
  items: Array<ConsultantEvaluateContactsSectionItem>;
};

export type ConsultantEvaluateContactsSectionItem = {
  name: Scalars["String"];
  phone: Scalars["String"];
};

export type ConsultantEvaluatesSection = {
  items?: Maybe<Array<ConsultantEvaluatesSectionItem>>;
};

export type ConsultantEvaluatesSectionInput = {
  items: Array<ConsultantEvaluatesSectionItemInput>;
};

export type ConsultantEvaluatesSectionItem = {
  _id: Scalars["ObjectId"];
  deleted?: Maybe<Scalars["Boolean"]>;
  email?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["String"]>;
  workPlace?: Maybe<Scalars["String"]>;
};

export type ConsultantEvaluatesSectionItemInput = {
  _id: Scalars["ObjectId"];
  deleted?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  workPlace?: InputMaybe<Scalars["String"]>;
};

export type ConsultantEvent = Event & {
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  EmailBody?: Maybe<Scalars["HTML"]>;
  EmailDescription?: Maybe<Scalars["String"]>;
  EmailRecipients?: Maybe<Array<EmailRecipient>>;
  EmailSubject?: Maybe<Scalars["String"]>;
  Links?: Maybe<Array<Scalars["String"]>>;
  MetBy?: Maybe<WeakUserRef>;
  Node: NodeRef;
  SMSMessage?: Maybe<SMSMessage>;
  SMSMessageID?: Maybe<Scalars["String"]>;
  SMSStatusLegacy?: Maybe<Scalars["String"]>;
  Sticky: Scalars["Boolean"];
  TodoItem?: Maybe<TodoItem>;
  TodoRef?: Maybe<NodeRef>;
  Type: ConsultantEventType;
  UpdatedBy: WeakUserRef;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum ConsultantEventTag {
  ClearConsultantQualityItem = "ClearConsultantQualityItem",
  SetConsultantQualityItem = "SetConsultantQualityItem"
}

export enum ConsultantEventType {
  Call = "Call",
  Comment = "Comment",
  ConsultantApp = "ConsultantApp",
  Document = "Document",
  Email = "Email",
  GDPR = "GDPR",
  Interest = "Interest",
  MarketingMessage = "MarketingMessage",
  MetInPerson = "MetInPerson",
  Noanswer = "Noanswer",
  QualityUpdate = "QualityUpdate",
  Registered = "Registered",
  Reminder = "Reminder",
  SMS = "SMS",
  SystemLog = "SystemLog",
  UserSettings = "UserSettings",
  WelcomeEmail = "WelcomeEmail"
}

export type ConsultantExpertise = {
  educations: Array<Scalars["String"]>;
  machines: Array<Scalars["String"]>;
  methods: Array<Scalars["String"]>;
  professions?: Maybe<Array<ConsultantProfession>>;
  systems: Array<Maybe<Scalars["String"]>>;
};

export type ConsultantExpertiseSectionSpecialization = {
  experienced: Scalars["Boolean"];
  interested: Scalars["Boolean"];
  name: Scalars["String"];
};

export type ConsultantExpertiseSectionSpecializationInput = {
  experienced?: InputMaybe<Scalars["Boolean"]>;
  interested?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
};

export type ConsultantExportCSVResult = {
  Filename: Scalars["String"];
  URL: Scalars["String"];
};

export type ConsultantForm = {
  GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
  address: FormAddress;
  competitors: ConsultantCompetitorsSection;
  consultantId: Scalars["ObjectId"];
  contactType: ConsultantContactTypeSection;
  contacts: ConsultantContactsSection;
  education: ConsultantEducationSection;
  emergencyContacts: ConsultantEmergencyContactsSection;
  employeeNumber: ConsultantEmployeeNumberSection;
  extraCurriculum?: Maybe<Scalars["String"]>;
  isNew: Scalars["Boolean"];
  knownSystems?: Maybe<Array<Maybe<Scalars["String"]>>>;
  languageSkills?: Maybe<ConsultantLanguageSkillsSection>;
  personal: ConsultantPersonalSection;
  prescriptionCode: ConsultantPrescriptionCodeSection;
  status?: Maybe<ConsultantStatus>;
  workExperience: ConsultantWorkExperienceSection;
};

export type ConsultantFormInput = {
  GDPRConsentRecords?: InputMaybe<Array<InputMaybe<GDPRInput>>>;
  address?: InputMaybe<FormAddressInput>;
  competitors?: InputMaybe<ConsultantCompetitorsSectionInput>;
  consultantId: Scalars["ObjectId"];
  contactType?: InputMaybe<ConsultantContactTypeSectionInput>;
  contacts?: InputMaybe<ConsultantContactsSectionInput>;
  education?: InputMaybe<ConsultantEducationSectionInput>;
  emergencyContacts?: InputMaybe<ConsultantEmergencyContactsSectionInput>;
  employeeNumber?: InputMaybe<ConsultantEmployeeNumberSectionInput>;
  extraCurriculum?: InputMaybe<Scalars["String"]>;
  isNew: Scalars["Boolean"];
  knownSystems?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  languageSkills?: InputMaybe<ConsultantLanguageSkillsSectionInput>;
  personal?: InputMaybe<ConsultantPersonalSectionInput>;
  prescriptionCode?: InputMaybe<ConsultantPrescriptionCodeSectionInput>;
  professions: Array<ConsultantProfessionInput>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
  status?: InputMaybe<ConsultantStatus>;
  workExperience?: InputMaybe<ConsultantWorkExperienceSectionInput>;
};

export type ConsultantFormResult = {
  Consultant?: Maybe<Consultant>;
  ConsultantForm?: Maybe<ConsultantForm>;
  Errors?: Maybe<Array<Scalars["String"]>>;
  OK: Scalars["Boolean"];
  ValidationErrors?: Maybe<Array<ValidationError>>;
};

export type ConsultantGeneralInterest = {
  comment: Scalars["String"];
  regions: Array<Scalars["String"]>;
  workshifts: Array<Workshift>;
};

export type ConsultantGeneralInterestInput = {
  comment: Scalars["String"];
  regions: Array<Scalars["String"]>;
  workshifts: Array<Workshift>;
};

export enum ConsultantGetsPaidPer {
  Hour = "Hour",
  Investigation = "Investigation"
}

export type ConsultantImportDocumentResult = {
  Rows: Array<Maybe<ConsultantImportRow>>;
};

export type ConsultantImportRow = {
  AreaOfExpertise: Array<Scalars["String"]>;
  CellPhone: Scalars["String"];
  Competitor: Scalars["String"];
  CompetitorSource: Scalars["String"];
  Duplicate?: Maybe<Consultant>;
  Errors: Array<Maybe<ConsultantRowError>>;
  FirstName: Scalars["String"];
  HPRNumber: Scalars["String"];
  InitialComment: Scalars["String"];
  IsDuplicate?: Maybe<Scalars["Boolean"]>;
  IsLookupSuccess?: Maybe<Scalars["Boolean"]>;
  LastName: Scalars["String"];
  Meta: ImportConsultantMeta;
  Phone: Scalars["String"];
  ResponsiblePerson?: Maybe<UserRef>;
  ResponsiblePersonSource?: Maybe<WeakUserRef>;
  RowID?: Maybe<Scalars["Int"]>;
  SocialSecurityNo?: Maybe<Scalars["String"]>;
  SocialSecurityNoSource?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  isApprovedAuthorization?: Maybe<Scalars["Boolean"]>;
  streetName?: Maybe<Scalars["String"]>;
  zipCode?: Maybe<Scalars["String"]>;
};

export type ConsultantImportRowsInput = {
  AreasOfExpertise: Array<Scalars["String"]>;
  CellPhone: Scalars["String"];
  Competitor?: InputMaybe<Scalars["String"]>;
  FirstName: Scalars["String"];
  HPRNumber?: InputMaybe<Scalars["String"]>;
  InitialComment?: InputMaybe<Scalars["String"]>;
  LastName: Scalars["String"];
  Meta: ImportConsultantMetaInput;
  Phone: Scalars["String"];
  ResponsiblePerson?: InputMaybe<UserRefInputStrict>;
  RowID?: InputMaybe<Scalars["Int"]>;
  SocialSecurityNo?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  isApprovedAuthorization?: InputMaybe<Scalars["Boolean"]>;
  streetName?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
};

export type ConsultantKarensInput = {
  karens: Array<ConsultantKarensItemInput>;
};

export type ConsultantKarensItem = {
  expDate: Scalars["String"];
  region: Scalars["String"];
};

export type ConsultantKarensItemInput = {
  expDate: Scalars["String"];
  region: Scalars["String"];
};

export type ConsultantLanguageSkillsSection = {
  items: Array<ConsultantLanguageSkillsSectionItem>;
};

export type ConsultantLanguageSkillsSectionInput = {
  items: Array<ConsultantLanguageSkillsSectionItemInput>;
};

export type ConsultantLanguageSkillsSectionItem = {
  level: LanguageSkillLevel;
  name: Scalars["String"];
};

export type ConsultantLanguageSkillsSectionItemInput = {
  level: LanguageSkillLevel;
  name: Scalars["String"];
};

export enum ConsultantLeadStatus {
  Assigned = "Assigned",
  BadTiming = "BadTiming",
  ContactedNoAnswer = "ContactedNoAnswer",
  NotContacted = "NotContacted",
  NotRelevant = "NotRelevant",
  RelevantLater = "RelevantLater",
  Unknown = "Unknown",
  Warm = "Warm"
}

export enum ConsultantLeadStatusCustom {
  BadTiming = "BadTiming",
  NotRelevant = "NotRelevant",
  RelevantLater = "RelevantLater",
  Unknown = "Unknown",
  Warm = "Warm"
}

export type ConsultantLeadStatusInput = {
  isResponsibleHBA: Scalars["Boolean"];
  leadStatus: ConsultantLeadStatusCustom;
  nextContactDate?: InputMaybe<Scalars["Date"]>;
  reason?: InputMaybe<NextContactDateReason>;
  reasonComment?: InputMaybe<Scalars["String"]>;
};

export type ConsultantLeadStatusParams = {
  comment?: Maybe<Scalars["String"]>;
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  status: ConsultantLeadStatus;
};

export type ConsultantMatchingItem = {
  consultant: Consultant;
  minutesTotal: Scalars["Int"];
  weeksTotal: Scalars["Int"];
};

export type ConsultantMatchingParams = {
  customerId: Scalars["ObjectId"];
};

export type ConsultantMatchingResult = {
  items: Array<ConsultantMatchingItem>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
  total: Scalars["Int"];
};

export type ConsultantNextContactDate = {
  date?: Maybe<Scalars["Date"]>;
  reason?: Maybe<Scalars["String"]>;
};

export type ConsultantOpportunity = {
  _id: Scalars["ObjectId"];
  areaOfExpertise?: Maybe<Scalars["String"]>;
  consultant?: Maybe<Consultant>;
  costCenter?: Maybe<CostCenter>;
  createdAt: Scalars["Date"];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  isShared?: Maybe<Scalars["Boolean"]>;
  originalIssue?: Maybe<ConsultantOpportunity>;
  users: Array<User>;
  weeks: Array<Scalars["Date"]>;
  weeksLost?: Maybe<Array<Scalars["Date"]>>;
  weeksLostString: Scalars["String"];
  weeksString: Scalars["String"];
  weeksWon?: Maybe<Array<Scalars["Date"]>>;
  weeksWonString: Scalars["String"];
};

export type ConsultantOpportunityCard = KanbanCard & {
  _id: Scalars["String"];
  assignee?: Maybe<User>;
  boardId: Scalars["String"];
  columnId: Scalars["String"];
  consultantOpportunity: ConsultantOpportunity;
  description?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  order: Scalars["Int"];
  title: Scalars["String"];
};

export type ConsultantOpportunityIssueWeeks = {
  lostWeeks: Array<Scalars["Date"]>;
  openWeeks: Array<Scalars["Date"]>;
  wonWeeks: Array<Scalars["Date"]>;
};

export type ConsultantOpportunityStats = {
  lostWeeks: Scalars["Float"];
  openWeeks: Scalars["Float"];
  presentedWeeks: Scalars["Float"];
  wonWeeks: Scalars["Float"];
};

export type ConsultantPayoutByYear = {
  total: Scalars["Float"];
  totalNationalProcurement: Scalars["Float"];
  totalNonNationalProcurement: Scalars["Float"];
  year: Scalars["Int"];
};

export type ConsultantPersonalSection = {
  about: Scalars["String"];
  accommodationPreferences: Scalars["String"];
  care: Scalars["String"];
  commentAuthorization: Scalars["String"];
  countries: Array<Scalars["String"]>;
  drivingLicenceType?: Maybe<DrivingLicenceTypeInput>;
  firstComment: Scalars["String"];
  firstName: Scalars["String"];
  hasDrivingLicence: Scalars["Boolean"];
  hprNumber: Scalars["String"];
  important: Scalars["String"];
  intro: Scalars["String"];
  isApprovedAuthorization: Scalars["Boolean"];
  isWorkedNorway: Scalars["Boolean"];
  lastName: Scalars["String"];
  norwayConsultantStatus?: Maybe<NorwayConsultantStatus>;
  norwegianSsn: Scalars["String"];
  ssn: Scalars["String"];
  travelPreferences: Scalars["String"];
};

export type ConsultantPersonalSectionInput = {
  about: Scalars["String"];
  accommodationPreferences: Scalars["String"];
  care: Scalars["String"];
  commentAuthorization: Scalars["String"];
  countries: Array<Scalars["String"]>;
  drivingLicenceType?: InputMaybe<DrivingLicenceTypeInput>;
  firstComment: Scalars["String"];
  firstName: Scalars["String"];
  hasDrivingLicence: Scalars["Boolean"];
  hprNumber: Scalars["String"];
  important: Scalars["String"];
  intro: Scalars["String"];
  isApprovedAuthorization: Scalars["Boolean"];
  isWorkedNorway: Scalars["Boolean"];
  lastName: Scalars["String"];
  norwayConsultantStatus?: InputMaybe<NorwayConsultantStatus>;
  norwegianSsn: Scalars["String"];
  ssn: Scalars["String"];
  travelPreferences: Scalars["String"];
};

export type ConsultantPipelineCard = KanbanCard & {
  _id: Scalars["String"];
  assignee?: Maybe<User>;
  boardId: Scalars["String"];
  columnId: Scalars["String"];
  consultant: Consultant;
  description?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  order: Scalars["Int"];
  title: Scalars["String"];
};

export enum ConsultantPipelineStatus {
  Booked = "Booked",
  NotPlaced = "NotPlaced",
  NotRelevant = "NotRelevant",
  Presented = "Presented",
  ReadyToBePresented = "ReadyToBePresented",
  RelevantInTheFuture = "RelevantInTheFuture",
  RelevantNow = "RelevantNow",
  Warm = "Warm"
}

export type ConsultantPrescriptionCodeSection = {
  code: Scalars["String"];
};

export type ConsultantPrescriptionCodeSectionInput = {
  code: Scalars["String"];
};

export type ConsultantPresentation = {
  ViewURL: Scalars["String"];
  _id: Scalars["ObjectId"];
};

export enum ConsultantPresentationCountry {
  Denmark = "Denmark",
  Norway = "Norway",
  Sweden = "Sweden"
}

export enum ConsultantPresentationType {
  AboutMe = "AboutMe",
  CustomText = "CustomText",
  IntroText = "IntroText",
  NoText = "NoText"
}

export type ConsultantProfession = {
  certifiedFrom?: Maybe<Scalars["String"]>;
  professionName: Scalars["String"];
};

export type ConsultantProfessionInput = {
  doctorProfession?: InputMaybe<DoctorProfessionInput>;
  genericProfession?: InputMaybe<GenericProfessionInput>;
  nurseProfession?: InputMaybe<NurseProfessionInput>;
  professionName: Scalars["String"];
  psykologProfession?: InputMaybe<PsykologProfessionInput>;
  radiographersProfession?: InputMaybe<RadioNurseProfessionInput>;
  socionomProfession?: InputMaybe<SocionomProfessionInput>;
  teacherProfession?: InputMaybe<TeacherProfessionInput>;
  type: ProfessionInputType;
};

export type ConsultantQualityCheck = {
  comment: Scalars["String"];
  country: Scalars["String"];
  expirationDate?: Maybe<Scalars["Date"]>;
  isPartiallyExpired: Scalars["Boolean"];
  itemName: Scalars["String"];
  params?: Maybe<Scalars["JSON"]>;
  setDate?: Maybe<Scalars["Date"]>;
  status?: Maybe<Scalars["String"]>;
};

export enum ConsultantQualityCheckStatus {
  Expired = "Expired",
  ExpiresSoon = "ExpiresSoon",
  NotSet = "NotSet",
  Valid = "Valid"
}

export type ConsultantQualityItem = {
  AvailableStatuses: Array<ConsultantQualityItemAvailableStatus>;
  Country: Scalars["String"];
  Disabled: Scalars["Boolean"];
  DisabledMsg?: Maybe<Scalars["String"]>;
  DocumentType?: Maybe<Scalars["String"]>;
  ExpiresOn?: Maybe<Scalars["Date"]>;
  ExpiresSoon?: Maybe<Scalars["Boolean"]>;
  HasDocument: Scalars["Boolean"];
  HasExpired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  Status?: Maybe<ConsultantQualityStatus>;
  StatusSetBy?: Maybe<UserRef>;
  StatusSetOn?: Maybe<Scalars["Date"]>;
  _id: Scalars["ObjectId"];
  templateName: Scalars["String"];
};

export type ConsultantQualityItemAvailableStatus = {
  Disabled?: Maybe<Scalars["Boolean"]>;
  DisabledMsg?: Maybe<Scalars["String"]>;
  IsCommentRequired: Scalars["Boolean"];
  IsDocumentRequired: Scalars["Boolean"];
  Name: Scalars["String"];
  WithComment: Scalars["Boolean"];
  WithDocument: Scalars["Boolean"];
};

export type ConsultantQualityPerCountry = {
  Country: Scalars["String"];
  QualityChecks: Array<ConsultantQualityItem>;
};

export enum ConsultantQualityReferenceType {
  CurrentBoss = "CurrentBoss",
  CurrentColleague = "CurrentColleague",
  FormerBoss = "FormerBoss",
  FormerColleague = "FormerColleague",
  LatestBoss = "LatestBoss"
}

export enum ConsultantQualityReferenceVariant {
  Evaluate = "Evaluate",
  EvaluateToThreeMonths = "EvaluateToThreeMonths",
  Reference = "Reference",
  UUNationalCrossQuestions = "UUNationalCrossQuestions"
}

export type ConsultantQualityStatus = {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export enum ConsultantQueryBookingStatus {
  BookingsInPeriod = "BookingsInPeriod",
  BookingsInPeriodButNotAfter = "BookingsInPeriodButNotAfter",
  HasBookingsFromDate = "HasBookingsFromDate",
  NoBookings = "NoBookings",
  NoBookingsBeforeDate = "NoBookingsBeforeDate",
  NoBookingsFromDate = "NoBookingsFromDate",
  NoBookingsFromDateBookedPreviously = "NoBookingsFromDateBookedPreviously",
  NoBookingsInPeriod = "NoBookingsInPeriod"
}

export type ConsultantReferenceDocument = {
  document: Document;
  name: Scalars["String"];
  referenceId: Scalars["ObjectId"];
  type: ConsultantReferenceType;
  workRelation?: Maybe<ConsultantReferenceRelation>;
};

export type ConsultantReferenceFormNew = {
  submittedAt?: Maybe<Scalars["Date"]>;
  submittedBy?: Maybe<NodeRefNew>;
};

export type ConsultantReferenceFormSubmissionHistory = {
  submittedAt?: Maybe<Scalars["Date"]>;
  submittedBy?: Maybe<Scalars["String"]>;
};

export type ConsultantReferenceInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  deleted?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  relation?: InputMaybe<Scalars["String"]>;
};

export type ConsultantReferenceInputNew = {
  areaOfExpertise: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  formType?: InputMaybe<ConsultantReferenceType>;
  name: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
  position: Scalars["String"];
  workPlace: Scalars["String"];
};

export type ConsultantReferenceNew = {
  _id: Scalars["ObjectId"];
  areaOfExpertise: Scalars["String"];
  canBeReSentToRef: Scalars["Boolean"];
  canBeSentToRef: Scalars["Boolean"];
  deleted: Scalars["Boolean"];
  document?: Maybe<Document>;
  editLink?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  form?: Maybe<ConsultantReferenceFormNew>;
  formLink?: Maybe<Scalars["String"]>;
  formType?: Maybe<ConsultantReferenceType>;
  lastStatusHistory: ConsultantReferenceStatusHistory;
  migrated?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  orderedUpdateFromKvk?: Maybe<Scalars["Boolean"]>;
  phone?: Maybe<Scalars["String"]>;
  position: Scalars["String"];
  reShared?: Maybe<Scalars["Boolean"]>;
  reminders?: Maybe<Array<ConsultantReferenceReminder>>;
  status: ConsultantReferenceStatus;
  submissionHistory?: Maybe<Array<Maybe<ConsultantReferenceFormSubmissionHistory>>>;
  updatedOn?: Maybe<Scalars["Date"]>;
  workPlace: Scalars["String"];
  workRelation?: Maybe<ConsultantReferenceRelation>;
};

export enum ConsultantReferenceRelation {
  CurrentBoss = "CurrentBoss",
  CurrentColleague = "CurrentColleague",
  FormerBoss = "FormerBoss",
  FormerColleague = "FormerColleague",
  LatestBoss = "LatestBoss"
}

export type ConsultantReferenceReminder = {
  createdAt: Scalars["Date"];
  sentTo: Scalars["String"];
};

export enum ConsultantReferenceReminderType {
  EightDays = "EightDays",
  FourDays = "FourDays",
  FourteenDays = "FourteenDays",
  SevenDays = "SevenDays",
  SixMonthsWarning = "SixMonthsWarning"
}

export enum ConsultantReferenceStatus {
  Approved = "Approved",
  ApprovedWithException = "ApprovedWithException",
  AwaitingApproval = "AwaitingApproval",
  Empty = "Empty",
  NotApproved = "NotApproved",
  NotRequested = "NotRequested",
  RequestExpired = "RequestExpired",
  RequestNotAnswered = "RequestNotAnswered",
  RequestSentToKVK = "RequestSentToKVK",
  RequestSentToReference = "RequestSentToReference"
}

export type ConsultantReferenceStatusHistory = {
  changedAt: Scalars["Date"];
  changedBy: NodeRefNew;
  newStatus: ConsultantReferenceStatus;
  prevStatus?: Maybe<ConsultantReferenceStatus>;
};

export enum ConsultantReferenceType {
  Evaluation = "Evaluation",
  EvaluationToThreeMonths = "EvaluationToThreeMonths",
  Reference = "Reference",
  UUCrossQuestions = "UUCrossQuestions"
}

export type ConsultantReferencesSection = {
  items: Array<ConsultantReferencesSectionItem>;
};

export type ConsultantReferencesSectionInput = {
  items: Array<ConsultantReferencesSectionItemInput>;
};

export type ConsultantReferencesSectionItem = {
  _id: Scalars["ObjectId"];
  deleted: Scalars["Boolean"];
  email: Scalars["String"];
  name: Scalars["String"];
  phone: Scalars["String"];
  position: Scalars["String"];
  relation: Scalars["String"];
};

export type ConsultantReferencesSectionItemInput = {
  _id: Scalars["ObjectId"];
  deleted?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  relation?: InputMaybe<Scalars["String"]>;
};

export type ConsultantResponsibleQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type ConsultantRowError = {
  Column: Scalars["String"];
  Message: Scalars["String"];
};

export enum ConsultantSITHSErrand {
  ExitCard = "ExitCard",
  OrderCard = "OrderCard"
}

export type ConsultantSMS = {
  ConsultantId: Scalars["ObjectId"];
  SMSMessage: SMSMessage;
};

export type ConsultantSearchQualityItem = {
  name: Scalars["String"];
  statuses: Array<SearchQualityCheckStatus>;
};

export type ConsultantServicePreference = {
  _id: Scalars["ObjectId"];
  archived: Scalars["Boolean"];
  createdById: Scalars["String"];
  createdByName: Scalars["String"];
  createdOn: Scalars["Date"];
  customers: Array<Maybe<CustomerRef>>;
  deleted: Scalars["Boolean"];
  description: Scalars["String"];
  nullifiedById?: Maybe<Scalars["String"]>;
  nullifiedByName?: Maybe<Scalars["String"]>;
  nullifiedOn?: Maybe<Scalars["Date"]>;
  period: ConsultantServicePreferencePeriod;
  reminders: Array<ConsultantServicePreferenceReminder>;
  status: ConsultantServicePreferenceStatus;
};

export type ConsultantServicePreferenceForm = {
  _id: Scalars["ObjectId"];
  customers: Array<Maybe<Customer>>;
  description: Scalars["String"];
  period: ConsultantServicePreferencePeriod;
  status: ConsultantServicePreferenceStatus;
};

export type ConsultantServicePreferencePeriod = {
  end: Scalars["Date"];
  start: Scalars["Date"];
};

export type ConsultantServicePreferencePeriodInput = {
  end: Scalars["Date"];
  start: Scalars["Date"];
};

export type ConsultantServicePreferenceReminder = {
  createdAt?: Maybe<Scalars["Date"]>;
  sentTo?: Maybe<Scalars["String"]>;
};

export enum ConsultantServicePreferenceStatus {
  Active = "Active",
  Nullified = "Nullified"
}

export enum ConsultantStatus {
  Active = "Active",
  Deleted = "Deleted",
  ToBeDeleted = "ToBeDeleted",
  Unverified = "Unverified",
  Verified = "Verified"
}

export enum ConsultantTableColumns {
  Address = "Address",
  AreasOfExpertise = "AreasOfExpertise",
  Availability = "Availability",
  AvailableForWorkIn = "AvailableForWorkIn",
  BookingStatus = "BookingStatus",
  CallListStats = "CallListStats",
  Comments = "Comments",
  CreatedAt = "CreatedAt",
  Email = "Email",
  GDPRIntegrationPolicy = "GDPRIntegrationPolicy",
  GDPRJobMailing = "GDPRJobMailing",
  GDPRLegalBasis = "GDPRLegalBasis",
  GDPRMarketing = "GDPRMarketing",
  HOSP = "HOSP",
  HasDrivingLicense = "HasDrivingLicense",
  IVO = "IVO",
  IVOErrands = "IVOErrands",
  InterestedToWorkIn = "InterestedToWorkIn",
  IsNationalQualityApproved = "IsNationalQualityApproved",
  IsQualityApproved = "IsQualityApproved",
  LastContactDate = "LastContactDate",
  Machines = "Machines",
  MethodsAndInstruments = "MethodsAndInstruments",
  Name = "Name",
  NextContactDate = "NextContactDate",
  OtherEducations = "OtherEducations",
  Phone = "Phone",
  PipelineStatus = "PipelineStatus",
  QualityNote = "QualityNote",
  ResponsiblePerson = "ResponsiblePerson",
  SocialSecurityNo = "SocialSecurityNo",
  Specializations = "Specializations",
  SwedenBusinessIntelligence = "SwedenBusinessIntelligence",
  SwedenCVAudit = "SwedenCVAudit",
  SwedenCriminalRecord = "SwedenCriminalRecord",
  SwedenHLR = "SwedenHLR",
  SwedenHSAIDSITHS = "SwedenHSAIDSITHS",
  SwedenHealthDeclaration = "SwedenHealthDeclaration",
  SwedenIdCheck = "SwedenIdCheck",
  SwedenInterviewDone = "SwedenInterviewDone",
  SwedenLanguageCheck = "SwedenLanguageCheck",
  SwedenNationalReferences = "SwedenNationalReferences",
  SwedenNpCriminalRecord = "SwedenNpCriminalRecord",
  SwedenProofOfEducation = "SwedenProofOfEducation",
  SwedenProofOfWork = "SwedenProofOfWork",
  SwedenReferences = "SwedenReferences",
  SwedenSAHLR = "SwedenSAHLR",
  Systems = "Systems",
  Tags = "Tags",
  UpdatedAt = "UpdatedAt",
  WorksForCompetitors = "WorksForCompetitors"
}

export type ConsultantTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum ConsultantUnfitType {
  NotContactable = "NotContactable",
  Unfit = "Unfit"
}

export type ConsultantUpcomingWorkplace = {
  bookingId: Scalars["ObjectId"];
  department: Array<CustomerRef>;
  organisation?: Maybe<CustomerRef>;
  week: WeekYear;
  workplace?: Maybe<CustomerRef>;
};

export type ConsultantWorkExperienceItem = {
  areaOfExpertise: Scalars["String"];
  competitors?: Maybe<Array<Maybe<Scalars["String"]>>>;
  customerRef?: Maybe<CustomerRef>;
  departmentIds?: Maybe<Array<Maybe<Scalars["ObjectId"]>>>;
  employmentType?: Maybe<LegalPersonType>;
  excludeFromPresentation?: Maybe<Scalars["Boolean"]>;
  experience?: Maybe<Scalars["String"]>;
  from?: Maybe<Scalars["Date"]>;
  fromMonth?: Maybe<Scalars["String"]>;
  fromYear?: Maybe<Scalars["String"]>;
  roles: Scalars["String"];
  to?: Maybe<Scalars["Date"]>;
  toMonth?: Maybe<Scalars["String"]>;
  toYear?: Maybe<Scalars["String"]>;
  workPlace: Scalars["String"];
  workType: Scalars["String"];
};

export type ConsultantWorkExperienceItemInput = {
  areaOfExpertise?: InputMaybe<Scalars["String"]>;
  competitors?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  customerRef?: InputMaybe<CustomerRefInput>;
  departmentIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  employmentType?: InputMaybe<LegalPersonType>;
  excludeFromPresentation?: InputMaybe<Scalars["Boolean"]>;
  experience?: InputMaybe<Scalars["String"]>;
  fromMonth?: InputMaybe<Scalars["String"]>;
  fromYear?: InputMaybe<Scalars["String"]>;
  roles?: InputMaybe<Scalars["String"]>;
  toMonth?: InputMaybe<Scalars["String"]>;
  toYear?: InputMaybe<Scalars["String"]>;
  workPlace?: InputMaybe<Scalars["String"]>;
  workType?: InputMaybe<Scalars["String"]>;
};

export type ConsultantWorkExperienceResult = {
  OK: Scalars["Boolean"];
};

export type ConsultantWorkExperienceSection = {
  items: Array<Maybe<ConsultantWorkExperienceItem>>;
};

export type ConsultantWorkExperienceSectionInput = {
  items: Array<InputMaybe<ConsultantWorkExperienceItemInput>>;
};

export type ConsultantWorkStatus = {
  _id: Scalars["ObjectId"];
  competitorName?: Maybe<Scalars["String"]>;
  createdByName: Scalars["String"];
  createdOn: Scalars["Date"];
  deleted: Scalars["Boolean"];
  reminderDate?: Maybe<Scalars["Date"]>;
  startDate: Scalars["Date"];
  type: ConsultantWorkStatusType;
};

export enum ConsultantWorkStatusType {
  FullTimeConsultant = "FullTimeConsultant",
  OnSickLeave = "OnSickLeave",
  PartTimeConsultant = "PartTimeConsultant",
  PermanentPosition = "PermanentPosition",
  Retired = "Retired",
  WorkingForCompetitor = "WorkingForCompetitor"
}

export type ConsultantsByWeeksQueryInput = {
  Klm?: InputMaybe<Scalars["String"]>;
  ZipOrCity?: InputMaybe<Scalars["String"]>;
  activeUser?: InputMaybe<Scalars["ObjectId"]>;
  alphabetFilter?: InputMaybe<Array<Scalars["String"]>>;
  approvedAuthorization?: InputMaybe<ApprovedAuthorizationOption>;
  areasOfExpertise?: InputMaybe<Array<ExpertiseInput>>;
  areasOfExpertiseExperience?: InputMaybe<Scalars["Int"]>;
  availabilityDateRange?: InputMaybe<DateRangeInput2>;
  availabilityRegions?: InputMaybe<Array<Scalars["String"]>>;
  availabilityWorkshifts?: InputMaybe<Array<Workshift>>;
  availableForWorkInCountries?: InputMaybe<Array<Scalars["String"]>>;
  birthdate?: InputMaybe<DateRangeInput>;
  callListIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  competences?: InputMaybe<Array<Scalars["String"]>>;
  competitors?: InputMaybe<Array<Scalars["String"]>>;
  consultantIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  dateRange?: InputMaybe<DateRangeInput>;
  dontRestrictAreasOfExpertise?: InputMaybe<Scalars["Boolean"]>;
  experienced?: InputMaybe<Scalars["String"]>;
  fitness?: InputMaybe<Scalars["String"]>;
  fullTextSearch?: InputMaybe<Scalars["Boolean"]>;
  gdprIntegrationPolicy?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailing?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailingEmail?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailingSms?: InputMaybe<Array<GDPROptionType>>;
  gdprMarketing?: InputMaybe<Array<GDPROptionType>>;
  hasDrivingLicence?: InputMaybe<Scalars["String"]>;
  hasEmail?: InputMaybe<Scalars["String"]>;
  hasLegalPersonType?: InputMaybe<LegalPersonTypeWithNoOption>;
  hasPhone?: InputMaybe<Scalars["String"]>;
  hprNumber?: InputMaybe<Scalars["Boolean"]>;
  initialContact?: InputMaybe<Array<Scalars["String"]>>;
  interested?: InputMaybe<Scalars["String"]>;
  isValid?: InputMaybe<Scalars["Boolean"]>;
  lastContactDate?: InputMaybe<DateRangeInput>;
  lastContactSelectType?: InputMaybe<SelectType>;
  lastContactType?: InputMaybe<Array<LastContactType>>;
  leadStatus?: InputMaybe<ConsultantLeadStatus>;
  legalBasis?: InputMaybe<LegalBasis>;
  location?: InputMaybe<LocationKlm>;
  norwayConsultantStatus?: InputMaybe<NorwayConsultantStatus>;
  participatesInVaccination?: InputMaybe<Scalars["Boolean"]>;
  professionsForm?: InputMaybe<ConsultantsQueryProfessionsFormInput>;
  qualification?: InputMaybe<Scalars["String"]>;
  responsiblePersonId?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  specializations?: InputMaybe<Array<Scalars["String"]>>;
  status?: InputMaybe<Array<ConsultantStatus>>;
  systems?: InputMaybe<Array<Scalars["String"]>>;
  tags?: InputMaybe<Array<Scalars["String"]>>;
  team?: InputMaybe<Scalars["String"]>;
  text?: InputMaybe<Scalars["String"]>;
  userActivityDate?: InputMaybe<DateRangeInput>;
  wageRange?: InputMaybe<NumericRangeInput>;
  workedInNorway?: InputMaybe<WorkedInNorwayOption>;
};

export type ConsultantsQueryDoctorInput = {
  experience?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQueryExpOnlyInput = {
  specializations?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQueryInput = {
  Klm?: InputMaybe<Scalars["String"]>;
  ZipOrCity?: InputMaybe<Scalars["String"]>;
  alphabetFilter?: InputMaybe<Array<Scalars["String"]>>;
  approvedAuthorization?: InputMaybe<ApprovedAuthorizationOption>;
  areasOfExpertise?: InputMaybe<Array<ExpertiseInput>>;
  areasOfExpertiseExperience?: InputMaybe<Scalars["Float"]>;
  availabilityDateRange?: InputMaybe<DateRangeInput2>;
  availabilityRegions?: InputMaybe<Array<Scalars["String"]>>;
  availabilityWorkshifts?: InputMaybe<Array<Workshift>>;
  availableForWorkInCountries?: InputMaybe<Array<Scalars["String"]>>;
  birthdate?: InputMaybe<DateRangeInput>;
  bookingStatus?: InputMaybe<ConsultantQueryBookingStatus>;
  bookingStatusDate?: InputMaybe<Scalars["Date"]>;
  bookingStatusDateEnd?: InputMaybe<Scalars["Date"]>;
  bookingStatusOption?: InputMaybe<Scalars["String"]>;
  callListIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  competences?: InputMaybe<Array<Scalars["String"]>>;
  competitors?: InputMaybe<Array<Scalars["String"]>>;
  consultantIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  dontRestrictAreasOfExpertise?: InputMaybe<Scalars["Boolean"]>;
  experienced?: InputMaybe<Scalars["String"]>;
  fitness?: InputMaybe<Scalars["String"]>;
  fullTextSearch?: InputMaybe<Scalars["Boolean"]>;
  gdprIntegrationPolicy?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailing?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailingEmail?: InputMaybe<Array<GDPROptionType>>;
  gdprJobMailingSms?: InputMaybe<Array<GDPROptionType>>;
  gdprMarketing?: InputMaybe<Array<GDPROptionType>>;
  hasDrivingLicence?: InputMaybe<DrivingLicenceType>;
  hasEmail?: InputMaybe<Scalars["String"]>;
  hasLegalPersonType?: InputMaybe<LegalPersonTypeWithNoOption>;
  hasPhone?: InputMaybe<Scalars["String"]>;
  hprNumber?: InputMaybe<Scalars["Boolean"]>;
  initialContact?: InputMaybe<Array<Scalars["String"]>>;
  initialsLastName?: InputMaybe<Array<Scalars["String"]>>;
  interested?: InputMaybe<Scalars["String"]>;
  isValid?: InputMaybe<Scalars["Boolean"]>;
  lastContactDate?: InputMaybe<DateRangeInput>;
  lastContactSelectType?: InputMaybe<SelectType>;
  lastContactType?: InputMaybe<Array<LastContactType>>;
  lastContactUserId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  leadStatus?: InputMaybe<ConsultantLeadStatus>;
  legalBasis?: InputMaybe<LegalBasis>;
  location?: InputMaybe<LocationKlm>;
  nationalQualification?: InputMaybe<Scalars["String"]>;
  nextContactDate?: InputMaybe<DateRangeInput>;
  norwayConsultantStatus?: InputMaybe<NorwayConsultantStatus>;
  onlyFavourites?: InputMaybe<Scalars["Boolean"]>;
  participatesInVaccination?: InputMaybe<Scalars["Boolean"]>;
  pipelineStatus?: InputMaybe<Array<Scalars["String"]>>;
  professionsForm?: InputMaybe<ConsultantsQueryProfessionsFormInput>;
  qualification?: InputMaybe<Scalars["String"]>;
  qualityCheckNames?: InputMaybe<Array<Scalars["String"]>>;
  qualityCheckStatuses?: InputMaybe<Array<Scalars["String"]>>;
  qualityCheckStatusesDate?: InputMaybe<DateRangeInput>;
  responsiblePersonId?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  specializations?: InputMaybe<Array<Scalars["String"]>>;
  status?: InputMaybe<Array<ConsultantStatus>>;
  systems?: InputMaybe<Array<Scalars["String"]>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  team?: InputMaybe<Scalars["String"]>;
  text?: InputMaybe<Scalars["String"]>;
  updatedBefore?: InputMaybe<Scalars["Date"]>;
  updatedSince?: InputMaybe<Scalars["Date"]>;
  wageRange?: InputMaybe<NumericRangeInput>;
  workedInNorway?: InputMaybe<WorkedInNorwayOption>;
};

export type ConsultantsQueryProfessionsFormInput = {
  doctor?: InputMaybe<ConsultantsQueryDoctorInput>;
  expOnly?: InputMaybe<ConsultantsQueryExpOnlyInput>;
  professions: Array<Scalars["String"]>;
  psykolog?: InputMaybe<ConsultantsQueryPsykologInput>;
  radiographer?: InputMaybe<ConsultantsQueryRadiographerInput>;
  socialWorkerForm?: InputMaybe<ConsultantsQuerySocialWorkerFormInput>;
  sskForm?: InputMaybe<ConsultantsQuerySskFormInput>;
  teacherForm?: InputMaybe<ConsultantsQueryTeacherFormInput>;
};

export type ConsultantsQueryPsykologInput = {
  experience?: InputMaybe<SelectValueInputString>;
  methods?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQueryRadiographerInput = {
  experience?: InputMaybe<SelectValueInputString>;
  machines?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQuerySocialWorkerFormInput = {
  educations?: InputMaybe<Array<Scalars["String"]>>;
  experienceMinYears?: InputMaybe<Scalars["String"]>;
  options?: InputMaybe<SocionomSelectOptionEnum>;
  specializations?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQuerySskFormInput = {
  areaOfExpertise?: InputMaybe<SelectValueInputString>;
  specializations?: InputMaybe<SelectValueInputString>;
};

export type ConsultantsQueryTeacherFormInput = {
  areaOfExpertise: Array<Scalars["String"]>;
  areaSelectType: SelectType;
  qualified: QualificationFilter;
};

export type ConsultantsResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<Consultant>;
  limit: Scalars["Int"];
  secondarySearch: Array<Consultant>;
  skip: Scalars["Int"];
  total: Scalars["Int"];
};

export type Contact = INode & {
  Address?: Maybe<Address>;
  AvatarPic?: Maybe<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  CellPhoneValid: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  EmailValid: Scalars["Boolean"];
  IsValid?: Maybe<Scalars["Boolean"]>;
  Name?: Maybe<Scalars["String"]>;
  NodeName: Scalars["String"];
  NodeType: NodeType;
  Phone?: Maybe<Scalars["String"]>;
  PhoneValid: Scalars["Boolean"];
  ResponsiblePerson?: Maybe<UserRef>;
  Roles?: Maybe<Array<Scalars["String"]>>;
  Title?: Maybe<Scalars["String"]>;
  ValidationErrors: Array<NodeValidationError>;
  _id: Scalars["ObjectId"];
  id?: Maybe<Scalars["ObjectId"]>;
  type: NodeType;
};

export type ContactInput = {
  Email?: InputMaybe<Scalars["String"]>;
};

export type ContactPerson = IContact & {
  Address?: Maybe<Address>;
  AreasOfExpertise: Array<Maybe<Scalars["String"]>>;
  Audit: Audit;
  AvatarPic?: Maybe<Scalars["String"]>;
  BooksProfessions: Array<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  CellPhoneValid: Scalars["Boolean"];
  CustomerGroups: Array<Scalars["String"]>;
  CustomerRefs: Array<CustomerRef>;
  Customers: Array<Customer>;
  Deleted: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  EmailValid: Scalars["Boolean"];
  GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
  IsInheritable: Scalars["Boolean"];
  IsValid?: Maybe<Scalars["Boolean"]>;
  /** Last update, else creation; date only when the change has no known user */
  LastChange: ContactPersonLastChange;
  Name?: Maybe<Scalars["String"]>;
  NodeName?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  PhoneValid: Scalars["Boolean"];
  ResponsiblePerson?: Maybe<UserRef>;
  Roles: Array<Scalars["String"]>;
  RootCustomer: CustomerRef;
  Title?: Maybe<Scalars["String"]>;
  ValidationErrors?: Maybe<Array<Maybe<ValidationError>>>;
  _id: Scalars["ObjectId"];
};

export type ContactPersonInput = {
  AreasOfExpertise?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  BooksProfessions?: InputMaybe<Array<Scalars["String"]>>;
  CellPhone?: InputMaybe<Scalars["String"]>;
  CustomerGroups?: InputMaybe<Array<Scalars["String"]>>;
  CustomersIds: Array<Scalars["ObjectId"]>;
  Email?: InputMaybe<Scalars["String"]>;
  IsInheritable?: InputMaybe<Scalars["Boolean"]>;
  Name?: InputMaybe<Scalars["String"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  Roles?: InputMaybe<Array<Scalars["String"]>>;
  Title?: InputMaybe<Scalars["String"]>;
};

export type ContactPersonLastChange = {
  Date: Scalars["Date"];
  IsUpdate: Scalars["Boolean"];
  User?: Maybe<UserRef>;
};

export type ContactPersonsFilter = {
  areasOfExpertise?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  customerId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  role?: InputMaybe<Array<Scalars["String"]>>;
  rootCustomerId?: InputMaybe<Scalars["ObjectId"]>;
  text?: InputMaybe<Array<Scalars["String"]>>;
  withEmailAttached?: InputMaybe<Scalars["Boolean"]>;
};

export type ContactPersonsResult = {
  items: Array<ContactPerson>;
  total?: Maybe<Scalars["Int"]>;
};

export enum ContractPensionModel {
  Annual = "Annual",
  Months = "Months"
}

export type ContractPriceTemplateFilter = {
  text?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Array<ContractsPriceTemplateType>>;
};

export type ContractPriceTemplateInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  deleted: Scalars["Boolean"];
  highHolidays?: InputMaybe<Array<HighHolidayInput>>;
  name: Scalars["String"];
  private?: InputMaybe<Scalars["Boolean"]>;
  records?: InputMaybe<Array<ContractPriceTemplateRecordInput>>;
  type?: InputMaybe<ContractsPriceTemplateType>;
};

export type ContractPriceTemplateOpResult = {
  errors?: Maybe<Array<Scalars["String"]>>;
  value?: Maybe<ContractsPriceTemplate>;
};

export type ContractPriceTemplateRecordInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  articleNumber?: InputMaybe<Scalars["String"]>;
  articleNumberForOtherSpeciality?: InputMaybe<Scalars["String"]>;
  currency?: InputMaybe<Currency>;
  customPrice?: InputMaybe<Scalars["Float"]>;
  deleted?: InputMaybe<Scalars["Boolean"]>;
  endDay?: InputMaybe<PriceListDay>;
  fixedPrice?: InputMaybe<Scalars["Float"]>;
  from?: InputMaybe<Scalars["Time"]>;
  indexInWorkType?: InputMaybe<Scalars["Float"]>;
  isSecondPass?: InputMaybe<Scalars["Boolean"]>;
  paidPer?: InputMaybe<PayUnit>;
  period?: InputMaybe<PayPeriod>;
  priceMultiplier?: InputMaybe<Scalars["Float"]>;
  startDay?: InputMaybe<PriceListDay>;
  to?: InputMaybe<Scalars["Time"]>;
  workType?: InputMaybe<PriceListWorkType>;
};

export type ContractPriceTemplateSearchResult = {
  items: Array<ContractsPriceTemplate>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
  total: Scalars["Int"];
};

export type ContractProfession = {
  areaOfExpertise?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  specialization?: Maybe<Scalars["String"]>;
};

export enum ContractType {
  Hourly = "Hourly",
  HourlyPension = "HourlyPension",
  HourlyPensionInsurance = "HourlyPensionInsurance",
  NationalProcurement = "NationalProcurement"
}

export type ContractsPriceRecord = {
  _id: Scalars["ObjectId"];
  articleNumber?: Maybe<Scalars["String"]>;
  articleNumberForOtherSpeciality?: Maybe<Scalars["String"]>;
  currency?: Maybe<Currency>;
  /** If user set it manual without calc */
  customPrice?: Maybe<Scalars["Float"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  endDay?: Maybe<PriceListDay>;
  /** Now it something like extra payment. */
  fixedPrice?: Maybe<Scalars["Float"]>;
  from?: Maybe<Scalars["String"]>;
  indexInWorkType?: Maybe<Scalars["Float"]>;
  isSecondPass?: Maybe<Scalars["Boolean"]>;
  paidPer?: Maybe<PayUnit>;
  period?: Maybe<PayPeriod>;
  /** If fixedPrice is set, priceMultiplier should be ignored on any calc */
  priceMultiplier?: Maybe<Scalars["Float"]>;
  startDay?: Maybe<PriceListDay>;
  to?: Maybe<Scalars["String"]>;
  workType?: Maybe<PriceListWorkType>;
};

export type ContractsPriceTemplate = {
  _id: Scalars["ObjectId"];
  createdByName?: Maybe<Scalars["String"]>;
  createdDate?: Maybe<Scalars["Date"]>;
  highHolidays?: Maybe<Array<HighHoliday>>;
  name?: Maybe<Scalars["String"]>;
  private?: Maybe<Scalars["Boolean"]>;
  records?: Maybe<Array<ContractsPriceRecord>>;
  type?: Maybe<Scalars["String"]>;
  updatedByName?: Maybe<Scalars["String"]>;
  updatedDate?: Maybe<Scalars["Date"]>;
};

export enum ContractsPriceTemplateType {
  ConsultantContract = "ConsultantContract",
  CustomerContract = "CustomerContract"
}

export type CostCenter = {
  Id: Scalars["String"];
  IsActive: Scalars["Boolean"];
  IsDeleted: Scalars["Boolean"];
  Name?: Maybe<Scalars["String"]>;
  Organisation?: Maybe<Scalars["String"]>;
  OriginalName?: Maybe<Scalars["String"]>;
};

export type CostCenterConfigFilterInput = {
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  organisation?: InputMaybe<Scalars["String"]>;
  text?: InputMaybe<Scalars["String"]>;
};

export type CostCenterConfigItem = {
  _id: Scalars["ObjectId"];
  costCenterId: Scalars["String"];
  isActive: Scalars["Boolean"];
  isDeleted: Scalars["Boolean"];
  name: Scalars["String"];
  organisation: Scalars["String"];
  tenant: Scalars["String"];
};

export type Count = {
  total?: Maybe<Scalars["Int"]>;
};

export type Country = {
  canWorkIn?: Maybe<Scalars["Boolean"]>;
  countryId: Scalars["String"];
  name: Scalars["String"];
  onTopInSearch?: Maybe<Scalars["Boolean"]>;
  regions: Array<Region>;
  sort?: Maybe<Scalars["Float"]>;
};

export type CreateApiTokenResult = {
  apiToken: ApiToken;
  token: Scalars["String"];
};

export type CreateBookingKitInput = {
  bookingId: Scalars["ObjectId"];
  bookingSupportCheckWasValid: Scalars["Boolean"];
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  filesIds: Array<Scalars["ObjectId"]>;
  managerId?: InputMaybe<Scalars["ObjectId"]>;
  receipts?: InputMaybe<Array<BookingKitExpensesReceiptInput>>;
  responsibleId?: InputMaybe<Scalars["ObjectId"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  tagsNote?: InputMaybe<Scalars["String"]>;
  templateType: TimeReportTemplateType;
  type: BookingKitType;
  withConsultantInvoice: Scalars["Boolean"];
  withCustomerInvoice: Scalars["Boolean"];
  withSickPay: Scalars["Boolean"];
  withSubcontractorPay: Scalars["Boolean"];
  withTimeReport: Scalars["Boolean"];
};

export type CreateConsultantOpportunityInput = {
  areaOfExpertise?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  costCenter: Scalars["String"];
  customerId: Scalars["ObjectId"];
  estimatedResponseDate: Scalars["Date"];
  note?: InputMaybe<Scalars["String"]>;
  users: Array<Scalars["ObjectId"]>;
  weeks: Array<Scalars["Date"]>;
  workrequestConsultantId?: InputMaybe<Scalars["ObjectId"]>;
  workrequestId?: InputMaybe<Scalars["ObjectId"]>;
};

export type CreateConsultantServicePreferenceInput = {
  customers?: InputMaybe<Array<InputMaybe<CustomerRefInput>>>;
  description: Scalars["String"];
  period: ConsultantServicePreferencePeriodInput;
};

export type CreateConsultantWorkStatusInput = {
  competitorName?: InputMaybe<Scalars["String"]>;
  reminderDate?: InputMaybe<Scalars["Date"]>;
  startDate: Scalars["Date"];
  type: ConsultantWorkStatusType;
};

export type CreateContactPersonResult = {
  contactPerson?: Maybe<ContactPerson>;
  validationErrors: Array<ValidationError>;
};

export type CreateCostCenterInput = {
  costCenterId: Scalars["String"];
  isActive: Scalars["Boolean"];
  name: Scalars["String"];
  organisation: Scalars["String"];
};

export type CreateCustomerResult = {
  customer?: Maybe<Customer>;
  validationErrors?: Maybe<Array<ValidationError>>;
};

export type CreateDirectRequestContractInput = {
  areaOfExpertise: Scalars["String"];
  avropsnummer: Scalars["String"];
  basicPrice: Scalars["Float"];
  customerId: Scalars["ObjectId"];
  departmentIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  extraInvoiceLine: Scalars["String"];
  weeks: Array<Scalars["Date"]>;
};

export type CreateTgRequirementInput = {
  costCenterId: Scalars["String"];
  minRequiredTG: Scalars["Float"];
  profession?: InputMaybe<Scalars["String"]>;
  validFrom?: InputMaybe<Scalars["Date"]>;
};

export enum CriminalRecordType {
  HVB = "HVB",
  HomeCareElderlyDisabled = "HomeCareElderlyDisabled",
  LSS = "LSS",
  MunicipalityLeadingPosition = "MunicipalityLeadingPosition",
  Norway = "Norway",
  OTHER = "OTHER",
  School = "School",
  WorkWithOtherKid = "WorkWithOtherKid"
}

export type CrmDocument = {
  _id: Scalars["ObjectId"];
  documentType?: Maybe<Scalars["String"]>;
  mimeType: Scalars["String"];
  name: Scalars["String"];
  pdfUrl: Scalars["String"];
  size: Scalars["Int"];
  thumbUrl: Scalars["String"];
  type: CrmDocumentType;
};

export enum CrmDocumentType {
  Accommodation = "Accommodation",
  Booking = "Booking",
  BookingKit = "BookingKit",
  Consultant = "Consultant",
  ConsultantContract = "ConsultantContract",
  ConsultantPresentation = "ConsultantPresentation",
  ConsultantReference = "ConsultantReference",
  Custom = "Custom",
  Customer = "Customer",
  CustomerContract = "CustomerContract",
  CustomerContractSnapshot = "CustomerContractSnapshot",
  Timereport = "Timereport"
}

export enum CrmEventType {
  Booking = "Booking",
  BookingKit = "BookingKit",
  Consultant = "Consultant",
  Customer = "Customer"
}

export enum Currency {
  NOK = "NOK",
  SEK = "SEK"
}

export type Customer = {
  AOESettings: Array<CustomerAOESettings>;
  Address?: Maybe<Address>;
  AreasOfExpertise: Array<Scalars["String"]>;
  AvatarPic?: Maybe<Scalars["String"]>;
  BgPic?: Maybe<Scalars["String"]>;
  CanBeDeleted: Scalars["Boolean"];
  CantBeDeletedReasons: Array<Scalars["String"]>;
  ContactPersons: Array<ContactPerson>;
  CustomerGroups: Array<Scalars["String"]>;
  CustomerTree: Array<CustomerTreeItem>;
  Deleted: Scalars["Boolean"];
  Description: Scalars["String"];
  DirectChildren: Array<CustomerRef>;
  DirectChildrenFull: Array<Customer>;
  DirectParent?: Maybe<CustomerRef>;
  DirectParents?: Maybe<Array<CustomerRef>>;
  DocumentTypes: Array<Scalars["String"]>;
  IsValid?: Maybe<Scalars["Boolean"]>;
  LastContactDate?: Maybe<Scalars["Date"]>;
  Name?: Maybe<Scalars["String"]>;
  NodeName: Scalars["String"];
  NodeType: NodeType;
  OrganizationNumber: Scalars["String"];
  OrganizationType?: Maybe<OrganizationType>;
  OwnProfessions: Array<Scalars["String"]>;
  Parents: Array<CustomerRef>;
  Professions: Array<Scalars["String"]>;
  RecruitingPortalType?: Maybe<RecruitingPortalType>;
  Ref: CustomerRef;
  RegionRef: CustomerRef;
  ShowHospitalAOERewriteWarning: Scalars["Boolean"];
  Specializations: Array<Scalars["String"]>;
  StaffingContactPersons: Array<ContactPerson>;
  Systems: Array<Scalars["String"]>;
  Type: CustomerType;
  ValidationErrors: Array<NodeValidationError>;
  WebsiteURL: Scalars["String"];
  WorkshiftSpans: Array<CustomerWorkshiftSpan>;
  _dummy?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
  areasOfExpertiseTotal: Scalars["Int"];
  bemloOrgId?: Maybe<Scalars["String"]>;
  bemloUnitId?: Maybe<Scalars["String"]>;
  billingInstructions?: Maybe<Scalars["String"]>;
  documents?: Maybe<Array<CustomerDocument>>;
  forceCallNumber?: Maybe<Scalars["Boolean"]>;
  geolocation?: Maybe<Geolocation>;
  id?: Maybe<Scalars["ObjectId"]>;
  inLists: Scalars["Boolean"];
  journalSystem?: Maybe<Scalars["String"]>;
  municipalityId?: Maybe<Scalars["ObjectId"]>;
  needSignature: Scalars["Boolean"];
  needSignatureTROkInApp: Scalars["Boolean"];
  noApproval: Scalars["Boolean"];
  noApprovalMonthly: Scalars["Boolean"];
  noApprovalShortening: Scalars["Boolean"];
  noApprovalSpecial: Scalars["Boolean"];
  recommendedPrices: Array<CustomerRecommendedPrice>;
  timeReportTemplateSettings?: Maybe<Array<Maybe<TimereportTemplateSettings>>>;
  type: NodeType;
};

export type CustomerAreasOfExpertiseArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type CustomerContactPersonsArgs = {
  customerGroup?: InputMaybe<Scalars["String"]>;
  showDeleted?: InputMaybe<Scalars["Boolean"]>;
};

export type CustomerAOESettings = {
  AreaOfExpertise: Scalars["String"];
  Enabled: Scalars["Boolean"];
  Error?: Maybe<Scalars["Boolean"]>;
  FortnoxId?: Maybe<Scalars["String"]>;
  GroupInvoicing?: Maybe<Scalars["Boolean"]>;
  Inherited?: Maybe<Scalars["Boolean"]>;
  InvoicingData?: Maybe<Scalars["String"]>;
  Profession: Scalars["String"];
  ResponsiblePerson?: Maybe<UserRef>;
  orderId?: Maybe<Scalars["String"]>;
  timeReport?: Maybe<Scalars["Boolean"]>;
};

export type CustomerAOESettingsInput = {
  AreaOfExpertise: Scalars["String"];
  Enabled: Scalars["Boolean"];
  FortnoxId?: InputMaybe<Scalars["String"]>;
  GroupInvoicing?: InputMaybe<Scalars["Boolean"]>;
  InvoicingData?: InputMaybe<Scalars["String"]>;
  Profession: Scalars["String"];
  ResponsiblePerson?: InputMaybe<OptionStringInput>;
  orderId?: InputMaybe<Scalars["String"]>;
  timeReport?: InputMaybe<Scalars["Boolean"]>;
};

export type CustomerContact = IContact & {
  Address?: Maybe<Address>;
  AvatarPic?: Maybe<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  CellPhoneValid: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  EmailValid: Scalars["Boolean"];
  GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
  Name?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  PhoneValid: Scalars["Boolean"];
  ResponsiblePerson?: Maybe<UserRef>;
  Roles: Array<Scalars["String"]>;
  Title: Scalars["String"];
  _id?: Maybe<Scalars["ObjectId"]>;
};

export type CustomerContactPerson = {
  CellPhone?: Maybe<Scalars["String"]>;
  Email?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  Title?: Maybe<Scalars["String"]>;
};

export type CustomerContactPersonInput = {
  Email?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  Phone?: InputMaybe<Scalars["String"]>;
  Title?: InputMaybe<Scalars["String"]>;
};

export type CustomerContract = {
  _id: Scalars["ObjectId"];
  adjustmentComment: Scalars["String"];
  attachmentRefs?: Maybe<Array<Maybe<FileRef>>>;
  attachments: Array<CustomerContractDocument>;
  avropsnummer?: Maybe<Scalars["String"]>;
  avtalsnummer?: Maybe<Scalars["String"]>;
  company: CustomerContractCompany;
  contactPerson?: Maybe<Array<CustomerContractContactPerson>>;
  contractEnd?: Maybe<Scalars["Date"]>;
  contractName?: Maybe<Scalars["String"]>;
  contractNumber?: Maybe<Scalars["String"]>;
  contractPriceAdjustmentDate?: Maybe<Scalars["Date"]>;
  contractPriceAdjustmentDateDeadline?: Maybe<Scalars["Date"]>;
  contractProlongation?: Maybe<Scalars["Date"]>;
  contractProlongationDeadline?: Maybe<Scalars["Date"]>;
  contractStart?: Maybe<Scalars["Date"]>;
  currentContractEnd?: Maybe<Scalars["Date"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  dispenseDeadline?: Maybe<Scalars["Float"]>;
  estimatedContractValue?: Maybe<Scalars["Float"]>;
  eventLogs: Array<CustomerContractEventLog>;
  extraInvoiceLine?: Maybe<Scalars["String"]>;
  info: Scalars["String"];
  introductionInfo?: Maybe<Scalars["String"]>;
  invoicingStrategy: InvoicingStrategyType;
  isNationalProcurement?: Maybe<Scalars["Boolean"]>;
  orgCustomerRefs: Array<CustomerRef>;
  orgCustomerTree: Array<CustomerTreeItem>;
  orgCustomers: Array<Customer>;
  otherOption?: Maybe<Scalars["Boolean"]>;
  otherOptionNote?: Maybe<Scalars["String"]>;
  overtime?: Maybe<Scalars["Boolean"]>;
  overtimeNote?: Maybe<Scalars["String"]>;
  overtimeOption?: Maybe<Scalars["Boolean"]>;
  overtimeOptionOBNote?: Maybe<Scalars["String"]>;
  possibleInvoiceForAccommodation?: Maybe<Scalars["Boolean"]>;
  possibleInvoiceForAccommodationNote?: Maybe<Scalars["String"]>;
  possibleInvoiceForTravel?: Maybe<Scalars["Boolean"]>;
  possibleInvoiceForTravelNote?: Maybe<Scalars["String"]>;
  priceLists: Array<CustomerContractPriceList>;
  professions: Array<Scalars["String"]>;
  prolongationComment: Scalars["String"];
  status?: Maybe<CustomerContractStatus>;
  subVersions: Array<CustomerContractSubVersion>;
  typeOfAgreement: CustomerContractAgreementType;
  useNationalProcurementInvoicing?: Maybe<Scalars["Boolean"]>;
};

export enum CustomerContractAgreementType {
  NotProcured = "NotProcured",
  Procured = "Procured"
}

export type CustomerContractByBookingFilter = {
  areaOfExpertise: Scalars["String"];
  consultantId: Scalars["String"];
  contractId?: InputMaybe<Scalars["String"]>;
  dates: Array<Scalars["Date"]>;
  weeks: Array<Scalars["Date"]>;
  workplaceIds: Array<Scalars["String"]>;
};

export enum CustomerContractCompany {
  Bonliva_AB = "Bonliva_AB",
  Bonliva_Care = "Bonliva_Care"
}

export type CustomerContractContactPerson = {
  _id: Scalars["ObjectId"];
  email: Scalars["String"];
  name: Scalars["String"];
  phone: Scalars["String"];
  title?: Maybe<Scalars["String"]>;
};

export type CustomerContractContactPersonInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  email: Scalars["String"];
  name: Scalars["String"];
  phone: Scalars["String"];
  title: Scalars["String"];
};

export type CustomerContractDocument = {
  DocumentType?: Maybe<Scalars["String"]>;
  FileRef: FileRef;
  PdfURL?: Maybe<Scalars["String"]>;
  ThumbURL?: Maybe<Scalars["String"]>;
};

export enum CustomerContractDocumentTypes {
  Agreement = "Agreement",
  ContractAttachments = "ContractAttachments",
  Other = "Other",
  PricesOB = "PricesOB",
  SubVersion = "SubVersion"
}

export type CustomerContractEventInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  description: Scalars["String"];
  sticky: Scalars["Boolean"];
};

export type CustomerContractEventLog = Event & {
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  EventType: CustomerContractEventType;
  Links?: Maybe<Array<Scalars["String"]>>;
  Sticky: Scalars["Boolean"];
  UpdatedBy?: Maybe<WeakUserRef>;
  UpdatedOn?: Maybe<Scalars["Date"]>;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum CustomerContractEventType {
  Comment = "Comment",
  Reminder = "Reminder",
  SystemLog = "SystemLog"
}

export type CustomerContractFilter = {
  company?: InputMaybe<CustomerContractCompany>;
  contractEnd?: InputMaybe<Scalars["Date"]>;
  contractPriceAdjustmentDate?: InputMaybe<Scalars["Date"]>;
  contractProlongation?: InputMaybe<Scalars["Date"]>;
  contractStart?: InputMaybe<Scalars["Date"]>;
  currentContractEnd?: InputMaybe<Scalars["Date"]>;
  professions?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  status?: InputMaybe<Array<CustomerContractStatus>>;
  tenant?: InputMaybe<Scalars["String"]>;
  text?: InputMaybe<Scalars["String"]>;
  typeOfAgreement?: InputMaybe<CustomerContractAgreementType>;
};

export type CustomerContractFormInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  adjustmentComment?: InputMaybe<Scalars["String"]>;
  avropsnummer?: InputMaybe<Scalars["String"]>;
  avtalsnummer?: InputMaybe<Scalars["String"]>;
  company: CustomerContractCompany;
  contactPerson: Array<CustomerContractContactPersonInput>;
  contractEnd: Scalars["Date"];
  contractName: Scalars["String"];
  contractNumber?: InputMaybe<Scalars["String"]>;
  contractPriceAdjustmentDate?: InputMaybe<Scalars["Date"]>;
  contractPriceAdjustmentDateDeadline?: InputMaybe<Scalars["Date"]>;
  contractProlongation?: InputMaybe<Scalars["Date"]>;
  contractProlongationDeadline?: InputMaybe<Scalars["Date"]>;
  contractStart: Scalars["Date"];
  currentContractEnd?: InputMaybe<Scalars["Date"]>;
  dispenseDeadline?: InputMaybe<Scalars["Float"]>;
  estimatedContractValue?: InputMaybe<Scalars["Float"]>;
  extraInvoiceLine?: InputMaybe<Scalars["String"]>;
  introductionInfo?: InputMaybe<Scalars["String"]>;
  orgCustomers: Array<CustomerRefInput>;
  otherOption?: InputMaybe<Scalars["Boolean"]>;
  otherOptionNote?: InputMaybe<Scalars["String"]>;
  overtime?: InputMaybe<Scalars["Boolean"]>;
  overtimeNote?: InputMaybe<Scalars["String"]>;
  overtimeOption?: InputMaybe<Scalars["Boolean"]>;
  overtimeOptionOBNote?: InputMaybe<Scalars["String"]>;
  possibleInvoiceForAccommodation?: InputMaybe<Scalars["Boolean"]>;
  possibleInvoiceForAccommodationNote?: InputMaybe<Scalars["String"]>;
  possibleInvoiceForTravel?: InputMaybe<Scalars["Boolean"]>;
  possibleInvoiceForTravelNote?: InputMaybe<Scalars["String"]>;
  priceAdjustmentComment?: InputMaybe<Scalars["String"]>;
  professions: Array<Scalars["String"]>;
  prolongationComment?: InputMaybe<Scalars["String"]>;
  typeOfAgreement: CustomerContractAgreementType;
  useNationalProcurementInvoicing?: InputMaybe<Scalars["Boolean"]>;
};

export type CustomerContractListItem = {
  _id: Scalars["String"];
  avropsnummer?: Maybe<Scalars["String"]>;
  basicPrices: Array<BasicPrice>;
  contractEnd: Scalars["Date"];
  contractName: Scalars["String"];
  contractStart: Scalars["Date"];
  contractType: Scalars["String"];
  isNationalProcurement: Scalars["Boolean"];
  isSubVersion: Scalars["Boolean"];
  parentId?: Maybe<Scalars["String"]>;
  priceLists: Array<Scalars["String"]>;
  useNationalProcurementInvoicing?: Maybe<Scalars["Boolean"]>;
};

export type CustomerContractOpResult = {
  errors?: Maybe<Array<Scalars["String"]>>;
  value?: Maybe<CustomerContract>;
};

export type CustomerContractPriceList = {
  _id: Scalars["ObjectId"];
  administrativeFee?: Maybe<Scalars["Float"]>;
  customerContract: CustomerContract;
  customerCount: Scalars["Int"];
  customerTree: Array<CustomerTreeItem>;
  customers: Array<Maybe<Customer>>;
  endDate?: Maybe<Scalars["Date"]>;
  name?: Maybe<Scalars["String"]>;
  priceGroups: Array<CustomerContractPriceListGroup>;
  startDate?: Maybe<Scalars["Date"]>;
  travelZones: Array<TravelZone>;
};

export type CustomerContractPriceListCustomersArgs = {
  limit?: InputMaybe<Scalars["Float"]>;
};

export type CustomerContractPriceListGroup = {
  _id: Scalars["ObjectId"];
  highHolidays: Array<HighHoliday>;
  professionsPrice: Array<CustomerContractProfessionsPrice>;
  records: Array<ContractsPriceRecord>;
};

export type CustomerContractProfessionsPrice = {
  price?: Maybe<Scalars["Float"]>;
  profession: ContractProfession;
};

export type CustomerContractSearchResult = {
  items: Array<CustomerContractSearchRow>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type CustomerContractSearchRow = {
  _id: Scalars["ObjectId"];
  contractEnd: Scalars["Date"];
  contractName?: Maybe<Scalars["String"]>;
  contractNumber?: Maybe<Scalars["String"]>;
  contractPriceAdjustmentDate?: Maybe<Scalars["Date"]>;
  contractPriceAdjustmentDateDeadline?: Maybe<Scalars["Date"]>;
  contractProlongation?: Maybe<Scalars["Date"]>;
  contractProlongationDeadline?: Maybe<Scalars["Date"]>;
  contractStart: Scalars["Date"];
  currentContractEnd?: Maybe<Scalars["Date"]>;
  estimatedContractValue?: Maybe<Scalars["Float"]>;
  orgCustomerRefs: Array<CustomerRef>;
  professions: Array<Scalars["String"]>;
  status?: Maybe<CustomerContractStatus>;
  subVersions: Array<CustomerContractSubVersion>;
};

export type CustomerContractSnapshot = {
  _id: Scalars["ObjectId"];
  consultantId?: Maybe<Scalars["ObjectId"]>;
  contactPersonId?: Maybe<Scalars["ObjectId"]>;
  customerContractId: Scalars["ObjectId"];
  customerId?: Maybe<Scalars["ObjectId"]>;
  externalId?: Maybe<Scalars["String"]>;
  fileRef?: Maybe<FileRef>;
  fileUrl?: Maybe<Scalars["String"]>;
  invoiceMarking?: Maybe<Scalars["String"]>;
  isNullified?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  parentId?: Maybe<Scalars["ObjectId"]>;
  publishedUrl?: Maybe<Scalars["String"]>;
  responsiblePersonId?: Maybe<Scalars["ObjectId"]>;
  signedOn?: Maybe<Scalars["Date"]>;
  type: CustomerContractSnapshotTypes;
  viewUrl?: Maybe<Scalars["String"]>;
};

export type CustomerContractSnapshotFormInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
  contactPersonId?: InputMaybe<Scalars["ObjectId"]>;
  customerContractId?: InputMaybe<Scalars["ObjectId"]>;
  customerId: Scalars["ObjectId"];
  invoiceMarking?: InputMaybe<Scalars["String"]>;
  parentId?: InputMaybe<Scalars["ObjectId"]>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
  type: CustomerContractSnapshotTypes;
};

export type CustomerContractSnapshotOpResult = {
  errors?: Maybe<Array<Scalars["String"]>>;
  value?: Maybe<CustomerContractSnapshot>;
};

export enum CustomerContractSnapshotTypes {
  Confirmation = "Confirmation",
  Framework = "Framework"
}

export enum CustomerContractSortBy {
  ContractEnd = "ContractEnd",
  ContractNumber = "ContractNumber",
  ContractPriceAdjustmentDate = "ContractPriceAdjustmentDate",
  ContractProlongation = "ContractProlongation",
  ContractStart = "ContractStart",
  CurrentContractEnd = "CurrentContractEnd",
  CustomerName = "CustomerName",
  EstimatedContractValue = "EstimatedContractValue"
}

export enum CustomerContractStatus {
  Active = "Active",
  Coming = "Coming",
  Completed = "Completed",
  Deleted = "Deleted"
}

export type CustomerContractSubVersion = {
  _id: Scalars["ObjectId"];
  basicPrice: Scalars["Float"];
  consultantId?: Maybe<Scalars["ObjectId"]>;
  customerContractName?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["Date"]>;
  fileRef?: Maybe<FileRef>;
  name?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
};

export type CustomerDocument = {
  DocumentType?: Maybe<CustomerDocumentTypes>;
  FileRef: FileRef;
  PdfURL?: Maybe<Scalars["String"]>;
  ThumbURL?: Maybe<Scalars["String"]>;
};

export enum CustomerDocumentTypes {
  Other = "Other",
  StandingCertificateForTR = "StandingCertificateForTR"
}

export type CustomerEvent = Event & {
  AreasOfExpertise: Array<Scalars["String"]>;
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  ContactPerson: Array<NodeRef>;
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  CustomerGroup?: Maybe<Scalars["String"]>;
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Scalars["String"]>>;
  MetBy?: Maybe<WeakUserRef>;
  Node: NodeRef;
  Roles: Array<Scalars["String"]>;
  RootCustomer: CustomerRef;
  Sticky: Scalars["Boolean"];
  TodoItem?: Maybe<TodoItem>;
  TodoRef?: Maybe<NodeRef>;
  Type: CustomerEventType;
  UpdatedBy: WeakUserRef;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export type CustomerEventFilter = {
  AreasOfExpertise?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  ContactPersonId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  CustomerGroup?: InputMaybe<Scalars["String"]>;
  CustomerId: Scalars["ObjectId"];
  Deleted?: InputMaybe<Scalars["Boolean"]>;
  Role?: InputMaybe<Array<Scalars["String"]>>;
  SearchField?: InputMaybe<Scalars["String"]>;
};

export type CustomerEventInput = {
  AreasOfExpertise?: InputMaybe<Array<Scalars["String"]>>;
  ContactPersonId?: InputMaybe<Array<Scalars["ObjectId"]>>;
  CustomerGroup?: InputMaybe<Scalars["String"]>;
  CustomerId: Scalars["ObjectId"];
  Description: Scalars["String"];
  RootCustomerId: Scalars["ObjectId"];
  Sticky?: InputMaybe<Scalars["Boolean"]>;
};

export enum CustomerEventType {
  Comment = "Comment",
  MetInPerson = "MetInPerson",
  Reminder = "Reminder"
}

export type CustomerInput = {
  AOESettings?: InputMaybe<Array<CustomerAOESettingsInput>>;
  Address?: InputMaybe<AddressInput>;
  AvatarPic?: InputMaybe<NodeRefInput>;
  BgPic?: InputMaybe<NodeRefInput>;
  CustomerGroups?: InputMaybe<Array<Scalars["String"]>>;
  Description?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  OrganizationNumber?: InputMaybe<Scalars["String"]>;
  OrganizationType?: InputMaybe<OrganizationType>;
  ParentId?: InputMaybe<Scalars["ObjectId"]>;
  Professions?: InputMaybe<Array<Scalars["String"]>>;
  RecruitingPortalType?: InputMaybe<RecruitingPortalType>;
  Systems?: InputMaybe<Array<Scalars["String"]>>;
  Type?: InputMaybe<CustomerType>;
  WorkshiftSpans?: InputMaybe<Array<CustomerWorkshiftSpanInput>>;
  _id?: InputMaybe<Scalars["ObjectId"]>;
  bemloOrgId?: InputMaybe<Scalars["String"]>;
  bemloUnitId?: InputMaybe<Scalars["String"]>;
  billingInstructions?: InputMaybe<Scalars["String"]>;
  forceCallNumber?: InputMaybe<Scalars["Boolean"]>;
  journalSystem?: InputMaybe<Scalars["String"]>;
  municipalityId?: InputMaybe<Scalars["ObjectId"]>;
};

export type CustomerRecommendedPrice = {
  areaOfExpertise: Scalars["String"];
  profession: Scalars["String"];
  value: Scalars["String"];
};

export type CustomerRecommendedPriceInput = {
  areaOfExpertise: Scalars["String"];
  profession: Scalars["String"];
  value: Scalars["String"];
};

export type CustomerRef = {
  Id: Scalars["ObjectId"];
  Name: Scalars["String"];
  Type: CustomerType;
};

export type CustomerRefInput = {
  Id: Scalars["ObjectId"];
  Name?: InputMaybe<Scalars["String"]>;
  Type?: InputMaybe<CustomerType>;
};

export enum CustomerSettingsKey {
  NeedSignature = "needSignature",
  NeedSignatureTROkInApp = "needSignatureTROkInApp",
  NoApprovalMonthly = "noApprovalMonthly",
  NoApprovalShortening = "noApprovalShortening",
  NoApprovalSpecial = "noApprovalSpecial"
}

export type CustomerTreeItem = {
  CustomerRef: CustomerRef;
  HospitalRef?: Maybe<CustomerRef>;
  ParentId?: Maybe<Scalars["ObjectId"]>;
  ParentRef?: Maybe<CustomerRef>;
};

export enum CustomerType {
  Department = "Department",
  Hospital = "Hospital",
  Region = "Region"
}

export type CustomerWorkshiftSpan = {
  FromMinutes: Scalars["Int"];
  Profession: Scalars["String"];
  ToMinutes: Scalars["Int"];
  Workshift: Workshift;
};

export type CustomerWorkshiftSpanInput = {
  FromMinutes: Scalars["Int"];
  Profession: Scalars["String"];
  ToMinutes: Scalars["Int"];
  Workshift: Workshift;
};

export type CustomersFilter = {
  areasOfExpertise?: InputMaybe<Array<Scalars["String"]>>;
  callListIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  customerNumbers?: InputMaybe<Array<Scalars["String"]>>;
  directParentId?: InputMaybe<Scalars["ObjectId"]>;
  dontRestrictAreasOfExpertise?: InputMaybe<Scalars["Boolean"]>;
  fullTextSearch?: InputMaybe<Scalars["Boolean"]>;
  group?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  includeCustomerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  journalSystem?: InputMaybe<Scalars["String"]>;
  lastContactDate?: InputMaybe<DateRangeInput>;
  lastContactType?: InputMaybe<Array<LastContactType>>;
  myActivity?: InputMaybe<Scalars["Boolean"]>;
  nameStartsWith?: InputMaybe<Scalars["String"]>;
  organizationType?: InputMaybe<Array<OrganizationType>>;
  parentId?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  region?: InputMaybe<Array<Scalars["String"]>>;
  responsiblePersonId?: InputMaybe<Array<Scalars["String"]>>;
  specializations?: InputMaybe<Array<Scalars["String"]>>;
  systems?: InputMaybe<Array<Scalars["String"]>>;
  text?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Array<CustomerType>>;
};

export type CustomersResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<Customer>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type CustomersTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars["Date"]>;
  to?: InputMaybe<Scalars["Date"]>;
};

export type DateRangeInput2 = {
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type DefaultTravelZone = {
  label: Scalars["String"];
  name: Scalars["String"];
};

export type DoctorAreasOfExpertise = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  open?: Maybe<Scalars["Boolean"]>;
  qualified?: Maybe<Scalars["Boolean"]>;
  specializations: Array<DoctorSpecialization>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type DoctorAreasOfExpertiseInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  open?: InputMaybe<Scalars["Boolean"]>;
  qualified?: InputMaybe<Scalars["Boolean"]>;
  specializations: Array<DoctorSpecializationInput>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type DoctorProfession = ConsultantProfession & {
  areasOfExpertise: Array<DoctorAreasOfExpertise>;
  certifiedFrom?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  professionName: Scalars["String"];
  systems: Array<Scalars["String"]>;
};

export type DoctorProfessionInput = {
  areasOfExpertise: Array<DoctorAreasOfExpertiseInput>;
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  code?: InputMaybe<Scalars["String"]>;
  professionName: Scalars["String"];
  systems: Array<Scalars["String"]>;
};

export type DoctorSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
};

export type DoctorSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
};

export type Document = {
  DocumentType?: Maybe<Scalars["String"]>;
  FileRef: FileRef;
  PdfURL: Scalars["String"];
  PreviewURL: Scalars["String"];
  ThumbURL: Scalars["String"];
};

export type DocumentInput = {
  DocumentType?: InputMaybe<Scalars["String"]>;
  FileRef: FileRefInput;
  PdfURL?: InputMaybe<Scalars["String"]>;
  ThumbURL?: InputMaybe<Scalars["String"]>;
};

export enum DocumentShareType {
  Private = "Private",
  Public = "Public",
  Shared = "Shared"
}

export enum DrivingLicenceType {
  Automatic = "Automatic",
  Manual = "Manual"
}

export enum DrivingLicenceTypeInput {
  Automatic = "Automatic",
  Manual = "Manual",
  NotSet = "NotSet"
}

export enum DurationType {
  Date = "Date",
  Week = "Week"
}

export type EditConsultantOpportunityInput = {
  areaOfExpertise?: InputMaybe<Scalars["String"]>;
  costCenter?: InputMaybe<Scalars["String"]>;
  customerId?: InputMaybe<Scalars["ObjectId"]>;
  estimatedResponseDate?: InputMaybe<Scalars["Date"]>;
  note?: InputMaybe<Scalars["String"]>;
  projectId?: InputMaybe<Scalars["ObjectId"]>;
};

export type EditProof = {
  _id?: Maybe<Scalars["ObjectId"]>;
  editBy?: Maybe<UserRef>;
  editOn?: Maybe<Scalars["String"]>;
  fileRefs?: Maybe<Array<FileRef>>;
};

export type EducationCC = {
  Show?: Maybe<Scalars["Boolean"]>;
  Text?: Maybe<Scalars["String"]>;
};

export type EducationCCInput = {
  Show?: InputMaybe<Scalars["Boolean"]>;
  Text?: InputMaybe<Scalars["String"]>;
};

export type EmailInput = {
  attachments?: InputMaybe<Array<Scalars["ObjectId"]>>;
  body?: InputMaybe<Scalars["String"]>;
  /** sender, opt email address */
  from?: InputMaybe<Scalars["String"]>;
  recipients: Array<EmailRecipientInput>;
  subject?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["ObjectId"]>;
};

export type EmailRecipient = {
  Email: Scalars["String"];
  Name?: Maybe<Scalars["String"]>;
};

export type EmailRecipientInput = {
  email: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
};

export type EmailResult = {
  Body: Scalars["String"];
  Subject: Scalars["String"];
};

export type Event = {
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  /** direct links. For example link to a document preview */
  Links?: Maybe<Array<Scalars["String"]>>;
  Sticky: Scalars["Boolean"];
  UpdatedBy?: Maybe<WeakUserRef>;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export type EventInput = {
  Description: Scalars["String"];
  Node: NodeRefInput;
  Sticky: Scalars["Boolean"];
};

export type Expertise = {
  Aliases: Array<Scalars["String"]>;
  Educations: Array<Scalars["String"]>;
  Exclusive?: Maybe<Scalars["Boolean"]>;
  Internal?: Maybe<Scalars["Boolean"]>;
  Machines: Array<Scalars["String"]>;
  Methods: Array<Scalars["String"]>;
  Name: Scalars["String"];
  Profession: Scalars["String"];
  QualityTemplates: Array<QualityTemplate>;
  Specializations: Array<Scalars["String"]>;
  Systems: Array<Scalars["String"]>;
};

export type ExpertiseConfig = {
  ADGroup: Array<Scalars["String"]>;
  Aliases: Array<Scalars["String"]>;
  Exclusive: Scalars["Boolean"];
  Internal: Scalars["Boolean"];
  Name: Scalars["String"];
  QualityTemplates: Scalars["String"];
  SNI: Array<Scalars["Int"]>;
  Specializations: Array<Scalars["String"]>;
};

export type ExpertiseInput = {
  exclusive?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
};

export enum ExternalDocumentSource {
  Erp = "Erp"
}

export enum ExternalOrderStatus {
  Closed = "Closed",
  Open = "Open"
}

export enum ExternalOrderType {
  Default = "Default",
  QualityCheck = "QualityCheck",
  Reference = "Reference"
}

export type ExtractContactPersonResult = {
  contactPerson?: Maybe<ContactPerson>;
  validationErrors: Array<ValidationError>;
};

export type FileRef = {
  MimeType: Scalars["String"];
  Name?: Maybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Size: Scalars["Int"];
};

export type FileRefInput = {
  MimeType?: InputMaybe<Scalars["String"]>;
  Name?: InputMaybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Size?: InputMaybe<Scalars["Int"]>;
};

export type FilterInput = {
  exclude?: InputMaybe<Array<Scalars["ObjectId"]>>;
  include?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type FinaliseConsultantOpportunityResult = {
  lost?: Maybe<ConsultantOpportunity>;
  won?: Maybe<ConsultantOpportunity>;
};

export type FormAddress = BaseFormAddress & {
  city: Scalars["String"];
  country: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type FormAddressInput = {
  city: Scalars["String"];
  country: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type FormAddressWithRegion = BaseFormAddress & {
  city: Scalars["String"];
  country: Scalars["String"];
  region: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type FormAddressWithRegionInput = {
  city: Scalars["String"];
  country: Scalars["String"];
  region: Scalars["String"];
  streetName: Scalars["String"];
  zipCode: Scalars["String"];
};

export type FortnoxSalaryCache = {
  consultantId: Scalars["ObjectId"];
  employeeId: Scalars["String"];
  id: Scalars["String"];
  lastFetchedAt?: Maybe<Scalars["String"]>;
  yearSums: Array<FortnoxSalaryYearSum>;
};

export type FortnoxSalaryYearSum = {
  sum: Scalars["Float"];
  year: Scalars["Int"];
};

export type FortnoxVoucherSubmitResult = {
  result?: Maybe<Scalars["String"]>;
};

export type FortnoxWeekSalaryCheck = {
  employeeId: Scalars["String"];
  takenWeekDays: Array<Scalars["Int"]>;
};

export type FreeTimereportResult = {
  freeTimereports: Array<Scalars["JSON"]>;
};

export type FreshdeskTicket = {
  createdAt: Scalars["Date"];
  id: Scalars["Int"];
  status: Scalars["String"];
  subject: Scalars["String"];
  updatedAt: Scalars["Date"];
  url: Scalars["String"];
};

export enum GDPRCommunicationChannel {
  Email = "Email",
  InterestForm = "InterestForm",
  MobileApp = "MobileApp",
  NotDefined = "NotDefined",
  Self = "Self",
  UnfitAction = "UnfitAction",
  Verbal = "Verbal"
}

export type GDPRConsent = {
  communicationChannel: GDPRCommunicationChannel;
  dateGranted?: Maybe<Scalars["Date"]>;
  dateRevoked?: Maybe<Scalars["Date"]>;
  granted?: Maybe<Scalars["Boolean"]>;
  grantedBy?: Maybe<NodeRef>;
  revokedBy?: Maybe<NodeRef>;
  type: GDPRConsentType;
};

export enum GDPRConsentType {
  IntegrationPolicy = "IntegrationPolicy",
  JobMailing = "JobMailing",
  JobMailingCampaignEmail = "JobMailingCampaignEmail",
  JobMailingEmail = "JobMailingEmail",
  JobMailingSms = "JobMailingSms",
  Marketing = "Marketing"
}

export type GDPRInput = {
  communicationChannel: GDPRCommunicationChannel;
  granted: Scalars["Boolean"];
  type: GDPRConsentType;
};

export enum GDPROptionType {
  No = "No",
  NotSpecified = "NotSpecified",
  Yes = "Yes"
}

export type GeneratePresentationAttachmentError = {
  error: Scalars["String"];
  fileId: Scalars["String"];
  filename: Scalars["String"];
};

export type GeneratePresentationResult = {
  attachmentErrors: Array<GeneratePresentationAttachmentError>;
  presentation?: Maybe<ConsultantPresentation>;
};

export type GenericProfession = ConsultantProfession & {
  certifiedFrom?: Maybe<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<GenericSpecialization>;
  systems: Array<Scalars["String"]>;
};

export type GenericProfessionInput = {
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<GenericSpecializationInput>;
  systems: Array<Scalars["String"]>;
};

export type GenericSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type GenericSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type Geolocation = {
  geometry: Geometry;
};

export type Geometry = {
  coordinates: Array<Scalars["Float"]>;
  type: Scalars["String"];
};

export type GetAttestContactPersonsResult = {
  items: Array<ContactPerson>;
  workplaceAllowsDigitalTimereport: Scalars["Boolean"];
};

export type GetTimereportToCustomerEmailResult = {
  Body: Scalars["String"];
  Subject: Scalars["String"];
};

export enum HasBookingKitsFilter {
  False = "False",
  MissingCompleteAndAccruedCost = "MissingCompleteAndAccruedCost",
  MissingCompleteAndAccruedIncome = "MissingCompleteAndAccruedIncome",
  True = "True"
}

export type HealthDeclarationDocument = {
  createdAt: Scalars["Date"];
  id: Scalars["ID"];
  name: Scalars["String"];
  signedAt?: Maybe<Scalars["Date"]>;
  status: Scalars["String"];
  url: Scalars["String"];
};

export enum HealthDeclarationStatus {
  Pending = "Pending",
  Signed = "Signed"
}

export type HealthDeclarationsQueryResult = {
  items: Array<HealthDeclarationDocument>;
  total: Scalars["Int"];
};

export type HighHoliday = {
  _id: Scalars["ObjectId"];
  isGreatHoliday?: Maybe<Scalars["Boolean"]>;
  option: HighHolidayOption;
};

export type HighHolidayInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  isGreatHoliday?: InputMaybe<Scalars["Boolean"]>;
  option: HighHolidayOptionInput;
};

export type HighHolidayOption = {
  _id: Scalars["ObjectId"];
  listPosition?: Maybe<Scalars["Float"]>;
  name?: Maybe<Scalars["String"]>;
};

export type HighHolidayOptionInput = {
  _id: Scalars["ObjectId"];
  listPosition: Scalars["Float"];
  name: Scalars["String"];
};

export enum HospitalityPaidBy {
  Bonliva = "Bonliva",
  Consultant = "Consultant"
}

export type HourlyRatesInput = {
  Day: Scalars["Float"];
  Evening: Scalars["Float"];
  Holiday: Scalars["Float"];
  Night: Scalars["Float"];
  OnCall: Scalars["Float"];
  Weekend: Scalars["Float"];
};

export type IContact = {
  Address?: Maybe<Address>;
  AvatarPic?: Maybe<Scalars["String"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  CellPhoneValid: Scalars["Boolean"];
  Email?: Maybe<Scalars["String"]>;
  EmailValid: Scalars["Boolean"];
  GDPRConsentRecords?: Maybe<Array<Maybe<GDPRConsent>>>;
  Name?: Maybe<Scalars["String"]>;
  Phone?: Maybe<Scalars["String"]>;
  PhoneValid: Scalars["Boolean"];
  ResponsiblePerson?: Maybe<UserRef>;
  Roles?: Maybe<Array<Scalars["String"]>>;
  Title?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ObjectId"]>;
};

export type INode = {
  IsValid?: Maybe<Scalars["Boolean"]>;
  NodeName: Scalars["String"];
  NodeType: NodeType;
  ValidationErrors: Array<NodeValidationError>;
  _id: Scalars["ObjectId"];
};

export type ImportConsultantMeta = {
  importBatch?: Maybe<Scalars["String"]>;
  source?: Maybe<Scalars["JSON"]>;
};

export type ImportConsultantMetaInput = {
  importBatch?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["JSON"]>;
};

export enum InitialContact {
  CreatedByBonliva = "CreatedByBonliva",
  CreatedByWCC = "CreatedByWCC",
  Recommendation = "Recommendation",
  SelfRegister = "SelfRegister"
}

export type Invoice = {
  CustomerName?: Maybe<Scalars["String"]>;
  CustomerNumber?: Maybe<Scalars["String"]>;
  DueDate?: Maybe<Scalars["Date"]>;
  InvoiceDate?: Maybe<Scalars["Date"]>;
  InvoiceNumber: Scalars["String"];
  InvoiceTotal?: Maybe<Scalars["Float"]>;
  IsCredit: Scalars["Boolean"];
  Notes?: Maybe<Scalars["String"]>;
  PreviewUrl: Scalars["String"];
  Provider: InvoiceProvider;
  TotalGross?: Maybe<Scalars["Float"]>;
  TotalNet?: Maybe<Scalars["Float"]>;
  _id: Scalars["ObjectId"];
};

export enum InvoiceMonth {
  FirstMonth = "FirstMonth",
  Full = "Full",
  SecondMonth = "SecondMonth"
}

export enum InvoiceProvider {
  Bonliva = "Bonliva",
  BonlivaCare = "BonlivaCare",
  Fortnox = "Fortnox",
  WCC = "WCC"
}

export enum InvoiceSplitType {
  ByDate = "ByDate",
  ByShift = "ByShift"
}

export enum InvoicingStrategyType {
  CreationDate = "CreationDate",
  ExecutionDate = "ExecutionDate"
}

export type KanbanBoard = {
  _id: Scalars["String"];
  columns: Array<KanbanColumn>;
  name: Scalars["String"];
  owner: User;
  type: KanbanBoardType;
};

export enum KanbanBoardType {
  ConsultantOpportunity = "ConsultantOpportunity",
  ConsultantPipeline = "ConsultantPipeline"
}

export type KanbanCard = {
  _id: Scalars["String"];
  assignee?: Maybe<User>;
  boardId: Scalars["String"];
  columnId: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  order: Scalars["Int"];
  title: Scalars["String"];
};

export type KanbanCardActionPayload = {
  boardId: Scalars["String"];
  cardId: Scalars["String"];
  sessionId: Scalars["String"];
  userId: Scalars["ObjectId"];
};

export type KanbanColumn = {
  _id: Scalars["String"];
  name: Scalars["String"];
  order: Scalars["Int"];
};

export type KitAssignedTo = {
  by?: Maybe<UserRef>;
  on?: Maybe<Scalars["Date"]>;
  to?: Maybe<UserRef>;
};

export enum LanguageSkillLevel {
  Fluent = "Fluent",
  Good = "Good",
  OK = "OK"
}

export enum LastContactType {
  Call = "Call",
  Comment = "Comment",
  Email = "Email",
  Interest = "Interest",
  MetInPerson = "MetInPerson",
  NoCall = "NoCall",
  NoCallAttempts = "NoCallAttempts",
  NoComment = "NoComment",
  NoContactAttempts = "NoContactAttempts",
  Noanswer = "Noanswer",
  Registered = "Registered",
  Reminder = "Reminder",
  SMS = "SMS"
}

export enum LegalBasis {
  Agreement = "Agreement",
  Consent = "Consent",
  InterestAssessment = "InterestAssessment"
}

export enum LegalPersonType {
  Employee = "Employee",
  Subcontractor = "Subcontractor"
}

export enum LegalPersonTypeWithNoOption {
  Employee = "Employee",
  NoOption = "NoOption",
  Subcontractor = "Subcontractor"
}

export type LocationKlm = {
  klm?: InputMaybe<Scalars["String"]>;
  zipOrCity?: InputMaybe<Scalars["String"]>;
};

export type LoginAttempt = {
  Date: Scalars["Date"];
  Ip: Scalars["String"];
  Success: Scalars["Boolean"];
};

export enum LuggageType {
  Handluggage = "Handluggage",
  HandluggagePlusChecked = "HandluggagePlusChecked"
}

export type Me = BaseUser & {
  AvatarPic?: Maybe<Scalars["String"]>;
  AzureGroups?: Maybe<Array<Scalars["String"]>>;
  AzureId?: Maybe<Scalars["String"]>;
  BirthDate?: Maybe<Scalars["Date"]>;
  CallLists: Array<CallList>;
  CellPhone?: Maybe<Scalars["String"]>;
  ContactLists: Array<CallList>;
  Deleted: Scalars["Boolean"];
  Email: Scalars["String"];
  Enabled: Scalars["Boolean"];
  ExtraAreasOfExpertise: Array<Expertise>;
  ManagerId?: Maybe<Scalars["ObjectId"]>;
  Name: Scalars["String"];
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Permissions: UserPermissions;
  Phone?: Maybe<Scalars["String"]>;
  Teams: Array<Scalars["String"]>;
  Title?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
  allowedCostCenters: Array<CostCenter>;
  favoriteTeam?: Maybe<Scalars["String"]>;
  favouriteConsultantIds: Array<Scalars["ObjectId"]>;
  permissions: Array<Scalars["String"]>;
  subordinates: Array<User>;
  todoBadges: TodoUserBadges;
};

export type MePartial = {
  CallLists?: Maybe<Array<CallList>>;
  ContactLists?: Maybe<Array<CallList>>;
};

export type Municipality = {
  _id: Scalars["ObjectId"];
  name: Scalars["String"];
  region: Scalars["String"];
  zone: Scalars["String"];
};

export type Mutation = {
  addAccommodation: Accommodation;
  addAccommodationCommentEvent?: Maybe<AccommodationEvent>;
  addBookingCommentEvent?: Maybe<BookingEvent>;
  addBookingKitCommentEvent?: Maybe<BookingKitEvent>;
  addConsultantAvailability: Consultant;
  addConsultantBookingContract: ConsultantBookingContractListItem;
  addConsultantCallEvent?: Maybe<ConsultantEvent>;
  addConsultantCommentEvent?: Maybe<ConsultantEvent>;
  addConsultantInterestEvent?: Maybe<ConsultantEvent>;
  addConsultantNoanswerEvent?: Maybe<AddNoanswerEventResult>;
  addConsultantReminderEvent?: Maybe<ConsultantEvent>;
  addConsultantSMSEvent?: Maybe<ConsultantEvent>;
  addConsultantTag: Consultant;
  addConsultantWorkExperience: ConsultantWorkExperienceResult;
  addCustomerCommentEvent?: Maybe<CustomerEvent>;
  addCustomerContractCommentEvent: CustomerContractOpResult;
  addCustomerMetInPersonEvent?: Maybe<CustomerEvent>;
  addCustomerReminderEvent?: Maybe<CustomerEvent>;
  addSalaryChoiceToConsultantContract: ConsultantContractListItem;
  addToCallList: CallListOpResult;
  addTodoCommentEvent?: Maybe<TodoEvent>;
  addTodoReminderEvent?: Maybe<TodoEvent>;
  addUnSignConsultantContract: ConsultantContractListItem;
  approveBookingKit: BookingKit;
  approveTimereport?: Maybe<Scalars["Boolean"]>;
  assignContactPersonToCustomer: AssignContactPersonToCustomerResult;
  assignFortnoxInvoiceToBooking: UpdateBookingResult;
  assignTimereportToBooking?: Maybe<Scalars["Boolean"]>;
  assignToBooking: BookingAssignedToResult;
  assignToBookingKit: Scalars["Boolean"];
  assignTodo?: Maybe<TodoItem>;
  bulkAction: BulkActionResult;
  bulkUpdateResponsiblePerson: BulkUpdateResult;
  cancelBooking?: Maybe<Scalars["Boolean"]>;
  cancelBookingGroup?: Maybe<Scalars["Boolean"]>;
  changeConsultantServicePreferenceStatus: ConsultantServicePreference;
  changeStatusConsultantReference: ConsultantReferenceNew;
  clearConsultantResponsiblePerson: Consultant;
  clearQualityItemStatus: Consultant;
  clearTimereportDays?: Maybe<Scalars["Boolean"]>;
  cloneBooking: Scalars["ObjectId"];
  confirmAccommodation: BookingHospitality;
  confirmTravel: BookingHospitality;
  consultantExportBulkAction: BulkActionResult;
  consultantExportSsnBulkAction: BulkActionResult;
  consultantGeneratePresentation: GeneratePresentationResult;
  consultantImportDeduplicate: Array<ConsultantImportRow>;
  consultantImportLookupRows: Array<ConsultantImportRow>;
  createAccommodationRequest: AccommodationRequest;
  createApiToken: CreateApiTokenResult;
  createBookingGroup: BookingGroup;
  createBookingKit: BookingKit;
  createCallList: CallListOpResult;
  createConsultantOpportunity: ConsultantOpportunity;
  createConsultantReference: ConsultantReferenceNew;
  createConsultantServicePreference: ConsultantServicePreference;
  createConsultantWorkStatus: ConsultantWorkStatus;
  createContactPerson: CreateContactPersonResult;
  createCostCenter: CostCenterConfigItem;
  createCustomer: CreateCustomerResult;
  createDirectRequestContract: CustomerContractOpResult;
  createTgRequirement: TgRequirement;
  createTravelRequest: TravelRequest;
  deassignContactPersonFromCustomers: ContactPerson;
  deleteAccommodation: Accommodation;
  deleteAccommodationDocument?: Maybe<Scalars["Boolean"]>;
  deleteAccommodationEvent?: Maybe<AccommodationEvent>;
  deleteBookingDocument: Scalars["Boolean"];
  deleteBookingEvent?: Maybe<BookingEvent>;
  deleteBookingKit?: Maybe<Scalars["Boolean"]>;
  deleteBookingKitEvent?: Maybe<BookingKitEvent>;
  deleteConsultantAvailability: Consultant;
  deleteConsultantBookingContract: ConsultantBookingContract;
  deleteConsultantContract: ConsultantContract;
  deleteConsultantEvent?: Maybe<ConsultantEvent>;
  deleteConsultantOpportunity: Scalars["Boolean"];
  deleteConsultantReference: Scalars["Boolean"];
  deleteConsultantServicePreference: Scalars["Boolean"];
  deleteConsultantWorkStatus: Scalars["Boolean"];
  deleteConsultants?: Maybe<Total>;
  deleteContactPerson: Scalars["Boolean"];
  deleteContractPriceTemplate: ContractPriceTemplateOpResult;
  deleteCostCenter: CostCenterConfigItem;
  deleteCustomer: Customer;
  deleteCustomerContractDocument: CustomerContractOpResult;
  deleteCustomerContractEvent: CustomerContractOpResult;
  deleteCustomerContractSnapshot: CustomerContractSnapshotOpResult;
  deleteCustomerContractSubVersion: CustomerContractOpResult;
  deleteCustomerDocument: Array<CustomerDocument>;
  deleteCustomerEvent?: Maybe<Scalars["Boolean"]>;
  deleteRestoreCustomerContract: CustomerContractOpResult;
  deleteTgRequirement: Scalars["Boolean"];
  deleteTodoEvent?: Maybe<TodoEvent>;
  duplicateConsultantToTenant?: Maybe<Scalars["String"]>;
  duplicateContractPriceTemplate: ContractPriceTemplateOpResult;
  editAccommodation: Accommodation;
  editConsultantBookingContract: ConsultantBookingContractListItem;
  editConsultantOpportunity: Scalars["Boolean"];
  editUnSignConsultantContract: ConsultantContractListItem;
  extractContactPerson: ExtractContactPersonResult;
  finaliseConsultantOpportunity: FinaliseConsultantOpportunityResult;
  generateCustomerContractSnapshot: CustomerContractSnapshotOpResult;
  importCV: ConsultantForm;
  importConsultants: ConsultantImportDocumentResult;
  leaveCallList: CallListOpResult;
  mergeConsultantReference: ConsultantReferenceNew;
  moveCard: Scalars["Boolean"];
  moveCustomer: UpdateMoveCustomerResult;
  nullifyConsultantBookingContract: ConsultantBookingContractListItem;
  nullifyConsultantContract: ConsultantContractListItem;
  nullifyCustomerContractSnapshot: CustomerContractSnapshotOpResult;
  pinAccommodationEvent?: Maybe<AccommodationEvent>;
  pinConsultantEvent?: Maybe<ConsultantEvent>;
  publishBookingContract: PublishContractResult;
  publishContract: PublishContractResult;
  publishContractViaWorkflow: PublishContractResult;
  publishCustomerContractSnapshot: Scalars["String"];
  publishPayFormRecordsToFortnox: WorkflowRun;
  publishSickPayFormToFortnox: WorkflowRun;
  publishSubcontractorInvoiceWorkflow: WorkflowRun;
  reSendConsultantReferenceForm: ConsultantReferenceNew;
  reactivateQualityItem: Consultant;
  refreshFortnoxSalaryCache: FortnoxSalaryCache;
  rejectBookingKit: BookingKit;
  rejectDoneBookingKit: BookingKit;
  removeAccommodationDocument?: Maybe<Scalars["Boolean"]>;
  removeConsultantAvatar?: Maybe<Consultant>;
  removeConsultantDocument: Scalars["Boolean"];
  removeConsultantTag: Consultant;
  removeCustomerAvatar?: Maybe<Customer>;
  removeCustomerContractPriceList: CustomerContractOpResult;
  removeFromCallList: CallListOpResult;
  removeSearchProfile: Scalars["Int"];
  removeSharedFile: Scalars["Boolean"];
  removeTravelDocument?: Maybe<Scalars["Boolean"]>;
  renameCallList: CallListOpResult;
  requestUpdToKvkConsultantReference: SendToKvkConsultantReferencePayload;
  resetConsultantUnfit: Consultant;
  restoreConsultantReference: ConsultantReferenceNew;
  restoreCostCenter: CostCenterConfigItem;
  resyncInvoice?: Maybe<Invoice>;
  revokeApiToken: ApiToken;
  runAutoCreateBookingKit: Scalars["Boolean"];
  saveConsultantSelection: SaveConsultantsResult;
  saveHSAIDStatusParams: Consultant;
  saveToFavouriteContractPriceTemplate: ContractPriceTemplateOpResult;
  sendBookingKitToOc: BookingKit;
  sendConsultantBookingContractEmailToBA?: Maybe<EmailResult>;
  sendConsultantContractEmailToConsultant?: Maybe<SendEmailToConsultantResult>;
  sendConsultantPresentation: Scalars["Boolean"];
  sendConsultantReferenceForm: ConsultantReferenceNew;
  sendConsultantToMedlo: SendConsultantToMedloResult;
  sendEmail?: Maybe<Scalars["String"]>;
  sendEmailToConsultant?: Maybe<SendEmailToConsultantResult>;
  sendMassEmail: SendMassEmailResult;
  sendMassSMSToConsultants: SendMassSMSToConsultantsResult;
  sendRequestIVO: Consultant;
  sendTimereportToConsultant?: Maybe<Scalars["String"]>;
  sendTimereportToCustomer?: Maybe<EmailResult>;
  sendToKvkConsultantReference: SendToKvkConsultantReferencePayload;
  setBookedStatus: Consultant;
  setBookingAdditionalPayout: Booking;
  setBookingCallNumber?: Maybe<Scalars["Boolean"]>;
  setCallListMembers: CallListOpResult;
  setConsultantNextContactDate: Scalars["Boolean"];
  setConsultantPipelineStatus: Consultant;
  setConsultantPipelineStatusComment: Consultant;
  setConsultantResponsiblePerson: Consultant;
  setConsultantResponsibleStatus: Consultant;
  setConsultantUnfit: Consultant;
  setConsultantWelcomeEmailSent: Consultant;
  setCustomerContractInvoiceStrategy: CustomerContractOpResult;
  setCustomerRecommendedPrices: Customer;
  setOrderedStatus: Consultant;
  setQualityItemApprovedStatus: Consultant;
  setQualityItemApprovedWithCommentStatus: Consultant;
  setQualityItemPausedStatus: Consultant;
  setQualityItemRequestReceivedStatus: Consultant;
  setQualityItemRequestSentIVOStatus: Consultant;
  setQualityItemRequestSentStatus: Consultant;
  setSkipTimereportReminder: BookingSkipTimereportReminderResults;
  setSupportTagToBooking: Array<BookingSupportTagStatus>;
  setTimereportToDraft?: Maybe<TimereportResult>;
  setTimereportToSubmitted?: Maybe<Scalars["Boolean"]>;
  setTodoStatus?: Maybe<TodoItem>;
  setUnlockBookingForms: UnlockFormsResult;
  submitConsultantForm: ConsultantFormResult;
  submitConsultantKarens: Consultant;
  submitContractPriceTemplateForm: ContractPriceTemplateOpResult;
  submitCustomerContractForm: CustomerContractOpResult;
  submitCustomerContractInfo: CustomerContractOpResult;
  submitCustomerContractPriceListForm: CustomerContractOpResult;
  submitCustomerContractSnapshotForm: CustomerContractSnapshotOpResult;
  submitCustomerContractSubVersionForm: CustomerContractOpResult;
  submitFortnoxVoucher?: Maybe<FortnoxVoucherSubmitResult>;
  submitSearchProfileForm: SearchProfile;
  syncTimeReportsWithBookingSearch: Array<Scalars["String"]>;
  toggleAccommodationConfirmation?: Maybe<BookingHospitality>;
  toggleConsultantFavourite: Scalars["Boolean"];
  toggleCostCenterActive: CostCenterConfigItem;
  toggleCustomerNoApproval: Customer;
  toggleCustomerSettings: Customer;
  toggleTravelConfirmation?: Maybe<BookingHospitality>;
  transitionConsultantQualityItem: Consultant;
  unAssignFromBookingKit: Scalars["Boolean"];
  unAssignToBooking: BookingAssignedToResult;
  unsetConsultantNextContactDate: Scalars["Boolean"];
  updateAccommodationConfirmation?: Maybe<Scalars["Boolean"]>;
  updateAccommodationEvent?: Maybe<AccommodationEvent>;
  updateBookingAudit?: Maybe<Scalars["Boolean"]>;
  updateBookingEvent?: Maybe<BookingEvent>;
  updateBookingFinance: Booking;
  updateBookingGroup: BookingGroup;
  updateBookingKit: BookingKit;
  updateBookingKitEvent?: Maybe<BookingKitEvent>;
  updateBookingKitTags: Array<BookingSupportTagStatus>;
  updateBookingProject: UpdateBookingResult;
  updateCommentForBookingAudit?: Maybe<Scalars["Boolean"]>;
  updateConsultantEvent?: Maybe<ConsultantEvent>;
  updateConsultantGDPR?: Maybe<Consultant>;
  updateConsultantGeneralInterest: Consultant;
  updateConsultantLeadStatus: Consultant;
  updateConsultantQualityNote: Scalars["Boolean"];
  updateConsultantReference: ConsultantReferenceNew;
  updateConsultantServicePreference: ConsultantServicePreference;
  updateConsultantStatus?: Maybe<Consultant>;
  updateConsultantUserSettings?: Maybe<Consultant>;
  updateConsultantWorkStatus: ConsultantWorkStatus;
  updateContactPerson: UpdateContactPersonResult;
  updateCostCenter: CostCenterConfigItem;
  updateCustomer: UpdateCustomerResult;
  updateCustomerContractEvent: CustomerContractOpResult;
  updateCustomerEvent?: Maybe<CustomerEvent>;
  updateCustomerRefsSearchProfiles: Array<SearchProfile>;
  updateFavoriteTeam?: Maybe<Me>;
  updateSharedFile: SharedFile;
  updateTgRequirement: TgRequirement;
  updateTodoEvent?: Maybe<TodoEvent>;
  updateTravelConfirmation?: Maybe<Scalars["Boolean"]>;
  updateUnfitAccommodation: AccommodationUnfit;
  uploadAccommodationDocument: Document;
  uploadBlob: Scalars["String"];
  uploadBookingDocument: UploadBookingDocumentResult;
  uploadConsultantAvatar?: Maybe<Consultant>;
  /** @deprecated Use uploadConsultantDocuments */
  uploadConsultantDocument: Document;
  uploadConsultantDocuments: Array<Document>;
  uploadCustomerAvatar?: Maybe<Customer>;
  uploadCustomerBgPic?: Maybe<Customer>;
  uploadCustomerContractDocument: CustomerContractOpResult;
  uploadCustomerContractSignedDocument: CustomerContractSnapshotOpResult;
  uploadCustomerDocument: Array<CustomerDocument>;
  uploadDocument: Document;
  uploadSharedFile: SharedFile;
  uploadSignedConsultantBookingContract: ConsultantBookingContractListItem;
  uploadSignedConsultantContract: ConsultantContractListItem;
};

export type MutationAddAccommodationArgs = {
  data: AccommodationInput;
  img?: InputMaybe<Scalars["Upload"]>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationAddAccommodationCommentEventArgs = {
  accommodationId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddBookingCommentEventArgs = {
  bookingId: Scalars["ObjectId"];
  desc: Scalars["String"];
};

export type MutationAddBookingKitCommentEventArgs = {
  desc: Scalars["String"];
  kitId: Scalars["ObjectId"];
};

export type MutationAddConsultantAvailabilityArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantAvailabilityInput;
};

export type MutationAddConsultantBookingContractArgs = {
  consultantId: Scalars["ObjectId"];
  data: ConsultantBookingContractFormInput;
};

export type MutationAddConsultantCallEventArgs = {
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
};

export type MutationAddConsultantCommentEventArgs = {
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddConsultantInterestEventArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationAddConsultantNoanswerEventArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationAddConsultantReminderEventArgs = {
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddConsultantSMSEventArgs = {
  consultantId: Scalars["ObjectId"];
  desc: Scalars["String"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddConsultantTagArgs = {
  consultantId: Scalars["ObjectId"];
  tag: Scalars["String"];
};

export type MutationAddConsultantWorkExperienceArgs = {
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
  data: ConsultantWorkExperienceItemInput;
};

export type MutationAddCustomerCommentEventArgs = {
  input: CustomerEventInput;
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddCustomerContractCommentEventArgs = {
  customerContractId: Scalars["ObjectId"];
  eventLog: CustomerContractEventInput;
};

export type MutationAddCustomerMetInPersonEventArgs = {
  input: CustomerEventInput;
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddCustomerReminderEventArgs = {
  input: CustomerEventInput;
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddSalaryChoiceToConsultantContractArgs = {
  contractId: Scalars["ObjectId"];
  salaryChoice: ContractType;
};

export type MutationAddToCallListArgs = {
  callListId: Scalars["ObjectId"];
  node: NodeRefFullInput;
};

export type MutationAddTodoCommentEventArgs = {
  desc: Scalars["String"];
  todoId: Scalars["ObjectId"];
};

export type MutationAddTodoReminderEventArgs = {
  desc: Scalars["String"];
  todoId: Scalars["ObjectId"];
  withTodo?: InputMaybe<WithTodoInput>;
};

export type MutationAddUnSignConsultantContractArgs = {
  consultantId: Scalars["ObjectId"];
  data: ConsultantContractFormInput;
};

export type MutationApproveBookingKitArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationApproveTimereportArgs = {
  approvedBy: Scalars["String"];
  timereportId: Scalars["ObjectId"];
};

export type MutationAssignContactPersonToCustomerArgs = {
  contactPersonId: Scalars["ObjectId"];
  customerId: Scalars["ObjectId"];
};

export type MutationAssignFortnoxInvoiceToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  isGroupInvoicing?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationAssignTimereportToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  timeReportId: Scalars["ObjectId"];
};

export type MutationAssignToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationAssignToBookingKitArgs = {
  kitId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationAssignTodoArgs = {
  todoId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationBulkActionArgs = {
  input: BulkActionInput;
};

export type MutationBulkUpdateResponsiblePersonArgs = {
  ids: Array<Scalars["ObjectId"]>;
  responsiblePersonId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationCancelBookingArgs = {
  bookingId: Scalars["ObjectId"];
  reason: Scalars["String"];
};

export type MutationCancelBookingGroupArgs = {
  bookingGroupId: Scalars["ObjectId"];
  reason: Scalars["String"];
};

export type MutationChangeConsultantServicePreferenceStatusArgs = {
  id: Scalars["ObjectId"];
  status: ConsultantServicePreferenceStatus;
};

export type MutationChangeStatusConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  file?: InputMaybe<Scalars["Upload"]>;
  input?: InputMaybe<ChangeStatusConsultantReferenceInput>;
};

export type MutationClearConsultantResponsiblePersonArgs = {
  consultantId: Scalars["ObjectId"];
  setLeadStatus?: InputMaybe<ConsultantLeadStatus>;
};

export type MutationClearQualityItemStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
};

export type MutationClearTimereportDaysArgs = {
  timeReportId: Scalars["ObjectId"];
};

export type MutationCloneBookingArgs = {
  bookingId: Scalars["ObjectId"];
};

export type MutationConfirmAccommodationArgs = {
  input: ConfirmAccommodationInput;
};

export type MutationConfirmTravelArgs = {
  input: ConfirmTravelInput;
};

export type MutationConsultantExportBulkActionArgs = {
  filter: ConsultantsQueryInput;
};

export type MutationConsultantExportSsnBulkActionArgs = {
  filter: ConsultantsQueryInput;
};

export type MutationConsultantGeneratePresentationArgs = {
  consultantId: Scalars["ObjectId"];
  contactPerson?: InputMaybe<Scalars["String"]>;
  evaluatesIds: Array<Scalars["ObjectId"]>;
  evaluatesThreeMonthsIds: Array<Scalars["ObjectId"]>;
  fileIds: Array<Scalars["ObjectId"]>;
  generateCV?: InputMaybe<Scalars["Boolean"]>;
  presentationCountry: ConsultantPresentationCountry;
  presentationText?: InputMaybe<Scalars["String"]>;
  presentationType: ConsultantPresentationType;
  referenceIds: Array<Scalars["ObjectId"]>;
};

export type MutationConsultantImportDeduplicateArgs = {
  rows: Array<ConsultantImportRowsInput>;
};

export type MutationConsultantImportLookupRowsArgs = {
  rows: Array<ConsultantImportRowsInput>;
};

export type MutationCreateAccommodationRequestArgs = {
  bookingGroupId?: InputMaybe<Scalars["ObjectId"]>;
  bookingIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  data: AccommodationRequestInput;
  file?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateApiTokenArgs = {
  name: Scalars["String"];
};

export type MutationCreateBookingGroupArgs = {
  duplicateFromBookingId?: InputMaybe<Scalars["ObjectId"]>;
  input: BookingGroupInput;
};

export type MutationCreateBookingKitArgs = {
  input: CreateBookingKitInput;
};

export type MutationCreateCallListArgs = {
  data: CallListCreateInput;
  type: CallListType;
};

export type MutationCreateConsultantOpportunityArgs = {
  input: CreateConsultantOpportunityInput;
};

export type MutationCreateConsultantReferenceArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantReferenceInputNew;
};

export type MutationCreateConsultantServicePreferenceArgs = {
  consultantId: Scalars["ObjectId"];
  input: CreateConsultantServicePreferenceInput;
};

export type MutationCreateConsultantWorkStatusArgs = {
  consultantId: Scalars["ObjectId"];
  input: CreateConsultantWorkStatusInput;
};

export type MutationCreateContactPersonArgs = {
  data: ContactPersonInput;
};

export type MutationCreateCostCenterArgs = {
  input: CreateCostCenterInput;
};

export type MutationCreateCustomerArgs = {
  input: CustomerInput;
};

export type MutationCreateDirectRequestContractArgs = {
  data: CreateDirectRequestContractInput;
};

export type MutationCreateTgRequirementArgs = {
  input: CreateTgRequirementInput;
};

export type MutationCreateTravelRequestArgs = {
  bookingGroupId?: InputMaybe<Scalars["ObjectId"]>;
  bookingIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  data: TravelRequestInput;
};

export type MutationDeassignContactPersonFromCustomersArgs = {
  contactPersonId: Scalars["ObjectId"];
  customerIds: Array<Scalars["ObjectId"]>;
};

export type MutationDeleteAccommodationArgs = {
  accommodationId: Scalars["ObjectId"];
};

export type MutationDeleteAccommodationDocumentArgs = {
  fileId: Scalars["ObjectId"];
  id: Scalars["ObjectId"];
};

export type MutationDeleteAccommodationEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteBookingDocumentArgs = {
  bookingId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationDeleteBookingEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteBookingKitArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteBookingKitEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantAvailabilityArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantAvailabilityInput;
};

export type MutationDeleteConsultantBookingContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantOpportunityArgs = {
  issueId: Scalars["ObjectId"];
};

export type MutationDeleteConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  softDelete: Scalars["Boolean"];
};

export type MutationDeleteConsultantServicePreferenceArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteConsultantWorkStatusArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteConsultantsArgs = {
  ids: Array<Scalars["ObjectId"]>;
};

export type MutationDeleteContactPersonArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteContractPriceTemplateArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteCostCenterArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteCustomerArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteCustomerContractDocumentArgs = {
  customerContractId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerContractEventArgs = {
  customerContractId: Scalars["ObjectId"];
  eventLogId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerContractSnapshotArgs = {
  snapshotId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerContractSubVersionArgs = {
  subVersionId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerDocumentArgs = {
  customerId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationDeleteCustomerEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDeleteRestoreCustomerContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationDeleteTgRequirementArgs = {
  id: Scalars["ObjectId"];
};

export type MutationDeleteTodoEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationDuplicateConsultantToTenantArgs = {
  id: Scalars["ObjectId"];
  toTenant: Scalars["String"];
};

export type MutationDuplicateContractPriceTemplateArgs = {
  data: ContractPriceTemplateInput;
};

export type MutationEditAccommodationArgs = {
  accommodationId: Scalars["ObjectId"];
  data: AccommodationInput;
  img?: InputMaybe<Scalars["Upload"]>;
};

export type MutationEditConsultantBookingContractArgs = {
  contractId: Scalars["ObjectId"];
  data: ConsultantBookingContractFormInput;
};

export type MutationEditConsultantOpportunityArgs = {
  input: EditConsultantOpportunityInput;
  issueId: Scalars["ObjectId"];
};

export type MutationEditUnSignConsultantContractArgs = {
  contractId: Scalars["ObjectId"];
  data: ConsultantContractFormInput;
};

export type MutationExtractContactPersonArgs = {
  contactPersonId: Scalars["ObjectId"];
  customerId?: InputMaybe<Scalars["ObjectId"]>;
  data: ContactPersonInput;
};

export type MutationFinaliseConsultantOpportunityArgs = {
  issueId: Scalars["ObjectId"];
  weeksWon: Array<Scalars["Date"]>;
};

export type MutationGenerateCustomerContractSnapshotArgs = {
  snapshotId: Scalars["ObjectId"];
};

export type MutationImportCVArgs = {
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
  file: Scalars["Upload"];
};

export type MutationImportConsultantsArgs = {
  bisnodeLookup?: InputMaybe<Scalars["Boolean"]>;
  checkForDuplicates?: InputMaybe<Scalars["Boolean"]>;
  file: Scalars["Upload"];
};

export type MutationLeaveCallListArgs = {
  callListId: Scalars["ObjectId"];
};

export type MutationMergeConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  mergeWithRefId: Scalars["ObjectId"];
};

export type MutationMoveCardArgs = {
  beforeCardId?: InputMaybe<Scalars["String"]>;
  boardId: Scalars["String"];
  boardType: KanbanBoardType;
  cardId: Scalars["String"];
  columnId: Scalars["String"];
  sessionId?: InputMaybe<Scalars["String"]>;
};

export type MutationMoveCustomerArgs = {
  id: Scalars["ObjectId"];
  parentId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationNullifyConsultantBookingContractArgs = {
  contractId: Scalars["ObjectId"];
  nullify: Scalars["Boolean"];
};

export type MutationNullifyConsultantContractArgs = {
  contractId: Scalars["ObjectId"];
  nullificationReason?: InputMaybe<Scalars["String"]>;
  nullify: Scalars["Boolean"];
};

export type MutationNullifyCustomerContractSnapshotArgs = {
  nullify: Scalars["Boolean"];
  snapshotId: Scalars["ObjectId"];
};

export type MutationPinAccommodationEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationPinConsultantEventArgs = {
  eventId: Scalars["ObjectId"];
};

export type MutationPublishBookingContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationPublishContractArgs = {
  contractId: Scalars["ObjectId"];
};

export type MutationPublishContractViaWorkflowArgs = {
  contractId: Scalars["ObjectId"];
  forcePublish?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationPublishCustomerContractSnapshotArgs = {
  snapshotId: Scalars["ObjectId"];
};

export type MutationPublishPayFormRecordsToFortnoxArgs = {
  bookingId: Scalars["ObjectId"];
  weekDay?: InputMaybe<Scalars["Int"]>;
};

export type MutationPublishSickPayFormToFortnoxArgs = {
  bookingId: Scalars["ObjectId"];
  weekDay?: InputMaybe<Scalars["Int"]>;
};

export type MutationPublishSubcontractorInvoiceWorkflowArgs = {
  bookingId: Scalars["ObjectId"];
};

export type MutationReSendConsultantReferenceFormArgs = {
  consultantReferenceId: Scalars["ObjectId"];
};

export type MutationReactivateQualityItemArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationRefreshFortnoxSalaryCacheArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationRejectBookingKitArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationRejectDoneBookingKitArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationRemoveAccommodationDocumentArgs = {
  bookingId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationRemoveConsultantAvatarArgs = {
  id: Scalars["ObjectId"];
};

export type MutationRemoveConsultantDocumentArgs = {
  documentId: Scalars["ObjectId"];
};

export type MutationRemoveConsultantTagArgs = {
  consultantId: Scalars["ObjectId"];
  tag: Scalars["String"];
};

export type MutationRemoveCustomerAvatarArgs = {
  id: Scalars["ObjectId"];
};

export type MutationRemoveCustomerContractPriceListArgs = {
  priceListId: Scalars["ObjectId"];
};

export type MutationRemoveFromCallListArgs = {
  callListId: Scalars["ObjectId"];
  nodeId: Scalars["ObjectId"];
};

export type MutationRemoveSearchProfileArgs = {
  searchProfileId: Scalars["ObjectId"];
};

export type MutationRemoveSharedFileArgs = {
  fileId: Scalars["ObjectId"];
};

export type MutationRemoveTravelDocumentArgs = {
  bookingId: Scalars["ObjectId"];
  fileId: Scalars["ObjectId"];
};

export type MutationRenameCallListArgs = {
  callListId: Scalars["ObjectId"];
  newName: Scalars["String"];
};

export type MutationRequestUpdToKvkConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  input: TodoItemInput;
};

export type MutationResetConsultantUnfitArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationRestoreConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
};

export type MutationRestoreCostCenterArgs = {
  id: Scalars["ObjectId"];
};

export type MutationResyncInvoiceArgs = {
  number: Scalars["String"];
  provider: InvoiceProvider;
};

export type MutationRevokeApiTokenArgs = {
  id: Scalars["ID"];
};

export type MutationRunAutoCreateBookingKitArgs = {
  bookingId: Scalars["ObjectId"];
};

export type MutationSaveConsultantSelectionArgs = {
  bisnodeLookup?: InputMaybe<Scalars["Boolean"]>;
  rows: Array<InputMaybe<ConsultantImportRowsInput>>;
};

export type MutationSaveHSAIDStatusParamsArgs = {
  cardNumber: Scalars["String"];
  cardType: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  hsaidNumber: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSaveToFavouriteContractPriceTemplateArgs = {
  data: ContractPriceTemplateInput;
};

export type MutationSendBookingKitToOcArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationSendConsultantBookingContractEmailToBAArgs = {
  attachment?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  body: Scalars["String"];
  recipients?: InputMaybe<Array<EmailRecipientInput>>;
  subject: Scalars["String"];
};

export type MutationSendConsultantContractEmailToConsultantArgs = {
  attachment?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  subject: Scalars["String"];
};

export type MutationSendConsultantPresentationArgs = {
  attachments?: InputMaybe<Array<Scalars["ObjectId"]>>;
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  presentationId: Scalars["ObjectId"];
  recipients: Array<EmailRecipientInput>;
  subject: Scalars["String"];
};

export type MutationSendConsultantReferenceFormArgs = {
  consultantReferenceId: Scalars["ObjectId"];
};

export type MutationSendConsultantToMedloArgs = {
  consultantId: Scalars["ObjectId"];
  crmCv?: InputMaybe<Scalars["Boolean"]>;
  cvDocuments?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
};

export type MutationSendEmailArgs = {
  input?: InputMaybe<EmailInput>;
};

export type MutationSendEmailToConsultantArgs = {
  attachment?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  subject: Scalars["String"];
};

export type MutationSendMassEmailArgs = {
  attachment?: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]>>>;
  body: Scalars["String"];
  campaign?: InputMaybe<Scalars["Boolean"]>;
  nodeIds: Array<Scalars["ObjectId"]>;
  nodeType: NodeType;
  subject: Scalars["String"];
};

export type MutationSendMassSMSToConsultantsArgs = {
  consultantIds: Array<Scalars["ObjectId"]>;
  message: Scalars["String"];
};

export type MutationSendRequestIVOArgs = {
  body: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  from?: InputMaybe<Scalars["String"]>;
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
  subject: Scalars["String"];
};

export type MutationSendTimereportToConsultantArgs = {
  bookingId: Scalars["ObjectId"];
  timereportTemplate?: InputMaybe<TimeReportTemplateType>;
};

export type MutationSendTimereportToCustomerArgs = {
  bookingId: Scalars["ObjectId"];
  emailInput: EmailInput;
  fileName: Scalars["String"];
  templateType: TimeReportTemplateType;
  timeReportId: Scalars["ObjectId"];
};

export type MutationSendToKvkConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  input: TodoItemInput;
};

export type MutationSetBookedStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetBookingAdditionalPayoutArgs = {
  amount?: InputMaybe<Scalars["Float"]>;
  bookingId: Scalars["ObjectId"];
  description?: InputMaybe<Scalars["String"]>;
};

export type MutationSetBookingCallNumberArgs = {
  bookingId: Scalars["ObjectId"];
  callNumber: Scalars["String"];
};

export type MutationSetCallListMembersArgs = {
  callListId: Scalars["ObjectId"];
  userIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type MutationSetConsultantNextContactDateArgs = {
  consultantId: Scalars["ObjectId"];
  date: Scalars["Date"];
  reason: Scalars["String"];
  reasonComment?: InputMaybe<Scalars["String"]>;
};

export type MutationSetConsultantPipelineStatusArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  leadStatus?: InputMaybe<ConsultantLeadStatus>;
  nextContactDate?: InputMaybe<Scalars["Date"]>;
  nextContactDateReason?: InputMaybe<Scalars["String"]>;
  pipelineStatus: ConsultantPipelineStatus;
};

export type MutationSetConsultantPipelineStatusCommentArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
};

export type MutationSetConsultantResponsiblePersonArgs = {
  consultantId: Scalars["ObjectId"];
  setLeadStatus?: InputMaybe<ConsultantLeadStatus>;
};

export type MutationSetConsultantResponsibleStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetConsultantUnfitArgs = {
  comment: Scalars["String"];
  consultantId: Scalars["ObjectId"];
  unfitType: ConsultantUnfitType;
};

export type MutationSetConsultantWelcomeEmailSentArgs = {
  consultantId: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationSetCustomerContractInvoiceStrategyArgs = {
  customerContractId: Scalars["ObjectId"];
  type: InvoicingStrategyType;
};

export type MutationSetCustomerRecommendedPricesArgs = {
  customerId: Scalars["ObjectId"];
  prices: Array<CustomerRecommendedPriceInput>;
};

export type MutationSetOrderedStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
  todo?: InputMaybe<TodoInput>;
};

export type MutationSetQualityItemApprovedStatusArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  params?: InputMaybe<Scalars["JSON"]>;
  qualityCheckName: Scalars["String"];
  sendEmail?: InputMaybe<Scalars["Boolean"]>;
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemApprovedWithCommentStatusArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  params?: InputMaybe<Scalars["JSON"]>;
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemPausedStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemRequestReceivedStatusArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  params?: InputMaybe<Scalars["JSON"]>;
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemRequestSentIVOStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationSetQualityItemRequestSentStatusArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  params?: InputMaybe<Scalars["JSON"]>;
  qualityCheckName: Scalars["String"];
  setOn?: InputMaybe<Scalars["Date"]>;
  todo?: InputMaybe<TodoInput>;
};

export type MutationSetSkipTimereportReminderArgs = {
  bookingId: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationSetSupportTagToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  comment?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Array<Scalars["String"]>>;
};

export type MutationSetTimereportToDraftArgs = {
  approvedBy: Scalars["String"];
  approvedId: Scalars["String"];
  bookingId: Scalars["ObjectId"];
};

export type MutationSetTimereportToSubmittedArgs = {
  submittedBy: Scalars["String"];
  timereportId: Scalars["ObjectId"];
};

export type MutationSetTodoStatusArgs = {
  status: TodoStatus;
  todoId: Scalars["ObjectId"];
};

export type MutationSetUnlockBookingFormsArgs = {
  bookingId: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationSubmitConsultantFormArgs = {
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
  data: ConsultantFormInput;
  file?: InputMaybe<Scalars["Upload"]>;
};

export type MutationSubmitConsultantKarensArgs = {
  consultantId: Scalars["ObjectId"];
  data: ConsultantKarensInput;
};

export type MutationSubmitContractPriceTemplateFormArgs = {
  contractPriceTemplateId?: InputMaybe<Scalars["ObjectId"]>;
  data: ContractPriceTemplateInput;
};

export type MutationSubmitCustomerContractFormArgs = {
  customerContractId?: InputMaybe<Scalars["ObjectId"]>;
  data: CustomerContractFormInput;
};

export type MutationSubmitCustomerContractInfoArgs = {
  customerContractId: Scalars["ObjectId"];
  info: Scalars["String"];
};

export type MutationSubmitCustomerContractPriceListFormArgs = {
  customerContractId: Scalars["ObjectId"];
  data: PriceListFormInput;
  priceListId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationSubmitCustomerContractSnapshotFormArgs = {
  data: CustomerContractSnapshotFormInput;
  snapshotId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationSubmitCustomerContractSubVersionFormArgs = {
  customerContractId: Scalars["ObjectId"];
  data: SubVersionFormInput;
  file?: InputMaybe<Scalars["Upload"]>;
  subVersionId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationSubmitFortnoxVoucherArgs = {
  date: Scalars["String"];
  description: Scalars["String"];
  provider: InvoiceProvider;
};

export type MutationSubmitSearchProfileFormArgs = {
  data: SearchProfileFormInput;
  searchProfileId?: InputMaybe<Scalars["ObjectId"]>;
};

export type MutationSyncTimeReportsWithBookingSearchArgs = {
  bookingIds: Array<Scalars["String"]>;
};

export type MutationToggleAccommodationConfirmationArgs = {
  bookingId: Scalars["ObjectId"];
  confirmationId: Scalars["ObjectId"];
};

export type MutationToggleConsultantFavouriteArgs = {
  consultantId: Scalars["ObjectId"];
};

export type MutationToggleCostCenterActiveArgs = {
  id: Scalars["ObjectId"];
};

export type MutationToggleCustomerNoApprovalArgs = {
  documentType: CustomerDocumentTypes;
  file?: InputMaybe<Scalars["Upload"]>;
  id: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationToggleCustomerSettingsArgs = {
  id: Scalars["ObjectId"];
  key: CustomerSettingsKey;
  value: Scalars["Boolean"];
};

export type MutationToggleTravelConfirmationArgs = {
  bookingId: Scalars["ObjectId"];
  confirmationId: Scalars["ObjectId"];
};

export type MutationTransitionConsultantQualityItemArgs = {
  consultantId: Scalars["ObjectId"];
  qualityCheck: Scalars["String"];
  qualityTemplate: Scalars["String"];
  transition: Scalars["String"];
  transitionParams?: InputMaybe<Scalars["JSON"]>;
};

export type MutationUnAssignFromBookingKitArgs = {
  kitId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationUnAssignToBookingArgs = {
  bookingId: Scalars["ObjectId"];
  userId: Scalars["ObjectId"];
};

export type MutationUnsetConsultantNextContactDateArgs = {
  consultantId: Scalars["ObjectId"];
  nextPipelineStatus: Scalars["String"];
};

export type MutationUpdateAccommodationConfirmationArgs = {
  id: Scalars["ObjectId"];
  input: ConfirmAccommodationInput;
};

export type MutationUpdateAccommodationEventArgs = {
  desc: Scalars["String"];
  eventId: Scalars["ObjectId"];
  sticky?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateBookingAuditArgs = {
  approved: Scalars["Boolean"];
  bookingId: Scalars["ObjectId"];
};

export type MutationUpdateBookingEventArgs = {
  desc?: InputMaybe<Scalars["String"]>;
  eventId: Scalars["ObjectId"];
  sticky?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateBookingFinanceArgs = {
  bookingId: Scalars["ObjectId"];
  data: UpdateBookingFinanceInput;
};

export type MutationUpdateBookingGroupArgs = {
  bookingGroupId: Scalars["ObjectId"];
  input: BookingGroupInput;
};

export type MutationUpdateBookingKitArgs = {
  input: UpdateBookingKitInput;
};

export type MutationUpdateBookingKitEventArgs = {
  desc?: InputMaybe<Scalars["String"]>;
  eventId: Scalars["ObjectId"];
  sticky?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateBookingKitTagsArgs = {
  comment?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type MutationUpdateBookingProjectArgs = {
  bookingId: Scalars["ObjectId"];
  projectId: Scalars["ObjectId"];
};

export type MutationUpdateCommentForBookingAuditArgs = {
  bookingId: Scalars["ObjectId"];
  comment: Scalars["String"];
};

export type MutationUpdateConsultantEventArgs = {
  desc: Scalars["String"];
  eventId: Scalars["ObjectId"];
};

export type MutationUpdateConsultantGDPRArgs = {
  id: Scalars["ObjectId"];
  input?: InputMaybe<GDPRInput>;
};

export type MutationUpdateConsultantGeneralInterestArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantGeneralInterestInput;
};

export type MutationUpdateConsultantLeadStatusArgs = {
  consultantId: Scalars["ObjectId"];
  input: ConsultantLeadStatusInput;
};

export type MutationUpdateConsultantQualityNoteArgs = {
  consultantId: Scalars["ObjectId"];
  note?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateConsultantReferenceArgs = {
  consultantReferenceId: Scalars["ObjectId"];
  input: ConsultantReferenceInputNew;
};

export type MutationUpdateConsultantServicePreferenceArgs = {
  id: Scalars["ObjectId"];
  input: UpdateConsultantServicePreferenceInput;
};

export type MutationUpdateConsultantStatusArgs = {
  id: Scalars["ObjectId"];
  status: ConsultantStatus;
};

export type MutationUpdateConsultantUserSettingsArgs = {
  id: Scalars["ObjectId"];
  input?: InputMaybe<UserSettingsInput>;
};

export type MutationUpdateConsultantWorkStatusArgs = {
  id: Scalars["ObjectId"];
  input: UpdateConsultantWorkStatusInput;
};

export type MutationUpdateContactPersonArgs = {
  data: ContactPersonInput;
  id: Scalars["ObjectId"];
};

export type MutationUpdateCostCenterArgs = {
  id: Scalars["ObjectId"];
  input: UpdateCostCenterInput;
};

export type MutationUpdateCustomerArgs = {
  id: Scalars["ObjectId"];
  input: CustomerInput;
};

export type MutationUpdateCustomerContractEventArgs = {
  customerContractId: Scalars["ObjectId"];
  eventLog: CustomerContractEventInput;
};

export type MutationUpdateCustomerEventArgs = {
  desc?: InputMaybe<Scalars["String"]>;
  eventId: Scalars["ObjectId"];
};

export type MutationUpdateCustomerRefsSearchProfilesArgs = {
  customerId?: InputMaybe<Scalars["ObjectId"]>;
  searchProfileIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type MutationUpdateFavoriteTeamArgs = {
  teamName: Scalars["String"];
};

export type MutationUpdateSharedFileArgs = {
  expiresOn?: InputMaybe<Scalars["Date"]>;
  fileName?: InputMaybe<Scalars["String"]>;
  id: Scalars["ObjectId"];
};

export type MutationUpdateTgRequirementArgs = {
  id: Scalars["ObjectId"];
  input: UpdateTgRequirementInput;
};

export type MutationUpdateTodoEventArgs = {
  desc: Scalars["String"];
  eventId: Scalars["ObjectId"];
};

export type MutationUpdateTravelConfirmationArgs = {
  id: Scalars["ObjectId"];
  input: ConfirmTravelInput;
};

export type MutationUpdateUnfitAccommodationArgs = {
  comment: Scalars["String"];
  id: Scalars["ObjectId"];
  value: Scalars["Boolean"];
};

export type MutationUploadAccommodationDocumentArgs = {
  documentType: AccommodationDocumentType;
  file: Scalars["Upload"];
  id: Scalars["ObjectId"];
};

export type MutationUploadBlobArgs = {
  file: Scalars["Upload"];
};

export type MutationUploadBookingDocumentArgs = {
  bookingId: Scalars["ObjectId"];
  documentType: BookingWeekDocumentTypes;
  file: Scalars["Upload"];
};

export type MutationUploadConsultantAvatarArgs = {
  file: Scalars["Upload"];
  id: Scalars["ObjectId"];
};

export type MutationUploadConsultantDocumentArgs = {
  consultantId: Scalars["ObjectId"];
  documentType: Scalars["String"];
  file: Scalars["Upload"];
  statusName?: InputMaybe<Scalars["String"]>;
};

export type MutationUploadConsultantDocumentsArgs = {
  blobRefs: Array<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  documentType: Scalars["String"];
  statusName?: InputMaybe<Scalars["String"]>;
};

export type MutationUploadCustomerAvatarArgs = {
  file: Scalars["Upload"];
  id: Scalars["ObjectId"];
};

export type MutationUploadCustomerBgPicArgs = {
  file: Scalars["Upload"];
  id: Scalars["ObjectId"];
};

export type MutationUploadCustomerContractDocumentArgs = {
  customerContractId: Scalars["ObjectId"];
  documentType: CustomerContractDocumentTypes;
  file: Scalars["Upload"];
};

export type MutationUploadCustomerContractSignedDocumentArgs = {
  file: Scalars["Upload"];
  signedOn: Scalars["Date"];
  snapshotId: Scalars["ObjectId"];
};

export type MutationUploadCustomerDocumentArgs = {
  customerId: Scalars["ObjectId"];
  documentType: CustomerDocumentTypes;
  file: Scalars["Upload"];
};

export type MutationUploadDocumentArgs = {
  file: Scalars["Upload"];
};

export type MutationUploadSharedFileArgs = {
  expiresOn: Scalars["Date"];
  file: Scalars["Upload"];
  fileName?: InputMaybe<Scalars["String"]>;
};

export type MutationUploadSignedConsultantBookingContractArgs = {
  contractId: Scalars["ObjectId"];
  file: Scalars["Upload"];
  signedOn?: InputMaybe<Scalars["Date"]>;
};

export type MutationUploadSignedConsultantContractArgs = {
  bankCounselling?: InputMaybe<Scalars["Boolean"]>;
  contractId: Scalars["ObjectId"];
  expectedSalary?: InputMaybe<Scalars["String"]>;
  file?: InputMaybe<Scalars["Upload"]>;
  payoutType?: InputMaybe<ConsultantContractPayoutType>;
  salaryChoice?: InputMaybe<ContractType>;
  signedOn?: InputMaybe<Scalars["Date"]>;
};

export enum NationalQualification {
  Expired = "Expired",
  PresentationReady = "PresentationReady",
  Qualified = "Qualified",
  Unqualified = "Unqualified"
}

export enum NextContactDateReason {
  Other = "Other",
  PermanentEmployment = "PermanentEmployment",
  WorksForCompetitor = "WorksForCompetitor"
}

export type Node = {
  IsValid?: Maybe<Scalars["Boolean"]>;
  NodeName: Scalars["String"];
  NodeType: NodeType;
  ValidationErrors: Array<NodeValidationError>;
  _id: Scalars["ObjectId"];
};

export type NodeRef = {
  Name?: Maybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export type NodeRefFullInput = {
  Name: Scalars["String"];
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export type NodeRefInput = {
  Name?: InputMaybe<Scalars["String"]>;
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export type NodeRefNew = {
  name: Scalars["String"];
  nodeId: Scalars["ObjectId"];
  nodeType: NodeType;
};

export type NodeRefSimple = {
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
};

export enum NodeType {
  Accommodation = "Accommodation",
  AccommodationRequest = "AccommodationRequest",
  Action = "Action",
  Blacklist = "Blacklist",
  Booking = "Booking",
  CallList = "CallList",
  Consultant = "Consultant",
  ConsultantContractOption = "ConsultantContractOption",
  ContactPerson = "ContactPerson",
  ContractArticle = "ContractArticle",
  Customer = "Customer",
  CustomerContract = "CustomerContract",
  CustomerContractOption = "CustomerContractOption",
  Day = "Day",
  Event = "Event",
  ExternalUser = "ExternalUser",
  File = "File",
  GeoPosition = "GeoPosition",
  Invoice = "Invoice",
  Memo = "Memo",
  Notification = "Notification",
  Project = "Project",
  SMSMessage = "SMSMessage",
  Team = "Team",
  TodoItem = "TodoItem",
  TravelRequest = "TravelRequest",
  User = "User"
}

export type NodeValidationError = {
  Message: Scalars["String"];
  Params?: Maybe<Scalars["JSON"]>;
  Type: NodeValidationErrorType;
};

export enum NodeValidationErrorType {
  CustomerInsufficientBookingProfessions = "CustomerInsufficientBookingProfessions",
  CustomerInsufficientRoles = "CustomerInsufficientRoles",
  Unknown = "Unknown"
}

export enum NorwayConsultantStatus {
  Committed = "Committed",
  NoAnswer = "NoAnswer",
  NotObligated = "NotObligated",
  Pending = "Pending"
}

export type NotApprovedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type NumericRangeInput = {
  from?: InputMaybe<Scalars["Float"]>;
  to?: InputMaybe<Scalars["Float"]>;
};

export type NurseAreasOfExpertise = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type NurseAreasOfExpertiseInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type NurseProfession = ConsultantProfession & {
  areasOfExpertise: Array<NurseAreasOfExpertise>;
  certifiedFrom?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<NurseSpecialization>;
  systems: Array<Scalars["String"]>;
};

export type NurseProfessionInput = {
  areasOfExpertise: Array<NurseAreasOfExpertiseInput>;
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  code?: InputMaybe<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<NurseSpecializationInput>;
  systems: Array<Scalars["String"]>;
};

export type NurseSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type NurseSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type OptionObjectIDInput = {
  description?: InputMaybe<Scalars["String"]>;
  error?: InputMaybe<Scalars["Boolean"]>;
  label?: InputMaybe<Scalars["String"]>;
  parent?: InputMaybe<Scalars["String"]>;
  value: Scalars["ObjectId"];
};

export type OptionObjectIDType = {
  description?: Maybe<Scalars["String"]>;
  error?: Maybe<Scalars["Boolean"]>;
  label?: Maybe<Scalars["String"]>;
  parent?: Maybe<Scalars["String"]>;
  value: Scalars["ObjectId"];
};

export type OptionStringInput = {
  description?: InputMaybe<Scalars["String"]>;
  error?: InputMaybe<Scalars["Boolean"]>;
  label?: InputMaybe<Scalars["String"]>;
  parent?: InputMaybe<Scalars["String"]>;
  value: Scalars["String"];
};

export type OrderedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export enum Organization {
  Bonliva = "Bonliva",
  BonlivaCare = "BonlivaCare"
}

export enum OrganizationType {
  CommercialAssociation = "CommercialAssociation",
  Commune = "Commune",
  County = "County",
  LLC = "LLC",
  NonprofitAssosiation = "NonprofitAssosiation",
  Norway = "Norway",
  Partnership = "Partnership",
  StateUnit = "StateUnit"
}

export type Pagination = {
  limit?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type PausedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  ExpiresOn?: Maybe<Scalars["Date"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
  pausedState?: Maybe<PausedState>;
};

export type PausedState = {
  isPaused: Scalars["Boolean"];
  pausedOn: Scalars["Date"];
  pausedUntil: Scalars["Date"];
  wasPaused: Scalars["Boolean"];
  workflowId?: Maybe<Scalars["String"]>;
};

export enum PayPeriod {
  Daily = "Daily",
  FullPeriod = "FullPeriod"
}

export enum PayUnit {
  EmergencyCall = "EmergencyCall",
  Hour = "Hour",
  Investigation = "Investigation",
  Operation = "Operation",
  Period = "Period",
  Quantity = "Quantity",
  WorkShift = "WorkShift"
}

export enum PreferredCommunication {
  Email = "Email",
  Letter = "Letter",
  Linkedin = "Linkedin",
  Phone = "Phone",
  SMS = "SMS"
}

export type PriceGroupInput = {
  _id: Scalars["ObjectId"];
  highHolidays: Array<HighHolidayInput>;
  professionsPrice: Array<ProfessionPrice>;
  records: Array<ContractPriceTemplateRecordInput>;
};

export enum PriceListDay {
  AllSaintsDay = "AllSaintsDay",
  AnyTime = "AnyTime",
  AscensionDay = "AscensionDay",
  BoxingDay = "BoxingDay",
  BusinessDay = "BusinessDay",
  ChristmasDay = "ChristmasDay",
  ChristmasEve = "ChristmasEve",
  DayAfterEasterMonday = "DayAfterEasterMonday",
  DayAfterHoliday = "DayAfterHoliday",
  DayAfterMajorHoliday = "DayAfterMajorHoliday",
  DayAfterWhitsunMonday = "DayAfterWhitsunMonday",
  DayBeforeChristmasEve = "DayBeforeChristmasEve",
  DayBeforeEasterFriday = "DayBeforeEasterFriday",
  DayBeforeHoliday = "DayBeforeHoliday",
  DayBeforeMajorHoliday = "DayBeforeMajorHoliday",
  DayBeforeMidsummerEve = "DayBeforeMidsummerEve",
  DayBeforeNewYearsEve = "DayBeforeNewYearsEve",
  DayBeforeWhitesunDay = "DayBeforeWhitesunDay",
  EasterFriday = "EasterFriday",
  EasterMonday = "EasterMonday",
  EasterSaturday = "EasterSaturday",
  EasterSunday = "EasterSunday",
  FirstOfMay = "FirstOfMay",
  Fri = "Fri",
  Holiday = "Holiday",
  MajorHoliday = "MajorHoliday",
  MidsummerDay = "MidsummerDay",
  MidsummerEve = "MidsummerEve",
  Mon = "Mon",
  NearestWeekdayAfterGreatHoliday = "NearestWeekdayAfterGreatHoliday",
  NearestWeekdayAfterHoliday = "NearestWeekdayAfterHoliday",
  NearestWeekdayBeforeHoliday = "NearestWeekdayBeforeHoliday",
  NewYearsDay = "NewYearsDay",
  NewYearsEve = "NewYearsEve",
  Sat = "Sat",
  SqueezedDay = "SqueezedDay",
  Sun = "Sun",
  SwedensNationalDay = "SwedensNationalDay",
  Thu = "Thu",
  Tue = "Tue",
  TwelfthDay = "TwelfthDay",
  Wed = "Wed",
  WeekdayAfterAscensionDay = "WeekdayAfterAscensionDay",
  WeekdayAfterBoxingDay = "WeekdayAfterBoxingDay",
  WeekdayAfterFirstOfMay = "WeekdayAfterFirstOfMay",
  WeekdayAfterMidsummerDay = "WeekdayAfterMidsummerDay",
  WeekdayAfterNewYearsDay = "WeekdayAfterNewYearsDay",
  WeekdayAfterSwedensNationalDay = "WeekdayAfterSwedensNationalDay",
  WeekdayAfterTwelfthDay = "WeekdayAfterTwelfthDay",
  WeekdayBeforeAllSaintsDay = "WeekdayBeforeAllSaintsDay",
  WeekdayBeforeAscensionDay = "WeekdayBeforeAscensionDay",
  WeekdayBeforeFirstOfMay = "WeekdayBeforeFirstOfMay",
  WeekdayBeforeSwedensNationalDay = "WeekdayBeforeSwedensNationalDay",
  WeekdayBeforeTwelfthDay = "WeekdayBeforeTwelfthDay",
  Weekends = "Weekends",
  WhitMonday = "WhitMonday",
  WhitSunday = "WhitSunday",
  WhitsunEve = "WhitsunEve"
}

export type PriceListFormInput = {
  administrativeFee?: InputMaybe<Scalars["Float"]>;
  customerIds: Array<Scalars["ObjectId"]>;
  endDate: Scalars["DateTime"];
  name: Scalars["String"];
  priceGroups: Array<PriceGroupInput>;
  startDate: Scalars["DateTime"];
  travelZones: Array<TravelZoneInput>;
};

export enum PriceListWorkType {
  Active = "Active",
  AdultEducationADHDADD = "AdultEducationADHDADD",
  AdultInvestigation = "AdultInvestigation",
  AdultStudiesAutism = "AdultStudiesAutism",
  AutismInvestigation = "AutismInvestigation",
  BasicInvestigation = "BasicInvestigation",
  ChildAndAdolescentInquiryAutism = "ChildAndAdolescentInquiryAutism",
  ChildAndAdolescentInvestigationADHDADD = "ChildAndAdolescentInvestigationADHDADD",
  ChildAndYouthInvestigation = "ChildAndYouthInvestigation",
  InvestigationWithinSchool = "InvestigationWithinSchool",
  MedicalExamination = "MedicalExamination",
  MedicalExaminationAdults = "MedicalExaminationAdults",
  MedicalExaminationChildrenAndYoungPeople = "MedicalExaminationChildrenAndYoungPeople",
  NeuropsychiatricExaminationAdults = "NeuropsychiatricExaminationAdults",
  NeuropsychiatricExaminationChildrenAndYoungPeople = "NeuropsychiatricExaminationChildrenAndYoungPeople",
  NeuropsychiatricExaminationChildrenAndYoungPeopleStep3 = "NeuropsychiatricExaminationChildrenAndYoungPeopleStep3",
  NeuropsychologicalExaminationAdults = "NeuropsychologicalExaminationAdults",
  NeuropsychologicalExaminationAdultsStep3 = "NeuropsychologicalExaminationAdultsStep3",
  Normal = "Normal",
  OnCall = "OnCall",
  OnCallA = "OnCallA",
  OnCallB = "OnCallB",
  OnCallBer = "OnCallBer",
  OnCallJour = "OnCallJour",
  OnCallPassive = "OnCallPassive",
  Overtime = "Overtime",
  PrivateAssessmentCall = "PrivateAssessmentCall",
  PrivateNPAssessmentAdults = "PrivateNPAssessmentAdults",
  PrivateNPAssessmentChildrenAndYoung = "PrivateNPAssessmentChildrenAndYoung",
  PsychologicalInvestigation = "PsychologicalInvestigation",
  PsychologicalInvestigationAdults = "PsychologicalInvestigationAdults",
  PsychologicalInvestigationChildrenAndYoungPeople = "PsychologicalInvestigationChildrenAndYoungPeople"
}

export type PriceRecruitment = {
  Currency?: Maybe<ConsultantContractCurrency>;
  R_0_159?: Maybe<Scalars["Float"]>;
  R_160_499?: Maybe<Scalars["Float"]>;
  R_500_699?: Maybe<Scalars["Float"]>;
  R_700_899?: Maybe<Scalars["Float"]>;
  R_900_1200?: Maybe<Scalars["Float"]>;
};

export type PriceRecruitmentInput = {
  Currency?: InputMaybe<ConsultantContractCurrency>;
  R_0_159?: InputMaybe<Scalars["Float"]>;
  R_160_499?: InputMaybe<Scalars["Float"]>;
  R_500_699?: InputMaybe<Scalars["Float"]>;
  R_700_899?: InputMaybe<Scalars["Float"]>;
  R_900_1200?: InputMaybe<Scalars["Float"]>;
};

export type ProfessionConfig = {
  AreasOfExpertise: Array<ExpertiseConfig>;
  DefaultAreaOfExpertise: Scalars["String"];
  Educations: Array<Scalars["String"]>;
  Machines: Array<Scalars["String"]>;
  Methods: Array<Scalars["String"]>;
  Name: Scalars["String"];
  Systems: Array<Scalars["String"]>;
};

export enum ProfessionInputType {
  DOCTOR = "DOCTOR",
  GENERIC = "GENERIC",
  NURSE = "NURSE",
  PSYKOLOG = "PSYKOLOG",
  RADIOGRAPHERS = "RADIOGRAPHERS",
  SOCIONOM = "SOCIONOM",
  TEACHER = "TEACHER"
}

export type ProfessionPrice = {
  price?: InputMaybe<Scalars["Float"]>;
  profession: Scalars["String"];
};

export type ProfessionsByCountry = {
  country: Scalars["String"];
  professions: Array<Scalars["String"]>;
};

export type Project = {
  Admin?: Maybe<UserRef>;
  Comment: Scalars["String"];
  Description: Scalars["String"];
  Members: Array<UserRef>;
  Name: Scalars["String"];
  Owner?: Maybe<UserRef>;
  ProjectNumber: Scalars["String"];
  Status?: Maybe<ProjectStatus>;
  _id: Scalars["ObjectId"];
};

export enum ProjectStatus {
  COMPLETED = "COMPLETED",
  NOTSTARTED = "NOTSTARTED",
  ONGOING = "ONGOING"
}

export enum ProjectVisibilityContext {
  ACCOMMODATION_REQUEST = "ACCOMMODATION_REQUEST",
  CREATE_BOOKING_FORM = "CREATE_BOOKING_FORM",
  TRAVEL_REQUEST = "TRAVEL_REQUEST"
}

export type PsykologProfession = ConsultantProfession & {
  certifiedFrom?: Maybe<Scalars["String"]>;
  methods?: Maybe<Array<Scalars["String"]>>;
  professionName: Scalars["String"];
  specializations: Array<PsykologSpecialization>;
  systems: Array<Scalars["String"]>;
};

export type PsykologProfessionInput = {
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  methods?: InputMaybe<Array<Scalars["String"]>>;
  professionName: Scalars["String"];
  specializations: Array<PsykologSpecializationInput>;
  systems: Array<Scalars["String"]>;
};

export type PsykologSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type PsykologSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type PublishContractResult = {
  contractUrl: Scalars["String"];
};

export enum QualificationFilter {
  Any = "Any",
  No = "No",
  Yes = "Yes"
}

export type QualityApproval = {
  Approved: Scalars["Boolean"];
  Country: Scalars["String"];
  Profession: Scalars["String"];
  approvalExpiresOn?: Maybe<Scalars["Date"]>;
  baseItems?: Maybe<Array<Maybe<QualityApprovalItem>>>;
  oneOfItems?: Maybe<Array<Maybe<QualityApprovalItem>>>;
};

export type QualityApprovalItem = {
  approvalExpiresOn?: Maybe<Scalars["Date"]>;
  approved: Scalars["Boolean"];
  name: Scalars["String"];
  partiallyExpiresOn?: Maybe<Scalars["Date"]>;
};

export type QualityTemplate = {
  Country: Scalars["String"];
  Items: Array<QualityTemplateItem>;
};

export type QualityTemplateItem = {
  Description?: Maybe<Scalars["String"]>;
  DocumentsFolder?: Maybe<Scalars["String"]>;
  ExpiresInMonths?: Maybe<Scalars["Int"]>;
  Name: Scalars["String"];
};

export type Query = {
  SearchProfiles: SearchProfilesSearchResult;
  accommodationConfirmationById: AccommodationConfirmation;
  accommodationEvents?: Maybe<Array<Maybe<AccommodationEvent>>>;
  accommodationRequestById: AccommodationRequest;
  accommodationRequestSearch: AccommodationRequestSearchResult;
  accommodationRequestSearchTotal: AccommodationRequestSearchTotalResult;
  attestContactPersons: GetAttestContactPersonsResult;
  bisnodeLookupByPhone?: Maybe<BisnodePerson>;
  bisnodeLookupBySSN?: Maybe<BisnodePerson>;
  bookingById?: Maybe<Booking>;
  bookingEvents?: Maybe<Array<Maybe<BookingEvent>>>;
  bookingHospitality: BookingHospitality;
  bookingKit?: Maybe<BookingKit>;
  bookingKitApprovalConfig: BookingKitApprovalConfig;
  bookingKitDraft: BookingKitDraft;
  bookingKitEvents?: Maybe<Array<Maybe<BookingKitEvent>>>;
  bookingKitFormConfig?: Maybe<Array<BookingKitTypeFormConfig>>;
  bookingKitSearch: BookingKitSearchResult;
  bookingKitSearchTotal: BookingKitSearchTotalResult;
  bookingKits?: Maybe<Array<BookingKitSearch>>;
  bookingSyncReport: BookingSyncReport;
  bookingWeeks: BookingWeekQueryResult;
  bookingWeeksByConsultant: Array<BookingWeekCalendarItem>;
  bookingWeeksCSV: BookingWeeksCSVResult;
  bookingWeeksCSVBackground?: Maybe<BookingWeeksCSVBackgroundResult>;
  bookingWeeksKitSupport: BookingWeekQueryResult;
  bookingWeeksTotal: BookingWeeksTotalResult;
  /** Longest typed text a bulk SMS of this sub-type may have; less than 306 when the unsubscribe link is appended. */
  bulkSmsTextMaxLength: Scalars["Int"];
  callListById: CallListOpResult;
  checkBookingCancellable?: Maybe<Array<BookingCannotBeRemovedReason>>;
  checkBookingGroupCancellable: BookingGroupCancellableResult;
  checkBookingGroupCancellableByBookingId: BookingGroupCancellableResult;
  checkConsultantExists: CheckContactExistsResult;
  checkFortnoxSalaryForWeek?: Maybe<FortnoxWeekSalaryCheck>;
  config: ConfigDoc;
  consultantById?: Maybe<Consultant>;
  consultantByWorkExperience: ConsultantByWorkExperienceResult;
  consultantCanDuplicateToTenants?: Maybe<CanDuplicateToTenantsResult>;
  consultantEvents: Array<ConsultantEvent>;
  consultantFormById: ConsultantForm;
  consultantHealthDeclarations: HealthDeclarationsQueryResult;
  consultantKarensById: Consultant;
  consultantMatching: ConsultantMatchingResult;
  consultantOpportunityByConsultantId: Array<ConsultantOpportunity>;
  consultantOpportunityById: ConsultantOpportunity;
  consultantOpportunityIssueWeeks: ConsultantOpportunityIssueWeeks;
  consultantOpportunityStatsByTeam: ConsultantOpportunityStats;
  consultantOpportunityStatsByUser: ConsultantOpportunityStats;
  consultantReferenceDocuments: Array<ConsultantReferenceDocument>;
  consultantReferences: Array<ConsultantReferenceNew>;
  consultantServicePreference?: Maybe<ConsultantServicePreference>;
  consultantServicePreferenceForm?: Maybe<ConsultantServicePreferenceForm>;
  consultantServicePreferences: Array<ConsultantServicePreference>;
  consultantServicePreferencesForBooking: Array<ConsultantServicePreference>;
  consultantUpcomingWorkplaces: Array<ConsultantUpcomingWorkplace>;
  consultantWorkStatuses: Array<ConsultantWorkStatus>;
  consultants: ConsultantsResult;
  consultantsByWeeks: Array<ConsultantAvailableOnWeek>;
  consultantsCSV: ConsultantExportCSVResult;
  consultantsFast: ConsultantsResult;
  consultantsTotal: ConsultantTotalResult;
  contactPersonById: ContactPerson;
  contactPersons: ContactPersonsResult;
  contract: BookingContractInfo;
  contractsPriceTemplateById?: Maybe<ContractsPriceTemplate>;
  contractsPriceTemplates: ContractPriceTemplateSearchResult;
  costCenterConfigItems: Array<CostCenterConfigItem>;
  customerById?: Maybe<Customer>;
  customerContractById?: Maybe<CustomerContract>;
  customerContractPriceListById: CustomerContractPriceList;
  customerContractSnapshotById?: Maybe<CustomerContractSnapshot>;
  customerContractSubVersionById: CustomerContractSubVersion;
  customerContracts: CustomerContractSearchResult;
  customerContractsByBooking: Array<CustomerContractListItem>;
  customerContractsTotal: Total;
  customerEvents: Array<CustomerEvent>;
  customerNumberByAOE?: Maybe<Scalars["String"]>;
  customers: CustomersResult;
  customersPicker: CustomersResult;
  customersTotal: CustomersTotalResult;
  findConsultantDuplicate?: Maybe<Consultant>;
  findConsultantSimilar?: Maybe<Consultant>;
  findContract: BookingContractInfo;
  freshdeskOpenTicketsCountByConsultant: Scalars["Int"];
  freshdeskTicketsByConsultant: Array<FreshdeskTicket>;
  getAccommodationDetails: Accommodation;
  getAccommodations: Array<AccommodationListItem>;
  getAccommodationsCount: Count;
  getAllConsultantTags: AllConsultantTagsResult;
  getBookingAssignedToTotal: BookingWeeksTotalResult;
  getBookingCustomerContacts: Array<CustomerContact>;
  getBookingGroup?: Maybe<BookingGroup>;
  getBookingKitAssignedToTotal: BookingKitSearchTotalResult;
  getChecksForBooking: BookingChecks;
  getConsultantBookingContractDetailInfo: ConsultantBookingContract;
  getConsultantBookingContracts: Array<ConsultantBookingContractListItem>;
  getConsultantBookingContractsByCustomerId: Array<ConsultantBookingContract>;
  getConsultantContractDetailInfo: ConsultantContract;
  getConsultantContracts: Array<ConsultantContractListItem>;
  getConsultantContractsByBooking: Array<ConsultantContractListItem>;
  getConsultantPayoutByYear: Array<Maybe<ConsultantPayoutByYear>>;
  getConsultantQualityItem: ConsultantQualityItem;
  getConsultantSearchQualityItems: Array<ConsultantSearchQualityItem>;
  getContactPersonsByCustomerIds: Array<ContactPerson>;
  getCustomerContractPriceLists: Array<CustomerContract>;
  getCustomerContractSnapshots: Array<CustomerContractSnapshot>;
  getFortnoxSalaryCache?: Maybe<FortnoxSalaryCache>;
  getFreeTimereports?: Maybe<FreeTimereportResult>;
  getHighHolidays: Array<HighHolidayOption>;
  getInvoiceStatusForBooking?: Maybe<BookingInvoicePaymentStatusesResult>;
  getLastAccommodationRequest?: Maybe<AccommodationRequest>;
  getLastSignedConsultantContract?: Maybe<ConsultantContractListItem>;
  getLastWorkflowRun?: Maybe<WorkflowRun>;
  getSystemsByProfession: Array<Scalars["String"]>;
  getTimereportByBookingId?: Maybe<TimereportResult>;
  getTimereportSendFailures?: Maybe<TimereportSendFailuresResult>;
  getTimereportStatusHistory?: Maybe<TimereportStatusHistoryResult>;
  getTimereportToCustomerEmail: GetTimereportToCustomerEmailResult;
  getWorkflowRuns: Array<WorkflowRun>;
  getWorkflowRunsByOwner: WorkflowRunsPaginatedResult;
  invoiceByNumber?: Maybe<Invoice>;
  kanbanBoard?: Maybe<KanbanBoard>;
  kanbanCard?: Maybe<KanbanCard>;
  kanbanCards: Array<KanbanCard>;
  me: Me;
  municipalities: Array<Municipality>;
  myApiTokens: Array<ApiToken>;
  npDirectRequestAvailable: Scalars["Boolean"];
  professionsByCountry: Array<ProfessionsByCountry>;
  projects: Array<Project>;
  searchProfileById?: Maybe<SearchProfile>;
  searchProfilesByCustomerId?: Maybe<Array<SearchProfile>>;
  sharedFileById: SharedFile;
  sharedFiles: SharedFilesResult;
  subcontractorInvoiceByNumber?: Maybe<SubcontractorInvoice>;
  teams: Array<Team>;
  tgRequirements: Array<TgRequirement>;
  todo: TodoItem;
  todoEvents?: Maybe<Array<Maybe<TodoEvent>>>;
  todoSearch: Array<TodoSearchItem>;
  todoTotal: TodoTotalResult;
  travelConfirmationById: TravelConfirmation;
  travelRequestById: TravelRequest;
  travelRequestSearch: TravelRequestSearchResult;
  travelRequestSearchTotal: TravelRequestSearchTotalResult;
  userById?: Maybe<User>;
  userPermissions: Array<Scalars["String"]>;
  users: Array<User>;
  workflowRunById: WorkflowRun;
  workflowRunByWorkflowId?: Maybe<WorkflowRun>;
};

export type QuerySearchProfilesArgs = {
  filter?: InputMaybe<SearchProfilesFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryAccommodationConfirmationByIdArgs = {
  confirmationId: Scalars["ObjectId"];
};

export type QueryAccommodationEventsArgs = {
  accommodationId: Scalars["ObjectId"];
};

export type QueryAccommodationRequestByIdArgs = {
  requestId: Scalars["ObjectId"];
};

export type QueryAccommodationRequestSearchArgs = {
  filter?: InputMaybe<AccommodationRequestQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<AccommodationRequestSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryAccommodationRequestSearchTotalArgs = {
  filter?: InputMaybe<AccommodationRequestQueryInput>;
};

export type QueryAttestContactPersonsArgs = {
  areaOfExpertise: Scalars["String"];
  departmentIds: Array<Scalars["ObjectId"]>;
  hospitalId: Scalars["ObjectId"];
};

export type QueryBisnodeLookupByPhoneArgs = {
  country: Scalars["String"];
  phone: Scalars["String"];
};

export type QueryBisnodeLookupBySSNArgs = {
  country: Scalars["String"];
  ssn: Scalars["String"];
};

export type QueryBookingByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryBookingEventsArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingHospitalityArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingKitArgs = {
  id: Scalars["ObjectId"];
};

export type QueryBookingKitApprovalConfigArgs = {
  id: Scalars["ObjectId"];
};

export type QueryBookingKitDraftArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingKitEventsArgs = {
  kitId: Scalars["ObjectId"];
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  types?: InputMaybe<Array<InputMaybe<BookingKitEventType>>>;
};

export type QueryBookingKitFormConfigArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingKitSearchArgs = {
  filter?: InputMaybe<BookingKitQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<BookingKitSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryBookingKitSearchTotalArgs = {
  filter?: InputMaybe<BookingKitQueryInput>;
};

export type QueryBookingKitsArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryBookingSyncReportArgs = {
  input: BookingWeekQueryInput;
};

export type QueryBookingWeeksArgs = {
  filter?: InputMaybe<BookingWeekQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryBookingWeeksByConsultantArgs = {
  consultantId: Scalars["ObjectId"];
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type QueryBookingWeeksCSVArgs = {
  filter?: InputMaybe<BookingWeekQueryInput>;
  type?: InputMaybe<BookingCSVReportType>;
};

export type QueryBookingWeeksCSVBackgroundArgs = {
  filter?: InputMaybe<BookingWeekQueryInput>;
  type?: InputMaybe<BookingCSVReportType>;
};

export type QueryBookingWeeksKitSupportArgs = {
  filter?: InputMaybe<BookingWeekQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryBookingWeeksTotalArgs = {
  input?: InputMaybe<BookingWeekQueryInput>;
};

export type QueryBulkSmsTextMaxLengthArgs = {
  subType?: InputMaybe<Scalars["String"]>;
};

export type QueryCallListByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryCheckBookingCancellableArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryCheckBookingGroupCancellableArgs = {
  bookingGroupId: Scalars["ObjectId"];
};

export type QueryCheckBookingGroupCancellableByBookingIdArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryCheckConsultantExistsArgs = {
  filter?: InputMaybe<CheckContactExistsInput>;
};

export type QueryCheckFortnoxSalaryForWeekArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryConsultantByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryConsultantByWorkExperienceArgs = {
  customerId: Scalars["ObjectId"];
};

export type QueryConsultantCanDuplicateToTenantsArgs = {
  email?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  ssn?: InputMaybe<Scalars["String"]>;
};

export type QueryConsultantEventsArgs = {
  consultantId: Scalars["ObjectId"];
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  type?: InputMaybe<Array<InputMaybe<ConsultantEventType>>>;
};

export type QueryConsultantFormByIdArgs = {
  consultantId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryConsultantHealthDeclarationsArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantKarensByIdArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantMatchingArgs = {
  filter: ConsultantsQueryInput;
  limit: Scalars["Int"];
  params: ConsultantMatchingParams;
  skip: Scalars["Int"];
  sortBy: SortBy;
  sortOrder: SortOrder;
};

export type QueryConsultantOpportunityByConsultantIdArgs = {
  consultantId: Scalars["ObjectId"];
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type QueryConsultantOpportunityByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryConsultantOpportunityIssueWeeksArgs = {
  issueId: Scalars["ObjectId"];
};

export type QueryConsultantOpportunityStatsByTeamArgs = {
  end: Scalars["Date"];
  start: Scalars["Date"];
  team: Scalars["String"];
};

export type QueryConsultantOpportunityStatsByUserArgs = {
  end: Scalars["Date"];
  start: Scalars["Date"];
  userId: Scalars["ObjectId"];
};

export type QueryConsultantReferenceDocumentsArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantReferencesArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantServicePreferenceArgs = {
  id: Scalars["ObjectId"];
};

export type QueryConsultantServicePreferenceFormArgs = {
  id: Scalars["ObjectId"];
};

export type QueryConsultantServicePreferencesArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantServicePreferencesForBookingArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryConsultantUpcomingWorkplacesArgs = {
  consultantId: Scalars["ObjectId"];
  from: Scalars["Date"];
  to: Scalars["Date"];
};

export type QueryConsultantWorkStatusesArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryConsultantsArgs = {
  filter?: InputMaybe<ConsultantsQueryInput>;
  includeEvents?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<ConsultantTableColumns>;
  sortOrder?: InputMaybe<SortOrder>;
  withSecondarySearch?: InputMaybe<Scalars["Boolean"]>;
};

export type QueryConsultantsByWeeksArgs = {
  filter?: InputMaybe<ConsultantsByWeeksQueryInput>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type QueryConsultantsCSVArgs = {
  ids: Array<Scalars["ObjectId"]>;
};

export type QueryConsultantsFastArgs = {
  filter?: InputMaybe<ConsultantsQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryConsultantsTotalArgs = {
  filter?: InputMaybe<ConsultantsQueryInput>;
};

export type QueryContactPersonByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryContactPersonsArgs = {
  filter?: InputMaybe<ContactPersonsFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryContractArgs = {
  id: Scalars["ObjectId"];
};

export type QueryContractsPriceTemplateByIdArgs = {
  contractsPriceTemplateId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryContractsPriceTemplatesArgs = {
  filter?: InputMaybe<ContractPriceTemplateFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  onlyPrivate?: InputMaybe<Scalars["Boolean"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryCostCenterConfigItemsArgs = {
  filter?: InputMaybe<CostCenterConfigFilterInput>;
};

export type QueryCustomerByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryCustomerContractByIdArgs = {
  customerContractId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryCustomerContractPriceListByIdArgs = {
  customerContractId: Scalars["ObjectId"];
  priceListId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryCustomerContractSnapshotByIdArgs = {
  snapshotId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryCustomerContractSubVersionByIdArgs = {
  customerContractId: Scalars["ObjectId"];
  subVersionId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryCustomerContractsArgs = {
  filter?: InputMaybe<CustomerContractFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<CustomerContractSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryCustomerContractsByBookingArgs = {
  filter?: InputMaybe<CustomerContractByBookingFilter>;
};

export type QueryCustomerContractsTotalArgs = {
  filter?: InputMaybe<CustomerContractFilter>;
};

export type QueryCustomerEventsArgs = {
  filter: CustomerEventFilter;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryCustomerNumberByAOEArgs = {
  areaOfExpertise: Scalars["String"];
  departmentIds: Array<Scalars["ObjectId"]>;
  hospitalId: Scalars["ObjectId"];
};

export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomersFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryCustomersPickerArgs = {
  filter?: InputMaybe<CustomersFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryCustomersTotalArgs = {
  filter?: InputMaybe<CustomersFilter>;
};

export type QueryFindConsultantDuplicateArgs = {
  filter?: InputMaybe<CheckContactExistsInput>;
};

export type QueryFindConsultantSimilarArgs = {
  filter?: InputMaybe<CheckContactExistsInput>;
};

export type QueryFindContractArgs = {
  id: Scalars["ObjectId"];
};

export type QueryFreshdeskOpenTicketsCountByConsultantArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryFreshdeskTicketsByConsultantArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetAccommodationDetailsArgs = {
  accommodationId: Scalars["ObjectId"];
};

export type QueryGetAccommodationsArgs = {
  input?: InputMaybe<AccommodationFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
};

export type QueryGetAccommodationsCountArgs = {
  input?: InputMaybe<AccommodationFilter>;
};

export type QueryGetBookingCustomerContactsArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetBookingGroupArgs = {
  id: Scalars["ObjectId"];
};

export type QueryGetBookingKitAssignedToTotalArgs = {
  filter?: InputMaybe<BookingKitQueryInput>;
};

export type QueryGetChecksForBookingArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetConsultantBookingContractDetailInfoArgs = {
  contractId: Scalars["ObjectId"];
};

export type QueryGetConsultantBookingContractsArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetConsultantBookingContractsByCustomerIdArgs = {
  consultantId: Scalars["ObjectId"];
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type QueryGetConsultantContractDetailInfoArgs = {
  contractId: Scalars["ObjectId"];
};

export type QueryGetConsultantContractsArgs = {
  consultantId: Scalars["ObjectId"];
  limit?: InputMaybe<Scalars["Int"]>;
};

export type QueryGetConsultantContractsByBookingArgs = {
  consultantId: Scalars["ObjectId"];
  dates: Array<InputMaybe<Scalars["Date"]>>;
};

export type QueryGetConsultantPayoutByYearArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetConsultantQualityItemArgs = {
  consultantId: Scalars["ObjectId"];
  country: Scalars["String"];
  itemName: Scalars["String"];
};

export type QueryGetContactPersonsByCustomerIdsArgs = {
  depIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  hospId?: InputMaybe<Scalars["ObjectId"]>;
};

export type QueryGetCustomerContractPriceListsArgs = {
  customerIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type QueryGetCustomerContractSnapshotsArgs = {
  customerContractId: Scalars["ObjectId"];
};

export type QueryGetFortnoxSalaryCacheArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetFreeTimereportsArgs = {
  consultantId: Scalars["ObjectId"];
  week: Scalars["Int"];
  year: Scalars["Int"];
};

export type QueryGetInvoiceStatusForBookingArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetLastAccommodationRequestArgs = {
  filter?: InputMaybe<AccommodationRequestQueryInput>;
};

export type QueryGetLastSignedConsultantContractArgs = {
  consultantId: Scalars["ObjectId"];
};

export type QueryGetLastWorkflowRunArgs = {
  entityId: Scalars["ObjectId"];
  workflowType?: InputMaybe<Scalars["String"]>;
};

export type QueryGetSystemsByProfessionArgs = {
  profession: Scalars["String"];
};

export type QueryGetTimereportByBookingIdArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetTimereportSendFailuresArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetTimereportStatusHistoryArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetTimereportToCustomerEmailArgs = {
  bookingId: Scalars["ObjectId"];
};

export type QueryGetWorkflowRunsArgs = {
  entityId: Scalars["ObjectId"];
  workflowType?: InputMaybe<Scalars["String"]>;
};

export type QueryGetWorkflowRunsByOwnerArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  status?: InputMaybe<WorkflowStatus>;
  workflowType?: InputMaybe<Scalars["String"]>;
};

export type QueryInvoiceByNumberArgs = {
  number: Scalars["String"];
  provider: InvoiceProvider;
};

export type QueryKanbanBoardArgs = {
  id: Scalars["String"];
  type: KanbanBoardType;
};

export type QueryKanbanCardArgs = {
  boardId: Scalars["String"];
  cardId: Scalars["String"];
  type: KanbanBoardType;
};

export type QueryKanbanCardsArgs = {
  boardId: Scalars["String"];
  filter?: InputMaybe<Scalars["JSON"]>;
  type: KanbanBoardType;
};

export type QueryNpDirectRequestAvailableArgs = {
  customerId: Scalars["ObjectId"];
  departmentIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type QueryProjectsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  memberIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  shared?: InputMaybe<Scalars["Boolean"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  text?: InputMaybe<Scalars["String"]>;
  visibilityContext?: InputMaybe<ProjectVisibilityContext>;
};

export type QuerySearchProfileByIdArgs = {
  id?: InputMaybe<Scalars["ObjectId"]>;
};

export type QuerySearchProfilesByCustomerIdArgs = {
  id?: InputMaybe<Scalars["ObjectId"]>;
};

export type QuerySharedFileByIdArgs = {
  fileId: Scalars["ObjectId"];
};

export type QuerySharedFilesArgs = {
  filter: SharedFilesFilter;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type QuerySubcontractorInvoiceByNumberArgs = {
  number: Scalars["String"];
  provider: InvoiceProvider;
};

export type QueryTeamsArgs = {
  filter?: InputMaybe<TeamsFilter>;
};

export type QueryTgRequirementsArgs = {
  filter?: InputMaybe<TgRequirementFilterInput>;
};

export type QueryTodoArgs = {
  id: Scalars["ObjectId"];
};

export type QueryTodoEventsArgs = {
  todoId: Scalars["ObjectId"];
};

export type QueryTodoSearchArgs = {
  filter?: InputMaybe<TodoSearchFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<TodoSearchSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryTodoTotalArgs = {
  filter?: InputMaybe<TodoSearchFilter>;
};

export type QueryTravelConfirmationByIdArgs = {
  confirmationId: Scalars["ObjectId"];
};

export type QueryTravelRequestByIdArgs = {
  requestId: Scalars["ObjectId"];
};

export type QueryTravelRequestSearchArgs = {
  filter?: InputMaybe<TravelRequestQueryInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  skip?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<TravelRequestSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryTravelRequestSearchTotalArgs = {
  filter?: InputMaybe<TravelRequestQueryInput>;
};

export type QueryUserByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryUserPermissionsArgs = {
  id: Scalars["ObjectId"];
};

export type QueryUsersArgs = {
  ids?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type QueryWorkflowRunByIdArgs = {
  id: Scalars["ObjectId"];
};

export type QueryWorkflowRunByWorkflowIdArgs = {
  workflowId: Scalars["String"];
};

export type RadioNurseProfession = ConsultantProfession & {
  certifiedFrom?: Maybe<Scalars["String"]>;
  machines: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<RadioNurseSpecialization>;
  systems: Array<Scalars["String"]>;
};

export type RadioNurseProfessionInput = {
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  machines: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  specializations: Array<RadioNurseSpecializationInput>;
  systems: Array<Scalars["String"]>;
};

export type RadioNurseSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type RadioNurseSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export enum RecruitingPortalType {
  Avropsportalen = "Avropsportalen",
  Bemlo = "Bemlo",
  Inkopio = "Inkopio",
  Medlo = "Medlo",
  Nemo = "Nemo"
}

export type ReferenceDataInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  email?: InputMaybe<Scalars["String"]>;
  formType?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  relation?: InputMaybe<Scalars["String"]>;
};

export type Region = {
  countryCouncilId?: Maybe<Scalars["Int"]>;
  name: Scalars["String"];
};

export type RequestReceivedNotProcessedQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
};

export type RequestSentQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
  params?: Maybe<Scalars["JSON"]>;
};

export enum RideType {
  OneWay = "OneWay",
  RoundTrip = "RoundTrip"
}

export type Role = {
  IsStaffing?: Maybe<Scalars["Boolean"]>;
  Name: Scalars["String"];
};

export enum SMSDeliveryStatus {
  Delivered = "Delivered",
  Error = "Error",
  Expired = "Expired",
  Pending = "Pending",
  Rejected = "Rejected",
  Unknown = "Unknown"
}

export type SMSMessage = {
  From: Scalars["String"];
  IsFailed: Scalars["Boolean"];
  IsOk: Scalars["Boolean"];
  IsStatusFinal: Scalars["Boolean"];
  Message: Scalars["String"];
  SentBy?: Maybe<User>;
  SentByRef: UserRef;
  SentOn: Scalars["Date"];
  Status: SMSDeliveryStatus;
  StatusUpdatedOn?: Maybe<Scalars["Date"]>;
  To: Scalars["String"];
  _id: Scalars["ObjectId"];
};

export type Salary = {
  Compensation?: Maybe<Compensation>;
  Workhours?: Maybe<Scalars["String"]>;
};

export type SalaryInput = {
  Compensation: CompensationInput;
  Workhours: Scalars["String"];
};

export type SaveConsultantsResult =
  | SaveConsultantsResultInvalid
  | SaveConsultantsResultOK;

export type SaveConsultantsResultInvalid = {
  IsValid: Scalars["Boolean"];
  Rows: Array<ConsultantImportRow>;
};

export type SaveConsultantsResultOK = {
  Consultants: Array<Consultant>;
  IsValid: Scalars["Boolean"];
  Msg: Scalars["String"];
  Rows: Array<ConsultantImportRow>;
};

export type SearchProfile = {
  _id: Scalars["ObjectId"];
  customerRefs?: Maybe<Array<CustomerRef>>;
  fields: Scalars["JSON"];
  name: Scalars["String"];
  type: SearchProfileType;
};

export type SearchProfileFormInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  customerRefs?: InputMaybe<Array<CustomerRefInput>>;
  fields?: InputMaybe<Scalars["JSON"]>;
  name?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<SearchProfileType>;
};

export enum SearchProfileType {
  AccommodationRequests = "AccommodationRequests",
  Bookings = "Bookings",
  Consultants = "Consultants",
  ConsultantsPipeline = "ConsultantsPipeline",
  Kits = "Kits",
  PipelineBoard = "PipelineBoard",
  TravelRequests = "TravelRequests"
}

export type SearchProfilesFilter = {
  text?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<SearchProfileType>;
};

export type SearchProfilesSearchResult = {
  items: Array<SearchProfile>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export enum SearchQualityCheckStatus {
  Approved = "Approved",
  ApprovedExpired = "ApprovedExpired",
  ApprovedRef = "ApprovedRef",
  ApprovedWithComment = "ApprovedWithComment",
  AwaitingApproval = "AwaitingApproval",
  Booked = "Booked",
  ConsultantResponsible = "ConsultantResponsible",
  Empty = "Empty",
  Expired = "Expired",
  FullyApproved = "FullyApproved",
  NotApproved = "NotApproved",
  NotApprovedRef = "NotApprovedRef",
  OneApproved = "OneApproved",
  Ordered = "Ordered",
  Paused = "Paused",
  RequestExpired = "RequestExpired",
  RequestNotAnswered = "RequestNotAnswered",
  RequestReceivedNotProcessed = "RequestReceivedNotProcessed",
  RequestSent = "RequestSent",
  RequestSentExpired = "RequestSentExpired",
  SentToRef = "SentToRef",
  SigningPeriodExpired = "SigningPeriodExpired"
}

export enum SelectType {
  AND = "AND",
  ANY = "ANY",
  ONLY = "ONLY"
}

export type SelectValueInputString = {
  type: SelectType;
  value: Array<Scalars["String"]>;
};

export enum SelfRegisterOption {
  Bemlo = "Bemlo",
  BonlivaApp = "BonlivaApp",
  EmploymentAgency = "EmploymentAgency",
  HomepageChat = "HomepageChat",
  Lead = "Lead",
  LinkedIn = "LinkedIn",
  Newsletter = "Newsletter",
  PhoneCall = "PhoneCall",
  SearchEngine = "SearchEngine",
  SelfRegisterHemsida = "SelfRegisterHemsida",
  SelfRegisterNotSpecified = "SelfRegisterNotSpecified",
  SelfRegisterPaper = "SelfRegisterPaper",
  SelfRegisterPhone = "SelfRegisterPhone",
  SocialMedia = "SocialMedia"
}

export type SendConsultantToMedloResult = {
  message?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type SendEmailToConsultantResult = {
  Body: Scalars["String"];
  Subject: Scalars["String"];
};

export type SendMassEmailResult = {
  Body: Scalars["String"];
  Subject: Scalars["String"];
};

export type SendMassSMSToConsultantsResult = {
  result: Array<ConsultantSMS>;
};

export type SendToKvkConsultantReferencePayload = {
  consultantReference: ConsultantReferenceNew;
};

export type SharedFile = {
  Deleted: Scalars["Boolean"];
  ExpiresOn: Scalars["Date"];
  FileRef: FileRef;
  FileStats: SharedFileStats;
  Name: Scalars["String"];
  ShareURL: Scalars["String"];
  SharedBy: UserRef;
  SharedOn: Scalars["Date"];
  ThumbURL: Scalars["String"];
  _id: Scalars["ObjectId"];
};

export type SharedFileAccessRecord = {
  AccessedOn: Scalars["Date"];
  IP: Scalars["String"];
};

export type SharedFileStats = {
  AccessRecords: Array<SharedFileAccessRecord>;
  AccessedTotal: Scalars["Int"];
};

export type SharedFilesFilter = {
  from?: InputMaybe<Scalars["Date"]>;
  text?: InputMaybe<Scalars["String"]>;
  to?: InputMaybe<Scalars["Date"]>;
  userIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
};

export type SharedFilesResult = {
  files: Array<SharedFile>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type SigningPeriodExpiredQualityStatus = ConsultantQualityStatus & {
  Comment: Scalars["String"];
  DocumentRequired?: Maybe<Scalars["Boolean"]>;
  ExpiresOn?: Maybe<Scalars["Date"]>;
  Name: Scalars["String"];
  SetBy?: Maybe<UserRef>;
  SetOn?: Maybe<Scalars["Date"]>;
};

export type SocionomAreasOfExpertise = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  open?: Maybe<Scalars["Boolean"]>;
  qualified?: Maybe<Scalars["Boolean"]>;
  specializations: Array<SocionomSpecialization>;
  yearFrom?: Maybe<Scalars["String"]>;
};

export type SocionomAreasOfExpertiseInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  open?: InputMaybe<Scalars["Boolean"]>;
  qualified?: InputMaybe<Scalars["Boolean"]>;
  specializations: Array<SocionomSpecializationInput>;
  yearFrom?: InputMaybe<Scalars["String"]>;
};

export type SocionomProfession = ConsultantProfession & {
  areasOfExpertise: Array<SocionomAreasOfExpertise>;
  certifiedFrom?: Maybe<Scalars["String"]>;
  educations: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  systems: Array<Scalars["String"]>;
};

export type SocionomProfessionInput = {
  areasOfExpertise: Array<SocionomAreasOfExpertiseInput>;
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  educations: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  systems: Array<Scalars["String"]>;
};

export enum SocionomSelectOption {
  Socionom1SS = "Socionom1SS",
  SocionomReception = "SocionomReception"
}

export type SocionomSelectOptionEnum = {
  type: SelectType;
  value: Array<SocionomSelectOption>;
};

export type SocionomSpecialization = {
  comment?: Maybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
};

export type SocionomSpecializationInput = {
  comment?: InputMaybe<Scalars["String"]>;
  interested: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
};

export enum SortBy {
  LastContactDate = "LastContactDate",
  Name = "Name",
  OldestContact = "OldestContact",
  Relevance = "Relevance"
}

export enum SortOrder {
  Asc = "Asc",
  Desc = "Desc"
}

export type SpecificPeriodPrice = {
  _id: Scalars["ObjectId"];
  endDate: Scalars["Date"];
  price: Scalars["Float"];
  startDate: Scalars["Date"];
  title?: Maybe<Scalars["String"]>;
};

export type SpecificPeriodPriceInput = {
  _id?: InputMaybe<Scalars["ObjectId"]>;
  endDate: Scalars["Date"];
  price: Scalars["Float"];
  startDate: Scalars["Date"];
  title?: InputMaybe<Scalars["String"]>;
};

export type SubVersionFormInput = {
  basicPrice: Scalars["Float"];
  consultantId: Scalars["ObjectId"];
  endDate: Scalars["DateTime"];
  startDate: Scalars["DateTime"];
};

export type SubcontractorInfo = {
  Address?: Maybe<Address>;
  BusinessNo: Scalars["String"];
  Name: Scalars["String"];
};

export type SubcontractorInvoice = {
  Balance?: Maybe<Scalars["String"]>;
  Booked?: Maybe<Scalars["Boolean"]>;
  CostCenter?: Maybe<Scalars["String"]>;
  Credit?: Maybe<Scalars["Boolean"]>;
  Currency?: Maybe<Scalars["String"]>;
  DueDate?: Maybe<Scalars["String"]>;
  FinalPayDate?: Maybe<Scalars["String"]>;
  GivenNumber?: Maybe<Scalars["String"]>;
  InvoiceDate?: Maybe<Scalars["String"]>;
  InvoiceNumber?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["String"]>;
};

export type Subscription = {
  kanbanCardAdded: KanbanCardActionPayload;
  kanbanCardDeleted: KanbanCardActionPayload;
  kanbanCardMoved: KanbanCardActionPayload;
  myProfileUpdated: MePartial;
  smsMessageUpdated: SMSMessage;
};

export type SubscriptionKanbanCardAddedArgs = {
  boardId: Scalars["ObjectId"];
  sessionId: Scalars["String"];
};

export type SubscriptionKanbanCardDeletedArgs = {
  boardId: Scalars["ObjectId"];
  sessionId: Scalars["String"];
};

export type SubscriptionKanbanCardMovedArgs = {
  boardId: Scalars["ObjectId"];
  sessionId: Scalars["String"];
};

export type SubscriptionSmsMessageUpdatedArgs = {
  id: Scalars["ObjectId"];
};

export enum SuppressionReason {
  Bounce = "Bounce",
  Invalid = "Invalid",
  Manual = "Manual",
  SpamReport = "SpamReport",
  Stop = "Stop",
  Unsubscribe = "Unsubscribe"
}

export enum SuppressionSource {
  CrmManual = "CrmManual",
  CrmUnsubscribeLink = "CrmUnsubscribeLink",
  Reconciliation = "Reconciliation",
  SendgridWebhook = "SendgridWebhook",
  Tele2Webhook = "Tele2Webhook"
}

export type TeacherAreasOfExpertise = {
  certifiedFrom?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  selected: Scalars["Boolean"];
  specializations: Array<TeacherSpecialization>;
};

export type TeacherAreasOfExpertiseInput = {
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  selected: Scalars["Boolean"];
  specializations: Array<TeacherSpecializationInput>;
};

export type TeacherProfession = ConsultantProfession & {
  areasOfExpertise: Array<TeacherAreasOfExpertise>;
  certifiedFrom?: Maybe<Scalars["String"]>;
  digitalCompetence: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  schoolPlatforms: Array<Scalars["String"]>;
  systems: Array<Scalars["String"]>;
};

export type TeacherProfessionInput = {
  areasOfExpertise: Array<TeacherAreasOfExpertiseInput>;
  certifiedFrom?: InputMaybe<Scalars["String"]>;
  digitalCompetence: Array<Scalars["String"]>;
  professionName: Scalars["String"];
  schoolPlatforms: Array<Scalars["String"]>;
  systems: Array<Scalars["String"]>;
};

export type TeacherSpecialization = {
  experience?: Maybe<Scalars["String"]>;
  interestedIn: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: Maybe<Scalars["Boolean"]>;
};

export type TeacherSpecializationInput = {
  experience?: InputMaybe<Scalars["String"]>;
  interestedIn: Scalars["Boolean"];
  name: Scalars["String"];
  qualified?: InputMaybe<Scalars["Boolean"]>;
};

export type Team = {
  ADGroups: Array<Scalars["String"]>;
  AreasOfExpertise: Array<Scalars["String"]>;
  Email?: Maybe<Scalars["String"]>;
  KnownSystems: Array<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  Tags: Array<Scalars["String"]>;
  TodoGroup?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
  workrequestTeamName?: Maybe<Scalars["String"]>;
};

export type TeamsFilter = {
  workrequestTeams: Scalars["Boolean"];
};

export enum Tenant {
  BonlivaAB = "BonlivaAB",
  WCC = "WCC"
}

export type TgRequirement = {
  _id: Scalars["ObjectId"];
  costCenterId: Scalars["String"];
  createdByName: Scalars["String"];
  createdOn: Scalars["Date"];
  deleted: Scalars["Boolean"];
  minRequiredTG: Scalars["Float"];
  profession?: Maybe<Scalars["String"]>;
  tenant: Scalars["String"];
  updatedByName?: Maybe<Scalars["String"]>;
  updatedOn?: Maybe<Scalars["Date"]>;
  validFrom: Scalars["Date"];
  validTo?: Maybe<Scalars["Date"]>;
};

export type TgRequirementFilterInput = {
  activeOnly?: InputMaybe<Scalars["Boolean"]>;
  costCenterId?: InputMaybe<Scalars["String"]>;
  profession?: InputMaybe<Scalars["String"]>;
  professionIsNull?: InputMaybe<Scalars["Boolean"]>;
};

export enum TicketDifficultyLevel {
  Easy = "Easy",
  Hard = "Hard",
  Medium = "Medium"
}

export enum TimeReportRowSource {
  Bemlo = "Bemlo",
  Crm = "Crm",
  Inkopio = "Inkopio",
  Manual = "Manual",
  Medlo = "Medlo",
  MobileApp = "MobileApp",
  Paper = "Paper",
  Unknown = "Unknown"
}

export enum TimeReportStatus {
  ApprovedByCustomer = "ApprovedByCustomer",
  Blank = "Blank",
  Canceled = "Canceled",
  ConsultantPaymentProcessed = "ConsultantPaymentProcessed",
  Disabled = "Disabled",
  Draft = "Draft",
  RejectByFinance = "RejectByFinance",
  RejectByHBA = "RejectByHBA",
  RejectByOC = "RejectByOC",
  RejectedByCustomer = "RejectedByCustomer",
  SentToConsultant = "SentToConsultant",
  SentToCustomer = "SentToCustomer",
  SentToFinance = "SentToFinance",
  SentToHBA = "SentToHBA",
  SentToOC = "SentToOC",
  SubmittedByConsultant = "SubmittedByConsultant"
}

export enum TimeReportTemplateType {
  Basic = "Basic",
  BlekingeLakare = "BlekingeLakare",
  BlekingeSSK = "BlekingeSSK",
  DalarnaLakare = "DalarnaLakare",
  GavleborgLakare = "GavleborgLakare",
  GotlandLakare = "GotlandLakare",
  GotlandSSK = "GotlandSSK",
  HallandLakare = "HallandLakare",
  HallandSSK = "HallandSSK",
  KronobergLakare = "KronobergLakare",
  KronobergSSK = "KronobergSSK",
  OstergotlandLakare = "OstergotlandLakare",
  OstergotlandSSK = "OstergotlandSSK"
}

export enum TimeReportType {
  ActivePreparednessAPeriod = "ActivePreparednessAPeriod",
  ActivePreparednessBPeriod = "ActivePreparednessBPeriod",
  Common = "Common",
  OnCall = "OnCall",
  PassiveOnCall = "PassiveOnCall",
  PreparednessA = "PreparednessA",
  PreparednessB = "PreparednessB",
  SickDay = "SickDay",
  VabDay = "VabDay"
}

export enum TimeReportWorkType {
  OnCall = "OnCall",
  PreparednessA = "PreparednessA",
  PreparednessB = "PreparednessB",
  Work = "Work"
}

export type Timereport = {
  bookingId?: Maybe<Scalars["String"]>;
  consultantId?: Maybe<Scalars["String"]>;
  days: Array<TimereportDay>;
  department?: Maybe<Scalars["String"]>;
  endsOnUtc?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  isAssignedToBooking: Scalars["Boolean"];
  startsOnUtc?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
  timereportId: Scalars["String"];
  totalExpenses: Scalars["Float"];
  totalMileage: Scalars["Float"];
  workplace?: Maybe<Scalars["String"]>;
};

export type TimereportDay = {
  comment?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["String"]>;
  dayIndex: Scalars["Int"];
  expenses: Array<TimereportExpense>;
  isLunchModified?: Maybe<Scalars["Boolean"]>;
  lunch?: Maybe<Scalars["Int"]>;
  mileage?: Maybe<Scalars["Float"]>;
  onCallShifts: Array<TimereportOnCallShift>;
  preparednessAShifts: Array<TimereportPreparednessShift>;
  preparednessBShifts: Array<TimereportPreparednessShift>;
  sickTimeShifts: Array<TimereportSickOrVabShift>;
  vabTimeShifts: Array<TimereportSickOrVabShift>;
  workTimeRange?: Maybe<TimereportDayTimeRange>;
  workTimeRanges: Array<TimereportDayTimeRange>;
};

export type TimereportDayTimeRange = {
  from: Scalars["String"];
  to: Scalars["String"];
};

export type TimereportExpense = {
  amount: Scalars["Float"];
  attachments: Array<TimereportExpenseAttachment>;
  comment?: Maybe<Scalars["String"]>;
};

export type TimereportExpenseAttachment = {
  path?: Maybe<Scalars["String"]>;
  previewPath?: Maybe<Scalars["String"]>;
};

export type TimereportOnCallShift = {
  passivePeriods: Array<TimereportDayTimeRange>;
  period: TimereportDayTimeRange;
};

export type TimereportPreparednessShift = {
  activePeriods: Array<TimereportDayTimeRange>;
  period: TimereportDayTimeRange;
};

export type TimereportResult = {
  timereport: Scalars["JSON"];
};

export type TimereportSendFailure = {
  failedOn: Scalars["Date"];
  reason?: Maybe<Scalars["String"]>;
  recipient: Scalars["String"];
};

export type TimereportSendFailuresResult = {
  failures: Array<TimereportSendFailure>;
  partiallySent: Scalars["Boolean"];
};

export enum TimereportSendingToCustomerStatus {
  Approved = "Approved",
  Expired = "Expired",
  Invalid = "Invalid",
  Rejected = "Rejected",
  Sent = "Sent"
}

export type TimereportSickOrVabShift = {
  from: Scalars["String"];
  to: Scalars["String"];
  type?: Maybe<Scalars["String"]>;
};

export type TimereportStatusHistoryResult = {
  history: Scalars["JSON"];
};

export type TimereportTemplateSettings = {
  professions: Array<Scalars["String"]>;
  type: TimeReportTemplateType;
};

export type TodoBadges = {
  Badges: Array<CategoryBadge>;
  TotalUnread: Scalars["Int"];
};

export enum TodoCategory {
  Accommodation = "Accommodation",
  Applications = "Applications",
  Birthday = "Birthday",
  DelegatedByMe = "DelegatedByMe",
  KitAttestation = "KitAttestation",
  MyTask = "MyTask",
  NonAnswers = "NonAnswers",
  NotContacted = "NotContacted",
  Team = "Team",
  Travel = "Travel"
}

export type TodoDateRangeInput = {
  from?: InputMaybe<Scalars["Date"]>;
  to?: InputMaybe<Scalars["Date"]>;
};

export type TodoEvent = Event & {
  Audit: Audit;
  CanDelete: Scalars["Boolean"];
  CanEdit: Scalars["Boolean"];
  CanPin: Scalars["Boolean"];
  CreatedBy: WeakUserRef;
  CreatedOn: Scalars["Date"];
  Deleted: Scalars["Boolean"];
  DeletedBy: WeakUserRef;
  Description: Scalars["String"];
  DescriptionHtml: Scalars["String"];
  Links?: Maybe<Array<Scalars["String"]>>;
  Sticky: Scalars["Boolean"];
  TodoItem?: Maybe<TodoItem>;
  TodoRef?: Maybe<NodeRef>;
  Type: TodoEventType;
  UpdatedBy: WeakUserRef;
  Warning?: Maybe<Scalars["Boolean"]>;
  _id: Scalars["ObjectId"];
};

export enum TodoEventType {
  Comment = "Comment",
  Log = "Log",
  Reminder = "Reminder"
}

export type TodoInput = {
  ChargedProjects?: InputMaybe<Scalars["String"]>;
  CriminalRecordType?: InputMaybe<CriminalRecordType>;
  DeliveryPlace?: InputMaybe<Scalars["String"]>;
  Description?: InputMaybe<Scalars["String"]>;
  Due?: InputMaybe<Scalars["Date"]>;
  DueDateText?: InputMaybe<Scalars["String"]>;
  EducationType?: InputMaybe<ConsultantEducationType>;
  Errand?: InputMaybe<ConsultantSITHSErrand>;
  PerfPlace?: InputMaybe<Scalars["String"]>;
  Priority?: InputMaybe<TodoPriority>;
  Reference?: InputMaybe<ReferenceDataInput>;
  Reminder?: InputMaybe<Scalars["Boolean"]>;
  SecondaryText?: InputMaybe<Scalars["String"]>;
  Tags?: InputMaybe<Array<Scalars["String"]>>;
  Text: Scalars["String"];
  WorkInStockholm?: InputMaybe<Scalars["String"]>;
};

export type TodoItem = {
  Accepted?: Maybe<Scalars["Boolean"]>;
  AssignedBy: UserRef;
  AssignedOn: Scalars["Date"];
  AssignedTeam?: Maybe<Scalars["String"]>;
  AssignedTo?: Maybe<UserRef>;
  CanAccept?: Maybe<Scalars["Boolean"]>;
  CanDelete: Scalars["Boolean"];
  Comments: Array<TodoEvent>;
  Completed?: Maybe<Scalars["Date"]>;
  DelegatedBy?: Maybe<UserRef>;
  Deleted: Scalars["Boolean"];
  Description: Scalars["String"];
  Due?: Maybe<Scalars["Date"]>;
  LinkedItems?: Maybe<Array<NodeRef>>;
  NodeName?: Maybe<Scalars["String"]>;
  NodeType?: Maybe<NodeType>;
  Priority?: Maybe<TodoPriority>;
  RelatedTo?: Maybe<NodeRef>;
  SecondaryText: Scalars["String"];
  Status: TodoStatus;
  Tags: Array<Scalars["String"]>;
  Type: TodoItemType;
  URL?: Maybe<Scalars["String"]>;
  ViewMode: Scalars["Boolean"];
  WhoWatched?: Maybe<Array<Maybe<UserRef>>>;
  _id: Scalars["ObjectId"];
  type?: Maybe<NodeType>;
};

export type TodoItemInput = {
  Accepted?: InputMaybe<Scalars["Boolean"]>;
  AssignedTeam?: InputMaybe<Scalars["String"]>;
  AssignedTo?: InputMaybe<UserRefInput>;
  Description?: InputMaybe<Scalars["String"]>;
  Due?: InputMaybe<Scalars["Date"]>;
  LinkedItems?: InputMaybe<Array<InputMaybe<NodeRefFullInput>>>;
  Priority?: InputMaybe<TodoPriority>;
  SecondaryText?: InputMaybe<Scalars["String"]>;
  Tags?: InputMaybe<Array<Scalars["String"]>>;
  _id?: InputMaybe<Scalars["ObjectId"]>;
};

export enum TodoItemType {
  AlienItem = "AlienItem",
  AssignedByMe = "AssignedByMe",
  AssignedToMe = "AssignedToMe",
  OwnItem = "OwnItem"
}

export type TodoLinkedItem = {
  Name: Scalars["String"];
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Uri: Scalars["String"];
};

export enum TodoPriority {
  High = "High",
  Low = "Low",
  NoStatus = "NoStatus"
}

export type TodoSearchFilter = {
  assignedToTeams?: InputMaybe<Array<Scalars["String"]>>;
  assignedToUsers?: InputMaybe<Array<Scalars["ObjectId"]>>;
  category?: InputMaybe<Array<TodoCategory>>;
  createdBy?: InputMaybe<FilterInput>;
  createdDate?: InputMaybe<TodoDateRangeInput>;
  delegatedBy?: InputMaybe<Array<Scalars["ObjectId"]>>;
  dueDate?: InputMaybe<TodoDateRangeInput>;
  managedBy?: InputMaybe<Array<Scalars["ObjectId"]>>;
  priority?: InputMaybe<TodoPriority>;
  relatedTo?: InputMaybe<Array<Scalars["ObjectId"]>>;
  status?: InputMaybe<Array<TodoStatus>>;
  tags?: InputMaybe<Array<Scalars["String"]>>;
  teamIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  text?: InputMaybe<Scalars["String"]>;
};

export type TodoSearchItem = {
  _id: Scalars["ObjectId"];
  assignedBy?: Maybe<Scalars["String"]>;
  assignedTo?: Maybe<Scalars["String"]>;
  canAccept?: Maybe<Scalars["Boolean"]>;
  canComplete?: Maybe<Scalars["Boolean"]>;
  canDecline?: Maybe<Scalars["Boolean"]>;
  category?: Maybe<TodoCategory>;
  completedOn?: Maybe<Scalars["Date"]>;
  createdBy: Scalars["String"];
  createdOn: Scalars["Date"];
  delegatedBy?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  managedBy?: Maybe<Scalars["String"]>;
  priority?: Maybe<TodoPriority>;
  relatedTo?: Maybe<Array<NodeRef>>;
  search: TodoSearchMeta;
  status: TodoStatus;
  tags: Array<Scalars["String"]>;
  teamIds: Array<Scalars["ObjectId"]>;
  title: Scalars["String"];
  unreadStatuses: Array<TodoUnreadUserStatus>;
};

export type TodoSearchMeta = {
  searchText: Scalars["String"];
  showTop: Scalars["Boolean"];
  unreadComments: Scalars["Float"];
  unreadNew: Scalars["Float"];
};

export enum TodoSearchSortBy {
  Create = "Create",
  Due = "Due",
  NewMessages = "NewMessages",
  NewTickets = "NewTickets"
}

export enum TodoSortBy {
  Create = "Create",
  Due = "Due",
  NewMessages = "NewMessages",
  NewTickets = "NewTickets"
}

export type TodoSortItem = {
  by: TodoSortBy;
  dir?: InputMaybe<Scalars["Int"]>;
};

export enum TodoStatus {
  Accepted = "Accepted",
  Done = "Done",
  InProgress = "InProgress",
  New = "New"
}

export enum TodoStatusForUser {
  Comment = "Comment",
  Done = "Done",
  Expire = "Expire",
  New = "New",
  Watched = "Watched"
}

export type TodoTeamBadges = {
  Badges: Array<CategoryBadge>;
  TeamRef: NodeRef;
  TotalUnread: Scalars["Int"];
};

export type TodoTotalResult = {
  dbTime: Scalars["Float"];
  total: Scalars["Float"];
};

export enum TodoUnreadStatus {
  Comment = "Comment",
  Done = "Done",
  Expire = "Expire",
  New = "New"
}

export type TodoUnreadUserStatus = {
  count: Scalars["Float"];
  type: TodoUnreadStatus;
};

export type TodoUserBadges = {
  TeamBadges: Array<TodoTeamBadges>;
  TotalUnread: Scalars["Boolean"];
};

export type Total = {
  total: Scalars["Int"];
};

export enum TransportationType {
  Any = "Any",
  Boat = "Boat",
  Bus = "Bus",
  Flight = "Flight",
  Taxi = "Taxi",
  Train = "Train"
}

export type TravelConfirmation = {
  _id: Scalars["ObjectId"];
  allWeeks: Array<TravelConfirmationWeek>;
  confirmedBy?: Maybe<UserRef>;
  confirmedOn?: Maybe<Scalars["Date"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  documents: Array<Document>;
  taxWeeks: Array<TravelConfirmationWeek>;
  totalCost?: Maybe<Scalars["Float"]>;
  totalExVAT?: Maybe<Scalars["Boolean"]>;
  weeks: Array<Scalars["Date"]>;
};

export type TravelConfirmationWeek = {
  cost: Scalars["Float"];
  description?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["Date"]>;
  isTravel: Scalars["Boolean"];
  note?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  weekYear: WeekYear;
};

export type TravelRequest = {
  _id: Scalars["ObjectId"];
  bookingGroup?: Maybe<Scalars["ObjectId"]>;
  consultantId?: Maybe<Scalars["String"]>;
  costCenterId?: Maybe<Scalars["String"]>;
  createdById?: Maybe<Scalars["ObjectId"]>;
  createdByName?: Maybe<Scalars["String"]>;
  createdOn?: Maybe<Scalars["Date"]>;
  deadline?: Maybe<Scalars["Date"]>;
  isCancelable?: Maybe<Scalars["Boolean"]>;
  isFlexible?: Maybe<Scalars["Boolean"]>;
  isReschedule?: Maybe<Scalars["Boolean"]>;
  luggage?: Maybe<Scalars["String"]>;
  luggageType?: Maybe<LuggageType>;
  projectId?: Maybe<Scalars["String"]>;
  rescheduleComment?: Maybe<Scalars["String"]>;
  rides: Array<TravelRequestReturnRide>;
  ticketDifficultyLevel?: Maybe<TicketDifficultyLevel>;
  transportationType?: Maybe<Scalars["String"]>;
  travelPreferences?: Maybe<Scalars["String"]>;
  travelSuggestion?: Maybe<Scalars["String"]>;
};

export type TravelRequestFromInput = {
  city: Scalars["String"];
  comment?: InputMaybe<Scalars["String"]>;
  country: Scalars["String"];
  date: Scalars["Date"];
  time?: InputMaybe<TravelRequestTime>;
};

export type TravelRequestInfo = {
  confirmations: Array<TravelConfirmation>;
  travelIsOk: Scalars["Boolean"];
  travelRequest: Array<TravelRequest>;
  travelRequested: Scalars["Boolean"];
};

export type TravelRequestInput = {
  consultantId?: InputMaybe<Scalars["String"]>;
  costCenterId?: InputMaybe<Scalars["String"]>;
  deadline?: InputMaybe<Scalars["Date"]>;
  id?: InputMaybe<Scalars["ObjectId"]>;
  isCancelable: Scalars["Boolean"];
  isFlexible: Scalars["Boolean"];
  isReschedule?: InputMaybe<Scalars["Boolean"]>;
  luggageType?: InputMaybe<LuggageType>;
  projectId?: InputMaybe<Scalars["String"]>;
  rescheduleComment?: InputMaybe<Scalars["String"]>;
  rides: Array<TravelRequestReturnRideInput>;
  ticketDifficultyLevel: TicketDifficultyLevel;
  travelPreferences?: InputMaybe<Scalars["String"]>;
  travelSuggestion: Scalars["String"];
};

export type TravelRequestQueryInput = {
  from?: InputMaybe<Scalars["Date"]>;
  responsibleUserIds?: InputMaybe<Array<Scalars["String"]>>;
  senderIds?: InputMaybe<Array<Scalars["String"]>>;
  status?: InputMaybe<Array<InputMaybe<TravelRequestStatusType>>>;
  text?: InputMaybe<Scalars["String"]>;
  to?: InputMaybe<Scalars["Date"]>;
};

export type TravelRequestReturnRide = {
  dir1?: Maybe<TravelRequestRide>;
  dir2?: Maybe<TravelRequestRide>;
  rideType?: Maybe<RideType>;
  transportationType?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type TravelRequestReturnRideInput = {
  dir1: TravelRequestFromInput;
  dir2: TravelRequestToInput;
  rideType: RideType;
  transportationType: Array<TransportationType>;
};

export type TravelRequestRide = {
  city?: Maybe<Scalars["String"]>;
  comment?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["Date"]>;
  time?: Maybe<TravelRequestTime>;
};

export type TravelRequestSearch = {
  _id?: Maybe<Scalars["ObjectId"]>;
  city?: Maybe<Scalars["String"]>;
  consultantName?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<UserRef>;
  createdOn?: Maybe<Scalars["Date"]>;
  firstDeparture?: Maybe<Scalars["Date"]>;
  status?: Maybe<TravelRequestStatus>;
  weeks?: Maybe<Array<Maybe<BookingLinks>>>;
};

export type TravelRequestSearchResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  items: Array<TravelRequestSearch>;
  limit: Scalars["Int"];
  skip: Scalars["Int"];
};

export type TravelRequestSearchTotalResult = {
  dbTime?: Maybe<Scalars["Int"]>;
  total: Scalars["Int"];
};

export enum TravelRequestSortBy {
  CreatedOn = "CreatedOn",
  FirstDepartureDate = "FirstDepartureDate"
}

export type TravelRequestStatus = {
  setBy?: Maybe<UserRef>;
  setOn?: Maybe<Scalars["Date"]>;
  status?: Maybe<TravelRequestStatusType>;
};

export enum TravelRequestStatusType {
  Closed = "Closed",
  Open = "Open"
}

export enum TravelRequestTableColumns {
  City = "City",
  Consultant = "Consultant",
  CreatedOn = "CreatedOn",
  DepartureDate = "DepartureDate",
  Sender = "Sender",
  Status = "Status",
  Week = "Week"
}

export enum TravelRequestTime {
  Day = "Day",
  Evening = "Evening",
  Morning = "Morning",
  Noon = "Noon"
}

export type TravelRequestToInput = {
  city: Scalars["String"];
  comment?: InputMaybe<Scalars["String"]>;
  country: Scalars["String"];
  date?: InputMaybe<Scalars["Date"]>;
  time?: InputMaybe<TravelRequestTime>;
};

export type TravelZone = {
  articleNumber: Scalars["String"];
  name: Scalars["String"];
};

export type TravelZoneInput = {
  articleNumber: Scalars["String"];
  name: Scalars["String"];
};

export type TravelsAlt = {
  MaxCost?: Maybe<ConsultantContractTravelsMaxCost>;
  PossibleSupplement?: Maybe<Scalars["String"]>;
  TravelTemplateValue?: Maybe<Scalars["Float"]>;
  Type?: Maybe<ConsultantContractTravelsAlt>;
};

export type TravelsAltInput = {
  MaxCost?: InputMaybe<ConsultantContractTravelsMaxCostInput>;
  PossibleSupplement?: InputMaybe<Scalars["String"]>;
  TravelTemplateValue?: InputMaybe<Scalars["Float"]>;
  Type?: InputMaybe<ConsultantContractTravelsAlt>;
};

export type UnlockFormsResult = {
  unlockForms: Scalars["Boolean"];
};

export type UpdateBookingFinanceInput = {
  AccommodationCost?: InputMaybe<Scalars["Float"]>;
  AdditionalWork?: InputMaybe<Scalars["Boolean"]>;
  AdditionalWorkNote?: InputMaybe<Scalars["String"]>;
  BonlivaCareInvoice?: InputMaybe<BonlivaCareInvoiceInput>;
  BusinessName?: InputMaybe<Scalars["String"]>;
  BusinessSocialSecurityNo?: InputMaybe<Scalars["String"]>;
  ChangedKeys?: InputMaybe<Array<Scalars["String"]>>;
  ContractType?: InputMaybe<ContractType>;
  CustomerFine?: InputMaybe<Scalars["String"]>;
  DeletedSubcontractorDocumentIds?: InputMaybe<Array<Scalars["ObjectId"]>>;
  EmployeeSalary?: InputMaybe<Scalars["Float"]>;
  GroupInvoiceTotal?: InputMaybe<Scalars["Float"]>;
  Invoices: Array<Scalars["String"]>;
  IsConsultantPayed?: InputMaybe<Scalars["Boolean"]>;
  IsSickPayed?: InputMaybe<Scalars["Boolean"]>;
  LegalPersonType?: InputMaybe<LegalPersonType>;
  NewSubcontractorDocuments?: InputMaybe<Array<Scalars["String"]>>;
  Note?: InputMaybe<Scalars["String"]>;
  PatientId?: InputMaybe<Scalars["String"]>;
  SickPayTotal?: InputMaybe<Scalars["Float"]>;
  SubcontractorInvoiceTotal?: InputMaybe<Scalars["Float"]>;
  TravelCost?: InputMaybe<Scalars["Float"]>;
  UpdateConsultantWithSnapshotData?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateBookingKitInput = {
  bookingId: Scalars["ObjectId"];
  bookingSupportCheckWasValid: Scalars["Boolean"];
  comment?: InputMaybe<Scalars["String"]>;
  consultantId: Scalars["ObjectId"];
  filesIds: Array<Scalars["ObjectId"]>;
  id: Scalars["ObjectId"];
  managerId?: InputMaybe<Scalars["ObjectId"]>;
  receipts?: InputMaybe<Array<BookingKitExpensesReceiptInput>>;
  responsibleId?: InputMaybe<Scalars["ObjectId"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  tagsNote?: InputMaybe<Scalars["String"]>;
  templateType: TimeReportTemplateType;
  type: BookingKitType;
  withConsultantInvoice: Scalars["Boolean"];
  withCustomerInvoice: Scalars["Boolean"];
  withSickPay: Scalars["Boolean"];
  withSubcontractorPay: Scalars["Boolean"];
  withTimeReport: Scalars["Boolean"];
};

export type UpdateBookingResult = {
  Booking?: Maybe<Booking>;
};

export type UpdateConsultantServicePreferenceInput = {
  customers?: InputMaybe<Array<InputMaybe<CustomerRefInput>>>;
  description: Scalars["String"];
  period: ConsultantServicePreferencePeriodInput;
};

export type UpdateConsultantWorkStatusInput = {
  competitorName?: InputMaybe<Scalars["String"]>;
  reminderDate?: InputMaybe<Scalars["Date"]>;
  startDate: Scalars["Date"];
  type: ConsultantWorkStatusType;
};

export type UpdateContactPersonResult = {
  contactPerson?: Maybe<ContactPerson>;
  validationErrors: Array<ValidationError>;
};

export type UpdateCostCenterInput = {
  isActive?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  organisation?: InputMaybe<Scalars["String"]>;
  tenant?: InputMaybe<Scalars["String"]>;
};

export type UpdateCustomerResult = {
  customer?: Maybe<Customer>;
  validationErrors?: Maybe<Array<ValidationError>>;
};

export type UpdateEventInput = {
  Description?: InputMaybe<Scalars["String"]>;
  Sticky?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateMoveCustomerResult = {
  customer?: Maybe<Customer>;
  validationErrors: Array<Scalars["String"]>;
};

export type UpdateTgRequirementInput = {
  minRequiredTG: Scalars["Float"];
};

export type UploadBookingDocumentResult = {
  fileRef: FileRef;
};

export type UploadConsultantDocumentResult = {
  Consultant: Consultant;
  FileRef: FileRef;
};

export type UploadSharedDocumentResult = {
  FileRef: FileRef;
};

export type User = BaseUser & {
  AvatarPic?: Maybe<Scalars["String"]>;
  AzureGroups?: Maybe<Array<Scalars["String"]>>;
  AzureId?: Maybe<Scalars["String"]>;
  BirthDate?: Maybe<Scalars["Date"]>;
  CellPhone?: Maybe<Scalars["String"]>;
  Deleted: Scalars["Boolean"];
  Email: Scalars["String"];
  Enabled: Scalars["Boolean"];
  ManagerId?: Maybe<Scalars["ObjectId"]>;
  Name: Scalars["String"];
  NodeID: Scalars["ObjectId"];
  NodeType: NodeType;
  Phone?: Maybe<Scalars["String"]>;
  Teams: Array<Scalars["String"]>;
  Title?: Maybe<Scalars["String"]>;
  _id: Scalars["ObjectId"];
};

export type UserCallList = {
  _id: Scalars["ObjectId"];
  name: Scalars["String"];
};

export type UserPermissions = {
  AllowInProduction?: Maybe<Scalars["Boolean"]>;
  CanAccessCustomers?: Maybe<Scalars["Boolean"]>;
  CanAccessReports?: Maybe<Scalars["Boolean"]>;
  CanAddAccommodation?: Maybe<Scalars["Boolean"]>;
  CanAddCustomer?: Maybe<Scalars["Boolean"]>;
  CanDeleteConsultantBookingContract?: Maybe<Scalars["Boolean"]>;
  CanDeleteConsultantContract?: Maybe<Scalars["Boolean"]>;
  CanDeleteConsultants?: Maybe<Scalars["Boolean"]>;
  CanDeleteCustomers?: Maybe<Scalars["Boolean"]>;
  CanImportConsultants?: Maybe<Scalars["Boolean"]>;
  CanMoveCustomers?: Maybe<Scalars["Boolean"]>;
  CanPose?: Maybe<Scalars["Boolean"]>;
  CanSelectAllInMassActions?: Maybe<Scalars["Boolean"]>;
  CanUpdateConsultantGDPR?: Maybe<Scalars["Boolean"]>;
  CanUpdateConsultantInitialContact?: Maybe<Scalars["Boolean"]>;
  CanUpdateCustomerNumber?: Maybe<Scalars["Boolean"]>;
};

export type UserRef = {
  Name: Scalars["String"];
  PersonId: Scalars["ObjectId"];
};

export type UserRefInput = {
  PersonId: Scalars["ObjectId"];
};

export type UserRefInputStrict = {
  Name: Scalars["String"];
  PersonId: Scalars["ObjectId"];
};

export type UserSettings = {
  Enabled: Scalars["Boolean"];
};

export type UserSettingsInput = {
  Enabled: Scalars["Boolean"];
};

export type ValidationError = {
  Message?: Maybe<Scalars["String"]>;
  Path?: Maybe<Scalars["String"]>;
};

export type ValueLabel = {
  disabled?: InputMaybe<Scalars["Boolean"]>;
  error?: InputMaybe<Scalars["Boolean"]>;
  label: Scalars["String"];
  value: Scalars["String"];
};

export type WeakUserRef = {
  Name?: Maybe<Scalars["String"]>;
  PersonId?: Maybe<Scalars["ObjectId"]>;
};

export enum WebhookDeliveryStatus {
  Completed = "Completed",
  Failed = "Failed",
  FailedPermanently = "FailedPermanently",
  Pending = "Pending"
}

export type WeekYear = {
  Week: Scalars["Int"];
  Year: Scalars["Int"];
};

export type WeekYearInput = {
  Week: Scalars["Int"];
  Year: Scalars["Int"];
};

export type WithTodoInput = {
  assignedTeam?: InputMaybe<Scalars["String"]>;
  assignedUserId?: InputMaybe<Scalars["ObjectId"]>;
  date?: InputMaybe<Scalars["Date"]>;
  priority?: InputMaybe<TodoPriority>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  text: Scalars["String"];
};

export enum WorkedInNorwayOption {
  All = "All",
  No = "No",
  Yes = "Yes",
  YesWithDNumber = "YesWithDNumber",
  YesWithoutDNumber = "YesWithoutDNumber"
}

export type WorkflowRun = {
  _id?: Maybe<Scalars["ObjectId"]>;
  completedAt?: Maybe<Scalars["Date"]>;
  entityId: Scalars["String"];
  entityType: Scalars["String"];
  errorMessage?: Maybe<Scalars["String"]>;
  metadata?: Maybe<Scalars["JSON"]>;
  result?: Maybe<Scalars["JSON"]>;
  scheduledAt: Scalars["Date"];
  startedAt?: Maybe<Scalars["Date"]>;
  status: WorkflowStatus;
  steps: Array<WorkflowStep>;
  workflowId: Scalars["String"];
  workflowType: Scalars["String"];
};

export type WorkflowRunsPaginatedResult = {
  items: Array<WorkflowRun>;
  total: Scalars["Int"];
};

export enum WorkflowStatus {
  Canceled = "Canceled",
  Completed = "Completed",
  Failed = "Failed",
  Running = "Running",
  Scheduled = "Scheduled",
  Terminated = "Terminated"
}

export type WorkflowStep = {
  _id: Scalars["ID"];
  completedAt?: Maybe<Scalars["Date"]>;
  description?: Maybe<Scalars["String"]>;
  failedAt?: Maybe<Scalars["Date"]>;
  startedAt?: Maybe<Scalars["Date"]>;
  title: Scalars["String"];
};

export enum Workshift {
  Day = "Day",
  Evening = "Evening",
  Holiday = "Holiday",
  Night = "Night",
  OnCall = "OnCall",
  Weekend = "Weekend"
}

export type AccommodationResolver<Parent> = ReturnTypeResolver<Parent, Accommodation>;
export type Accommodation__Fields = {
  Address: Address__Fields;
  CancellationPolicy: boolean;
  CheckIn: boolean;
  CheckOut: boolean;
  Email: boolean;
  ImgUrl: boolean;
  Instruction: boolean;
  Name: boolean;
  Offers: AccommodationOffer__Fields;
  Phone: boolean;
  ResponsiblePersonRef: UserRef__Fields;
  Site: boolean;
  Type: boolean;
  _id: boolean;
  documents: Document__Fields;
  envCertification: boolean;
  envCertificationName: boolean;
  preferredChoice: boolean;
  unfit: AccommodationUnfit__Fields;
};

export type AccommodationAltResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationAlt
>;
export type AccommodationAlt__Fields = {
  MaxCost: ConsultantContractMaxCost__Fields;
  PossibleSupplement: boolean;
  Type: boolean;
};

export type AccommodationBaseResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationBase
>;
export type AccommodationBase__Fields = {
  Address: Address__Fields;
  Email: boolean;
  ImgUrl: boolean;
  Name: boolean;
  Offers: AccommodationOffer__Fields;
  Phone: boolean;
  ResponsiblePersonRef: UserRef__Fields;
  Site: boolean;
  Type: boolean;
  _id: boolean;
  envCertification: boolean;
  envCertificationName: boolean;
  preferredChoice: boolean;
};

export type AccommodationConfirmationResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationConfirmation
>;
export type AccommodationConfirmation__Fields = {
  _id: boolean;
  accommodationRef: AccommodationRef__Fields;
  allWeeks: AccommodationConfirmationWeek__Fields;
  area: boolean;
  city: boolean;
  confirmedBy: UserRef__Fields;
  confirmedOn: boolean;
  deleted: boolean;
  documents: Document__Fields;
  offerId: boolean;
  source: boolean;
  squareFootageAttached: boolean;
  syncedAt: boolean;
  taxWeeks: AccommodationConfirmationWeek__Fields;
  taxationId: boolean;
  totalCost: boolean;
  totalExVAT: boolean;
  weeks: boolean;
};

export type AccommodationConfirmationLineResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationConfirmationLine
>;
export type AccommodationConfirmationLine__Fields = {
  accommodationName: boolean;
  area: boolean;
  city: boolean;
  cost: boolean;
  endDate: boolean;
  extraCost: boolean;
  extraDescription: boolean;
  nights: boolean;
  paymentMethod: boolean;
  reservationId: boolean;
  startDate: boolean;
  stayedNights: boolean;
  tax: boolean;
};

export type AccommodationConfirmationWeekResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationConfirmationWeek
>;
export type AccommodationConfirmationWeek__Fields = {
  cost: boolean;
  endDate: boolean;
  extraCost: boolean;
  extraDescription: boolean;
  isTaxed: boolean;
  lines: AccommodationConfirmationLine__Fields;
  nights: boolean;
  note: boolean;
  startDate: boolean;
  tax: boolean;
  weekYear: WeekYear__Fields;
};

export type AccommodationEventResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationEvent
>;
export type AccommodationEvent__Fields = {
  Audit: Audit__Fields;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedBy: WeakUserRef__Fields;
  CreatedOn: boolean;
  Deleted: boolean;
  DeletedBy: WeakUserRef__Fields;
  Description: boolean;
  DescriptionHtml: boolean;
  Links: boolean;
  Node: NodeRef__Fields;
  Sticky: boolean;
  Type: boolean;
  UpdatedBy: WeakUserRef__Fields;
  Warning: boolean;
  _id: boolean;
};

export type AccommodationListItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationListItem
>;
export type AccommodationListItem__Fields = {
  Address: Address__Fields;
  Email: boolean;
  ImgUrl: boolean;
  Name: boolean;
  Offers: AccommodationOffer__Fields;
  Phone: boolean;
  ResponsiblePersonRef: UserRef__Fields;
  Site: boolean;
  Type: boolean;
  _id: boolean;
  envCertification: boolean;
  envCertificationName: boolean;
  preferredChoice: boolean;
  unfit: AccommodationUnfit__Fields;
};

export type AccommodationOfferResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationOffer
>;
export type AccommodationOffer__Fields = {
  Area: boolean;
  Beds: boolean;
  Name: boolean;
  Options: boolean;
  Price: boolean;
  PriceType: boolean;
  Rooms: boolean;
  _id: boolean;
};

export type AccommodationPeriodResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationPeriod
>;
export type AccommodationPeriod__Fields = {
  end: boolean;
  start: boolean;
};

export type AccommodationRefResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationRef
>;
export type AccommodationRef__Fields = {
  Name: boolean;
  NodeID: boolean;
  NodeType: boolean;
};

export type AccommodationRequestResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationRequest
>;
export type AccommodationRequest__Fields = {
  _id: boolean;
  acceptedOveragePercent: boolean;
  accommodationLink: boolean;
  accommodationPreferences: boolean;
  accommodationSuggestion: boolean;
  accommodationType: boolean;
  additionalInfo: boolean;
  bookingConfirmationFile: CrmDocument__Fields;
  bookingGroup: boolean;
  bookingInformation: boolean;
  budget: boolean;
  budgetPeriod: boolean;
  carAccess: boolean;
  city: boolean;
  commentAboutBooking: boolean;
  consultantId: boolean;
  costCenterId: boolean;
  country: boolean;
  createdById: boolean;
  createdByName: boolean;
  createdOn: boolean;
  customerAddress: boolean;
  deadline: boolean;
  differentCity: boolean;
  endTime: boolean;
  hasAccommodationSuggestion: boolean;
  hasCarAccess: boolean;
  hasOwnCar: boolean;
  isProlongation: boolean;
  isReschedule: boolean;
  maxAllowedPerNight: boolean;
  paidBy: boolean;
  parkingMaxPrice: boolean;
  periodInput: boolean;
  periods: AccommodationPeriod__Fields;
  projectId: boolean;
  rescheduleComment: boolean;
  sharedBathroom: boolean;
  sharedConveniences: boolean;
  sharedKitchen: boolean;
  shouldBeBookedDirectly: boolean;
  specifyCity: boolean;
  staffAccommodation: boolean;
  startTime: boolean;
  ticketDifficultyLevel: boolean;
  travelPreferences: boolean;
  walkingDistance: boolean;
  zzNumber: boolean;
};

export type AccommodationRequestInfoResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationRequestInfo
>;
export type AccommodationRequestInfo__Fields = {
  accommodationIsOk: boolean;
  accommodationRequest: AccommodationRequest__Fields;
  accommodationRequested: boolean;
  confirmations: AccommodationConfirmation__Fields;
};

export type AccommodationRequestSearchResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationRequestSearch
>;
export type AccommodationRequestSearch__Fields = {
  _id: boolean;
  city: boolean;
  consultantName: boolean;
  createdBy: UserRef__Fields;
  createdOn: boolean;
  firstArrival: boolean;
  status: AccommodationRequestStatus__Fields;
  weeks: BookingLinks__Fields;
};

export type AccommodationRequestSearchResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationRequestSearchResult
>;
export type AccommodationRequestSearchResult__Fields = {
  dbTime: boolean;
  items: AccommodationRequestSearch__Fields;
  limit: boolean;
  skip: boolean;
};

export type AccommodationRequestSearchTotalResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationRequestSearchTotalResult
>;
export type AccommodationRequestSearchTotalResult__Fields = {
  dbTime: boolean;
  total: boolean;
};

export type AccommodationRequestStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationRequestStatus
>;
export type AccommodationRequestStatus__Fields = {
  setBy: UserRef__Fields;
  setOn: boolean;
  status: boolean;
};

export type AccommodationTravelAuditResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationTravelAudit
>;
export type AccommodationTravelAudit__Fields = {
  approved: boolean;
  setBy: UserRef__Fields;
  setOn: boolean;
};

export type AccommodationUnfitResolver<Parent> = ReturnTypeResolver<
  Parent,
  AccommodationUnfit
>;
export type AccommodationUnfit__Fields = {
  comment: boolean;
  userRef: UserRef__Fields;
  value: boolean;
};

export type ActivitiesRecordResolver<Parent> = ReturnTypeResolver<
  Parent,
  ActivitiesRecord
>;
export type ActivitiesRecord__Fields = {
  count: boolean;
  date: boolean;
};

export type AddNoanswerEventResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  AddNoanswerEventResult
>;
export type AddNoanswerEventResult__Fields = {
  event: ConsultantEvent__Fields;
  todo: TodoItem__Fields;
};

export type AddressResolver<Parent> = ReturnTypeResolver<Parent, Address>;
export type Address__Fields = {
  City: boolean;
  Country: boolean;
  Region: boolean;
  StreetName: boolean;
  ZipCode: boolean;
  formattedShort: boolean;
};

export type AllConsultantTagsResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  AllConsultantTagsResult
>;
export type AllConsultantTagsResult__Fields = {
  tags: boolean;
};

export type AnsweredQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  AnsweredQualityStatus
>;
export type AnsweredQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
};

export type AnyNodeResolver<Parent> = ReturnTypeResolver<Parent, AnyNode>;
export type AnyNode__Fields = Consultant__Fields | Customer__Fields | TodoItem__Fields;

export type ApiTokenResolver<Parent> = ReturnTypeResolver<Parent, ApiToken>;
export type ApiToken__Fields = {
  createdOn: boolean;
  id: boolean;
  lastUsedOn: boolean;
  name: boolean;
  revoked: boolean;
};

export type ApprovedQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  ApprovedQualityStatus
>;
export type ApprovedQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  ExpiresInMonths: boolean;
  ExpiresOn: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
  params: boolean;
  pausedState: PausedState__Fields;
};

export type ApprovedWithCommentQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  ApprovedWithCommentQualityStatus
>;
export type ApprovedWithCommentQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  ExpiresInMonths: boolean;
  ExpiresOn: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
  params: boolean;
};

export type AssignContactPersonToCustomerResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  AssignContactPersonToCustomerResult
>;
export type AssignContactPersonToCustomerResult__Fields = {
  ContactPerson: ContactPerson__Fields;
  Customer: Customer__Fields;
};

export type AuditResolver<Parent> = ReturnTypeResolver<Parent, Audit>;
export type Audit__Fields = {
  Created: AuditContent__Fields;
  Deleted: AuditContent__Fields;
  Updated: AuditContent__Fields;
};

export type AuditContentResolver<Parent> = ReturnTypeResolver<Parent, AuditContent>;
export type AuditContent__Fields = {
  Date: boolean;
  User: UserRef__Fields;
};

export type AuditItemResolver<Parent> = ReturnTypeResolver<Parent, AuditItem>;
export type AuditItem__Fields = {
  date: boolean;
  type: boolean;
  userRef: UserRef__Fields;
};

export type AwaitingApprovalQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  AwaitingApprovalQualityStatus
>;
export type AwaitingApprovalQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
};

export type BaseContractResolver<Parent> = ReturnTypeResolver<Parent, BaseContract>;
export type BaseContract__Fields = {
  _id: boolean;
  name: boolean;
  variant: boolean;
};

export type BaseFormAddressResolver<Parent> = ReturnTypeResolver<Parent, BaseFormAddress>;
export type BaseFormAddress__Fields = {
  city: boolean;
  country: boolean;
  streetName: boolean;
  zipCode: boolean;
};

export type BaseUserResolver<Parent> = ReturnTypeResolver<Parent, BaseUser>;
export type BaseUser__Fields = {
  AzureGroups: boolean;
  AzureId: boolean;
  BirthDate: boolean;
  CellPhone: boolean;
  Deleted: boolean;
  Email: boolean;
  Enabled: boolean;
  ManagerId: boolean;
  Name: boolean;
  Phone: boolean;
  Teams: boolean;
  Title: boolean;
  _id: boolean;
};

export type BasicPriceResolver<Parent> = ReturnTypeResolver<Parent, BasicPrice>;
export type BasicPrice__Fields = {
  dates: boolean;
  price: boolean;
};

export type BisnodePersonResolver<Parent> = ReturnTypeResolver<Parent, BisnodePerson>;
export type BisnodePerson__Fields = {
  AddressCity: boolean;
  AddressCountry: boolean;
  AddressStreetName: boolean;
  AddressZipCode: boolean;
  BirthDate: boolean;
  CellPhone: boolean;
  Fax: boolean;
  FirstName: boolean;
  LastName: boolean;
  Phone: boolean;
};

export type BookedQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookedQualityStatus
>;
export type BookedQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
};

export type BookingResolver<Parent> = ReturnTypeResolver<Parent, Booking>;
export type Booking__Fields = {
  AccommodationRequired: boolean;
  AdditionalWork: boolean;
  AdditionalWorkNote: boolean;
  AdministrativeFee: boolean;
  AreaOfExpertise: boolean;
  BookingAudit: BookingAudit__Fields;
  BookingGroup: BookingGroup__Fields;
  Consultant: Consultant__Fields;
  ConsultantSnapshot: BookingConsultantSnapshot__Fields;
  ContractType: boolean;
  CostCenter: CostCenter__Fields;
  CustomerFine: boolean;
  CustomerNumber: boolean;
  GroupInvoiceTotal: boolean;
  GroupInvoicing: boolean;
  InvoiceTotal: boolean;
  Invoices: BookingCustomerInvoice__Fields;
  IsCanceled: boolean;
  IsConsultantPayed: boolean;
  IsCustomerBilled: boolean;
  Note: boolean;
  PatientId: boolean;
  Project: Project__Fields;
  SubcontractorDocuments: Document__Fields;
  TravelRequired: boolean;
  Week: boolean;
  _id: boolean;
  additionalPayoutAmount: boolean;
  additionalPayoutDescription: boolean;
  attachments: Document__Fields;
  bookingAssignedTo: BookingAssignedTo__Fields;
  bookingIntro: BookingIntro__Fields;
  bookingKits: BookingKit__Fields;
  bookingStatus: BookingStatus__Fields;
  bookingSupportTagComment: boolean;
  bookingSupportTagStatus: BookingSupportTagStatus__Fields;
  callNumber: boolean;
  costs: BookingCosts__Fields;
  createdBy: User__Fields;
  createdOn: boolean;
  customersWithNoApproval: BookingNoApprovalForTimeReport__Fields;
  deletedBy: User__Fields;
  deletedOn: boolean;
  draftCosts: BookingCosts__Fields;
  duplicateIds: boolean;
  erpExportUnitRef: boolean;
  externalRef: boolean;
  hasKits: boolean;
  isCancellable: boolean;
  isFirstWeek: boolean;
  isOpen: boolean;
  isSickPayed: boolean;
  monthBreakSide: boolean;
  profit: BookingProfit__Fields;
  rejectedBookingKits: BookingKit__Fields;
  requireTravelInvoicing: boolean;
  skipTimereportReminder: boolean;
  specializations: boolean;
  timeReportHasSickTime: boolean;
  timeReportStatus: boolean;
  timeReportTypeSentToHBA: boolean;
  unlockForms: boolean;
  updatedBy: User__Fields;
  updatedOn: boolean;
};

export type BookingAssignedToResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingAssignedTo
>;
export type BookingAssignedTo__Fields = {
  setBy: UserRef__Fields;
  setOn: boolean;
  setTo: UserRef__Fields;
};

export type BookingAssignedToResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingAssignedToResult
>;
export type BookingAssignedToResult__Fields = {
  bookingAssignedTo: BookingAssignedTo__Fields;
  bookingId: boolean;
};

export type BookingAuditResolver<Parent> = ReturnTypeResolver<Parent, BookingAudit>;
export type BookingAudit__Fields = {
  Approved: boolean;
  Comment: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
};

export type BookingChecksResolver<Parent> = ReturnTypeResolver<Parent, BookingChecks>;
export type BookingChecks__Fields = {
  accommodationSum: boolean;
  attachTimeReport: boolean;
  consultantContractId: boolean;
  contractNumber: boolean;
  costCenter: boolean;
  customerContractId: boolean;
  customerNumber: boolean;
  expenses: boolean;
  groupInvoicing: boolean;
  hours: boolean;
  mileage: boolean;
  orderId: boolean;
  orderNumber: boolean;
  project: boolean;
  requiredForm: boolean;
  totalInvoice: boolean;
  travelSum: boolean;
};

export type BookingConsultantSnapshotResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingConsultantSnapshot
>;
export type BookingConsultantSnapshot__Fields = {
  BusinessName: boolean;
  BusinessSocialSecurityNo: boolean;
  LegalPersonType: boolean;
};

export type BookingContractInfoResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingContractInfo
>;
export type BookingContractInfo__Fields = {
  _id: boolean;
  name: boolean;
  variant: boolean;
};

export type BookingCostsResolver<Parent> = ReturnTypeResolver<Parent, BookingCosts>;
export type BookingCosts__Fields = {
  accommodation: boolean;
  employeeSalary: boolean;
  invoiceTotal: boolean;
  sickPayTotal: boolean;
  travel: boolean;
};

export type BookingCustomerInvoiceResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingCustomerInvoice
>;
export type BookingCustomerInvoice__Fields = {
  invoice: Invoice__Fields;
  invoiceNumber: boolean;
};

export type BookingDocumentResolver<Parent> = ReturnTypeResolver<Parent, BookingDocument>;
export type BookingDocument__Fields = {
  _id: boolean;
  name: boolean;
  type: boolean;
};

export type BookingEventResolver<Parent> = ReturnTypeResolver<Parent, BookingEvent>;
export type BookingEvent__Fields = {
  Audit: Audit__Fields;
  BookingId: boolean;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedBy: WeakUserRef__Fields;
  CreatedOn: boolean;
  Deleted: boolean;
  DeletedBy: WeakUserRef__Fields;
  Description: boolean;
  DescriptionHtml: boolean;
  Links: boolean;
  ResultOfAction: boolean;
  Sticky: boolean;
  Type: boolean;
  UpdatedBy: WeakUserRef__Fields;
  UserRef: UserRef__Fields;
  Warning: boolean;
  _id: boolean;
};

export type BookingGroupResolver<Parent> = ReturnTypeResolver<Parent, BookingGroup>;
export type BookingGroup__Fields = {
  _id: boolean;
  accommodationRequestedWeeks: boolean;
  authorizedOrderer: boolean;
  billingInstructions: boolean;
  bookings: Booking__Fields;
  consultant: Consultant__Fields;
  consultantContractId: boolean;
  customerContract: CustomerContractListItem__Fields;
  customerContractId: boolean;
  department: Customer__Fields;
  externalId: boolean;
  hasClosedBooking: boolean;
  hasOpenBookings: boolean;
  hospital: Customer__Fields;
  isDiscount: boolean;
  isNationalProcurement: boolean;
  nationalProcurementTravelRequired: boolean;
  subVersionId: boolean;
  travelTemplateLevel: boolean;
};

export type BookingGroupCancellableResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingGroupCancellableResult
>;
export type BookingGroupCancellableResult__Fields = {
  isCancellable: boolean;
  nonCancellableReason: boolean;
};

export type BookingHospitalityResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingHospitality
>;
export type BookingHospitality__Fields = {
  _id: boolean;
  accommodation: AccommodationRequestInfo__Fields;
  travel: TravelRequestInfo__Fields;
};

export type BookingIntroResolver<Parent> = ReturnTypeResolver<Parent, BookingIntro>;
export type BookingIntro__Fields = {
  description: boolean;
  endDate: boolean;
  required: boolean;
  startDate: boolean;
};

export type BookingInvoicePaymentStatusesResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingInvoicePaymentStatusesResult
>;
export type BookingInvoicePaymentStatusesResult__Fields = {
  invoicePaymentStatuses: boolean;
};

export type BookingKitResolver<Parent> = ReturnTypeResolver<Parent, BookingKit>;
export type BookingKit__Fields = {
  _id: boolean;
  assigned: KitAssignedTo__Fields;
  booking: Booking__Fields;
  bookingId: boolean;
  bookingSupportCheckWasValid: boolean;
  bookingSupportTagComment: boolean;
  bookingSupportTagStatus: BookingSupportTagStatus__Fields;
  comments: boolean;
  consultant: Consultant__Fields;
  consultantPayoutType: boolean;
  costCenter: CostCenter__Fields;
  createdOn: boolean;
  currentFinanceInvoiceStatus: BookingKitStatus__Fields;
  currentFinancePaymentStatus: BookingKitStatus__Fields;
  currentHBAStatus: BookingKitStatus__Fields;
  currentOCStatus: BookingKitStatus__Fields;
  customerBillingInstructions: boolean;
  customerContractType: boolean;
  deleted: boolean;
  deletedByName: boolean;
  deletedOn: boolean;
  department: Customer__Fields;
  documents: CrmDocument__Fields;
  hospital: Customer__Fields;
  isDone: boolean;
  isGroupInvoicing: boolean;
  isRejected: boolean;
  manager: User__Fields;
  name: boolean;
  profitNet: boolean;
  profitRatio: boolean;
  project: Project__Fields;
  receipts: BookingKitExpensesReceipt__Fields;
  responsible: User__Fields;
  status: boolean;
  statuses: BookingKitStatus__Fields;
  timeReportType: boolean;
  type: boolean;
  week: boolean;
  withConsultantInvoice: boolean;
  withCustomerInvoice: boolean;
  withSickPay: boolean;
  withSubcontractorPay: boolean;
  withTimeReport: boolean;
};

export type BookingKitApprovalConfigResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingKitApprovalConfig
>;
export type BookingKitApprovalConfig__Fields = {
  canApprove: boolean;
  canReject: boolean;
  canRejectDone: boolean;
};

export type BookingKitDraftResolver<Parent> = ReturnTypeResolver<Parent, BookingKitDraft>;
export type BookingKitDraft__Fields = {
  costCenterId: boolean;
  documents: CrmDocument__Fields;
  timereportTemplateType: boolean;
};

export type BookingKitEventResolver<Parent> = ReturnTypeResolver<Parent, BookingKitEvent>;
export type BookingKitEvent__Fields = {
  Audit: Audit__Fields;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedBy: WeakUserRef__Fields;
  CreatedOn: boolean;
  Deleted: boolean;
  DeletedBy: WeakUserRef__Fields;
  Description: boolean;
  DescriptionHtml: boolean;
  Links: boolean;
  ResultOfAction: boolean;
  Sticky: boolean;
  Type: boolean;
  UpdatedBy: WeakUserRef__Fields;
  UserRef: UserRef__Fields;
  Warning: boolean;
  _id: boolean;
  kitId: boolean;
};

export type BookingKitExpensesReceiptResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingKitExpensesReceipt
>;
export type BookingKitExpensesReceipt__Fields = {
  name: boolean;
  uri: boolean;
};

export type BookingKitSearchResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingKitSearch
>;
export type BookingKitSearch__Fields = {
  _id: boolean;
  areaOfExpertise: boolean;
  assignedByUserId: boolean;
  assignedByUserName: boolean;
  assignedOn: boolean;
  assignedToUserId: boolean;
  assignedToUserName: boolean;
  bookingId: boolean;
  bookingSupportTagComment: boolean;
  bookingSupportTagStatus: BookingSupportTagStatus__Fields;
  consultantId: boolean;
  consultantName: boolean;
  consultantPayoutType: boolean;
  costCenterId: boolean;
  costCenterName: boolean;
  createdOn: boolean;
  customerBillingInstructions: boolean;
  customerContractType: boolean;
  departmentId: boolean;
  departmentName: boolean;
  hospitalId: boolean;
  hospitalName: boolean;
  isHighPriority: boolean;
  isNationalProcurement: boolean;
  lastStatusSetByUserId: boolean;
  lastStatusSetByUserName: boolean;
  lastStatusSetOn: boolean;
  lastStatusType: boolean;
  name: boolean;
  projectId: boolean;
  projectName: boolean;
  regionId: boolean;
  regionName: boolean;
  timereportApprovedOn: boolean;
  type: boolean;
  week: boolean;
};

export type BookingKitSearchResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingKitSearchResult
>;
export type BookingKitSearchResult__Fields = {
  dbTime: boolean;
  items: BookingKitSearch__Fields;
  limit: boolean;
  skip: boolean;
};

export type BookingKitSearchTotalResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingKitSearchTotalResult
>;
export type BookingKitSearchTotalResult__Fields = {
  dbTime: boolean;
  total: boolean;
};

export type BookingKitStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingKitStatus
>;
export type BookingKitStatus__Fields = {
  comment: boolean;
  setBy: UserRef__Fields;
  setOn: boolean;
  status: boolean;
};

export type BookingKitTypeFormConfigResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingKitTypeFormConfig
>;
export type BookingKitTypeFormConfig__Fields = {
  isAvailableForCreation: boolean;
  requirements: BookingKitTypeFormRequirements__Fields;
  type: boolean;
};

export type BookingKitTypeFormRequirementsResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingKitTypeFormRequirements
>;
export type BookingKitTypeFormRequirements__Fields = {
  hbaApproval: boolean;
  invoiceForm: boolean;
  ocApproval: boolean;
  payForm: boolean;
  sickPayForm: boolean;
  timeReport: boolean;
};

export type BookingLinksResolver<Parent> = ReturnTypeResolver<Parent, BookingLinks>;
export type BookingLinks__Fields = {
  link: boolean;
  name: boolean;
};

export type BookingNoApprovalForTimeReportResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingNoApprovalForTimeReport
>;
export type BookingNoApprovalForTimeReport__Fields = {
  needSignature: CustomerRef__Fields;
  needSignatureTROkInApp: CustomerRef__Fields;
  noApproval: CustomerRef__Fields;
  noApprovalMonthly: CustomerRef__Fields;
  noApprovalShortening: CustomerRef__Fields;
  noApprovalSpecial: CustomerRef__Fields;
};

export type BookingProfitResolver<Parent> = ReturnTypeResolver<Parent, BookingProfit>;
export type BookingProfit__Fields = {
  invoiceTotal: boolean;
  profitNet: boolean;
  profitRatio: boolean;
};

export type BookingSkipTimereportReminderResultsResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingSkipTimereportReminderResults
>;
export type BookingSkipTimereportReminderResults__Fields = {
  value: boolean;
};

export type BookingStatusResolver<Parent> = ReturnTypeResolver<Parent, BookingStatus>;
export type BookingStatus__Fields = {
  createdByUserId: boolean;
  createdByUserName: boolean;
  createdOn: boolean;
  status: boolean;
};

export type BookingSupportTagStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingSupportTagStatus
>;
export type BookingSupportTagStatus__Fields = {
  setBy: UserRef__Fields;
  setOn: boolean;
  tag: boolean;
};

export type BookingSyncReportResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingSyncReport
>;
export type BookingSyncReport__Fields = {
  Groups: BookingSyncReportGroup__Fields;
  Items: BookingSyncReportItem__Fields;
  Total: boolean;
};

export type BookingSyncReportGroupResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingSyncReportGroup
>;
export type BookingSyncReportGroup__Fields = {
  Total: boolean;
  UserRef: UserRef__Fields;
};

export type BookingSyncReportItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingSyncReportItem
>;
export type BookingSyncReportItem__Fields = {
  ProjectName: boolean;
  Score: boolean;
  UserRef: UserRef__Fields;
};

export type BookingTagResolver<Parent> = ReturnTypeResolver<Parent, BookingTag>;
export type BookingTag__Fields = {
  booking: boolean;
  bookingKit: boolean;
  code: boolean;
  color: boolean;
  label: boolean;
};

export type BookingWeekResolver<Parent> = ReturnTypeResolver<Parent, BookingWeek>;
export type BookingWeek__Fields = {
  AccommodationAudit: AccommodationTravelAudit__Fields;
  AccommodationCost: boolean;
  AccommodationDocuments: Document__Fields;
  AccommodationExpense: boolean;
  AccommodationOK: boolean;
  AccommodationRequired: boolean;
  AccommodationStatus: boolean;
  AdditionalWork: boolean;
  AdditionalWorkNote: boolean;
  AreaOfExpertise: boolean;
  BookingAudit: BookingAudit__Fields;
  BookingGroup: BookingGroup__Fields;
  BookingRef: NodeRef__Fields;
  Consultant: Consultant__Fields;
  ConsultantRef: NodeRef__Fields;
  ConsultantSnapshot: BookingConsultantSnapshot__Fields;
  ContractType: boolean;
  ContractTypeAbbr: boolean;
  CostCenter: CostCenter__Fields;
  CustomerFine: boolean;
  CustomerNumber: boolean;
  Departments: Customer__Fields;
  DepartmentsRefs: CustomerRef__Fields;
  EmployeeSalary: boolean;
  FinanceOK: boolean;
  GroupInvoiceTotal: boolean;
  Hospital: Customer__Fields;
  HospitalRef: CustomerRef__Fields;
  InvoiceTotalGross: boolean;
  InvoiceTotalGrossFmt: boolean;
  InvoiceTotalNet: boolean;
  InvoiceTotalNetFmt: boolean;
  InvoicedTotal: boolean;
  InvoicedTotalFmt: boolean;
  Invoices: BookingCustomerInvoice__Fields;
  IsCanceled: boolean;
  IsConsultantPayed: boolean;
  IsCustomerBilled: boolean;
  IsDirect: boolean;
  IsMarked: boolean;
  Note: boolean;
  OrganizationRef: CustomerRef__Fields;
  OtherExpenses: boolean;
  PatientId: boolean;
  ProfitNet: boolean;
  ProfitNetFmt: boolean;
  ProfitRatio: boolean;
  Project: Project__Fields;
  Salary: boolean;
  SubcontractorInvoiceTotal: boolean;
  TimeReportStatus: boolean;
  TravelAudit: AccommodationTravelAudit__Fields;
  TravelCost: boolean;
  TravelDocuments: Document__Fields;
  TravelExpense: boolean;
  TravelOK: boolean;
  TravelRequired: boolean;
  TravelStatus: boolean;
  Week: boolean;
  WorkRequestId: boolean;
  WorkRequestRef: NodeRef__Fields;
  _id: boolean;
  bookingAssignedTo: BookingAssignedTo__Fields;
  bookingSupportTagStatus: BookingSupportTagStatus__Fields;
};

export type BookingWeekCalendarItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingWeekCalendarItem
>;
export type BookingWeekCalendarItem__Fields = {
  Week: boolean;
  _id: boolean;
};

export type BookingWeekListItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingWeekListItem
>;
export type BookingWeekListItem__Fields = {
  AccommodationAudit: AccommodationTravelAudit__Fields;
  AccommodationOK: boolean;
  AccommodationRequired: boolean;
  AccommodationStatus: boolean;
  AreaOfExpertise: boolean;
  BookingAudit: BookingAudit__Fields;
  BookingRef: NodeRef__Fields;
  ConsultantRef: NodeRef__Fields;
  ConsultantServicePreferences: boolean;
  ContractType: boolean;
  ContractTypeAbbr: boolean;
  CostCenterId: boolean;
  CostCenterName: boolean;
  CustomerNumber: boolean;
  DepartmentsRefs: CustomerRef__Fields;
  HospitalRef: CustomerRef__Fields;
  InvoiceNumbers: boolean;
  InvoiceTotalGrossFmt: boolean;
  InvoicedTotalFmt: boolean;
  IsCanceled: boolean;
  IsConsultantPayed: boolean;
  IsCustomerBilled: boolean;
  IsMarked: boolean;
  OrganizationRef: CustomerRef__Fields;
  ProfitNetFmt: boolean;
  ProfitRatio: boolean;
  ProjectId: boolean;
  TimeReportStatus: boolean;
  TravelAudit: AccommodationTravelAudit__Fields;
  TravelOK: boolean;
  TravelRequired: boolean;
  TravelStatus: boolean;
  Week: boolean;
  _id: boolean;
  bookingAssignedTo: BookingAssignedTo__Fields;
  bookingStatus: BookingStatus__Fields;
  bookingSupportTagComment: boolean;
  bookingSupportTagStatus: BookingSupportTagStatus__Fields;
  callNumber: boolean;
  consultantContractId: boolean;
  customerContractId: boolean;
  demandSource: boolean;
  demandSourceUrl: boolean;
  isHighPrior: boolean;
  isNationalProcurement: boolean;
  isTravelInvoiced: boolean;
  lastKitCreationWfFailedAt: boolean;
  projectName: boolean;
  projectNumber: boolean;
  requireTravelInvoicing: boolean;
  timeReportRowSources: boolean;
  timeReportStatusSetBy: UserRef__Fields;
  timeReportStatusSetOn: boolean;
};

export type BookingWeekQueryResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingWeekQueryResult
>;
export type BookingWeekQueryResult__Fields = {
  dbTime: boolean;
  items: BookingWeekListItem__Fields;
  limit: boolean;
  skip: boolean;
  total: boolean;
  totalDbTime: boolean;
};

export type BookingWeeksCSVBackgroundResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingWeeksCSVBackgroundResult
>;
export type BookingWeeksCSVBackgroundResult__Fields = {
  result: boolean;
};

export type BookingWeeksCSVResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingWeeksCSVResult
>;
export type BookingWeeksCSVResult__Fields = {
  Filename: boolean;
  URL: boolean;
};

export type BookingWeeksTotalResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BookingWeeksTotalResult
>;
export type BookingWeeksTotalResult__Fields = {
  dbTime: boolean;
  total: boolean;
};

export type BulkActionResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BulkActionResult
>;
export type BulkActionResult__Fields = {
  actionId: boolean;
  error: boolean;
  status: boolean;
};

export type BulkUpdateResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  BulkUpdateResult
>;
export type BulkUpdateResult__Fields = {
  consultants: Consultant__Fields;
  updated: boolean;
};

export type CallListResolver<Parent> = ReturnTypeResolver<Parent, CallList>;
export type CallList__Fields = {
  _id: boolean;
  audit: Audit__Fields;
  deleted: boolean;
  members: UserRef__Fields;
  name: boolean;
  nodes: NodeRef__Fields;
  type: boolean;
};

export type CallListOpResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CallListOpResult
>;
export type CallListOpResult__Fields = {
  callList: CallList__Fields;
};

export type CallListStatsResolver<Parent> = ReturnTypeResolver<Parent, CallListStats>;
export type CallListStats__Fields = {
  callListType: boolean;
  count: boolean;
};

export type CanDuplicateToTenantsResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CanDuplicateToTenantsResult
>;
export type CanDuplicateToTenantsResult__Fields = {
  items: CanDuplicateToTenantsResultItem__Fields;
};

export type CanDuplicateToTenantsResultItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  CanDuplicateToTenantsResultItem
>;
export type CanDuplicateToTenantsResultItem__Fields = {
  canDuplicate: boolean;
  links: boolean;
  tenant: boolean;
};

export type CancelBookingResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CancelBookingResult
>;
export type CancelBookingResult__Fields = {
  Booking: Booking__Fields;
};

export type CategoryBadgeResolver<Parent> = ReturnTypeResolver<Parent, CategoryBadge>;
export type CategoryBadge__Fields = {
  Category: boolean;
  Done: boolean;
  Read: boolean;
  Unread: boolean;
};

export type CheckContactExistsResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CheckContactExistsResult
>;
export type CheckContactExistsResult__Fields = {
  exact: Consultant__Fields;
  similar: Consultant__Fields;
};

export type CityInhabitantsResolver<Parent> = ReturnTypeResolver<Parent, CityInhabitants>;
export type CityInhabitants__Fields = {
  city: boolean;
  inhabitants: boolean;
  taxRegion: boolean;
};

export type CommentResolver<Parent> = ReturnTypeResolver<Parent, Comment>;
export type Comment__Fields = {
  message: boolean;
};

export type CompensationResolver<Parent> = ReturnTypeResolver<Parent, Compensation>;
export type Compensation__Fields = {
  Price: boolean;
  Type: boolean;
};

export type ConfigDocResolver<Parent> = ReturnTypeResolver<Parent, ConfigDoc>;
export type ConfigDoc__Fields = {
  blockBookingCreationForBemloCustomers: boolean;
  bookingTags: BookingTag__Fields;
  cityInhabitants: CityInhabitants__Fields;
  competitors: boolean;
  costCenters: CostCenter__Fields;
  countries: Country__Fields;
  customerGroups: boolean;
  defaultTravelZones: DefaultTravelZone__Fields;
  expertises: Expertise__Fields;
  getSSKSpecializations: boolean;
  languages: boolean;
  nationalProcurementTravelRegions: boolean;
  professionConfigs: ProfessionConfig__Fields;
  roles: Role__Fields;
  titles: boolean;
  version: boolean;
};

export type ConsultantResolver<Parent> = ReturnTypeResolver<Parent, Consultant>;
export type Consultant__Fields = {
  AccommodationPreferences: boolean;
  Address: Address__Fields;
  AreasOfExpertise: boolean;
  Availability: ConsultantAvailability__Fields;
  AvailableForWorkInCountries: boolean;
  AvatarPic: boolean;
  BirthDate: boolean;
  BookingDocuments: Document__Fields;
  BusinessName: boolean;
  BusinessSocialSecurityNo: boolean;
  CellPhone: boolean;
  CellPhoneValid: boolean;
  ConsultantForm: ConsultantForm__Fields;
  ContractSigned: boolean;
  DocumentTypes: boolean;
  Documents: Document__Fields;
  DocumentsShareable: Document__Fields;
  Email: boolean;
  EmailValid: boolean;
  EmployeeNumber: boolean;
  Events: ConsultantEvent__Fields;
  FirstName: boolean;
  GDPRConsentRecords: GDPRConsent__Fields;
  Intro: boolean;
  IsSocialSecurityNoExist: boolean;
  IsValid: boolean;
  KnownSystems: boolean;
  LastContactDate: boolean;
  LastMetInPerson: boolean;
  LastName: boolean;
  LegalBasis: boolean;
  LegalPersonType: boolean;
  Name: boolean;
  NodeName: boolean;
  NodeType: boolean;
  Phone: boolean;
  PhoneValid: boolean;
  PrescriptionCode: boolean;
  PresentationUrl: boolean;
  Professions: boolean;
  QualityPerCountry: ConsultantQualityPerCountry__Fields;
  ResponsiblePerson: UserRef__Fields;
  Roles: boolean;
  SocialSecurityNo: boolean;
  Specializations: boolean;
  Status: boolean;
  SubcontractorInfo: SubcontractorInfo__Fields;
  Teams: boolean;
  Title: boolean;
  TravelPreferences: boolean;
  Unfit: boolean;
  UnfitComment: boolean;
  UnfitedBy: WeakUserRef__Fields;
  UnfitedSetOn: boolean;
  UserSettings: UserSettings__Fields;
  ValidationErrors: NodeValidationError__Fields;
  _id: boolean;
  availableCountries: boolean;
  bookedPeriodEnd: boolean;
  bookedPeriodStart: boolean;
  bookingStatus: boolean;
  businessAddress: Address__Fields;
  callListStats: boolean;
  canCreateContractCheck: boolean;
  canCreateSelfInvoicingContractCheck: boolean;
  care: boolean;
  contactType: ConsultantContactTypeSection__Fields;
  contracts: ConsultantContractSnapshot__Fields;
  createdAt: boolean;
  drivingLicenceType: boolean;
  expertise: ConsultantExpertise__Fields;
  generalInterest: ConsultantGeneralInterest__Fields;
  hasDrivingLicence: boolean;
  id: boolean;
  initialContact: boolean;
  isCvDataAffected: boolean;
  isNationalQualityApproved: boolean;
  isNationalQualityExpired: boolean;
  isPresentationReadyQualityApproved: boolean;
  isPresentationReadyQualityExpired: boolean;
  isQualityApproved: boolean;
  isQualityExpired: boolean;
  karens: ConsultantKarensItem__Fields;
  leadStatus: ConsultantLeadStatusParams__Fields;
  nationalQualification: boolean;
  nationalQualityApprovals: QualityApproval__Fields;
  nextContactDate: ConsultantNextContactDate__Fields;
  pipelineStatus: boolean;
  pipelineStatusComment: boolean;
  preferredCommunication: boolean;
  professions: ConsultantProfession__Fields;
  qualityApprovals: QualityApproval__Fields;
  qualityChecks: ConsultantQualityCheck__Fields;
  qualityNote: boolean;
  secondaryEmail: boolean;
  sithsCardNumber: boolean;
  tags: boolean;
  type: boolean;
  unfitType: boolean;
  updatedAt: boolean;
  welcomeEmail: boolean;
  welcomeEmailSetBy: boolean;
  welcomeEmailSetOn: boolean;
  worksForCompetitors: boolean;
};

export type ConsultantAvailabilityResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantAvailability
>;
export type ConsultantAvailability__Fields = {
  availableWeeksString: boolean;
  ranges: ConsultantAvailabilityRange__Fields;
  weeks: boolean;
};

export type ConsultantAvailabilityRangeResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantAvailabilityRange
>;
export type ConsultantAvailabilityRange__Fields = {
  from: boolean;
  to: boolean;
};

export type ConsultantAvailableOnWeekResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantAvailableOnWeek
>;
export type ConsultantAvailableOnWeek__Fields = {
  Consultant: Consultant__Fields;
  Week: boolean;
};

export type ConsultantBookingContractResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantBookingContract
>;
export type ConsultantBookingContract__Fields = {
  Address: Address__Fields;
  AreaOfExpertise: boolean;
  BasicPrice: boolean;
  Bonus: ConsultantContractBonus__Fields;
  ConsultantId: boolean;
  ContactPerson: CustomerContactPerson__Fields;
  ContractPriceTemplateId: boolean;
  DepartmentsRefs: CustomerRef__Fields;
  EndDate: boolean;
  FileRef: FileRef__Fields;
  HospitalRef: CustomerRef__Fields;
  IntroductionPrice: ConsultantContractIntroductionPrice__Fields;
  OtherInfo: boolean;
  Period: boolean;
  Price: boolean;
  PriceRecruitment: PriceRecruitment__Fields;
  Profession: boolean;
  Recipients: boolean;
  ResponsiblePersonId: boolean;
  SalaryRecords: ContractsPriceRecord__Fields;
  Schedule: boolean;
  SignedBy: UserRef__Fields;
  SignedOn: boolean;
  SpecificPeriodPrices: SpecificPeriodPrice__Fields;
  SpecificRequirements: boolean;
  StartDate: boolean;
  Type: boolean;
  _id: boolean;
  callNumber: boolean;
  hideDeptName: boolean;
  hideHospitalName: boolean;
  highHolidays: HighHoliday__Fields;
  sithsCardNumber: boolean;
};

export type ConsultantBookingContractListItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantBookingContractListItem
>;
export type ConsultantBookingContractListItem__Fields = {
  Attachment: Document__Fields;
  ContactPerson: CustomerContactPerson__Fields;
  CustomerCity: boolean;
  CustomerName: boolean;
  Dates: boolean;
  FileUrl: boolean;
  IsNullified: boolean;
  IsSigned: boolean;
  PublishedUrl: boolean;
  Recipients: boolean;
  Type: boolean;
  ViewUrl: boolean;
  _id: boolean;
  canDownload: boolean;
  canDuplicate: boolean;
  canEdit: boolean;
  canPreview: boolean;
};

export type ConsultantByWorkExperienceItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantByWorkExperienceItem
>;
export type ConsultantByWorkExperienceItem__Fields = {
  consultant: Consultant__Fields;
  workExperience: ConsultantWorkExperienceItem__Fields;
};

export type ConsultantByWorkExperienceResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantByWorkExperienceResult
>;
export type ConsultantByWorkExperienceResult__Fields = {
  items: ConsultantByWorkExperienceItem__Fields;
};

export type ConsultantCompetenceSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantCompetenceSection
>;
export type ConsultantCompetenceSection__Fields = {
  items: ConsultantCompetenceSectionItem__Fields;
};

export type ConsultantCompetenceSectionItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantCompetenceSectionItem
>;
export type ConsultantCompetenceSectionItem__Fields = {
  competenceName: boolean;
  fromYear: boolean;
  interested: boolean;
  lastUsedYear: boolean;
};

export type ConsultantCompetitorsSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantCompetitorsSection
>;
export type ConsultantCompetitorsSection__Fields = {
  items: boolean;
};

export type ConsultantContactTypeSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantContactTypeSection
>;
export type ConsultantContactTypeSection__Fields = {
  FTaxChecked: boolean;
  VATChecked: boolean;
  accountNumber: boolean;
  businessAddress: FormAddress__Fields;
  clearingNumber: boolean;
  companyName: boolean;
  emailForSelfInvoicing: boolean;
  employeeContractType: boolean;
  employeeSalaryClaim: boolean;
  endDate: boolean;
  externalTaxNumber: boolean;
  increasedRate: boolean;
  rate: boolean;
  receiveWorkBreakdownByEmail: boolean;
  ssn: boolean;
  startDate: boolean;
  subcontractorSalaryClaim: boolean;
  type: boolean;
};

export type ConsultantContactsSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantContactsSection
>;
export type ConsultantContactsSection__Fields = {
  cellPhone: boolean;
  email: boolean;
  initialContact: boolean;
  phone: boolean;
  preferredCommunication: boolean;
  recommendedByConsultant: OptionObjectIDType__Fields;
  secondaryEmail: boolean;
  selfRegisterOption: boolean;
};

export type ConsultantContractResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantContract
>;
export type ConsultantContract__Fields = {
  Accommodation: AccommodationAlt__Fields;
  Address: Address__Fields;
  AreaOfExpertise: boolean;
  BasicPrice: boolean;
  Bonus: ConsultantContractBonus__Fields;
  Compensation: Compensation__Fields;
  ConsultantGetsPaidPer: boolean;
  ConsultantId: boolean;
  ContractPriceTemplateId: boolean;
  Country: boolean;
  Currency: boolean;
  CustomerName: boolean;
  DateFrameworkContractTypeIsSigned: boolean;
  Dates: boolean;
  DepartmentsRefs: CustomerRef__Fields;
  DriverLicense: boolean;
  Education: EducationCC__Fields;
  EndDate: boolean;
  ExcludeAddress: boolean;
  FileName: boolean;
  FileRef: FileRef__Fields;
  HospitalRef: CustomerRef__Fields;
  IntroductionPrice: ConsultantContractIntroductionPrice__Fields;
  InvestigationsNumber: boolean;
  IsRegionDalarna: boolean;
  Language: boolean;
  NotRelevantMonthlyWeeklyPayouts: boolean;
  NullificationReason: boolean;
  NullifiedBy: UserRef__Fields;
  NullifiedOn: boolean;
  OtherRequirements: boolean;
  Overtime: boolean;
  ParentContractId: boolean;
  PatientVisits: boolean;
  PayoutType: boolean;
  Period: boolean;
  Profession: boolean;
  SalaryChoice: boolean;
  SalaryRecords: ContractsPriceRecord__Fields;
  Schedule: boolean;
  SignedBy: UserRef__Fields;
  SignedOn: boolean;
  Specializations: boolean;
  SpecificPeriodPrices: SpecificPeriodPrice__Fields;
  SpecificRequirements: boolean;
  StartDate: boolean;
  Travels: TravelsAlt__Fields;
  Type: boolean;
  YoEx: boolean;
  _id: boolean;
  hideDeptName: boolean;
  highHolidays: HighHoliday__Fields;
  isNationalProcurementPriceStrategy: boolean;
  pensionModel: boolean;
  pensionSolution: boolean;
  showOrgName: boolean;
};

export type ConsultantContractBonusResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantContractBonus
>;
export type ConsultantContractBonus__Fields = {
  Amount: boolean;
  Config: boolean;
  Currency: boolean;
  SalaryType: boolean;
  Type: boolean;
  _id: boolean;
};

export type ConsultantContractIntroductionPriceResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantContractIntroductionPrice
>;
export type ConsultantContractIntroductionPrice__Fields = {
  Currency: boolean;
  Description: boolean;
  Sum: boolean;
};

export type ConsultantContractListItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantContractListItem
>;
export type ConsultantContractListItem__Fields = {
  Attachment: Document__Fields;
  ChildContracts: ConsultantContractListItem__Fields;
  Consultant: Consultant__Fields;
  CustomerCity: boolean;
  CustomerName: boolean;
  Dates: boolean;
  EndDate: boolean;
  FileUrl: boolean;
  IsNullified: boolean;
  IsSigned: boolean;
  Name: boolean;
  NotRelevantMonthlyWeeklyPayouts: boolean;
  NullificationReason: boolean;
  ParentContractId: boolean;
  ParentId: boolean;
  PayoutsAbbr: boolean;
  PdfUrl: boolean;
  Period: boolean;
  Profession: boolean;
  PublishedUrl: boolean;
  SalaryChoice: boolean;
  SalaryChoiceAbbr: boolean;
  StartDate: boolean;
  Type: boolean;
  ViewUrl: boolean;
  _id: boolean;
  canDownload: boolean;
  canDuplicate: boolean;
  canEdit: boolean;
  canNullify: boolean;
  canPreview: boolean;
  canPublishToOneFlowViaTicket: boolean;
  canPublishToOneflowDirectly: boolean;
  editsProof: EditProof__Fields;
  pensionSolution: boolean;
};

export type ConsultantContractMaxCostResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantContractMaxCost
>;
export type ConsultantContractMaxCost__Fields = {
  Currency: boolean;
  Period: boolean;
  Price: boolean;
  SalaryType: boolean;
};

export type ConsultantContractSnapshotResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantContractSnapshot
>;
export type ConsultantContractSnapshot__Fields = {
  endDate: boolean;
  id: boolean;
  startDate: boolean;
};

export type ConsultantContractTravelsMaxCostResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantContractTravelsMaxCost
>;
export type ConsultantContractTravelsMaxCost__Fields = {
  Currency: boolean;
  Period: boolean;
  Price: boolean;
  SalaryType: boolean;
};

export type ConsultantEducationSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantEducationSection
>;
export type ConsultantEducationSection__Fields = {
  items: ConsultantEducationSectionItem__Fields;
};

export type ConsultantEducationSectionItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantEducationSectionItem
>;
export type ConsultantEducationSectionItem__Fields = {
  courseLocation: boolean;
  courseName: boolean;
  educationType: boolean;
  from: boolean;
  fromMonth: boolean;
  fromYear: boolean;
  isCourse: boolean;
  to: boolean;
  toMonth: boolean;
  toYear: boolean;
};

export type ConsultantEmergencyContactsSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantEmergencyContactsSection
>;
export type ConsultantEmergencyContactsSection__Fields = {
  items: ConsultantEmergencyContactsSectionItem__Fields;
};

export type ConsultantEmergencyContactsSectionItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantEmergencyContactsSectionItem
>;
export type ConsultantEmergencyContactsSectionItem__Fields = {
  name: boolean;
  phone: boolean;
  relation: boolean;
};

export type ConsultantEmployeeNumberSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantEmployeeNumberSection
>;
export type ConsultantEmployeeNumberSection__Fields = {
  employeeNumber: boolean;
  employeeNumber2: boolean;
  employeeNumber3: boolean;
};

export type ConsultantEvaluateContactsSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantEvaluateContactsSection
>;
export type ConsultantEvaluateContactsSection__Fields = {
  items: ConsultantEvaluateContactsSectionItem__Fields;
};

export type ConsultantEvaluateContactsSectionItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantEvaluateContactsSectionItem
>;
export type ConsultantEvaluateContactsSectionItem__Fields = {
  name: boolean;
  phone: boolean;
};

export type ConsultantEvaluatesSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantEvaluatesSection
>;
export type ConsultantEvaluatesSection__Fields = {
  items: ConsultantEvaluatesSectionItem__Fields;
};

export type ConsultantEvaluatesSectionItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantEvaluatesSectionItem
>;
export type ConsultantEvaluatesSectionItem__Fields = {
  _id: boolean;
  deleted: boolean;
  email: boolean;
  name: boolean;
  phone: boolean;
  position: boolean;
  workPlace: boolean;
};

export type ConsultantEventResolver<Parent> = ReturnTypeResolver<Parent, ConsultantEvent>;
export type ConsultantEvent__Fields = {
  Audit: Audit__Fields;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedBy: WeakUserRef__Fields;
  CreatedOn: boolean;
  Deleted: boolean;
  DeletedBy: WeakUserRef__Fields;
  Description: boolean;
  DescriptionHtml: boolean;
  EmailBody: boolean;
  EmailDescription: boolean;
  EmailRecipients: EmailRecipient__Fields;
  EmailSubject: boolean;
  Links: boolean;
  MetBy: WeakUserRef__Fields;
  Node: NodeRef__Fields;
  SMSMessage: SMSMessage__Fields;
  SMSMessageID: boolean;
  SMSStatusLegacy: boolean;
  Sticky: boolean;
  TodoItem: TodoItem__Fields;
  TodoRef: NodeRef__Fields;
  Type: boolean;
  UpdatedBy: WeakUserRef__Fields;
  Warning: boolean;
  _id: boolean;
};

export type ConsultantExpertiseResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantExpertise
>;
export type ConsultantExpertise__Fields = {
  educations: boolean;
  machines: boolean;
  methods: boolean;
  professions: ConsultantProfession__Fields;
  systems: boolean;
};

export type ConsultantExpertiseSectionSpecializationResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantExpertiseSectionSpecialization
>;
export type ConsultantExpertiseSectionSpecialization__Fields = {
  experienced: boolean;
  interested: boolean;
  name: boolean;
};

export type ConsultantExportCSVResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantExportCSVResult
>;
export type ConsultantExportCSVResult__Fields = {
  Filename: boolean;
  URL: boolean;
};

export type ConsultantFormResolver<Parent> = ReturnTypeResolver<Parent, ConsultantForm>;
export type ConsultantForm__Fields = {
  GDPRConsentRecords: GDPRConsent__Fields;
  address: FormAddress__Fields;
  competitors: ConsultantCompetitorsSection__Fields;
  consultantId: boolean;
  contactType: ConsultantContactTypeSection__Fields;
  contacts: ConsultantContactsSection__Fields;
  education: ConsultantEducationSection__Fields;
  emergencyContacts: ConsultantEmergencyContactsSection__Fields;
  employeeNumber: ConsultantEmployeeNumberSection__Fields;
  extraCurriculum: boolean;
  isNew: boolean;
  knownSystems: boolean;
  languageSkills: ConsultantLanguageSkillsSection__Fields;
  personal: ConsultantPersonalSection__Fields;
  prescriptionCode: ConsultantPrescriptionCodeSection__Fields;
  status: boolean;
  workExperience: ConsultantWorkExperienceSection__Fields;
};

export type ConsultantFormResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantFormResult
>;
export type ConsultantFormResult__Fields = {
  Consultant: Consultant__Fields;
  ConsultantForm: ConsultantForm__Fields;
  Errors: boolean;
  OK: boolean;
  ValidationErrors: ValidationError__Fields;
};

export type ConsultantGeneralInterestResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantGeneralInterest
>;
export type ConsultantGeneralInterest__Fields = {
  comment: boolean;
  regions: boolean;
  workshifts: boolean;
};

export type ConsultantImportDocumentResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantImportDocumentResult
>;
export type ConsultantImportDocumentResult__Fields = {
  Rows: ConsultantImportRow__Fields;
};

export type ConsultantImportRowResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantImportRow
>;
export type ConsultantImportRow__Fields = {
  AreaOfExpertise: boolean;
  CellPhone: boolean;
  Competitor: boolean;
  CompetitorSource: boolean;
  Duplicate: Consultant__Fields;
  Errors: ConsultantRowError__Fields;
  FirstName: boolean;
  HPRNumber: boolean;
  InitialComment: boolean;
  IsDuplicate: boolean;
  IsLookupSuccess: boolean;
  LastName: boolean;
  Meta: ImportConsultantMeta__Fields;
  Phone: boolean;
  ResponsiblePerson: UserRef__Fields;
  ResponsiblePersonSource: WeakUserRef__Fields;
  RowID: boolean;
  SocialSecurityNo: boolean;
  SocialSecurityNoSource: boolean;
  city: boolean;
  country: boolean;
  isApprovedAuthorization: boolean;
  streetName: boolean;
  zipCode: boolean;
};

export type ConsultantKarensItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantKarensItem
>;
export type ConsultantKarensItem__Fields = {
  expDate: boolean;
  region: boolean;
};

export type ConsultantLanguageSkillsSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantLanguageSkillsSection
>;
export type ConsultantLanguageSkillsSection__Fields = {
  items: ConsultantLanguageSkillsSectionItem__Fields;
};

export type ConsultantLanguageSkillsSectionItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantLanguageSkillsSectionItem
>;
export type ConsultantLanguageSkillsSectionItem__Fields = {
  level: boolean;
  name: boolean;
};

export type ConsultantLeadStatusParamsResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantLeadStatusParams
>;
export type ConsultantLeadStatusParams__Fields = {
  comment: boolean;
  setBy: UserRef__Fields;
  setOn: boolean;
  status: boolean;
};

export type ConsultantMatchingItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantMatchingItem
>;
export type ConsultantMatchingItem__Fields = {
  consultant: Consultant__Fields;
  minutesTotal: boolean;
  weeksTotal: boolean;
};

export type ConsultantMatchingResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantMatchingResult
>;
export type ConsultantMatchingResult__Fields = {
  items: ConsultantMatchingItem__Fields;
  limit: boolean;
  skip: boolean;
  total: boolean;
};

export type ConsultantNextContactDateResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantNextContactDate
>;
export type ConsultantNextContactDate__Fields = {
  date: boolean;
  reason: boolean;
};

export type ConsultantOpportunityResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantOpportunity
>;
export type ConsultantOpportunity__Fields = {
  _id: boolean;
  areaOfExpertise: boolean;
  consultant: Consultant__Fields;
  costCenter: CostCenter__Fields;
  createdAt: boolean;
  customer: Customer__Fields;
  description: boolean;
  dueDate: boolean;
  isShared: boolean;
  originalIssue: ConsultantOpportunity__Fields;
  users: User__Fields;
  weeks: boolean;
  weeksLost: boolean;
  weeksLostString: boolean;
  weeksString: boolean;
  weeksWon: boolean;
  weeksWonString: boolean;
};

export type ConsultantOpportunityCardResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantOpportunityCard
>;
export type ConsultantOpportunityCard__Fields = {
  _id: boolean;
  assignee: User__Fields;
  boardId: boolean;
  columnId: boolean;
  consultantOpportunity: ConsultantOpportunity__Fields;
  description: boolean;
  dueDate: boolean;
  order: boolean;
  title: boolean;
};

export type ConsultantOpportunityIssueWeeksResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantOpportunityIssueWeeks
>;
export type ConsultantOpportunityIssueWeeks__Fields = {
  lostWeeks: boolean;
  openWeeks: boolean;
  wonWeeks: boolean;
};

export type ConsultantOpportunityStatsResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantOpportunityStats
>;
export type ConsultantOpportunityStats__Fields = {
  lostWeeks: boolean;
  openWeeks: boolean;
  presentedWeeks: boolean;
  wonWeeks: boolean;
};

export type ConsultantPayoutByYearResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantPayoutByYear
>;
export type ConsultantPayoutByYear__Fields = {
  total: boolean;
  totalNationalProcurement: boolean;
  totalNonNationalProcurement: boolean;
  year: boolean;
};

export type ConsultantPersonalSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantPersonalSection
>;
export type ConsultantPersonalSection__Fields = {
  about: boolean;
  accommodationPreferences: boolean;
  care: boolean;
  commentAuthorization: boolean;
  countries: boolean;
  drivingLicenceType: boolean;
  firstComment: boolean;
  firstName: boolean;
  hasDrivingLicence: boolean;
  hprNumber: boolean;
  important: boolean;
  intro: boolean;
  isApprovedAuthorization: boolean;
  isWorkedNorway: boolean;
  lastName: boolean;
  norwayConsultantStatus: boolean;
  norwegianSsn: boolean;
  ssn: boolean;
  travelPreferences: boolean;
};

export type ConsultantPipelineCardResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantPipelineCard
>;
export type ConsultantPipelineCard__Fields = {
  _id: boolean;
  assignee: User__Fields;
  boardId: boolean;
  columnId: boolean;
  consultant: Consultant__Fields;
  description: boolean;
  dueDate: boolean;
  order: boolean;
  title: boolean;
};

export type ConsultantPrescriptionCodeSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantPrescriptionCodeSection
>;
export type ConsultantPrescriptionCodeSection__Fields = {
  code: boolean;
};

export type ConsultantPresentationResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantPresentation
>;
export type ConsultantPresentation__Fields = {
  ViewURL: boolean;
  _id: boolean;
};

export type ConsultantProfessionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantProfession
>;
export type ConsultantProfession__Fields = {
  certifiedFrom: boolean;
  professionName: boolean;
};

export type ConsultantQualityCheckResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantQualityCheck
>;
export type ConsultantQualityCheck__Fields = {
  comment: boolean;
  country: boolean;
  expirationDate: boolean;
  isPartiallyExpired: boolean;
  itemName: boolean;
  params: boolean;
  setDate: boolean;
  status: boolean;
};

export type ConsultantQualityItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantQualityItem
>;
export type ConsultantQualityItem__Fields = {
  AvailableStatuses: ConsultantQualityItemAvailableStatus__Fields;
  Country: boolean;
  Disabled: boolean;
  DisabledMsg: boolean;
  DocumentType: boolean;
  ExpiresOn: boolean;
  ExpiresSoon: boolean;
  HasDocument: boolean;
  HasExpired: boolean;
  Name: boolean;
  Status: ConsultantQualityStatus__Fields;
  StatusSetBy: UserRef__Fields;
  StatusSetOn: boolean;
  _id: boolean;
  templateName: boolean;
};

export type ConsultantQualityItemAvailableStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantQualityItemAvailableStatus
>;
export type ConsultantQualityItemAvailableStatus__Fields = {
  Disabled: boolean;
  DisabledMsg: boolean;
  IsCommentRequired: boolean;
  IsDocumentRequired: boolean;
  Name: boolean;
  WithComment: boolean;
  WithDocument: boolean;
};

export type ConsultantQualityPerCountryResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantQualityPerCountry
>;
export type ConsultantQualityPerCountry__Fields = {
  Country: boolean;
  QualityChecks: ConsultantQualityItem__Fields;
};

export type ConsultantQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantQualityStatus
>;
export type ConsultantQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
};

export type ConsultantReferenceDocumentResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantReferenceDocument
>;
export type ConsultantReferenceDocument__Fields = {
  document: Document__Fields;
  name: boolean;
  referenceId: boolean;
  type: boolean;
  workRelation: boolean;
};

export type ConsultantReferenceFormNewResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantReferenceFormNew
>;
export type ConsultantReferenceFormNew__Fields = {
  submittedAt: boolean;
  submittedBy: NodeRefNew__Fields;
};

export type ConsultantReferenceFormSubmissionHistoryResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantReferenceFormSubmissionHistory
>;
export type ConsultantReferenceFormSubmissionHistory__Fields = {
  submittedAt: boolean;
  submittedBy: boolean;
};

export type ConsultantReferenceNewResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantReferenceNew
>;
export type ConsultantReferenceNew__Fields = {
  _id: boolean;
  areaOfExpertise: boolean;
  canBeReSentToRef: boolean;
  canBeSentToRef: boolean;
  deleted: boolean;
  document: Document__Fields;
  editLink: boolean;
  email: boolean;
  form: ConsultantReferenceFormNew__Fields;
  formLink: boolean;
  formType: boolean;
  lastStatusHistory: ConsultantReferenceStatusHistory__Fields;
  migrated: boolean;
  name: boolean;
  orderedUpdateFromKvk: boolean;
  phone: boolean;
  position: boolean;
  reShared: boolean;
  reminders: ConsultantReferenceReminder__Fields;
  status: boolean;
  submissionHistory: ConsultantReferenceFormSubmissionHistory__Fields;
  updatedOn: boolean;
  workPlace: boolean;
  workRelation: boolean;
};

export type ConsultantReferenceReminderResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantReferenceReminder
>;
export type ConsultantReferenceReminder__Fields = {
  createdAt: boolean;
  sentTo: boolean;
};

export type ConsultantReferenceStatusHistoryResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantReferenceStatusHistory
>;
export type ConsultantReferenceStatusHistory__Fields = {
  changedAt: boolean;
  changedBy: NodeRefNew__Fields;
  newStatus: boolean;
  prevStatus: boolean;
};

export type ConsultantReferencesSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantReferencesSection
>;
export type ConsultantReferencesSection__Fields = {
  items: ConsultantReferencesSectionItem__Fields;
};

export type ConsultantReferencesSectionItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantReferencesSectionItem
>;
export type ConsultantReferencesSectionItem__Fields = {
  _id: boolean;
  deleted: boolean;
  email: boolean;
  name: boolean;
  phone: boolean;
  position: boolean;
  relation: boolean;
};

export type ConsultantResponsibleQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantResponsibleQualityStatus
>;
export type ConsultantResponsibleQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
};

export type ConsultantRowErrorResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantRowError
>;
export type ConsultantRowError__Fields = {
  Column: boolean;
  Message: boolean;
};

export type ConsultantSMSResolver<Parent> = ReturnTypeResolver<Parent, ConsultantSMS>;
export type ConsultantSMS__Fields = {
  ConsultantId: boolean;
  SMSMessage: SMSMessage__Fields;
};

export type ConsultantSearchQualityItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantSearchQualityItem
>;
export type ConsultantSearchQualityItem__Fields = {
  name: boolean;
  statuses: boolean;
};

export type ConsultantServicePreferenceResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantServicePreference
>;
export type ConsultantServicePreference__Fields = {
  _id: boolean;
  archived: boolean;
  createdById: boolean;
  createdByName: boolean;
  createdOn: boolean;
  customers: CustomerRef__Fields;
  deleted: boolean;
  description: boolean;
  nullifiedById: boolean;
  nullifiedByName: boolean;
  nullifiedOn: boolean;
  period: ConsultantServicePreferencePeriod__Fields;
  reminders: ConsultantServicePreferenceReminder__Fields;
  status: boolean;
};

export type ConsultantServicePreferenceFormResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantServicePreferenceForm
>;
export type ConsultantServicePreferenceForm__Fields = {
  _id: boolean;
  customers: Customer__Fields;
  description: boolean;
  period: ConsultantServicePreferencePeriod__Fields;
  status: boolean;
};

export type ConsultantServicePreferencePeriodResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantServicePreferencePeriod
>;
export type ConsultantServicePreferencePeriod__Fields = {
  end: boolean;
  start: boolean;
};

export type ConsultantServicePreferenceReminderResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantServicePreferenceReminder
>;
export type ConsultantServicePreferenceReminder__Fields = {
  createdAt: boolean;
  sentTo: boolean;
};

export type ConsultantTotalResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantTotalResult
>;
export type ConsultantTotalResult__Fields = {
  dbTime: boolean;
  total: boolean;
};

export type ConsultantUpcomingWorkplaceResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantUpcomingWorkplace
>;
export type ConsultantUpcomingWorkplace__Fields = {
  bookingId: boolean;
  department: CustomerRef__Fields;
  organisation: CustomerRef__Fields;
  week: WeekYear__Fields;
  workplace: CustomerRef__Fields;
};

export type ConsultantWorkExperienceItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantWorkExperienceItem
>;
export type ConsultantWorkExperienceItem__Fields = {
  areaOfExpertise: boolean;
  competitors: boolean;
  customerRef: CustomerRef__Fields;
  departmentIds: boolean;
  employmentType: boolean;
  excludeFromPresentation: boolean;
  experience: boolean;
  from: boolean;
  fromMonth: boolean;
  fromYear: boolean;
  roles: boolean;
  to: boolean;
  toMonth: boolean;
  toYear: boolean;
  workPlace: boolean;
  workType: boolean;
};

export type ConsultantWorkExperienceResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantWorkExperienceResult
>;
export type ConsultantWorkExperienceResult__Fields = {
  OK: boolean;
};

export type ConsultantWorkExperienceSectionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantWorkExperienceSection
>;
export type ConsultantWorkExperienceSection__Fields = {
  items: ConsultantWorkExperienceItem__Fields;
};

export type ConsultantWorkStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantWorkStatus
>;
export type ConsultantWorkStatus__Fields = {
  _id: boolean;
  competitorName: boolean;
  createdByName: boolean;
  createdOn: boolean;
  deleted: boolean;
  reminderDate: boolean;
  startDate: boolean;
  type: boolean;
};

export type ConsultantsResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ConsultantsResult
>;
export type ConsultantsResult__Fields = {
  dbTime: boolean;
  items: Consultant__Fields;
  limit: boolean;
  secondarySearch: Consultant__Fields;
  skip: boolean;
  total: boolean;
};

export type ContactResolver<Parent> = ReturnTypeResolver<Parent, Contact>;
export type Contact__Fields = {
  Address: Address__Fields;
  AvatarPic: boolean;
  CellPhone: boolean;
  CellPhoneValid: boolean;
  Email: boolean;
  EmailValid: boolean;
  IsValid: boolean;
  Name: boolean;
  NodeName: boolean;
  NodeType: boolean;
  Phone: boolean;
  PhoneValid: boolean;
  ResponsiblePerson: UserRef__Fields;
  Roles: boolean;
  Title: boolean;
  ValidationErrors: NodeValidationError__Fields;
  _id: boolean;
  id: boolean;
  type: boolean;
};

export type ContactPersonResolver<Parent> = ReturnTypeResolver<Parent, ContactPerson>;
export type ContactPerson__Fields = {
  Address: Address__Fields;
  AreasOfExpertise: boolean;
  Audit: Audit__Fields;
  AvatarPic: boolean;
  BooksProfessions: boolean;
  CellPhone: boolean;
  CellPhoneValid: boolean;
  CustomerGroups: boolean;
  CustomerRefs: CustomerRef__Fields;
  Customers: Customer__Fields;
  Deleted: boolean;
  Email: boolean;
  EmailValid: boolean;
  GDPRConsentRecords: GDPRConsent__Fields;
  IsInheritable: boolean;
  IsValid: boolean;
  LastChange: ContactPersonLastChange__Fields;
  Name: boolean;
  NodeName: boolean;
  Phone: boolean;
  PhoneValid: boolean;
  ResponsiblePerson: UserRef__Fields;
  Roles: boolean;
  RootCustomer: CustomerRef__Fields;
  Title: boolean;
  ValidationErrors: ValidationError__Fields;
  _id: boolean;
};

export type ContactPersonLastChangeResolver<Parent> = ReturnTypeResolver<
  Parent,
  ContactPersonLastChange
>;
export type ContactPersonLastChange__Fields = {
  Date: boolean;
  IsUpdate: boolean;
  User: UserRef__Fields;
};

export type ContactPersonsResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ContactPersonsResult
>;
export type ContactPersonsResult__Fields = {
  items: ContactPerson__Fields;
  total: boolean;
};

export type ContractPriceTemplateOpResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ContractPriceTemplateOpResult
>;
export type ContractPriceTemplateOpResult__Fields = {
  errors: boolean;
  value: ContractsPriceTemplate__Fields;
};

export type ContractPriceTemplateSearchResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ContractPriceTemplateSearchResult
>;
export type ContractPriceTemplateSearchResult__Fields = {
  items: ContractsPriceTemplate__Fields;
  limit: boolean;
  skip: boolean;
  total: boolean;
};

export type ContractProfessionResolver<Parent> = ReturnTypeResolver<
  Parent,
  ContractProfession
>;
export type ContractProfession__Fields = {
  areaOfExpertise: boolean;
  name: boolean;
  specialization: boolean;
};

export type ContractsPriceRecordResolver<Parent> = ReturnTypeResolver<
  Parent,
  ContractsPriceRecord
>;
export type ContractsPriceRecord__Fields = {
  _id: boolean;
  articleNumber: boolean;
  articleNumberForOtherSpeciality: boolean;
  currency: boolean;
  customPrice: boolean;
  deleted: boolean;
  endDay: boolean;
  fixedPrice: boolean;
  from: boolean;
  indexInWorkType: boolean;
  isSecondPass: boolean;
  paidPer: boolean;
  period: boolean;
  priceMultiplier: boolean;
  startDay: boolean;
  to: boolean;
  workType: boolean;
};

export type ContractsPriceTemplateResolver<Parent> = ReturnTypeResolver<
  Parent,
  ContractsPriceTemplate
>;
export type ContractsPriceTemplate__Fields = {
  _id: boolean;
  createdByName: boolean;
  createdDate: boolean;
  highHolidays: HighHoliday__Fields;
  name: boolean;
  private: boolean;
  records: ContractsPriceRecord__Fields;
  type: boolean;
  updatedByName: boolean;
  updatedDate: boolean;
};

export type CostCenterResolver<Parent> = ReturnTypeResolver<Parent, CostCenter>;
export type CostCenter__Fields = {
  Id: boolean;
  IsActive: boolean;
  IsDeleted: boolean;
  Name: boolean;
  Organisation: boolean;
  OriginalName: boolean;
};

export type CostCenterConfigItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  CostCenterConfigItem
>;
export type CostCenterConfigItem__Fields = {
  _id: boolean;
  costCenterId: boolean;
  isActive: boolean;
  isDeleted: boolean;
  name: boolean;
  organisation: boolean;
  tenant: boolean;
};

export type CountResolver<Parent> = ReturnTypeResolver<Parent, Count>;
export type Count__Fields = {
  total: boolean;
};

export type CountryResolver<Parent> = ReturnTypeResolver<Parent, Country>;
export type Country__Fields = {
  canWorkIn: boolean;
  countryId: boolean;
  name: boolean;
  onTopInSearch: boolean;
  regions: Region__Fields;
  sort: boolean;
};

export type CreateApiTokenResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CreateApiTokenResult
>;
export type CreateApiTokenResult__Fields = {
  apiToken: ApiToken__Fields;
  token: boolean;
};

export type CreateContactPersonResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CreateContactPersonResult
>;
export type CreateContactPersonResult__Fields = {
  contactPerson: ContactPerson__Fields;
  validationErrors: ValidationError__Fields;
};

export type CreateCustomerResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CreateCustomerResult
>;
export type CreateCustomerResult__Fields = {
  customer: Customer__Fields;
  validationErrors: ValidationError__Fields;
};

export type CrmDocumentResolver<Parent> = ReturnTypeResolver<Parent, CrmDocument>;
export type CrmDocument__Fields = {
  _id: boolean;
  documentType: boolean;
  mimeType: boolean;
  name: boolean;
  pdfUrl: boolean;
  size: boolean;
  thumbUrl: boolean;
  type: boolean;
};

export type CustomerResolver<Parent> = ReturnTypeResolver<Parent, Customer>;
export type Customer__Fields = {
  AOESettings: CustomerAOESettings__Fields;
  Address: Address__Fields;
  AreasOfExpertise: boolean;
  AvatarPic: boolean;
  BgPic: boolean;
  CanBeDeleted: boolean;
  CantBeDeletedReasons: boolean;
  ContactPersons: ContactPerson__Fields;
  CustomerGroups: boolean;
  CustomerTree: CustomerTreeItem__Fields;
  Deleted: boolean;
  Description: boolean;
  DirectChildren: CustomerRef__Fields;
  DirectChildrenFull: Customer__Fields;
  DirectParent: CustomerRef__Fields;
  DirectParents: CustomerRef__Fields;
  DocumentTypes: boolean;
  IsValid: boolean;
  LastContactDate: boolean;
  Name: boolean;
  NodeName: boolean;
  NodeType: boolean;
  OrganizationNumber: boolean;
  OrganizationType: boolean;
  OwnProfessions: boolean;
  Parents: CustomerRef__Fields;
  Professions: boolean;
  RecruitingPortalType: boolean;
  Ref: CustomerRef__Fields;
  RegionRef: CustomerRef__Fields;
  ShowHospitalAOERewriteWarning: boolean;
  Specializations: boolean;
  StaffingContactPersons: ContactPerson__Fields;
  Systems: boolean;
  Type: boolean;
  ValidationErrors: NodeValidationError__Fields;
  WebsiteURL: boolean;
  WorkshiftSpans: CustomerWorkshiftSpan__Fields;
  _dummy: boolean;
  _id: boolean;
  areasOfExpertiseTotal: boolean;
  bemloOrgId: boolean;
  bemloUnitId: boolean;
  billingInstructions: boolean;
  documents: CustomerDocument__Fields;
  forceCallNumber: boolean;
  geolocation: Geolocation__Fields;
  id: boolean;
  inLists: boolean;
  journalSystem: boolean;
  municipalityId: boolean;
  needSignature: boolean;
  needSignatureTROkInApp: boolean;
  noApproval: boolean;
  noApprovalMonthly: boolean;
  noApprovalShortening: boolean;
  noApprovalSpecial: boolean;
  recommendedPrices: CustomerRecommendedPrice__Fields;
  timeReportTemplateSettings: TimereportTemplateSettings__Fields;
  type: boolean;
};

export type CustomerAOESettingsResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerAOESettings
>;
export type CustomerAOESettings__Fields = {
  AreaOfExpertise: boolean;
  Enabled: boolean;
  Error: boolean;
  FortnoxId: boolean;
  GroupInvoicing: boolean;
  Inherited: boolean;
  InvoicingData: boolean;
  Profession: boolean;
  ResponsiblePerson: UserRef__Fields;
  orderId: boolean;
  timeReport: boolean;
};

export type CustomerContactResolver<Parent> = ReturnTypeResolver<Parent, CustomerContact>;
export type CustomerContact__Fields = {
  Address: Address__Fields;
  AvatarPic: boolean;
  CellPhone: boolean;
  CellPhoneValid: boolean;
  Email: boolean;
  EmailValid: boolean;
  GDPRConsentRecords: GDPRConsent__Fields;
  Name: boolean;
  Phone: boolean;
  PhoneValid: boolean;
  ResponsiblePerson: UserRef__Fields;
  Roles: boolean;
  Title: boolean;
  _id: boolean;
};

export type CustomerContactPersonResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContactPerson
>;
export type CustomerContactPerson__Fields = {
  CellPhone: boolean;
  Email: boolean;
  Name: boolean;
  Phone: boolean;
  Title: boolean;
};

export type CustomerContractResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContract
>;
export type CustomerContract__Fields = {
  _id: boolean;
  adjustmentComment: boolean;
  attachmentRefs: FileRef__Fields;
  attachments: CustomerContractDocument__Fields;
  avropsnummer: boolean;
  avtalsnummer: boolean;
  company: boolean;
  contactPerson: CustomerContractContactPerson__Fields;
  contractEnd: boolean;
  contractName: boolean;
  contractNumber: boolean;
  contractPriceAdjustmentDate: boolean;
  contractPriceAdjustmentDateDeadline: boolean;
  contractProlongation: boolean;
  contractProlongationDeadline: boolean;
  contractStart: boolean;
  currentContractEnd: boolean;
  deleted: boolean;
  dispenseDeadline: boolean;
  estimatedContractValue: boolean;
  eventLogs: CustomerContractEventLog__Fields;
  extraInvoiceLine: boolean;
  info: boolean;
  introductionInfo: boolean;
  invoicingStrategy: boolean;
  isNationalProcurement: boolean;
  orgCustomerRefs: CustomerRef__Fields;
  orgCustomerTree: CustomerTreeItem__Fields;
  orgCustomers: Customer__Fields;
  otherOption: boolean;
  otherOptionNote: boolean;
  overtime: boolean;
  overtimeNote: boolean;
  overtimeOption: boolean;
  overtimeOptionOBNote: boolean;
  possibleInvoiceForAccommodation: boolean;
  possibleInvoiceForAccommodationNote: boolean;
  possibleInvoiceForTravel: boolean;
  possibleInvoiceForTravelNote: boolean;
  priceLists: CustomerContractPriceList__Fields;
  professions: boolean;
  prolongationComment: boolean;
  status: boolean;
  subVersions: CustomerContractSubVersion__Fields;
  typeOfAgreement: boolean;
  useNationalProcurementInvoicing: boolean;
};

export type CustomerContractContactPersonResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractContactPerson
>;
export type CustomerContractContactPerson__Fields = {
  _id: boolean;
  email: boolean;
  name: boolean;
  phone: boolean;
  title: boolean;
};

export type CustomerContractDocumentResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractDocument
>;
export type CustomerContractDocument__Fields = {
  DocumentType: boolean;
  FileRef: FileRef__Fields;
  PdfURL: boolean;
  ThumbURL: boolean;
};

export type CustomerContractEventLogResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractEventLog
>;
export type CustomerContractEventLog__Fields = {
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedBy: WeakUserRef__Fields;
  CreatedOn: boolean;
  Deleted: boolean;
  DeletedBy: WeakUserRef__Fields;
  Description: boolean;
  DescriptionHtml: boolean;
  EventType: boolean;
  Links: boolean;
  Sticky: boolean;
  UpdatedBy: WeakUserRef__Fields;
  UpdatedOn: boolean;
  Warning: boolean;
  _id: boolean;
};

export type CustomerContractListItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractListItem
>;
export type CustomerContractListItem__Fields = {
  _id: boolean;
  avropsnummer: boolean;
  basicPrices: BasicPrice__Fields;
  contractEnd: boolean;
  contractName: boolean;
  contractStart: boolean;
  contractType: boolean;
  isNationalProcurement: boolean;
  isSubVersion: boolean;
  parentId: boolean;
  priceLists: boolean;
  useNationalProcurementInvoicing: boolean;
};

export type CustomerContractOpResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractOpResult
>;
export type CustomerContractOpResult__Fields = {
  errors: boolean;
  value: CustomerContract__Fields;
};

export type CustomerContractPriceListResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractPriceList
>;
export type CustomerContractPriceList__Fields = {
  _id: boolean;
  administrativeFee: boolean;
  customerContract: CustomerContract__Fields;
  customerCount: boolean;
  customerTree: CustomerTreeItem__Fields;
  customers: Customer__Fields;
  endDate: boolean;
  name: boolean;
  priceGroups: CustomerContractPriceListGroup__Fields;
  startDate: boolean;
  travelZones: TravelZone__Fields;
};

export type CustomerContractPriceListGroupResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractPriceListGroup
>;
export type CustomerContractPriceListGroup__Fields = {
  _id: boolean;
  highHolidays: HighHoliday__Fields;
  professionsPrice: CustomerContractProfessionsPrice__Fields;
  records: ContractsPriceRecord__Fields;
};

export type CustomerContractProfessionsPriceResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractProfessionsPrice
>;
export type CustomerContractProfessionsPrice__Fields = {
  price: boolean;
  profession: ContractProfession__Fields;
};

export type CustomerContractSearchResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractSearchResult
>;
export type CustomerContractSearchResult__Fields = {
  items: CustomerContractSearchRow__Fields;
  limit: boolean;
  skip: boolean;
};

export type CustomerContractSearchRowResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractSearchRow
>;
export type CustomerContractSearchRow__Fields = {
  _id: boolean;
  contractEnd: boolean;
  contractName: boolean;
  contractNumber: boolean;
  contractPriceAdjustmentDate: boolean;
  contractPriceAdjustmentDateDeadline: boolean;
  contractProlongation: boolean;
  contractProlongationDeadline: boolean;
  contractStart: boolean;
  currentContractEnd: boolean;
  estimatedContractValue: boolean;
  orgCustomerRefs: CustomerRef__Fields;
  professions: boolean;
  status: boolean;
  subVersions: CustomerContractSubVersion__Fields;
};

export type CustomerContractSnapshotResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractSnapshot
>;
export type CustomerContractSnapshot__Fields = {
  _id: boolean;
  consultantId: boolean;
  contactPersonId: boolean;
  customerContractId: boolean;
  customerId: boolean;
  externalId: boolean;
  fileRef: FileRef__Fields;
  fileUrl: boolean;
  invoiceMarking: boolean;
  isNullified: boolean;
  name: boolean;
  parentId: boolean;
  publishedUrl: boolean;
  responsiblePersonId: boolean;
  signedOn: boolean;
  type: boolean;
  viewUrl: boolean;
};

export type CustomerContractSnapshotOpResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractSnapshotOpResult
>;
export type CustomerContractSnapshotOpResult__Fields = {
  errors: boolean;
  value: CustomerContractSnapshot__Fields;
};

export type CustomerContractSubVersionResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerContractSubVersion
>;
export type CustomerContractSubVersion__Fields = {
  _id: boolean;
  basicPrice: boolean;
  consultantId: boolean;
  customerContractName: boolean;
  endDate: boolean;
  fileRef: FileRef__Fields;
  name: boolean;
  startDate: boolean;
};

export type CustomerDocumentResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerDocument
>;
export type CustomerDocument__Fields = {
  DocumentType: boolean;
  FileRef: FileRef__Fields;
  PdfURL: boolean;
  ThumbURL: boolean;
};

export type CustomerEventResolver<Parent> = ReturnTypeResolver<Parent, CustomerEvent>;
export type CustomerEvent__Fields = {
  AreasOfExpertise: boolean;
  Audit: Audit__Fields;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  ContactPerson: NodeRef__Fields;
  CreatedBy: WeakUserRef__Fields;
  CreatedOn: boolean;
  CustomerGroup: boolean;
  Deleted: boolean;
  DeletedBy: WeakUserRef__Fields;
  Description: boolean;
  DescriptionHtml: boolean;
  Links: boolean;
  MetBy: WeakUserRef__Fields;
  Node: NodeRef__Fields;
  Roles: boolean;
  RootCustomer: CustomerRef__Fields;
  Sticky: boolean;
  TodoItem: TodoItem__Fields;
  TodoRef: NodeRef__Fields;
  Type: boolean;
  UpdatedBy: WeakUserRef__Fields;
  Warning: boolean;
  _id: boolean;
};

export type CustomerRecommendedPriceResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerRecommendedPrice
>;
export type CustomerRecommendedPrice__Fields = {
  areaOfExpertise: boolean;
  profession: boolean;
  value: boolean;
};

export type CustomerRefResolver<Parent> = ReturnTypeResolver<Parent, CustomerRef>;
export type CustomerRef__Fields = {
  Id: boolean;
  Name: boolean;
  Type: boolean;
};

export type CustomerTreeItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerTreeItem
>;
export type CustomerTreeItem__Fields = {
  CustomerRef: CustomerRef__Fields;
  HospitalRef: CustomerRef__Fields;
  ParentId: boolean;
  ParentRef: CustomerRef__Fields;
};

export type CustomerWorkshiftSpanResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomerWorkshiftSpan
>;
export type CustomerWorkshiftSpan__Fields = {
  FromMinutes: boolean;
  Profession: boolean;
  ToMinutes: boolean;
  Workshift: boolean;
};

export type CustomersResultResolver<Parent> = ReturnTypeResolver<Parent, CustomersResult>;
export type CustomersResult__Fields = {
  dbTime: boolean;
  items: Customer__Fields;
  limit: boolean;
  skip: boolean;
};

export type CustomersTotalResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  CustomersTotalResult
>;
export type CustomersTotalResult__Fields = {
  dbTime: boolean;
  total: boolean;
};

export type DefaultTravelZoneResolver<Parent> = ReturnTypeResolver<
  Parent,
  DefaultTravelZone
>;
export type DefaultTravelZone__Fields = {
  label: boolean;
  name: boolean;
};

export type DoctorAreasOfExpertiseResolver<Parent> = ReturnTypeResolver<
  Parent,
  DoctorAreasOfExpertise
>;
export type DoctorAreasOfExpertise__Fields = {
  comment: boolean;
  interested: boolean;
  name: boolean;
  open: boolean;
  qualified: boolean;
  specializations: DoctorSpecialization__Fields;
  yearFrom: boolean;
};

export type DoctorProfessionResolver<Parent> = ReturnTypeResolver<
  Parent,
  DoctorProfession
>;
export type DoctorProfession__Fields = {
  areasOfExpertise: DoctorAreasOfExpertise__Fields;
  certifiedFrom: boolean;
  code: boolean;
  professionName: boolean;
  systems: boolean;
};

export type DoctorSpecializationResolver<Parent> = ReturnTypeResolver<
  Parent,
  DoctorSpecialization
>;
export type DoctorSpecialization__Fields = {
  comment: boolean;
  interested: boolean;
  name: boolean;
  qualified: boolean;
};

export type DocumentResolver<Parent> = ReturnTypeResolver<Parent, Document>;
export type Document__Fields = {
  DocumentType: boolean;
  FileRef: FileRef__Fields;
  PdfURL: boolean;
  PreviewURL: boolean;
  ThumbURL: boolean;
};

export type EditProofResolver<Parent> = ReturnTypeResolver<Parent, EditProof>;
export type EditProof__Fields = {
  _id: boolean;
  editBy: UserRef__Fields;
  editOn: boolean;
  fileRefs: FileRef__Fields;
};

export type EducationCCResolver<Parent> = ReturnTypeResolver<Parent, EducationCC>;
export type EducationCC__Fields = {
  Show: boolean;
  Text: boolean;
};

export type EmailRecipientResolver<Parent> = ReturnTypeResolver<Parent, EmailRecipient>;
export type EmailRecipient__Fields = {
  Email: boolean;
  Name: boolean;
};

export type EmailResultResolver<Parent> = ReturnTypeResolver<Parent, EmailResult>;
export type EmailResult__Fields = {
  Body: boolean;
  Subject: boolean;
};

export type EventResolver<Parent> = ReturnTypeResolver<Parent, Event>;
export type Event__Fields = {
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedBy: WeakUserRef__Fields;
  CreatedOn: boolean;
  Deleted: boolean;
  DeletedBy: WeakUserRef__Fields;
  Description: boolean;
  DescriptionHtml: boolean;
  Links: boolean;
  Sticky: boolean;
  UpdatedBy: WeakUserRef__Fields;
  Warning: boolean;
  _id: boolean;
};

export type ExpertiseResolver<Parent> = ReturnTypeResolver<Parent, Expertise>;
export type Expertise__Fields = {
  Aliases: boolean;
  Educations: boolean;
  Exclusive: boolean;
  Internal: boolean;
  Machines: boolean;
  Methods: boolean;
  Name: boolean;
  Profession: boolean;
  QualityTemplates: QualityTemplate__Fields;
  Specializations: boolean;
  Systems: boolean;
};

export type ExpertiseConfigResolver<Parent> = ReturnTypeResolver<Parent, ExpertiseConfig>;
export type ExpertiseConfig__Fields = {
  ADGroup: boolean;
  Aliases: boolean;
  Exclusive: boolean;
  Internal: boolean;
  Name: boolean;
  QualityTemplates: boolean;
  SNI: boolean;
  Specializations: boolean;
};

export type ExtractContactPersonResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  ExtractContactPersonResult
>;
export type ExtractContactPersonResult__Fields = {
  contactPerson: ContactPerson__Fields;
  validationErrors: ValidationError__Fields;
};

export type FileRefResolver<Parent> = ReturnTypeResolver<Parent, FileRef>;
export type FileRef__Fields = {
  MimeType: boolean;
  Name: boolean;
  NodeID: boolean;
  NodeType: boolean;
  Size: boolean;
};

export type FinaliseConsultantOpportunityResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  FinaliseConsultantOpportunityResult
>;
export type FinaliseConsultantOpportunityResult__Fields = {
  lost: ConsultantOpportunity__Fields;
  won: ConsultantOpportunity__Fields;
};

export type FormAddressResolver<Parent> = ReturnTypeResolver<Parent, FormAddress>;
export type FormAddress__Fields = {
  city: boolean;
  country: boolean;
  streetName: boolean;
  zipCode: boolean;
};

export type FormAddressWithRegionResolver<Parent> = ReturnTypeResolver<
  Parent,
  FormAddressWithRegion
>;
export type FormAddressWithRegion__Fields = {
  city: boolean;
  country: boolean;
  region: boolean;
  streetName: boolean;
  zipCode: boolean;
};

export type FortnoxSalaryCacheResolver<Parent> = ReturnTypeResolver<
  Parent,
  FortnoxSalaryCache
>;
export type FortnoxSalaryCache__Fields = {
  consultantId: boolean;
  employeeId: boolean;
  id: boolean;
  lastFetchedAt: boolean;
  yearSums: FortnoxSalaryYearSum__Fields;
};

export type FortnoxSalaryYearSumResolver<Parent> = ReturnTypeResolver<
  Parent,
  FortnoxSalaryYearSum
>;
export type FortnoxSalaryYearSum__Fields = {
  sum: boolean;
  year: boolean;
};

export type FortnoxVoucherSubmitResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  FortnoxVoucherSubmitResult
>;
export type FortnoxVoucherSubmitResult__Fields = {
  result: boolean;
};

export type FortnoxWeekSalaryCheckResolver<Parent> = ReturnTypeResolver<
  Parent,
  FortnoxWeekSalaryCheck
>;
export type FortnoxWeekSalaryCheck__Fields = {
  employeeId: boolean;
  takenWeekDays: boolean;
};

export type FreeTimereportResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  FreeTimereportResult
>;
export type FreeTimereportResult__Fields = {
  freeTimereports: boolean;
};

export type FreshdeskTicketResolver<Parent> = ReturnTypeResolver<Parent, FreshdeskTicket>;
export type FreshdeskTicket__Fields = {
  createdAt: boolean;
  id: boolean;
  status: boolean;
  subject: boolean;
  updatedAt: boolean;
  url: boolean;
};

export type GDPRConsentResolver<Parent> = ReturnTypeResolver<Parent, GDPRConsent>;
export type GDPRConsent__Fields = {
  communicationChannel: boolean;
  dateGranted: boolean;
  dateRevoked: boolean;
  granted: boolean;
  grantedBy: NodeRef__Fields;
  revokedBy: NodeRef__Fields;
  type: boolean;
};

export type GeneratePresentationAttachmentErrorResolver<Parent> = ReturnTypeResolver<
  Parent,
  GeneratePresentationAttachmentError
>;
export type GeneratePresentationAttachmentError__Fields = {
  error: boolean;
  fileId: boolean;
  filename: boolean;
};

export type GeneratePresentationResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  GeneratePresentationResult
>;
export type GeneratePresentationResult__Fields = {
  attachmentErrors: GeneratePresentationAttachmentError__Fields;
  presentation: ConsultantPresentation__Fields;
};

export type GenericProfessionResolver<Parent> = ReturnTypeResolver<
  Parent,
  GenericProfession
>;
export type GenericProfession__Fields = {
  certifiedFrom: boolean;
  professionName: boolean;
  specializations: GenericSpecialization__Fields;
  systems: boolean;
};

export type GenericSpecializationResolver<Parent> = ReturnTypeResolver<
  Parent,
  GenericSpecialization
>;
export type GenericSpecialization__Fields = {
  comment: boolean;
  interested: boolean;
  name: boolean;
  qualified: boolean;
  yearFrom: boolean;
};

export type GeolocationResolver<Parent> = ReturnTypeResolver<Parent, Geolocation>;
export type Geolocation__Fields = {
  geometry: Geometry__Fields;
};

export type GeometryResolver<Parent> = ReturnTypeResolver<Parent, Geometry>;
export type Geometry__Fields = {
  coordinates: boolean;
  type: boolean;
};

export type GetAttestContactPersonsResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  GetAttestContactPersonsResult
>;
export type GetAttestContactPersonsResult__Fields = {
  items: ContactPerson__Fields;
  workplaceAllowsDigitalTimereport: boolean;
};

export type GetTimereportToCustomerEmailResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  GetTimereportToCustomerEmailResult
>;
export type GetTimereportToCustomerEmailResult__Fields = {
  Body: boolean;
  Subject: boolean;
};

export type HealthDeclarationDocumentResolver<Parent> = ReturnTypeResolver<
  Parent,
  HealthDeclarationDocument
>;
export type HealthDeclarationDocument__Fields = {
  createdAt: boolean;
  id: boolean;
  name: boolean;
  signedAt: boolean;
  status: boolean;
  url: boolean;
};

export type HealthDeclarationsQueryResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  HealthDeclarationsQueryResult
>;
export type HealthDeclarationsQueryResult__Fields = {
  items: HealthDeclarationDocument__Fields;
  total: boolean;
};

export type HighHolidayResolver<Parent> = ReturnTypeResolver<Parent, HighHoliday>;
export type HighHoliday__Fields = {
  _id: boolean;
  isGreatHoliday: boolean;
  option: HighHolidayOption__Fields;
};

export type HighHolidayOptionResolver<Parent> = ReturnTypeResolver<
  Parent,
  HighHolidayOption
>;
export type HighHolidayOption__Fields = {
  _id: boolean;
  listPosition: boolean;
  name: boolean;
};

export type IContactResolver<Parent> = ReturnTypeResolver<Parent, IContact>;
export type IContact__Fields = {
  Address: Address__Fields;
  AvatarPic: boolean;
  CellPhone: boolean;
  CellPhoneValid: boolean;
  Email: boolean;
  EmailValid: boolean;
  GDPRConsentRecords: GDPRConsent__Fields;
  Name: boolean;
  Phone: boolean;
  PhoneValid: boolean;
  ResponsiblePerson: UserRef__Fields;
  Roles: boolean;
  Title: boolean;
  _id: boolean;
};

export type INodeResolver<Parent> = ReturnTypeResolver<Parent, INode>;
export type INode__Fields = {
  IsValid: boolean;
  NodeName: boolean;
  NodeType: boolean;
  ValidationErrors: NodeValidationError__Fields;
  _id: boolean;
};

export type ImportConsultantMetaResolver<Parent> = ReturnTypeResolver<
  Parent,
  ImportConsultantMeta
>;
export type ImportConsultantMeta__Fields = {
  importBatch: boolean;
  source: boolean;
};

export type InvoiceResolver<Parent> = ReturnTypeResolver<Parent, Invoice>;
export type Invoice__Fields = {
  CustomerName: boolean;
  CustomerNumber: boolean;
  DueDate: boolean;
  InvoiceDate: boolean;
  InvoiceNumber: boolean;
  InvoiceTotal: boolean;
  IsCredit: boolean;
  Notes: boolean;
  PreviewUrl: boolean;
  Provider: boolean;
  TotalGross: boolean;
  TotalNet: boolean;
  _id: boolean;
};

export type KanbanBoardResolver<Parent> = ReturnTypeResolver<Parent, KanbanBoard>;
export type KanbanBoard__Fields = {
  _id: boolean;
  columns: KanbanColumn__Fields;
  name: boolean;
  owner: User__Fields;
  type: boolean;
};

export type KanbanCardResolver<Parent> = ReturnTypeResolver<Parent, KanbanCard>;
export type KanbanCard__Fields = {
  _id: boolean;
  assignee: User__Fields;
  boardId: boolean;
  columnId: boolean;
  description: boolean;
  dueDate: boolean;
  order: boolean;
  title: boolean;
};

export type KanbanCardActionPayloadResolver<Parent> = ReturnTypeResolver<
  Parent,
  KanbanCardActionPayload
>;
export type KanbanCardActionPayload__Fields = {
  boardId: boolean;
  cardId: boolean;
  sessionId: boolean;
  userId: boolean;
};

export type KanbanColumnResolver<Parent> = ReturnTypeResolver<Parent, KanbanColumn>;
export type KanbanColumn__Fields = {
  _id: boolean;
  name: boolean;
  order: boolean;
};

export type KitAssignedToResolver<Parent> = ReturnTypeResolver<Parent, KitAssignedTo>;
export type KitAssignedTo__Fields = {
  by: UserRef__Fields;
  on: boolean;
  to: UserRef__Fields;
};

export type LoginAttemptResolver<Parent> = ReturnTypeResolver<Parent, LoginAttempt>;
export type LoginAttempt__Fields = {
  Date: boolean;
  Ip: boolean;
  Success: boolean;
};

export type MeResolver<Parent> = ReturnTypeResolver<Parent, Me>;
export type Me__Fields = {
  AvatarPic: boolean;
  AzureGroups: boolean;
  AzureId: boolean;
  BirthDate: boolean;
  CallLists: CallList__Fields;
  CellPhone: boolean;
  ContactLists: CallList__Fields;
  Deleted: boolean;
  Email: boolean;
  Enabled: boolean;
  ExtraAreasOfExpertise: Expertise__Fields;
  ManagerId: boolean;
  Name: boolean;
  NodeID: boolean;
  NodeType: boolean;
  Permissions: UserPermissions__Fields;
  Phone: boolean;
  Teams: boolean;
  Title: boolean;
  _id: boolean;
  allowedCostCenters: CostCenter__Fields;
  favoriteTeam: boolean;
  favouriteConsultantIds: boolean;
  permissions: boolean;
  subordinates: User__Fields;
  todoBadges: TodoUserBadges__Fields;
};

export type MePartialResolver<Parent> = ReturnTypeResolver<Parent, MePartial>;
export type MePartial__Fields = {
  CallLists: CallList__Fields;
  ContactLists: CallList__Fields;
};

export type MunicipalityResolver<Parent> = ReturnTypeResolver<Parent, Municipality>;
export type Municipality__Fields = {
  _id: boolean;
  name: boolean;
  region: boolean;
  zone: boolean;
};
export namespace Mutation {
  export type AddAccommodationResolver<Parent = never> = Resolver<
    Accommodation | Parent,
    Parent,
    MutationAddAccommodationArgs
  >;
  export type AddAccommodationArgs = MutationAddAccommodationArgs;

  export type AddAccommodationCommentEventResolver<Parent = never> = Resolver<
    AccommodationEvent | Parent,
    Parent,
    MutationAddAccommodationCommentEventArgs
  >;
  export type AddAccommodationCommentEventArgs = MutationAddAccommodationCommentEventArgs;

  export type AddBookingCommentEventResolver<Parent = never> = Resolver<
    BookingEvent | Parent,
    Parent,
    MutationAddBookingCommentEventArgs
  >;
  export type AddBookingCommentEventArgs = MutationAddBookingCommentEventArgs;

  export type AddBookingKitCommentEventResolver<Parent = never> = Resolver<
    BookingKitEvent | Parent,
    Parent,
    MutationAddBookingKitCommentEventArgs
  >;
  export type AddBookingKitCommentEventArgs = MutationAddBookingKitCommentEventArgs;

  export type AddConsultantAvailabilityResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationAddConsultantAvailabilityArgs
  >;
  export type AddConsultantAvailabilityArgs = MutationAddConsultantAvailabilityArgs;

  export type AddConsultantBookingContractResolver<Parent = never> = Resolver<
    ConsultantBookingContractListItem | Parent,
    Parent,
    MutationAddConsultantBookingContractArgs
  >;
  export type AddConsultantBookingContractArgs = MutationAddConsultantBookingContractArgs;

  export type AddConsultantCallEventResolver<Parent = never> = Resolver<
    ConsultantEvent | Parent,
    Parent,
    MutationAddConsultantCallEventArgs
  >;
  export type AddConsultantCallEventArgs = MutationAddConsultantCallEventArgs;

  export type AddConsultantCommentEventResolver<Parent = never> = Resolver<
    ConsultantEvent | Parent,
    Parent,
    MutationAddConsultantCommentEventArgs
  >;
  export type AddConsultantCommentEventArgs = MutationAddConsultantCommentEventArgs;

  export type AddConsultantInterestEventResolver<Parent = never> = Resolver<
    ConsultantEvent | Parent,
    Parent,
    MutationAddConsultantInterestEventArgs
  >;
  export type AddConsultantInterestEventArgs = MutationAddConsultantInterestEventArgs;

  export type AddConsultantNoanswerEventResolver<Parent = never> = Resolver<
    AddNoanswerEventResult | Parent,
    Parent,
    MutationAddConsultantNoanswerEventArgs
  >;
  export type AddConsultantNoanswerEventArgs = MutationAddConsultantNoanswerEventArgs;

  export type AddConsultantReminderEventResolver<Parent = never> = Resolver<
    ConsultantEvent | Parent,
    Parent,
    MutationAddConsultantReminderEventArgs
  >;
  export type AddConsultantReminderEventArgs = MutationAddConsultantReminderEventArgs;

  export type AddConsultantSMSEventResolver<Parent = never> = Resolver<
    ConsultantEvent | Parent,
    Parent,
    MutationAddConsultantSMSEventArgs
  >;
  export type AddConsultantSMSEventArgs = MutationAddConsultantSMSEventArgs;

  export type AddConsultantTagResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationAddConsultantTagArgs
  >;
  export type AddConsultantTagArgs = MutationAddConsultantTagArgs;

  export type AddConsultantWorkExperienceResolver<Parent = never> = Resolver<
    ConsultantWorkExperienceResult | Parent,
    Parent,
    MutationAddConsultantWorkExperienceArgs
  >;
  export type AddConsultantWorkExperienceArgs = MutationAddConsultantWorkExperienceArgs;

  export type AddCustomerCommentEventResolver<Parent = never> = Resolver<
    CustomerEvent | Parent,
    Parent,
    MutationAddCustomerCommentEventArgs
  >;
  export type AddCustomerCommentEventArgs = MutationAddCustomerCommentEventArgs;

  export type AddCustomerContractCommentEventResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationAddCustomerContractCommentEventArgs
  >;
  export type AddCustomerContractCommentEventArgs =
    MutationAddCustomerContractCommentEventArgs;

  export type AddCustomerMetInPersonEventResolver<Parent = never> = Resolver<
    CustomerEvent | Parent,
    Parent,
    MutationAddCustomerMetInPersonEventArgs
  >;
  export type AddCustomerMetInPersonEventArgs = MutationAddCustomerMetInPersonEventArgs;

  export type AddCustomerReminderEventResolver<Parent = never> = Resolver<
    CustomerEvent | Parent,
    Parent,
    MutationAddCustomerReminderEventArgs
  >;
  export type AddCustomerReminderEventArgs = MutationAddCustomerReminderEventArgs;

  export type AddSalaryChoiceToConsultantContractResolver<Parent = never> = Resolver<
    ConsultantContractListItem | Parent,
    Parent,
    MutationAddSalaryChoiceToConsultantContractArgs
  >;
  export type AddSalaryChoiceToConsultantContractArgs =
    MutationAddSalaryChoiceToConsultantContractArgs;

  export type AddToCallListResolver<Parent = never> = Resolver<
    CallListOpResult | Parent,
    Parent,
    MutationAddToCallListArgs
  >;
  export type AddToCallListArgs = MutationAddToCallListArgs;

  export type AddTodoCommentEventResolver<Parent = never> = Resolver<
    TodoEvent | Parent,
    Parent,
    MutationAddTodoCommentEventArgs
  >;
  export type AddTodoCommentEventArgs = MutationAddTodoCommentEventArgs;

  export type AddTodoReminderEventResolver<Parent = never> = Resolver<
    TodoEvent | Parent,
    Parent,
    MutationAddTodoReminderEventArgs
  >;
  export type AddTodoReminderEventArgs = MutationAddTodoReminderEventArgs;

  export type AddUnSignConsultantContractResolver<Parent = never> = Resolver<
    ConsultantContractListItem | Parent,
    Parent,
    MutationAddUnSignConsultantContractArgs
  >;
  export type AddUnSignConsultantContractArgs = MutationAddUnSignConsultantContractArgs;

  export type ApproveBookingKitResolver<Parent = never> = Resolver<
    BookingKit | Parent,
    Parent,
    MutationApproveBookingKitArgs
  >;
  export type ApproveBookingKitArgs = MutationApproveBookingKitArgs;

  export type ApproveTimereportResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationApproveTimereportArgs
  >;
  export type ApproveTimereportArgs = MutationApproveTimereportArgs;

  export type AssignContactPersonToCustomerResolver<Parent = never> = Resolver<
    AssignContactPersonToCustomerResult | Parent,
    Parent,
    MutationAssignContactPersonToCustomerArgs
  >;
  export type AssignContactPersonToCustomerArgs =
    MutationAssignContactPersonToCustomerArgs;

  export type AssignFortnoxInvoiceToBookingResolver<Parent = never> = Resolver<
    UpdateBookingResult | Parent,
    Parent,
    MutationAssignFortnoxInvoiceToBookingArgs
  >;
  export type AssignFortnoxInvoiceToBookingArgs =
    MutationAssignFortnoxInvoiceToBookingArgs;

  export type AssignTimereportToBookingResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationAssignTimereportToBookingArgs
  >;
  export type AssignTimereportToBookingArgs = MutationAssignTimereportToBookingArgs;

  export type AssignToBookingResolver<Parent = never> = Resolver<
    BookingAssignedToResult | Parent,
    Parent,
    MutationAssignToBookingArgs
  >;
  export type AssignToBookingArgs = MutationAssignToBookingArgs;

  export type AssignToBookingKitResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationAssignToBookingKitArgs
  >;
  export type AssignToBookingKitArgs = MutationAssignToBookingKitArgs;

  export type AssignTodoResolver<Parent = never> = Resolver<
    TodoItem | Parent,
    Parent,
    MutationAssignTodoArgs
  >;
  export type AssignTodoArgs = MutationAssignTodoArgs;

  export type BulkActionResolver<Parent = never> = Resolver<
    BulkActionResult | Parent,
    Parent,
    MutationBulkActionArgs
  >;
  export type BulkActionArgs = MutationBulkActionArgs;

  export type BulkUpdateResponsiblePersonResolver<Parent = never> = Resolver<
    BulkUpdateResult | Parent,
    Parent,
    MutationBulkUpdateResponsiblePersonArgs
  >;
  export type BulkUpdateResponsiblePersonArgs = MutationBulkUpdateResponsiblePersonArgs;

  export type CancelBookingResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationCancelBookingArgs
  >;
  export type CancelBookingArgs = MutationCancelBookingArgs;

  export type CancelBookingGroupResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationCancelBookingGroupArgs
  >;
  export type CancelBookingGroupArgs = MutationCancelBookingGroupArgs;

  export type ChangeConsultantServicePreferenceStatusResolver<Parent = never> = Resolver<
    ConsultantServicePreference | Parent,
    Parent,
    MutationChangeConsultantServicePreferenceStatusArgs
  >;
  export type ChangeConsultantServicePreferenceStatusArgs =
    MutationChangeConsultantServicePreferenceStatusArgs;

  export type ChangeStatusConsultantReferenceResolver<Parent = never> = Resolver<
    ConsultantReferenceNew | Parent,
    Parent,
    MutationChangeStatusConsultantReferenceArgs
  >;
  export type ChangeStatusConsultantReferenceArgs =
    MutationChangeStatusConsultantReferenceArgs;

  export type ClearConsultantResponsiblePersonResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationClearConsultantResponsiblePersonArgs
  >;
  export type ClearConsultantResponsiblePersonArgs =
    MutationClearConsultantResponsiblePersonArgs;

  export type ClearQualityItemStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationClearQualityItemStatusArgs
  >;
  export type ClearQualityItemStatusArgs = MutationClearQualityItemStatusArgs;

  export type ClearTimereportDaysResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationClearTimereportDaysArgs
  >;
  export type ClearTimereportDaysArgs = MutationClearTimereportDaysArgs;

  export type CloneBookingResolver<Parent = never> = Resolver<
    ObjectId | Parent,
    Parent,
    MutationCloneBookingArgs
  >;
  export type CloneBookingArgs = MutationCloneBookingArgs;

  export type ConfirmAccommodationResolver<Parent = never> = Resolver<
    BookingHospitality | Parent,
    Parent,
    MutationConfirmAccommodationArgs
  >;
  export type ConfirmAccommodationArgs = MutationConfirmAccommodationArgs;

  export type ConfirmTravelResolver<Parent = never> = Resolver<
    BookingHospitality | Parent,
    Parent,
    MutationConfirmTravelArgs
  >;
  export type ConfirmTravelArgs = MutationConfirmTravelArgs;

  export type ConsultantExportBulkActionResolver<Parent = never> = Resolver<
    BulkActionResult | Parent,
    Parent,
    MutationConsultantExportBulkActionArgs
  >;
  export type ConsultantExportBulkActionArgs = MutationConsultantExportBulkActionArgs;

  export type ConsultantExportSsnBulkActionResolver<Parent = never> = Resolver<
    BulkActionResult | Parent,
    Parent,
    MutationConsultantExportSsnBulkActionArgs
  >;
  export type ConsultantExportSsnBulkActionArgs =
    MutationConsultantExportSsnBulkActionArgs;

  export type ConsultantGeneratePresentationResolver<Parent = never> = Resolver<
    GeneratePresentationResult | Parent,
    Parent,
    MutationConsultantGeneratePresentationArgs
  >;
  export type ConsultantGeneratePresentationArgs =
    MutationConsultantGeneratePresentationArgs;

  export type ConsultantImportDeduplicateResolver<Parent = never> = Resolver<
    Array<ConsultantImportRow> | Parent,
    Parent,
    MutationConsultantImportDeduplicateArgs
  >;
  export type ConsultantImportDeduplicateArgs = MutationConsultantImportDeduplicateArgs;

  export type ConsultantImportLookupRowsResolver<Parent = never> = Resolver<
    Array<ConsultantImportRow> | Parent,
    Parent,
    MutationConsultantImportLookupRowsArgs
  >;
  export type ConsultantImportLookupRowsArgs = MutationConsultantImportLookupRowsArgs;

  export type CreateAccommodationRequestResolver<Parent = never> = Resolver<
    AccommodationRequest | Parent,
    Parent,
    MutationCreateAccommodationRequestArgs
  >;
  export type CreateAccommodationRequestArgs = MutationCreateAccommodationRequestArgs;

  export type CreateApiTokenResolver<Parent = never> = Resolver<
    CreateApiTokenResult | Parent,
    Parent,
    MutationCreateApiTokenArgs
  >;
  export type CreateApiTokenArgs = MutationCreateApiTokenArgs;

  export type CreateBookingGroupResolver<Parent = never> = Resolver<
    BookingGroup | Parent,
    Parent,
    MutationCreateBookingGroupArgs
  >;
  export type CreateBookingGroupArgs = MutationCreateBookingGroupArgs;

  export type CreateBookingKitResolver<Parent = never> = Resolver<
    BookingKit | Parent,
    Parent,
    MutationCreateBookingKitArgs
  >;
  export type CreateBookingKitArgs = MutationCreateBookingKitArgs;

  export type CreateCallListResolver<Parent = never> = Resolver<
    CallListOpResult | Parent,
    Parent,
    MutationCreateCallListArgs
  >;
  export type CreateCallListArgs = MutationCreateCallListArgs;

  export type CreateConsultantOpportunityResolver<Parent = never> = Resolver<
    ConsultantOpportunity | Parent,
    Parent,
    MutationCreateConsultantOpportunityArgs
  >;
  export type CreateConsultantOpportunityArgs = MutationCreateConsultantOpportunityArgs;

  export type CreateConsultantReferenceResolver<Parent = never> = Resolver<
    ConsultantReferenceNew | Parent,
    Parent,
    MutationCreateConsultantReferenceArgs
  >;
  export type CreateConsultantReferenceArgs = MutationCreateConsultantReferenceArgs;

  export type CreateConsultantServicePreferenceResolver<Parent = never> = Resolver<
    ConsultantServicePreference | Parent,
    Parent,
    MutationCreateConsultantServicePreferenceArgs
  >;
  export type CreateConsultantServicePreferenceArgs =
    MutationCreateConsultantServicePreferenceArgs;

  export type CreateConsultantWorkStatusResolver<Parent = never> = Resolver<
    ConsultantWorkStatus | Parent,
    Parent,
    MutationCreateConsultantWorkStatusArgs
  >;
  export type CreateConsultantWorkStatusArgs = MutationCreateConsultantWorkStatusArgs;

  export type CreateContactPersonResolver<Parent = never> = Resolver<
    CreateContactPersonResult | Parent,
    Parent,
    MutationCreateContactPersonArgs
  >;
  export type CreateContactPersonArgs = MutationCreateContactPersonArgs;

  export type CreateCostCenterResolver<Parent = never> = Resolver<
    CostCenterConfigItem | Parent,
    Parent,
    MutationCreateCostCenterArgs
  >;
  export type CreateCostCenterArgs = MutationCreateCostCenterArgs;

  export type CreateCustomerResolver<Parent = never> = Resolver<
    CreateCustomerResult | Parent,
    Parent,
    MutationCreateCustomerArgs
  >;
  export type CreateCustomerArgs = MutationCreateCustomerArgs;

  export type CreateDirectRequestContractResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationCreateDirectRequestContractArgs
  >;
  export type CreateDirectRequestContractArgs = MutationCreateDirectRequestContractArgs;

  export type CreateTgRequirementResolver<Parent = never> = Resolver<
    TgRequirement | Parent,
    Parent,
    MutationCreateTgRequirementArgs
  >;
  export type CreateTgRequirementArgs = MutationCreateTgRequirementArgs;

  export type CreateTravelRequestResolver<Parent = never> = Resolver<
    TravelRequest | Parent,
    Parent,
    MutationCreateTravelRequestArgs
  >;
  export type CreateTravelRequestArgs = MutationCreateTravelRequestArgs;

  export type DeassignContactPersonFromCustomersResolver<Parent = never> = Resolver<
    ContactPerson | Parent,
    Parent,
    MutationDeassignContactPersonFromCustomersArgs
  >;
  export type DeassignContactPersonFromCustomersArgs =
    MutationDeassignContactPersonFromCustomersArgs;

  export type DeleteAccommodationResolver<Parent = never> = Resolver<
    Accommodation | Parent,
    Parent,
    MutationDeleteAccommodationArgs
  >;
  export type DeleteAccommodationArgs = MutationDeleteAccommodationArgs;

  export type DeleteAccommodationDocumentResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteAccommodationDocumentArgs
  >;
  export type DeleteAccommodationDocumentArgs = MutationDeleteAccommodationDocumentArgs;

  export type DeleteAccommodationEventResolver<Parent = never> = Resolver<
    AccommodationEvent | Parent,
    Parent,
    MutationDeleteAccommodationEventArgs
  >;
  export type DeleteAccommodationEventArgs = MutationDeleteAccommodationEventArgs;

  export type DeleteBookingDocumentResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteBookingDocumentArgs
  >;
  export type DeleteBookingDocumentArgs = MutationDeleteBookingDocumentArgs;

  export type DeleteBookingEventResolver<Parent = never> = Resolver<
    BookingEvent | Parent,
    Parent,
    MutationDeleteBookingEventArgs
  >;
  export type DeleteBookingEventArgs = MutationDeleteBookingEventArgs;

  export type DeleteBookingKitResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteBookingKitArgs
  >;
  export type DeleteBookingKitArgs = MutationDeleteBookingKitArgs;

  export type DeleteBookingKitEventResolver<Parent = never> = Resolver<
    BookingKitEvent | Parent,
    Parent,
    MutationDeleteBookingKitEventArgs
  >;
  export type DeleteBookingKitEventArgs = MutationDeleteBookingKitEventArgs;

  export type DeleteConsultantAvailabilityResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationDeleteConsultantAvailabilityArgs
  >;
  export type DeleteConsultantAvailabilityArgs = MutationDeleteConsultantAvailabilityArgs;

  export type DeleteConsultantBookingContractResolver<Parent = never> = Resolver<
    ConsultantBookingContract | Parent,
    Parent,
    MutationDeleteConsultantBookingContractArgs
  >;
  export type DeleteConsultantBookingContractArgs =
    MutationDeleteConsultantBookingContractArgs;

  export type DeleteConsultantContractResolver<Parent = never> = Resolver<
    ConsultantContract | Parent,
    Parent,
    MutationDeleteConsultantContractArgs
  >;
  export type DeleteConsultantContractArgs = MutationDeleteConsultantContractArgs;

  export type DeleteConsultantEventResolver<Parent = never> = Resolver<
    ConsultantEvent | Parent,
    Parent,
    MutationDeleteConsultantEventArgs
  >;
  export type DeleteConsultantEventArgs = MutationDeleteConsultantEventArgs;

  export type DeleteConsultantOpportunityResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteConsultantOpportunityArgs
  >;
  export type DeleteConsultantOpportunityArgs = MutationDeleteConsultantOpportunityArgs;

  export type DeleteConsultantReferenceResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteConsultantReferenceArgs
  >;
  export type DeleteConsultantReferenceArgs = MutationDeleteConsultantReferenceArgs;

  export type DeleteConsultantServicePreferenceResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteConsultantServicePreferenceArgs
  >;
  export type DeleteConsultantServicePreferenceArgs =
    MutationDeleteConsultantServicePreferenceArgs;

  export type DeleteConsultantWorkStatusResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteConsultantWorkStatusArgs
  >;
  export type DeleteConsultantWorkStatusArgs = MutationDeleteConsultantWorkStatusArgs;

  export type DeleteConsultantsResolver<Parent = never> = Resolver<
    Total | Parent,
    Parent,
    MutationDeleteConsultantsArgs
  >;
  export type DeleteConsultantsArgs = MutationDeleteConsultantsArgs;

  export type DeleteContactPersonResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteContactPersonArgs
  >;
  export type DeleteContactPersonArgs = MutationDeleteContactPersonArgs;

  export type DeleteContractPriceTemplateResolver<Parent = never> = Resolver<
    ContractPriceTemplateOpResult | Parent,
    Parent,
    MutationDeleteContractPriceTemplateArgs
  >;
  export type DeleteContractPriceTemplateArgs = MutationDeleteContractPriceTemplateArgs;

  export type DeleteCostCenterResolver<Parent = never> = Resolver<
    CostCenterConfigItem | Parent,
    Parent,
    MutationDeleteCostCenterArgs
  >;
  export type DeleteCostCenterArgs = MutationDeleteCostCenterArgs;

  export type DeleteCustomerResolver<Parent = never> = Resolver<
    Customer | Parent,
    Parent,
    MutationDeleteCustomerArgs
  >;
  export type DeleteCustomerArgs = MutationDeleteCustomerArgs;

  export type DeleteCustomerContractDocumentResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationDeleteCustomerContractDocumentArgs
  >;
  export type DeleteCustomerContractDocumentArgs =
    MutationDeleteCustomerContractDocumentArgs;

  export type DeleteCustomerContractEventResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationDeleteCustomerContractEventArgs
  >;
  export type DeleteCustomerContractEventArgs = MutationDeleteCustomerContractEventArgs;

  export type DeleteCustomerContractSnapshotResolver<Parent = never> = Resolver<
    CustomerContractSnapshotOpResult | Parent,
    Parent,
    MutationDeleteCustomerContractSnapshotArgs
  >;
  export type DeleteCustomerContractSnapshotArgs =
    MutationDeleteCustomerContractSnapshotArgs;

  export type DeleteCustomerContractSubVersionResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationDeleteCustomerContractSubVersionArgs
  >;
  export type DeleteCustomerContractSubVersionArgs =
    MutationDeleteCustomerContractSubVersionArgs;

  export type DeleteCustomerDocumentResolver<Parent = never> = Resolver<
    Array<CustomerDocument> | Parent,
    Parent,
    MutationDeleteCustomerDocumentArgs
  >;
  export type DeleteCustomerDocumentArgs = MutationDeleteCustomerDocumentArgs;

  export type DeleteCustomerEventResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteCustomerEventArgs
  >;
  export type DeleteCustomerEventArgs = MutationDeleteCustomerEventArgs;

  export type DeleteRestoreCustomerContractResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationDeleteRestoreCustomerContractArgs
  >;
  export type DeleteRestoreCustomerContractArgs =
    MutationDeleteRestoreCustomerContractArgs;

  export type DeleteTgRequirementResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationDeleteTgRequirementArgs
  >;
  export type DeleteTgRequirementArgs = MutationDeleteTgRequirementArgs;

  export type DeleteTodoEventResolver<Parent = never> = Resolver<
    TodoEvent | Parent,
    Parent,
    MutationDeleteTodoEventArgs
  >;
  export type DeleteTodoEventArgs = MutationDeleteTodoEventArgs;

  export type DuplicateConsultantToTenantResolver<Parent = never> = Resolver<
    string | Parent,
    Parent,
    MutationDuplicateConsultantToTenantArgs
  >;
  export type DuplicateConsultantToTenantArgs = MutationDuplicateConsultantToTenantArgs;

  export type DuplicateContractPriceTemplateResolver<Parent = never> = Resolver<
    ContractPriceTemplateOpResult | Parent,
    Parent,
    MutationDuplicateContractPriceTemplateArgs
  >;
  export type DuplicateContractPriceTemplateArgs =
    MutationDuplicateContractPriceTemplateArgs;

  export type EditAccommodationResolver<Parent = never> = Resolver<
    Accommodation | Parent,
    Parent,
    MutationEditAccommodationArgs
  >;
  export type EditAccommodationArgs = MutationEditAccommodationArgs;

  export type EditConsultantBookingContractResolver<Parent = never> = Resolver<
    ConsultantBookingContractListItem | Parent,
    Parent,
    MutationEditConsultantBookingContractArgs
  >;
  export type EditConsultantBookingContractArgs =
    MutationEditConsultantBookingContractArgs;

  export type EditConsultantOpportunityResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationEditConsultantOpportunityArgs
  >;
  export type EditConsultantOpportunityArgs = MutationEditConsultantOpportunityArgs;

  export type EditUnSignConsultantContractResolver<Parent = never> = Resolver<
    ConsultantContractListItem | Parent,
    Parent,
    MutationEditUnSignConsultantContractArgs
  >;
  export type EditUnSignConsultantContractArgs = MutationEditUnSignConsultantContractArgs;

  export type ExtractContactPersonResolver<Parent = never> = Resolver<
    ExtractContactPersonResult | Parent,
    Parent,
    MutationExtractContactPersonArgs
  >;
  export type ExtractContactPersonArgs = MutationExtractContactPersonArgs;

  export type FinaliseConsultantOpportunityResolver<Parent = never> = Resolver<
    FinaliseConsultantOpportunityResult | Parent,
    Parent,
    MutationFinaliseConsultantOpportunityArgs
  >;
  export type FinaliseConsultantOpportunityArgs =
    MutationFinaliseConsultantOpportunityArgs;

  export type GenerateCustomerContractSnapshotResolver<Parent = never> = Resolver<
    CustomerContractSnapshotOpResult | Parent,
    Parent,
    MutationGenerateCustomerContractSnapshotArgs
  >;
  export type GenerateCustomerContractSnapshotArgs =
    MutationGenerateCustomerContractSnapshotArgs;

  export type ImportCVResolver<Parent = never> = Resolver<
    ConsultantForm | Parent,
    Parent,
    MutationImportCVArgs
  >;
  export type ImportCVArgs = MutationImportCVArgs;

  export type ImportConsultantsResolver<Parent = never> = Resolver<
    ConsultantImportDocumentResult | Parent,
    Parent,
    MutationImportConsultantsArgs
  >;
  export type ImportConsultantsArgs = MutationImportConsultantsArgs;

  export type LeaveCallListResolver<Parent = never> = Resolver<
    CallListOpResult | Parent,
    Parent,
    MutationLeaveCallListArgs
  >;
  export type LeaveCallListArgs = MutationLeaveCallListArgs;

  export type MergeConsultantReferenceResolver<Parent = never> = Resolver<
    ConsultantReferenceNew | Parent,
    Parent,
    MutationMergeConsultantReferenceArgs
  >;
  export type MergeConsultantReferenceArgs = MutationMergeConsultantReferenceArgs;

  export type MoveCardResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationMoveCardArgs
  >;
  export type MoveCardArgs = MutationMoveCardArgs;

  export type MoveCustomerResolver<Parent = never> = Resolver<
    UpdateMoveCustomerResult | Parent,
    Parent,
    MutationMoveCustomerArgs
  >;
  export type MoveCustomerArgs = MutationMoveCustomerArgs;

  export type NullifyConsultantBookingContractResolver<Parent = never> = Resolver<
    ConsultantBookingContractListItem | Parent,
    Parent,
    MutationNullifyConsultantBookingContractArgs
  >;
  export type NullifyConsultantBookingContractArgs =
    MutationNullifyConsultantBookingContractArgs;

  export type NullifyConsultantContractResolver<Parent = never> = Resolver<
    ConsultantContractListItem | Parent,
    Parent,
    MutationNullifyConsultantContractArgs
  >;
  export type NullifyConsultantContractArgs = MutationNullifyConsultantContractArgs;

  export type NullifyCustomerContractSnapshotResolver<Parent = never> = Resolver<
    CustomerContractSnapshotOpResult | Parent,
    Parent,
    MutationNullifyCustomerContractSnapshotArgs
  >;
  export type NullifyCustomerContractSnapshotArgs =
    MutationNullifyCustomerContractSnapshotArgs;

  export type PinAccommodationEventResolver<Parent = never> = Resolver<
    AccommodationEvent | Parent,
    Parent,
    MutationPinAccommodationEventArgs
  >;
  export type PinAccommodationEventArgs = MutationPinAccommodationEventArgs;

  export type PinConsultantEventResolver<Parent = never> = Resolver<
    ConsultantEvent | Parent,
    Parent,
    MutationPinConsultantEventArgs
  >;
  export type PinConsultantEventArgs = MutationPinConsultantEventArgs;

  export type PublishBookingContractResolver<Parent = never> = Resolver<
    PublishContractResult | Parent,
    Parent,
    MutationPublishBookingContractArgs
  >;
  export type PublishBookingContractArgs = MutationPublishBookingContractArgs;

  export type PublishContractResolver<Parent = never> = Resolver<
    PublishContractResult | Parent,
    Parent,
    MutationPublishContractArgs
  >;
  export type PublishContractArgs = MutationPublishContractArgs;

  export type PublishContractViaWorkflowResolver<Parent = never> = Resolver<
    PublishContractResult | Parent,
    Parent,
    MutationPublishContractViaWorkflowArgs
  >;
  export type PublishContractViaWorkflowArgs = MutationPublishContractViaWorkflowArgs;

  export type PublishCustomerContractSnapshotResolver<Parent = never> = Resolver<
    string | Parent,
    Parent,
    MutationPublishCustomerContractSnapshotArgs
  >;
  export type PublishCustomerContractSnapshotArgs =
    MutationPublishCustomerContractSnapshotArgs;

  export type PublishPayFormRecordsToFortnoxResolver<Parent = never> = Resolver<
    WorkflowRun | Parent,
    Parent,
    MutationPublishPayFormRecordsToFortnoxArgs
  >;
  export type PublishPayFormRecordsToFortnoxArgs =
    MutationPublishPayFormRecordsToFortnoxArgs;

  export type PublishSickPayFormToFortnoxResolver<Parent = never> = Resolver<
    WorkflowRun | Parent,
    Parent,
    MutationPublishSickPayFormToFortnoxArgs
  >;
  export type PublishSickPayFormToFortnoxArgs = MutationPublishSickPayFormToFortnoxArgs;

  export type PublishSubcontractorInvoiceWorkflowResolver<Parent = never> = Resolver<
    WorkflowRun | Parent,
    Parent,
    MutationPublishSubcontractorInvoiceWorkflowArgs
  >;
  export type PublishSubcontractorInvoiceWorkflowArgs =
    MutationPublishSubcontractorInvoiceWorkflowArgs;

  export type ReSendConsultantReferenceFormResolver<Parent = never> = Resolver<
    ConsultantReferenceNew | Parent,
    Parent,
    MutationReSendConsultantReferenceFormArgs
  >;
  export type ReSendConsultantReferenceFormArgs =
    MutationReSendConsultantReferenceFormArgs;

  export type ReactivateQualityItemResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationReactivateQualityItemArgs
  >;
  export type ReactivateQualityItemArgs = MutationReactivateQualityItemArgs;

  export type RefreshFortnoxSalaryCacheResolver<Parent = never> = Resolver<
    FortnoxSalaryCache | Parent,
    Parent,
    MutationRefreshFortnoxSalaryCacheArgs
  >;
  export type RefreshFortnoxSalaryCacheArgs = MutationRefreshFortnoxSalaryCacheArgs;

  export type RejectBookingKitResolver<Parent = never> = Resolver<
    BookingKit | Parent,
    Parent,
    MutationRejectBookingKitArgs
  >;
  export type RejectBookingKitArgs = MutationRejectBookingKitArgs;

  export type RejectDoneBookingKitResolver<Parent = never> = Resolver<
    BookingKit | Parent,
    Parent,
    MutationRejectDoneBookingKitArgs
  >;
  export type RejectDoneBookingKitArgs = MutationRejectDoneBookingKitArgs;

  export type RemoveAccommodationDocumentResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationRemoveAccommodationDocumentArgs
  >;
  export type RemoveAccommodationDocumentArgs = MutationRemoveAccommodationDocumentArgs;

  export type RemoveConsultantAvatarResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationRemoveConsultantAvatarArgs
  >;
  export type RemoveConsultantAvatarArgs = MutationRemoveConsultantAvatarArgs;

  export type RemoveConsultantDocumentResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationRemoveConsultantDocumentArgs
  >;
  export type RemoveConsultantDocumentArgs = MutationRemoveConsultantDocumentArgs;

  export type RemoveConsultantTagResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationRemoveConsultantTagArgs
  >;
  export type RemoveConsultantTagArgs = MutationRemoveConsultantTagArgs;

  export type RemoveCustomerAvatarResolver<Parent = never> = Resolver<
    Customer | Parent,
    Parent,
    MutationRemoveCustomerAvatarArgs
  >;
  export type RemoveCustomerAvatarArgs = MutationRemoveCustomerAvatarArgs;

  export type RemoveCustomerContractPriceListResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationRemoveCustomerContractPriceListArgs
  >;
  export type RemoveCustomerContractPriceListArgs =
    MutationRemoveCustomerContractPriceListArgs;

  export type RemoveFromCallListResolver<Parent = never> = Resolver<
    CallListOpResult | Parent,
    Parent,
    MutationRemoveFromCallListArgs
  >;
  export type RemoveFromCallListArgs = MutationRemoveFromCallListArgs;

  export type RemoveSearchProfileResolver<Parent = never> = Resolver<
    number | Parent,
    Parent,
    MutationRemoveSearchProfileArgs
  >;
  export type RemoveSearchProfileArgs = MutationRemoveSearchProfileArgs;

  export type RemoveSharedFileResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationRemoveSharedFileArgs
  >;
  export type RemoveSharedFileArgs = MutationRemoveSharedFileArgs;

  export type RemoveTravelDocumentResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationRemoveTravelDocumentArgs
  >;
  export type RemoveTravelDocumentArgs = MutationRemoveTravelDocumentArgs;

  export type RenameCallListResolver<Parent = never> = Resolver<
    CallListOpResult | Parent,
    Parent,
    MutationRenameCallListArgs
  >;
  export type RenameCallListArgs = MutationRenameCallListArgs;

  export type RequestUpdToKvkConsultantReferenceResolver<Parent = never> = Resolver<
    SendToKvkConsultantReferencePayload | Parent,
    Parent,
    MutationRequestUpdToKvkConsultantReferenceArgs
  >;
  export type RequestUpdToKvkConsultantReferenceArgs =
    MutationRequestUpdToKvkConsultantReferenceArgs;

  export type ResetConsultantUnfitResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationResetConsultantUnfitArgs
  >;
  export type ResetConsultantUnfitArgs = MutationResetConsultantUnfitArgs;

  export type RestoreConsultantReferenceResolver<Parent = never> = Resolver<
    ConsultantReferenceNew | Parent,
    Parent,
    MutationRestoreConsultantReferenceArgs
  >;
  export type RestoreConsultantReferenceArgs = MutationRestoreConsultantReferenceArgs;

  export type RestoreCostCenterResolver<Parent = never> = Resolver<
    CostCenterConfigItem | Parent,
    Parent,
    MutationRestoreCostCenterArgs
  >;
  export type RestoreCostCenterArgs = MutationRestoreCostCenterArgs;

  export type ResyncInvoiceResolver<Parent = never> = Resolver<
    Invoice | Parent,
    Parent,
    MutationResyncInvoiceArgs
  >;
  export type ResyncInvoiceArgs = MutationResyncInvoiceArgs;

  export type RevokeApiTokenResolver<Parent = never> = Resolver<
    ApiToken | Parent,
    Parent,
    MutationRevokeApiTokenArgs
  >;
  export type RevokeApiTokenArgs = MutationRevokeApiTokenArgs;

  export type RunAutoCreateBookingKitResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationRunAutoCreateBookingKitArgs
  >;
  export type RunAutoCreateBookingKitArgs = MutationRunAutoCreateBookingKitArgs;

  export type SaveConsultantSelectionResolver<Parent = never> = Resolver<
    SaveConsultantsResult | Parent,
    Parent,
    MutationSaveConsultantSelectionArgs
  >;
  export type SaveConsultantSelectionArgs = MutationSaveConsultantSelectionArgs;

  export type SaveHSAIDStatusParamsResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSaveHSAIDStatusParamsArgs
  >;
  export type SaveHSAIDStatusParamsArgs = MutationSaveHSAIDStatusParamsArgs;

  export type SaveToFavouriteContractPriceTemplateResolver<Parent = never> = Resolver<
    ContractPriceTemplateOpResult | Parent,
    Parent,
    MutationSaveToFavouriteContractPriceTemplateArgs
  >;
  export type SaveToFavouriteContractPriceTemplateArgs =
    MutationSaveToFavouriteContractPriceTemplateArgs;

  export type SendBookingKitToOcResolver<Parent = never> = Resolver<
    BookingKit | Parent,
    Parent,
    MutationSendBookingKitToOcArgs
  >;
  export type SendBookingKitToOcArgs = MutationSendBookingKitToOcArgs;

  export type SendConsultantBookingContractEmailToBAResolver<Parent = never> = Resolver<
    EmailResult | Parent,
    Parent,
    MutationSendConsultantBookingContractEmailToBAArgs
  >;
  export type SendConsultantBookingContractEmailToBAArgs =
    MutationSendConsultantBookingContractEmailToBAArgs;

  export type SendConsultantContractEmailToConsultantResolver<Parent = never> = Resolver<
    SendEmailToConsultantResult | Parent,
    Parent,
    MutationSendConsultantContractEmailToConsultantArgs
  >;
  export type SendConsultantContractEmailToConsultantArgs =
    MutationSendConsultantContractEmailToConsultantArgs;

  export type SendConsultantPresentationResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationSendConsultantPresentationArgs
  >;
  export type SendConsultantPresentationArgs = MutationSendConsultantPresentationArgs;

  export type SendConsultantReferenceFormResolver<Parent = never> = Resolver<
    ConsultantReferenceNew | Parent,
    Parent,
    MutationSendConsultantReferenceFormArgs
  >;
  export type SendConsultantReferenceFormArgs = MutationSendConsultantReferenceFormArgs;

  export type SendConsultantToMedloResolver<Parent = never> = Resolver<
    SendConsultantToMedloResult | Parent,
    Parent,
    MutationSendConsultantToMedloArgs
  >;
  export type SendConsultantToMedloArgs = MutationSendConsultantToMedloArgs;

  export type SendEmailResolver<Parent = never> = Resolver<
    string | Parent,
    Parent,
    MutationSendEmailArgs
  >;
  export type SendEmailArgs = MutationSendEmailArgs;

  export type SendEmailToConsultantResolver<Parent = never> = Resolver<
    SendEmailToConsultantResult | Parent,
    Parent,
    MutationSendEmailToConsultantArgs
  >;
  export type SendEmailToConsultantArgs = MutationSendEmailToConsultantArgs;

  export type SendMassEmailResolver<Parent = never> = Resolver<
    SendMassEmailResult | Parent,
    Parent,
    MutationSendMassEmailArgs
  >;
  export type SendMassEmailArgs = MutationSendMassEmailArgs;

  export type SendMassSMSToConsultantsResolver<Parent = never> = Resolver<
    SendMassSMSToConsultantsResult | Parent,
    Parent,
    MutationSendMassSMSToConsultantsArgs
  >;
  export type SendMassSMSToConsultantsArgs = MutationSendMassSMSToConsultantsArgs;

  export type SendRequestIVOResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSendRequestIVOArgs
  >;
  export type SendRequestIVOArgs = MutationSendRequestIVOArgs;

  export type SendTimereportToConsultantResolver<Parent = never> = Resolver<
    string | Parent,
    Parent,
    MutationSendTimereportToConsultantArgs
  >;
  export type SendTimereportToConsultantArgs = MutationSendTimereportToConsultantArgs;

  export type SendTimereportToCustomerResolver<Parent = never> = Resolver<
    EmailResult | Parent,
    Parent,
    MutationSendTimereportToCustomerArgs
  >;
  export type SendTimereportToCustomerArgs = MutationSendTimereportToCustomerArgs;

  export type SendToKvkConsultantReferenceResolver<Parent = never> = Resolver<
    SendToKvkConsultantReferencePayload | Parent,
    Parent,
    MutationSendToKvkConsultantReferenceArgs
  >;
  export type SendToKvkConsultantReferenceArgs = MutationSendToKvkConsultantReferenceArgs;

  export type SetBookedStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetBookedStatusArgs
  >;
  export type SetBookedStatusArgs = MutationSetBookedStatusArgs;

  export type SetBookingAdditionalPayoutResolver<Parent = never> = Resolver<
    Booking | Parent,
    Parent,
    MutationSetBookingAdditionalPayoutArgs
  >;
  export type SetBookingAdditionalPayoutArgs = MutationSetBookingAdditionalPayoutArgs;

  export type SetBookingCallNumberResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationSetBookingCallNumberArgs
  >;
  export type SetBookingCallNumberArgs = MutationSetBookingCallNumberArgs;

  export type SetCallListMembersResolver<Parent = never> = Resolver<
    CallListOpResult | Parent,
    Parent,
    MutationSetCallListMembersArgs
  >;
  export type SetCallListMembersArgs = MutationSetCallListMembersArgs;

  export type SetConsultantNextContactDateResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationSetConsultantNextContactDateArgs
  >;
  export type SetConsultantNextContactDateArgs = MutationSetConsultantNextContactDateArgs;

  export type SetConsultantPipelineStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetConsultantPipelineStatusArgs
  >;
  export type SetConsultantPipelineStatusArgs = MutationSetConsultantPipelineStatusArgs;

  export type SetConsultantPipelineStatusCommentResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetConsultantPipelineStatusCommentArgs
  >;
  export type SetConsultantPipelineStatusCommentArgs =
    MutationSetConsultantPipelineStatusCommentArgs;

  export type SetConsultantResponsiblePersonResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetConsultantResponsiblePersonArgs
  >;
  export type SetConsultantResponsiblePersonArgs =
    MutationSetConsultantResponsiblePersonArgs;

  export type SetConsultantResponsibleStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetConsultantResponsibleStatusArgs
  >;
  export type SetConsultantResponsibleStatusArgs =
    MutationSetConsultantResponsibleStatusArgs;

  export type SetConsultantUnfitResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetConsultantUnfitArgs
  >;
  export type SetConsultantUnfitArgs = MutationSetConsultantUnfitArgs;

  export type SetConsultantWelcomeEmailSentResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetConsultantWelcomeEmailSentArgs
  >;
  export type SetConsultantWelcomeEmailSentArgs =
    MutationSetConsultantWelcomeEmailSentArgs;

  export type SetCustomerContractInvoiceStrategyResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationSetCustomerContractInvoiceStrategyArgs
  >;
  export type SetCustomerContractInvoiceStrategyArgs =
    MutationSetCustomerContractInvoiceStrategyArgs;

  export type SetCustomerRecommendedPricesResolver<Parent = never> = Resolver<
    Customer | Parent,
    Parent,
    MutationSetCustomerRecommendedPricesArgs
  >;
  export type SetCustomerRecommendedPricesArgs = MutationSetCustomerRecommendedPricesArgs;

  export type SetOrderedStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetOrderedStatusArgs
  >;
  export type SetOrderedStatusArgs = MutationSetOrderedStatusArgs;

  export type SetQualityItemApprovedStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetQualityItemApprovedStatusArgs
  >;
  export type SetQualityItemApprovedStatusArgs = MutationSetQualityItemApprovedStatusArgs;

  export type SetQualityItemApprovedWithCommentStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetQualityItemApprovedWithCommentStatusArgs
  >;
  export type SetQualityItemApprovedWithCommentStatusArgs =
    MutationSetQualityItemApprovedWithCommentStatusArgs;

  export type SetQualityItemPausedStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetQualityItemPausedStatusArgs
  >;
  export type SetQualityItemPausedStatusArgs = MutationSetQualityItemPausedStatusArgs;

  export type SetQualityItemRequestReceivedStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetQualityItemRequestReceivedStatusArgs
  >;
  export type SetQualityItemRequestReceivedStatusArgs =
    MutationSetQualityItemRequestReceivedStatusArgs;

  export type SetQualityItemRequestSentIVOStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetQualityItemRequestSentIVOStatusArgs
  >;
  export type SetQualityItemRequestSentIVOStatusArgs =
    MutationSetQualityItemRequestSentIVOStatusArgs;

  export type SetQualityItemRequestSentStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSetQualityItemRequestSentStatusArgs
  >;
  export type SetQualityItemRequestSentStatusArgs =
    MutationSetQualityItemRequestSentStatusArgs;

  export type SetSkipTimereportReminderResolver<Parent = never> = Resolver<
    BookingSkipTimereportReminderResults | Parent,
    Parent,
    MutationSetSkipTimereportReminderArgs
  >;
  export type SetSkipTimereportReminderArgs = MutationSetSkipTimereportReminderArgs;

  export type SetSupportTagToBookingResolver<Parent = never> = Resolver<
    Array<BookingSupportTagStatus> | Parent,
    Parent,
    MutationSetSupportTagToBookingArgs
  >;
  export type SetSupportTagToBookingArgs = MutationSetSupportTagToBookingArgs;

  export type SetTimereportToDraftResolver<Parent = never> = Resolver<
    TimereportResult | Parent,
    Parent,
    MutationSetTimereportToDraftArgs
  >;
  export type SetTimereportToDraftArgs = MutationSetTimereportToDraftArgs;

  export type SetTimereportToSubmittedResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationSetTimereportToSubmittedArgs
  >;
  export type SetTimereportToSubmittedArgs = MutationSetTimereportToSubmittedArgs;

  export type SetTodoStatusResolver<Parent = never> = Resolver<
    TodoItem | Parent,
    Parent,
    MutationSetTodoStatusArgs
  >;
  export type SetTodoStatusArgs = MutationSetTodoStatusArgs;

  export type SetUnlockBookingFormsResolver<Parent = never> = Resolver<
    UnlockFormsResult | Parent,
    Parent,
    MutationSetUnlockBookingFormsArgs
  >;
  export type SetUnlockBookingFormsArgs = MutationSetUnlockBookingFormsArgs;

  export type SubmitConsultantFormResolver<Parent = never> = Resolver<
    ConsultantFormResult | Parent,
    Parent,
    MutationSubmitConsultantFormArgs
  >;
  export type SubmitConsultantFormArgs = MutationSubmitConsultantFormArgs;

  export type SubmitConsultantKarensResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationSubmitConsultantKarensArgs
  >;
  export type SubmitConsultantKarensArgs = MutationSubmitConsultantKarensArgs;

  export type SubmitContractPriceTemplateFormResolver<Parent = never> = Resolver<
    ContractPriceTemplateOpResult | Parent,
    Parent,
    MutationSubmitContractPriceTemplateFormArgs
  >;
  export type SubmitContractPriceTemplateFormArgs =
    MutationSubmitContractPriceTemplateFormArgs;

  export type SubmitCustomerContractFormResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationSubmitCustomerContractFormArgs
  >;
  export type SubmitCustomerContractFormArgs = MutationSubmitCustomerContractFormArgs;

  export type SubmitCustomerContractInfoResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationSubmitCustomerContractInfoArgs
  >;
  export type SubmitCustomerContractInfoArgs = MutationSubmitCustomerContractInfoArgs;

  export type SubmitCustomerContractPriceListFormResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationSubmitCustomerContractPriceListFormArgs
  >;
  export type SubmitCustomerContractPriceListFormArgs =
    MutationSubmitCustomerContractPriceListFormArgs;

  export type SubmitCustomerContractSnapshotFormResolver<Parent = never> = Resolver<
    CustomerContractSnapshotOpResult | Parent,
    Parent,
    MutationSubmitCustomerContractSnapshotFormArgs
  >;
  export type SubmitCustomerContractSnapshotFormArgs =
    MutationSubmitCustomerContractSnapshotFormArgs;

  export type SubmitCustomerContractSubVersionFormResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationSubmitCustomerContractSubVersionFormArgs
  >;
  export type SubmitCustomerContractSubVersionFormArgs =
    MutationSubmitCustomerContractSubVersionFormArgs;

  export type SubmitFortnoxVoucherResolver<Parent = never> = Resolver<
    FortnoxVoucherSubmitResult | Parent,
    Parent,
    MutationSubmitFortnoxVoucherArgs
  >;
  export type SubmitFortnoxVoucherArgs = MutationSubmitFortnoxVoucherArgs;

  export type SubmitSearchProfileFormResolver<Parent = never> = Resolver<
    SearchProfile | Parent,
    Parent,
    MutationSubmitSearchProfileFormArgs
  >;
  export type SubmitSearchProfileFormArgs = MutationSubmitSearchProfileFormArgs;

  export type SyncTimeReportsWithBookingSearchResolver<Parent = never> = Resolver<
    Array<string> | Parent,
    Parent,
    MutationSyncTimeReportsWithBookingSearchArgs
  >;
  export type SyncTimeReportsWithBookingSearchArgs =
    MutationSyncTimeReportsWithBookingSearchArgs;

  export type ToggleAccommodationConfirmationResolver<Parent = never> = Resolver<
    BookingHospitality | Parent,
    Parent,
    MutationToggleAccommodationConfirmationArgs
  >;
  export type ToggleAccommodationConfirmationArgs =
    MutationToggleAccommodationConfirmationArgs;

  export type ToggleConsultantFavouriteResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationToggleConsultantFavouriteArgs
  >;
  export type ToggleConsultantFavouriteArgs = MutationToggleConsultantFavouriteArgs;

  export type ToggleCostCenterActiveResolver<Parent = never> = Resolver<
    CostCenterConfigItem | Parent,
    Parent,
    MutationToggleCostCenterActiveArgs
  >;
  export type ToggleCostCenterActiveArgs = MutationToggleCostCenterActiveArgs;

  export type ToggleCustomerNoApprovalResolver<Parent = never> = Resolver<
    Customer | Parent,
    Parent,
    MutationToggleCustomerNoApprovalArgs
  >;
  export type ToggleCustomerNoApprovalArgs = MutationToggleCustomerNoApprovalArgs;

  export type ToggleCustomerSettingsResolver<Parent = never> = Resolver<
    Customer | Parent,
    Parent,
    MutationToggleCustomerSettingsArgs
  >;
  export type ToggleCustomerSettingsArgs = MutationToggleCustomerSettingsArgs;

  export type ToggleTravelConfirmationResolver<Parent = never> = Resolver<
    BookingHospitality | Parent,
    Parent,
    MutationToggleTravelConfirmationArgs
  >;
  export type ToggleTravelConfirmationArgs = MutationToggleTravelConfirmationArgs;

  export type TransitionConsultantQualityItemResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationTransitionConsultantQualityItemArgs
  >;
  export type TransitionConsultantQualityItemArgs =
    MutationTransitionConsultantQualityItemArgs;

  export type UnAssignFromBookingKitResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationUnAssignFromBookingKitArgs
  >;
  export type UnAssignFromBookingKitArgs = MutationUnAssignFromBookingKitArgs;

  export type UnAssignToBookingResolver<Parent = never> = Resolver<
    BookingAssignedToResult | Parent,
    Parent,
    MutationUnAssignToBookingArgs
  >;
  export type UnAssignToBookingArgs = MutationUnAssignToBookingArgs;

  export type UnsetConsultantNextContactDateResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationUnsetConsultantNextContactDateArgs
  >;
  export type UnsetConsultantNextContactDateArgs =
    MutationUnsetConsultantNextContactDateArgs;

  export type UpdateAccommodationConfirmationResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationUpdateAccommodationConfirmationArgs
  >;
  export type UpdateAccommodationConfirmationArgs =
    MutationUpdateAccommodationConfirmationArgs;

  export type UpdateAccommodationEventResolver<Parent = never> = Resolver<
    AccommodationEvent | Parent,
    Parent,
    MutationUpdateAccommodationEventArgs
  >;
  export type UpdateAccommodationEventArgs = MutationUpdateAccommodationEventArgs;

  export type UpdateBookingAuditResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationUpdateBookingAuditArgs
  >;
  export type UpdateBookingAuditArgs = MutationUpdateBookingAuditArgs;

  export type UpdateBookingEventResolver<Parent = never> = Resolver<
    BookingEvent | Parent,
    Parent,
    MutationUpdateBookingEventArgs
  >;
  export type UpdateBookingEventArgs = MutationUpdateBookingEventArgs;

  export type UpdateBookingFinanceResolver<Parent = never> = Resolver<
    Booking | Parent,
    Parent,
    MutationUpdateBookingFinanceArgs
  >;
  export type UpdateBookingFinanceArgs = MutationUpdateBookingFinanceArgs;

  export type UpdateBookingGroupResolver<Parent = never> = Resolver<
    BookingGroup | Parent,
    Parent,
    MutationUpdateBookingGroupArgs
  >;
  export type UpdateBookingGroupArgs = MutationUpdateBookingGroupArgs;

  export type UpdateBookingKitResolver<Parent = never> = Resolver<
    BookingKit | Parent,
    Parent,
    MutationUpdateBookingKitArgs
  >;
  export type UpdateBookingKitArgs = MutationUpdateBookingKitArgs;

  export type UpdateBookingKitEventResolver<Parent = never> = Resolver<
    BookingKitEvent | Parent,
    Parent,
    MutationUpdateBookingKitEventArgs
  >;
  export type UpdateBookingKitEventArgs = MutationUpdateBookingKitEventArgs;

  export type UpdateBookingKitTagsResolver<Parent = never> = Resolver<
    Array<BookingSupportTagStatus> | Parent,
    Parent,
    MutationUpdateBookingKitTagsArgs
  >;
  export type UpdateBookingKitTagsArgs = MutationUpdateBookingKitTagsArgs;

  export type UpdateBookingProjectResolver<Parent = never> = Resolver<
    UpdateBookingResult | Parent,
    Parent,
    MutationUpdateBookingProjectArgs
  >;
  export type UpdateBookingProjectArgs = MutationUpdateBookingProjectArgs;

  export type UpdateCommentForBookingAuditResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationUpdateCommentForBookingAuditArgs
  >;
  export type UpdateCommentForBookingAuditArgs = MutationUpdateCommentForBookingAuditArgs;

  export type UpdateConsultantEventResolver<Parent = never> = Resolver<
    ConsultantEvent | Parent,
    Parent,
    MutationUpdateConsultantEventArgs
  >;
  export type UpdateConsultantEventArgs = MutationUpdateConsultantEventArgs;

  export type UpdateConsultantGDPRResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationUpdateConsultantGDPRArgs
  >;
  export type UpdateConsultantGDPRArgs = MutationUpdateConsultantGDPRArgs;

  export type UpdateConsultantGeneralInterestResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationUpdateConsultantGeneralInterestArgs
  >;
  export type UpdateConsultantGeneralInterestArgs =
    MutationUpdateConsultantGeneralInterestArgs;

  export type UpdateConsultantLeadStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationUpdateConsultantLeadStatusArgs
  >;
  export type UpdateConsultantLeadStatusArgs = MutationUpdateConsultantLeadStatusArgs;

  export type UpdateConsultantQualityNoteResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationUpdateConsultantQualityNoteArgs
  >;
  export type UpdateConsultantQualityNoteArgs = MutationUpdateConsultantQualityNoteArgs;

  export type UpdateConsultantReferenceResolver<Parent = never> = Resolver<
    ConsultantReferenceNew | Parent,
    Parent,
    MutationUpdateConsultantReferenceArgs
  >;
  export type UpdateConsultantReferenceArgs = MutationUpdateConsultantReferenceArgs;

  export type UpdateConsultantServicePreferenceResolver<Parent = never> = Resolver<
    ConsultantServicePreference | Parent,
    Parent,
    MutationUpdateConsultantServicePreferenceArgs
  >;
  export type UpdateConsultantServicePreferenceArgs =
    MutationUpdateConsultantServicePreferenceArgs;

  export type UpdateConsultantStatusResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationUpdateConsultantStatusArgs
  >;
  export type UpdateConsultantStatusArgs = MutationUpdateConsultantStatusArgs;

  export type UpdateConsultantUserSettingsResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationUpdateConsultantUserSettingsArgs
  >;
  export type UpdateConsultantUserSettingsArgs = MutationUpdateConsultantUserSettingsArgs;

  export type UpdateConsultantWorkStatusResolver<Parent = never> = Resolver<
    ConsultantWorkStatus | Parent,
    Parent,
    MutationUpdateConsultantWorkStatusArgs
  >;
  export type UpdateConsultantWorkStatusArgs = MutationUpdateConsultantWorkStatusArgs;

  export type UpdateContactPersonResolver<Parent = never> = Resolver<
    UpdateContactPersonResult | Parent,
    Parent,
    MutationUpdateContactPersonArgs
  >;
  export type UpdateContactPersonArgs = MutationUpdateContactPersonArgs;

  export type UpdateCostCenterResolver<Parent = never> = Resolver<
    CostCenterConfigItem | Parent,
    Parent,
    MutationUpdateCostCenterArgs
  >;
  export type UpdateCostCenterArgs = MutationUpdateCostCenterArgs;

  export type UpdateCustomerResolver<Parent = never> = Resolver<
    UpdateCustomerResult | Parent,
    Parent,
    MutationUpdateCustomerArgs
  >;
  export type UpdateCustomerArgs = MutationUpdateCustomerArgs;

  export type UpdateCustomerContractEventResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationUpdateCustomerContractEventArgs
  >;
  export type UpdateCustomerContractEventArgs = MutationUpdateCustomerContractEventArgs;

  export type UpdateCustomerEventResolver<Parent = never> = Resolver<
    CustomerEvent | Parent,
    Parent,
    MutationUpdateCustomerEventArgs
  >;
  export type UpdateCustomerEventArgs = MutationUpdateCustomerEventArgs;

  export type UpdateCustomerRefsSearchProfilesResolver<Parent = never> = Resolver<
    Array<SearchProfile> | Parent,
    Parent,
    MutationUpdateCustomerRefsSearchProfilesArgs
  >;
  export type UpdateCustomerRefsSearchProfilesArgs =
    MutationUpdateCustomerRefsSearchProfilesArgs;

  export type UpdateFavoriteTeamResolver<Parent = never> = Resolver<
    Me | Parent,
    Parent,
    MutationUpdateFavoriteTeamArgs
  >;
  export type UpdateFavoriteTeamArgs = MutationUpdateFavoriteTeamArgs;

  export type UpdateSharedFileResolver<Parent = never> = Resolver<
    SharedFile | Parent,
    Parent,
    MutationUpdateSharedFileArgs
  >;
  export type UpdateSharedFileArgs = MutationUpdateSharedFileArgs;

  export type UpdateTgRequirementResolver<Parent = never> = Resolver<
    TgRequirement | Parent,
    Parent,
    MutationUpdateTgRequirementArgs
  >;
  export type UpdateTgRequirementArgs = MutationUpdateTgRequirementArgs;

  export type UpdateTodoEventResolver<Parent = never> = Resolver<
    TodoEvent | Parent,
    Parent,
    MutationUpdateTodoEventArgs
  >;
  export type UpdateTodoEventArgs = MutationUpdateTodoEventArgs;

  export type UpdateTravelConfirmationResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    MutationUpdateTravelConfirmationArgs
  >;
  export type UpdateTravelConfirmationArgs = MutationUpdateTravelConfirmationArgs;

  export type UpdateUnfitAccommodationResolver<Parent = never> = Resolver<
    AccommodationUnfit | Parent,
    Parent,
    MutationUpdateUnfitAccommodationArgs
  >;
  export type UpdateUnfitAccommodationArgs = MutationUpdateUnfitAccommodationArgs;

  export type UploadAccommodationDocumentResolver<Parent = never> = Resolver<
    Document | Parent,
    Parent,
    MutationUploadAccommodationDocumentArgs
  >;
  export type UploadAccommodationDocumentArgs = MutationUploadAccommodationDocumentArgs;

  export type UploadBlobResolver<Parent = never> = Resolver<
    string | Parent,
    Parent,
    MutationUploadBlobArgs
  >;
  export type UploadBlobArgs = MutationUploadBlobArgs;

  export type UploadBookingDocumentResolver<Parent = never> = Resolver<
    UploadBookingDocumentResult | Parent,
    Parent,
    MutationUploadBookingDocumentArgs
  >;
  export type UploadBookingDocumentArgs = MutationUploadBookingDocumentArgs;

  export type UploadConsultantAvatarResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    MutationUploadConsultantAvatarArgs
  >;
  export type UploadConsultantAvatarArgs = MutationUploadConsultantAvatarArgs;

  export type UploadConsultantDocumentResolver<Parent = never> = Resolver<
    Document | Parent,
    Parent,
    MutationUploadConsultantDocumentArgs
  >;
  export type UploadConsultantDocumentArgs = MutationUploadConsultantDocumentArgs;

  export type UploadConsultantDocumentsResolver<Parent = never> = Resolver<
    Array<Document> | Parent,
    Parent,
    MutationUploadConsultantDocumentsArgs
  >;
  export type UploadConsultantDocumentsArgs = MutationUploadConsultantDocumentsArgs;

  export type UploadCustomerAvatarResolver<Parent = never> = Resolver<
    Customer | Parent,
    Parent,
    MutationUploadCustomerAvatarArgs
  >;
  export type UploadCustomerAvatarArgs = MutationUploadCustomerAvatarArgs;

  export type UploadCustomerBgPicResolver<Parent = never> = Resolver<
    Customer | Parent,
    Parent,
    MutationUploadCustomerBgPicArgs
  >;
  export type UploadCustomerBgPicArgs = MutationUploadCustomerBgPicArgs;

  export type UploadCustomerContractDocumentResolver<Parent = never> = Resolver<
    CustomerContractOpResult | Parent,
    Parent,
    MutationUploadCustomerContractDocumentArgs
  >;
  export type UploadCustomerContractDocumentArgs =
    MutationUploadCustomerContractDocumentArgs;

  export type UploadCustomerContractSignedDocumentResolver<Parent = never> = Resolver<
    CustomerContractSnapshotOpResult | Parent,
    Parent,
    MutationUploadCustomerContractSignedDocumentArgs
  >;
  export type UploadCustomerContractSignedDocumentArgs =
    MutationUploadCustomerContractSignedDocumentArgs;

  export type UploadCustomerDocumentResolver<Parent = never> = Resolver<
    Array<CustomerDocument> | Parent,
    Parent,
    MutationUploadCustomerDocumentArgs
  >;
  export type UploadCustomerDocumentArgs = MutationUploadCustomerDocumentArgs;

  export type UploadDocumentResolver<Parent = never> = Resolver<
    Document | Parent,
    Parent,
    MutationUploadDocumentArgs
  >;
  export type UploadDocumentArgs = MutationUploadDocumentArgs;

  export type UploadSharedFileResolver<Parent = never> = Resolver<
    SharedFile | Parent,
    Parent,
    MutationUploadSharedFileArgs
  >;
  export type UploadSharedFileArgs = MutationUploadSharedFileArgs;

  export type UploadSignedConsultantBookingContractResolver<Parent = never> = Resolver<
    ConsultantBookingContractListItem | Parent,
    Parent,
    MutationUploadSignedConsultantBookingContractArgs
  >;
  export type UploadSignedConsultantBookingContractArgs =
    MutationUploadSignedConsultantBookingContractArgs;

  export type UploadSignedConsultantContractResolver<Parent = never> = Resolver<
    ConsultantContractListItem | Parent,
    Parent,
    MutationUploadSignedConsultantContractArgs
  >;
  export type UploadSignedConsultantContractArgs =
    MutationUploadSignedConsultantContractArgs;
  export type Resolvers<Parent = never> = {
    addAccommodation?: AddAccommodationResolver<Parent>;
    addAccommodationCommentEvent?: AddAccommodationCommentEventResolver<Parent>;
    addBookingCommentEvent?: AddBookingCommentEventResolver<Parent>;
    addBookingKitCommentEvent?: AddBookingKitCommentEventResolver<Parent>;
    addConsultantAvailability?: AddConsultantAvailabilityResolver<Parent>;
    addConsultantBookingContract?: AddConsultantBookingContractResolver<Parent>;
    addConsultantCallEvent?: AddConsultantCallEventResolver<Parent>;
    addConsultantCommentEvent?: AddConsultantCommentEventResolver<Parent>;
    addConsultantInterestEvent?: AddConsultantInterestEventResolver<Parent>;
    addConsultantNoanswerEvent?: AddConsultantNoanswerEventResolver<Parent>;
    addConsultantReminderEvent?: AddConsultantReminderEventResolver<Parent>;
    addConsultantSMSEvent?: AddConsultantSMSEventResolver<Parent>;
    addConsultantTag?: AddConsultantTagResolver<Parent>;
    addConsultantWorkExperience?: AddConsultantWorkExperienceResolver<Parent>;
    addCustomerCommentEvent?: AddCustomerCommentEventResolver<Parent>;
    addCustomerContractCommentEvent?: AddCustomerContractCommentEventResolver<Parent>;
    addCustomerMetInPersonEvent?: AddCustomerMetInPersonEventResolver<Parent>;
    addCustomerReminderEvent?: AddCustomerReminderEventResolver<Parent>;
    addSalaryChoiceToConsultantContract?: AddSalaryChoiceToConsultantContractResolver<Parent>;
    addToCallList?: AddToCallListResolver<Parent>;
    addTodoCommentEvent?: AddTodoCommentEventResolver<Parent>;
    addTodoReminderEvent?: AddTodoReminderEventResolver<Parent>;
    addUnSignConsultantContract?: AddUnSignConsultantContractResolver<Parent>;
    approveBookingKit?: ApproveBookingKitResolver<Parent>;
    approveTimereport?: ApproveTimereportResolver<Parent>;
    assignContactPersonToCustomer?: AssignContactPersonToCustomerResolver<Parent>;
    assignFortnoxInvoiceToBooking?: AssignFortnoxInvoiceToBookingResolver<Parent>;
    assignTimereportToBooking?: AssignTimereportToBookingResolver<Parent>;
    assignToBooking?: AssignToBookingResolver<Parent>;
    assignToBookingKit?: AssignToBookingKitResolver<Parent>;
    assignTodo?: AssignTodoResolver<Parent>;
    bulkAction?: BulkActionResolver<Parent>;
    bulkUpdateResponsiblePerson?: BulkUpdateResponsiblePersonResolver<Parent>;
    cancelBooking?: CancelBookingResolver<Parent>;
    cancelBookingGroup?: CancelBookingGroupResolver<Parent>;
    changeConsultantServicePreferenceStatus?: ChangeConsultantServicePreferenceStatusResolver<Parent>;
    changeStatusConsultantReference?: ChangeStatusConsultantReferenceResolver<Parent>;
    clearConsultantResponsiblePerson?: ClearConsultantResponsiblePersonResolver<Parent>;
    clearQualityItemStatus?: ClearQualityItemStatusResolver<Parent>;
    clearTimereportDays?: ClearTimereportDaysResolver<Parent>;
    cloneBooking?: CloneBookingResolver<Parent>;
    confirmAccommodation?: ConfirmAccommodationResolver<Parent>;
    confirmTravel?: ConfirmTravelResolver<Parent>;
    consultantExportBulkAction?: ConsultantExportBulkActionResolver<Parent>;
    consultantExportSsnBulkAction?: ConsultantExportSsnBulkActionResolver<Parent>;
    consultantGeneratePresentation?: ConsultantGeneratePresentationResolver<Parent>;
    consultantImportDeduplicate?: ConsultantImportDeduplicateResolver<Parent>;
    consultantImportLookupRows?: ConsultantImportLookupRowsResolver<Parent>;
    createAccommodationRequest?: CreateAccommodationRequestResolver<Parent>;
    createApiToken?: CreateApiTokenResolver<Parent>;
    createBookingGroup?: CreateBookingGroupResolver<Parent>;
    createBookingKit?: CreateBookingKitResolver<Parent>;
    createCallList?: CreateCallListResolver<Parent>;
    createConsultantOpportunity?: CreateConsultantOpportunityResolver<Parent>;
    createConsultantReference?: CreateConsultantReferenceResolver<Parent>;
    createConsultantServicePreference?: CreateConsultantServicePreferenceResolver<Parent>;
    createConsultantWorkStatus?: CreateConsultantWorkStatusResolver<Parent>;
    createContactPerson?: CreateContactPersonResolver<Parent>;
    createCostCenter?: CreateCostCenterResolver<Parent>;
    createCustomer?: CreateCustomerResolver<Parent>;
    createDirectRequestContract?: CreateDirectRequestContractResolver<Parent>;
    createTgRequirement?: CreateTgRequirementResolver<Parent>;
    createTravelRequest?: CreateTravelRequestResolver<Parent>;
    deassignContactPersonFromCustomers?: DeassignContactPersonFromCustomersResolver<Parent>;
    deleteAccommodation?: DeleteAccommodationResolver<Parent>;
    deleteAccommodationDocument?: DeleteAccommodationDocumentResolver<Parent>;
    deleteAccommodationEvent?: DeleteAccommodationEventResolver<Parent>;
    deleteBookingDocument?: DeleteBookingDocumentResolver<Parent>;
    deleteBookingEvent?: DeleteBookingEventResolver<Parent>;
    deleteBookingKit?: DeleteBookingKitResolver<Parent>;
    deleteBookingKitEvent?: DeleteBookingKitEventResolver<Parent>;
    deleteConsultantAvailability?: DeleteConsultantAvailabilityResolver<Parent>;
    deleteConsultantBookingContract?: DeleteConsultantBookingContractResolver<Parent>;
    deleteConsultantContract?: DeleteConsultantContractResolver<Parent>;
    deleteConsultantEvent?: DeleteConsultantEventResolver<Parent>;
    deleteConsultantOpportunity?: DeleteConsultantOpportunityResolver<Parent>;
    deleteConsultantReference?: DeleteConsultantReferenceResolver<Parent>;
    deleteConsultantServicePreference?: DeleteConsultantServicePreferenceResolver<Parent>;
    deleteConsultantWorkStatus?: DeleteConsultantWorkStatusResolver<Parent>;
    deleteConsultants?: DeleteConsultantsResolver<Parent>;
    deleteContactPerson?: DeleteContactPersonResolver<Parent>;
    deleteContractPriceTemplate?: DeleteContractPriceTemplateResolver<Parent>;
    deleteCostCenter?: DeleteCostCenterResolver<Parent>;
    deleteCustomer?: DeleteCustomerResolver<Parent>;
    deleteCustomerContractDocument?: DeleteCustomerContractDocumentResolver<Parent>;
    deleteCustomerContractEvent?: DeleteCustomerContractEventResolver<Parent>;
    deleteCustomerContractSnapshot?: DeleteCustomerContractSnapshotResolver<Parent>;
    deleteCustomerContractSubVersion?: DeleteCustomerContractSubVersionResolver<Parent>;
    deleteCustomerDocument?: DeleteCustomerDocumentResolver<Parent>;
    deleteCustomerEvent?: DeleteCustomerEventResolver<Parent>;
    deleteRestoreCustomerContract?: DeleteRestoreCustomerContractResolver<Parent>;
    deleteTgRequirement?: DeleteTgRequirementResolver<Parent>;
    deleteTodoEvent?: DeleteTodoEventResolver<Parent>;
    duplicateConsultantToTenant?: DuplicateConsultantToTenantResolver<Parent>;
    duplicateContractPriceTemplate?: DuplicateContractPriceTemplateResolver<Parent>;
    editAccommodation?: EditAccommodationResolver<Parent>;
    editConsultantBookingContract?: EditConsultantBookingContractResolver<Parent>;
    editConsultantOpportunity?: EditConsultantOpportunityResolver<Parent>;
    editUnSignConsultantContract?: EditUnSignConsultantContractResolver<Parent>;
    extractContactPerson?: ExtractContactPersonResolver<Parent>;
    finaliseConsultantOpportunity?: FinaliseConsultantOpportunityResolver<Parent>;
    generateCustomerContractSnapshot?: GenerateCustomerContractSnapshotResolver<Parent>;
    importCV?: ImportCVResolver<Parent>;
    importConsultants?: ImportConsultantsResolver<Parent>;
    leaveCallList?: LeaveCallListResolver<Parent>;
    mergeConsultantReference?: MergeConsultantReferenceResolver<Parent>;
    moveCard?: MoveCardResolver<Parent>;
    moveCustomer?: MoveCustomerResolver<Parent>;
    nullifyConsultantBookingContract?: NullifyConsultantBookingContractResolver<Parent>;
    nullifyConsultantContract?: NullifyConsultantContractResolver<Parent>;
    nullifyCustomerContractSnapshot?: NullifyCustomerContractSnapshotResolver<Parent>;
    pinAccommodationEvent?: PinAccommodationEventResolver<Parent>;
    pinConsultantEvent?: PinConsultantEventResolver<Parent>;
    publishBookingContract?: PublishBookingContractResolver<Parent>;
    publishContract?: PublishContractResolver<Parent>;
    publishContractViaWorkflow?: PublishContractViaWorkflowResolver<Parent>;
    publishCustomerContractSnapshot?: PublishCustomerContractSnapshotResolver<Parent>;
    publishPayFormRecordsToFortnox?: PublishPayFormRecordsToFortnoxResolver<Parent>;
    publishSickPayFormToFortnox?: PublishSickPayFormToFortnoxResolver<Parent>;
    publishSubcontractorInvoiceWorkflow?: PublishSubcontractorInvoiceWorkflowResolver<Parent>;
    reSendConsultantReferenceForm?: ReSendConsultantReferenceFormResolver<Parent>;
    reactivateQualityItem?: ReactivateQualityItemResolver<Parent>;
    refreshFortnoxSalaryCache?: RefreshFortnoxSalaryCacheResolver<Parent>;
    rejectBookingKit?: RejectBookingKitResolver<Parent>;
    rejectDoneBookingKit?: RejectDoneBookingKitResolver<Parent>;
    removeAccommodationDocument?: RemoveAccommodationDocumentResolver<Parent>;
    removeConsultantAvatar?: RemoveConsultantAvatarResolver<Parent>;
    removeConsultantDocument?: RemoveConsultantDocumentResolver<Parent>;
    removeConsultantTag?: RemoveConsultantTagResolver<Parent>;
    removeCustomerAvatar?: RemoveCustomerAvatarResolver<Parent>;
    removeCustomerContractPriceList?: RemoveCustomerContractPriceListResolver<Parent>;
    removeFromCallList?: RemoveFromCallListResolver<Parent>;
    removeSearchProfile?: RemoveSearchProfileResolver<Parent>;
    removeSharedFile?: RemoveSharedFileResolver<Parent>;
    removeTravelDocument?: RemoveTravelDocumentResolver<Parent>;
    renameCallList?: RenameCallListResolver<Parent>;
    requestUpdToKvkConsultantReference?: RequestUpdToKvkConsultantReferenceResolver<Parent>;
    resetConsultantUnfit?: ResetConsultantUnfitResolver<Parent>;
    restoreConsultantReference?: RestoreConsultantReferenceResolver<Parent>;
    restoreCostCenter?: RestoreCostCenterResolver<Parent>;
    resyncInvoice?: ResyncInvoiceResolver<Parent>;
    revokeApiToken?: RevokeApiTokenResolver<Parent>;
    runAutoCreateBookingKit?: RunAutoCreateBookingKitResolver<Parent>;
    saveConsultantSelection?: SaveConsultantSelectionResolver<Parent>;
    saveHSAIDStatusParams?: SaveHSAIDStatusParamsResolver<Parent>;
    saveToFavouriteContractPriceTemplate?: SaveToFavouriteContractPriceTemplateResolver<Parent>;
    sendBookingKitToOc?: SendBookingKitToOcResolver<Parent>;
    sendConsultantBookingContractEmailToBA?: SendConsultantBookingContractEmailToBAResolver<Parent>;
    sendConsultantContractEmailToConsultant?: SendConsultantContractEmailToConsultantResolver<Parent>;
    sendConsultantPresentation?: SendConsultantPresentationResolver<Parent>;
    sendConsultantReferenceForm?: SendConsultantReferenceFormResolver<Parent>;
    sendConsultantToMedlo?: SendConsultantToMedloResolver<Parent>;
    sendEmail?: SendEmailResolver<Parent>;
    sendEmailToConsultant?: SendEmailToConsultantResolver<Parent>;
    sendMassEmail?: SendMassEmailResolver<Parent>;
    sendMassSMSToConsultants?: SendMassSMSToConsultantsResolver<Parent>;
    sendRequestIVO?: SendRequestIVOResolver<Parent>;
    sendTimereportToConsultant?: SendTimereportToConsultantResolver<Parent>;
    sendTimereportToCustomer?: SendTimereportToCustomerResolver<Parent>;
    sendToKvkConsultantReference?: SendToKvkConsultantReferenceResolver<Parent>;
    setBookedStatus?: SetBookedStatusResolver<Parent>;
    setBookingAdditionalPayout?: SetBookingAdditionalPayoutResolver<Parent>;
    setBookingCallNumber?: SetBookingCallNumberResolver<Parent>;
    setCallListMembers?: SetCallListMembersResolver<Parent>;
    setConsultantNextContactDate?: SetConsultantNextContactDateResolver<Parent>;
    setConsultantPipelineStatus?: SetConsultantPipelineStatusResolver<Parent>;
    setConsultantPipelineStatusComment?: SetConsultantPipelineStatusCommentResolver<Parent>;
    setConsultantResponsiblePerson?: SetConsultantResponsiblePersonResolver<Parent>;
    setConsultantResponsibleStatus?: SetConsultantResponsibleStatusResolver<Parent>;
    setConsultantUnfit?: SetConsultantUnfitResolver<Parent>;
    setConsultantWelcomeEmailSent?: SetConsultantWelcomeEmailSentResolver<Parent>;
    setCustomerContractInvoiceStrategy?: SetCustomerContractInvoiceStrategyResolver<Parent>;
    setCustomerRecommendedPrices?: SetCustomerRecommendedPricesResolver<Parent>;
    setOrderedStatus?: SetOrderedStatusResolver<Parent>;
    setQualityItemApprovedStatus?: SetQualityItemApprovedStatusResolver<Parent>;
    setQualityItemApprovedWithCommentStatus?: SetQualityItemApprovedWithCommentStatusResolver<Parent>;
    setQualityItemPausedStatus?: SetQualityItemPausedStatusResolver<Parent>;
    setQualityItemRequestReceivedStatus?: SetQualityItemRequestReceivedStatusResolver<Parent>;
    setQualityItemRequestSentIVOStatus?: SetQualityItemRequestSentIVOStatusResolver<Parent>;
    setQualityItemRequestSentStatus?: SetQualityItemRequestSentStatusResolver<Parent>;
    setSkipTimereportReminder?: SetSkipTimereportReminderResolver<Parent>;
    setSupportTagToBooking?: SetSupportTagToBookingResolver<Parent>;
    setTimereportToDraft?: SetTimereportToDraftResolver<Parent>;
    setTimereportToSubmitted?: SetTimereportToSubmittedResolver<Parent>;
    setTodoStatus?: SetTodoStatusResolver<Parent>;
    setUnlockBookingForms?: SetUnlockBookingFormsResolver<Parent>;
    submitConsultantForm?: SubmitConsultantFormResolver<Parent>;
    submitConsultantKarens?: SubmitConsultantKarensResolver<Parent>;
    submitContractPriceTemplateForm?: SubmitContractPriceTemplateFormResolver<Parent>;
    submitCustomerContractForm?: SubmitCustomerContractFormResolver<Parent>;
    submitCustomerContractInfo?: SubmitCustomerContractInfoResolver<Parent>;
    submitCustomerContractPriceListForm?: SubmitCustomerContractPriceListFormResolver<Parent>;
    submitCustomerContractSnapshotForm?: SubmitCustomerContractSnapshotFormResolver<Parent>;
    submitCustomerContractSubVersionForm?: SubmitCustomerContractSubVersionFormResolver<Parent>;
    submitFortnoxVoucher?: SubmitFortnoxVoucherResolver<Parent>;
    submitSearchProfileForm?: SubmitSearchProfileFormResolver<Parent>;
    syncTimeReportsWithBookingSearch?: SyncTimeReportsWithBookingSearchResolver<Parent>;
    toggleAccommodationConfirmation?: ToggleAccommodationConfirmationResolver<Parent>;
    toggleConsultantFavourite?: ToggleConsultantFavouriteResolver<Parent>;
    toggleCostCenterActive?: ToggleCostCenterActiveResolver<Parent>;
    toggleCustomerNoApproval?: ToggleCustomerNoApprovalResolver<Parent>;
    toggleCustomerSettings?: ToggleCustomerSettingsResolver<Parent>;
    toggleTravelConfirmation?: ToggleTravelConfirmationResolver<Parent>;
    transitionConsultantQualityItem?: TransitionConsultantQualityItemResolver<Parent>;
    unAssignFromBookingKit?: UnAssignFromBookingKitResolver<Parent>;
    unAssignToBooking?: UnAssignToBookingResolver<Parent>;
    unsetConsultantNextContactDate?: UnsetConsultantNextContactDateResolver<Parent>;
    updateAccommodationConfirmation?: UpdateAccommodationConfirmationResolver<Parent>;
    updateAccommodationEvent?: UpdateAccommodationEventResolver<Parent>;
    updateBookingAudit?: UpdateBookingAuditResolver<Parent>;
    updateBookingEvent?: UpdateBookingEventResolver<Parent>;
    updateBookingFinance?: UpdateBookingFinanceResolver<Parent>;
    updateBookingGroup?: UpdateBookingGroupResolver<Parent>;
    updateBookingKit?: UpdateBookingKitResolver<Parent>;
    updateBookingKitEvent?: UpdateBookingKitEventResolver<Parent>;
    updateBookingKitTags?: UpdateBookingKitTagsResolver<Parent>;
    updateBookingProject?: UpdateBookingProjectResolver<Parent>;
    updateCommentForBookingAudit?: UpdateCommentForBookingAuditResolver<Parent>;
    updateConsultantEvent?: UpdateConsultantEventResolver<Parent>;
    updateConsultantGDPR?: UpdateConsultantGDPRResolver<Parent>;
    updateConsultantGeneralInterest?: UpdateConsultantGeneralInterestResolver<Parent>;
    updateConsultantLeadStatus?: UpdateConsultantLeadStatusResolver<Parent>;
    updateConsultantQualityNote?: UpdateConsultantQualityNoteResolver<Parent>;
    updateConsultantReference?: UpdateConsultantReferenceResolver<Parent>;
    updateConsultantServicePreference?: UpdateConsultantServicePreferenceResolver<Parent>;
    updateConsultantStatus?: UpdateConsultantStatusResolver<Parent>;
    updateConsultantUserSettings?: UpdateConsultantUserSettingsResolver<Parent>;
    updateConsultantWorkStatus?: UpdateConsultantWorkStatusResolver<Parent>;
    updateContactPerson?: UpdateContactPersonResolver<Parent>;
    updateCostCenter?: UpdateCostCenterResolver<Parent>;
    updateCustomer?: UpdateCustomerResolver<Parent>;
    updateCustomerContractEvent?: UpdateCustomerContractEventResolver<Parent>;
    updateCustomerEvent?: UpdateCustomerEventResolver<Parent>;
    updateCustomerRefsSearchProfiles?: UpdateCustomerRefsSearchProfilesResolver<Parent>;
    updateFavoriteTeam?: UpdateFavoriteTeamResolver<Parent>;
    updateSharedFile?: UpdateSharedFileResolver<Parent>;
    updateTgRequirement?: UpdateTgRequirementResolver<Parent>;
    updateTodoEvent?: UpdateTodoEventResolver<Parent>;
    updateTravelConfirmation?: UpdateTravelConfirmationResolver<Parent>;
    updateUnfitAccommodation?: UpdateUnfitAccommodationResolver<Parent>;
    uploadAccommodationDocument?: UploadAccommodationDocumentResolver<Parent>;
    uploadBlob?: UploadBlobResolver<Parent>;
    uploadBookingDocument?: UploadBookingDocumentResolver<Parent>;
    uploadConsultantAvatar?: UploadConsultantAvatarResolver<Parent>;
    uploadConsultantDocument?: UploadConsultantDocumentResolver<Parent>;
    uploadConsultantDocuments?: UploadConsultantDocumentsResolver<Parent>;
    uploadCustomerAvatar?: UploadCustomerAvatarResolver<Parent>;
    uploadCustomerBgPic?: UploadCustomerBgPicResolver<Parent>;
    uploadCustomerContractDocument?: UploadCustomerContractDocumentResolver<Parent>;
    uploadCustomerContractSignedDocument?: UploadCustomerContractSignedDocumentResolver<Parent>;
    uploadCustomerDocument?: UploadCustomerDocumentResolver<Parent>;
    uploadDocument?: UploadDocumentResolver<Parent>;
    uploadSharedFile?: UploadSharedFileResolver<Parent>;
    uploadSignedConsultantBookingContract?: UploadSignedConsultantBookingContractResolver<Parent>;
    uploadSignedConsultantContract?: UploadSignedConsultantContractResolver<Parent>;
  };
}

export type NodeResolver<Parent> = ReturnTypeResolver<Parent, Node>;
export type Node__Fields = {
  IsValid: boolean;
  NodeName: boolean;
  NodeType: boolean;
  ValidationErrors: NodeValidationError__Fields;
  _id: boolean;
};

export type NodeRefResolver<Parent> = ReturnTypeResolver<Parent, NodeRef>;
export type NodeRef__Fields = {
  Name: boolean;
  NodeID: boolean;
  NodeType: boolean;
};

export type NodeRefNewResolver<Parent> = ReturnTypeResolver<Parent, NodeRefNew>;
export type NodeRefNew__Fields = {
  name: boolean;
  nodeId: boolean;
  nodeType: boolean;
};

export type NodeRefSimpleResolver<Parent> = ReturnTypeResolver<Parent, NodeRefSimple>;
export type NodeRefSimple__Fields = {
  NodeID: boolean;
  NodeType: boolean;
};

export type NodeValidationErrorResolver<Parent> = ReturnTypeResolver<
  Parent,
  NodeValidationError
>;
export type NodeValidationError__Fields = {
  Message: boolean;
  Params: boolean;
  Type: boolean;
};

export type NotApprovedQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  NotApprovedQualityStatus
>;
export type NotApprovedQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
};

export type NurseAreasOfExpertiseResolver<Parent> = ReturnTypeResolver<
  Parent,
  NurseAreasOfExpertise
>;
export type NurseAreasOfExpertise__Fields = {
  comment: boolean;
  interested: boolean;
  name: boolean;
  qualified: boolean;
  yearFrom: boolean;
};

export type NurseProfessionResolver<Parent> = ReturnTypeResolver<Parent, NurseProfession>;
export type NurseProfession__Fields = {
  areasOfExpertise: NurseAreasOfExpertise__Fields;
  certifiedFrom: boolean;
  code: boolean;
  professionName: boolean;
  specializations: NurseSpecialization__Fields;
  systems: boolean;
};

export type NurseSpecializationResolver<Parent> = ReturnTypeResolver<
  Parent,
  NurseSpecialization
>;
export type NurseSpecialization__Fields = {
  comment: boolean;
  interested: boolean;
  name: boolean;
  qualified: boolean;
  yearFrom: boolean;
};

export type OptionObjectIDTypeResolver<Parent> = ReturnTypeResolver<
  Parent,
  OptionObjectIDType
>;
export type OptionObjectIDType__Fields = {
  description: boolean;
  error: boolean;
  label: boolean;
  parent: boolean;
  value: boolean;
};

export type OrderedQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  OrderedQualityStatus
>;
export type OrderedQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
};

export type PaginationResolver<Parent> = ReturnTypeResolver<Parent, Pagination>;
export type Pagination__Fields = {
  limit: boolean;
  skip: boolean;
};

export type PausedQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  PausedQualityStatus
>;
export type PausedQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  ExpiresOn: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
  params: boolean;
  pausedState: PausedState__Fields;
};

export type PausedStateResolver<Parent> = ReturnTypeResolver<Parent, PausedState>;
export type PausedState__Fields = {
  isPaused: boolean;
  pausedOn: boolean;
  pausedUntil: boolean;
  wasPaused: boolean;
  workflowId: boolean;
};

export type PriceRecruitmentResolver<Parent> = ReturnTypeResolver<
  Parent,
  PriceRecruitment
>;
export type PriceRecruitment__Fields = {
  Currency: boolean;
  R_0_159: boolean;
  R_160_499: boolean;
  R_500_699: boolean;
  R_700_899: boolean;
  R_900_1200: boolean;
};

export type ProfessionConfigResolver<Parent> = ReturnTypeResolver<
  Parent,
  ProfessionConfig
>;
export type ProfessionConfig__Fields = {
  AreasOfExpertise: ExpertiseConfig__Fields;
  DefaultAreaOfExpertise: boolean;
  Educations: boolean;
  Machines: boolean;
  Methods: boolean;
  Name: boolean;
  Systems: boolean;
};

export type ProfessionsByCountryResolver<Parent> = ReturnTypeResolver<
  Parent,
  ProfessionsByCountry
>;
export type ProfessionsByCountry__Fields = {
  country: boolean;
  professions: boolean;
};

export type ProjectResolver<Parent> = ReturnTypeResolver<Parent, Project>;
export type Project__Fields = {
  Admin: UserRef__Fields;
  Comment: boolean;
  Description: boolean;
  Members: UserRef__Fields;
  Name: boolean;
  Owner: UserRef__Fields;
  ProjectNumber: boolean;
  Status: boolean;
  _id: boolean;
};

export type PsykologProfessionResolver<Parent> = ReturnTypeResolver<
  Parent,
  PsykologProfession
>;
export type PsykologProfession__Fields = {
  certifiedFrom: boolean;
  methods: boolean;
  professionName: boolean;
  specializations: PsykologSpecialization__Fields;
  systems: boolean;
};

export type PsykologSpecializationResolver<Parent> = ReturnTypeResolver<
  Parent,
  PsykologSpecialization
>;
export type PsykologSpecialization__Fields = {
  comment: boolean;
  interested: boolean;
  name: boolean;
  qualified: boolean;
  yearFrom: boolean;
};

export type PublishContractResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  PublishContractResult
>;
export type PublishContractResult__Fields = {
  contractUrl: boolean;
};

export type QualityApprovalResolver<Parent> = ReturnTypeResolver<Parent, QualityApproval>;
export type QualityApproval__Fields = {
  Approved: boolean;
  Country: boolean;
  Profession: boolean;
  approvalExpiresOn: boolean;
  baseItems: QualityApprovalItem__Fields;
  oneOfItems: QualityApprovalItem__Fields;
};

export type QualityApprovalItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  QualityApprovalItem
>;
export type QualityApprovalItem__Fields = {
  approvalExpiresOn: boolean;
  approved: boolean;
  name: boolean;
  partiallyExpiresOn: boolean;
};

export type QualityTemplateResolver<Parent> = ReturnTypeResolver<Parent, QualityTemplate>;
export type QualityTemplate__Fields = {
  Country: boolean;
  Items: QualityTemplateItem__Fields;
};

export type QualityTemplateItemResolver<Parent> = ReturnTypeResolver<
  Parent,
  QualityTemplateItem
>;
export type QualityTemplateItem__Fields = {
  Description: boolean;
  DocumentsFolder: boolean;
  ExpiresInMonths: boolean;
  Name: boolean;
};
export namespace Query {
  export type SearchProfilesResolver<Parent = never> = Resolver<
    SearchProfilesSearchResult | Parent,
    Parent,
    QuerySearchProfilesArgs
  >;
  export type SearchProfilesArgs = QuerySearchProfilesArgs;

  export type AccommodationConfirmationByIdResolver<Parent = never> = Resolver<
    AccommodationConfirmation | Parent,
    Parent,
    QueryAccommodationConfirmationByIdArgs
  >;
  export type AccommodationConfirmationByIdArgs = QueryAccommodationConfirmationByIdArgs;

  export type AccommodationEventsResolver<Parent = never> = Resolver<
    Array<AccommodationEvent> | Parent,
    Parent,
    QueryAccommodationEventsArgs
  >;
  export type AccommodationEventsArgs = QueryAccommodationEventsArgs;

  export type AccommodationRequestByIdResolver<Parent = never> = Resolver<
    AccommodationRequest | Parent,
    Parent,
    QueryAccommodationRequestByIdArgs
  >;
  export type AccommodationRequestByIdArgs = QueryAccommodationRequestByIdArgs;

  export type AccommodationRequestSearchResolver<Parent = never> = Resolver<
    AccommodationRequestSearchResult | Parent,
    Parent,
    QueryAccommodationRequestSearchArgs
  >;
  export type AccommodationRequestSearchArgs = QueryAccommodationRequestSearchArgs;

  export type AccommodationRequestSearchTotalResolver<Parent = never> = Resolver<
    AccommodationRequestSearchTotalResult | Parent,
    Parent,
    QueryAccommodationRequestSearchTotalArgs
  >;
  export type AccommodationRequestSearchTotalArgs =
    QueryAccommodationRequestSearchTotalArgs;

  export type AttestContactPersonsResolver<Parent = never> = Resolver<
    GetAttestContactPersonsResult | Parent,
    Parent,
    QueryAttestContactPersonsArgs
  >;
  export type AttestContactPersonsArgs = QueryAttestContactPersonsArgs;

  export type BisnodeLookupByPhoneResolver<Parent = never> = Resolver<
    BisnodePerson | Parent,
    Parent,
    QueryBisnodeLookupByPhoneArgs
  >;
  export type BisnodeLookupByPhoneArgs = QueryBisnodeLookupByPhoneArgs;

  export type BisnodeLookupBySSNResolver<Parent = never> = Resolver<
    BisnodePerson | Parent,
    Parent,
    QueryBisnodeLookupBySSNArgs
  >;
  export type BisnodeLookupBySSNArgs = QueryBisnodeLookupBySSNArgs;

  export type BookingByIdResolver<Parent = never> = Resolver<
    Booking | Parent,
    Parent,
    QueryBookingByIdArgs
  >;
  export type BookingByIdArgs = QueryBookingByIdArgs;

  export type BookingEventsResolver<Parent = never> = Resolver<
    Array<BookingEvent> | Parent,
    Parent,
    QueryBookingEventsArgs
  >;
  export type BookingEventsArgs = QueryBookingEventsArgs;

  export type BookingHospitalityResolver<Parent = never> = Resolver<
    BookingHospitality | Parent,
    Parent,
    QueryBookingHospitalityArgs
  >;
  export type BookingHospitalityArgs = QueryBookingHospitalityArgs;

  export type BookingKitResolver<Parent = never> = Resolver<
    BookingKit | Parent,
    Parent,
    QueryBookingKitArgs
  >;
  export type BookingKitArgs = QueryBookingKitArgs;

  export type BookingKitApprovalConfigResolver<Parent = never> = Resolver<
    BookingKitApprovalConfig | Parent,
    Parent,
    QueryBookingKitApprovalConfigArgs
  >;
  export type BookingKitApprovalConfigArgs = QueryBookingKitApprovalConfigArgs;

  export type BookingKitDraftResolver<Parent = never> = Resolver<
    BookingKitDraft | Parent,
    Parent,
    QueryBookingKitDraftArgs
  >;
  export type BookingKitDraftArgs = QueryBookingKitDraftArgs;

  export type BookingKitEventsResolver<Parent = never> = Resolver<
    Array<BookingKitEvent> | Parent,
    Parent,
    QueryBookingKitEventsArgs
  >;
  export type BookingKitEventsArgs = QueryBookingKitEventsArgs;

  export type BookingKitFormConfigResolver<Parent = never> = Resolver<
    Array<BookingKitTypeFormConfig> | Parent,
    Parent,
    QueryBookingKitFormConfigArgs
  >;
  export type BookingKitFormConfigArgs = QueryBookingKitFormConfigArgs;

  export type BookingKitSearchResolver<Parent = never> = Resolver<
    BookingKitSearchResult | Parent,
    Parent,
    QueryBookingKitSearchArgs
  >;
  export type BookingKitSearchArgs = QueryBookingKitSearchArgs;

  export type BookingKitSearchTotalResolver<Parent = never> = Resolver<
    BookingKitSearchTotalResult | Parent,
    Parent,
    QueryBookingKitSearchTotalArgs
  >;
  export type BookingKitSearchTotalArgs = QueryBookingKitSearchTotalArgs;

  export type BookingKitsResolver<Parent = never> = Resolver<
    Array<BookingKitSearch> | Parent,
    Parent,
    QueryBookingKitsArgs
  >;
  export type BookingKitsArgs = QueryBookingKitsArgs;

  export type BookingSyncReportResolver<Parent = never> = Resolver<
    BookingSyncReport | Parent,
    Parent,
    QueryBookingSyncReportArgs
  >;
  export type BookingSyncReportArgs = QueryBookingSyncReportArgs;

  export type BookingWeeksResolver<Parent = never> = Resolver<
    BookingWeekQueryResult | Parent,
    Parent,
    QueryBookingWeeksArgs
  >;
  export type BookingWeeksArgs = QueryBookingWeeksArgs;

  export type BookingWeeksByConsultantResolver<Parent = never> = Resolver<
    Array<BookingWeekCalendarItem> | Parent,
    Parent,
    QueryBookingWeeksByConsultantArgs
  >;
  export type BookingWeeksByConsultantArgs = QueryBookingWeeksByConsultantArgs;

  export type BookingWeeksCSVResolver<Parent = never> = Resolver<
    BookingWeeksCSVResult | Parent,
    Parent,
    QueryBookingWeeksCSVArgs
  >;
  export type BookingWeeksCSVArgs = QueryBookingWeeksCSVArgs;

  export type BookingWeeksCSVBackgroundResolver<Parent = never> = Resolver<
    BookingWeeksCSVBackgroundResult | Parent,
    Parent,
    QueryBookingWeeksCSVBackgroundArgs
  >;
  export type BookingWeeksCSVBackgroundArgs = QueryBookingWeeksCSVBackgroundArgs;

  export type BookingWeeksKitSupportResolver<Parent = never> = Resolver<
    BookingWeekQueryResult | Parent,
    Parent,
    QueryBookingWeeksKitSupportArgs
  >;
  export type BookingWeeksKitSupportArgs = QueryBookingWeeksKitSupportArgs;

  export type BookingWeeksTotalResolver<Parent = never> = Resolver<
    BookingWeeksTotalResult | Parent,
    Parent,
    QueryBookingWeeksTotalArgs
  >;
  export type BookingWeeksTotalArgs = QueryBookingWeeksTotalArgs;

  export type BulkSmsTextMaxLengthResolver<Parent = never> = Resolver<
    number | Parent,
    Parent,
    QueryBulkSmsTextMaxLengthArgs
  >;
  export type BulkSmsTextMaxLengthArgs = QueryBulkSmsTextMaxLengthArgs;

  export type CallListByIdResolver<Parent = never> = Resolver<
    CallListOpResult | Parent,
    Parent,
    QueryCallListByIdArgs
  >;
  export type CallListByIdArgs = QueryCallListByIdArgs;

  export type CheckBookingCancellableResolver<Parent = never> = Resolver<
    Array<BookingCannotBeRemovedReason> | Parent,
    Parent,
    QueryCheckBookingCancellableArgs
  >;
  export type CheckBookingCancellableArgs = QueryCheckBookingCancellableArgs;

  export type CheckBookingGroupCancellableResolver<Parent = never> = Resolver<
    BookingGroupCancellableResult | Parent,
    Parent,
    QueryCheckBookingGroupCancellableArgs
  >;
  export type CheckBookingGroupCancellableArgs = QueryCheckBookingGroupCancellableArgs;

  export type CheckBookingGroupCancellableByBookingIdResolver<Parent = never> = Resolver<
    BookingGroupCancellableResult | Parent,
    Parent,
    QueryCheckBookingGroupCancellableByBookingIdArgs
  >;
  export type CheckBookingGroupCancellableByBookingIdArgs =
    QueryCheckBookingGroupCancellableByBookingIdArgs;

  export type CheckConsultantExistsResolver<Parent = never> = Resolver<
    CheckContactExistsResult | Parent,
    Parent,
    QueryCheckConsultantExistsArgs
  >;
  export type CheckConsultantExistsArgs = QueryCheckConsultantExistsArgs;

  export type CheckFortnoxSalaryForWeekResolver<Parent = never> = Resolver<
    FortnoxWeekSalaryCheck | Parent,
    Parent,
    QueryCheckFortnoxSalaryForWeekArgs
  >;
  export type CheckFortnoxSalaryForWeekArgs = QueryCheckFortnoxSalaryForWeekArgs;

  export type ConfigResolver<Parent = never> = Resolver<ConfigDoc | Parent, Parent>;

  export type ConsultantByIdResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    QueryConsultantByIdArgs
  >;
  export type ConsultantByIdArgs = QueryConsultantByIdArgs;

  export type ConsultantByWorkExperienceResolver<Parent = never> = Resolver<
    ConsultantByWorkExperienceResult | Parent,
    Parent,
    QueryConsultantByWorkExperienceArgs
  >;
  export type ConsultantByWorkExperienceArgs = QueryConsultantByWorkExperienceArgs;

  export type ConsultantCanDuplicateToTenantsResolver<Parent = never> = Resolver<
    CanDuplicateToTenantsResult | Parent,
    Parent,
    QueryConsultantCanDuplicateToTenantsArgs
  >;
  export type ConsultantCanDuplicateToTenantsArgs =
    QueryConsultantCanDuplicateToTenantsArgs;

  export type ConsultantEventsResolver<Parent = never> = Resolver<
    Array<ConsultantEvent> | Parent,
    Parent,
    QueryConsultantEventsArgs
  >;
  export type ConsultantEventsArgs = QueryConsultantEventsArgs;

  export type ConsultantFormByIdResolver<Parent = never> = Resolver<
    ConsultantForm | Parent,
    Parent,
    QueryConsultantFormByIdArgs
  >;
  export type ConsultantFormByIdArgs = QueryConsultantFormByIdArgs;

  export type ConsultantHealthDeclarationsResolver<Parent = never> = Resolver<
    HealthDeclarationsQueryResult | Parent,
    Parent,
    QueryConsultantHealthDeclarationsArgs
  >;
  export type ConsultantHealthDeclarationsArgs = QueryConsultantHealthDeclarationsArgs;

  export type ConsultantKarensByIdResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    QueryConsultantKarensByIdArgs
  >;
  export type ConsultantKarensByIdArgs = QueryConsultantKarensByIdArgs;

  export type ConsultantMatchingResolver<Parent = never> = Resolver<
    ConsultantMatchingResult | Parent,
    Parent,
    QueryConsultantMatchingArgs
  >;
  export type ConsultantMatchingArgs = QueryConsultantMatchingArgs;

  export type ConsultantOpportunityByConsultantIdResolver<Parent = never> = Resolver<
    Array<ConsultantOpportunity> | Parent,
    Parent,
    QueryConsultantOpportunityByConsultantIdArgs
  >;
  export type ConsultantOpportunityByConsultantIdArgs =
    QueryConsultantOpportunityByConsultantIdArgs;

  export type ConsultantOpportunityByIdResolver<Parent = never> = Resolver<
    ConsultantOpportunity | Parent,
    Parent,
    QueryConsultantOpportunityByIdArgs
  >;
  export type ConsultantOpportunityByIdArgs = QueryConsultantOpportunityByIdArgs;

  export type ConsultantOpportunityIssueWeeksResolver<Parent = never> = Resolver<
    ConsultantOpportunityIssueWeeks | Parent,
    Parent,
    QueryConsultantOpportunityIssueWeeksArgs
  >;
  export type ConsultantOpportunityIssueWeeksArgs =
    QueryConsultantOpportunityIssueWeeksArgs;

  export type ConsultantOpportunityStatsByTeamResolver<Parent = never> = Resolver<
    ConsultantOpportunityStats | Parent,
    Parent,
    QueryConsultantOpportunityStatsByTeamArgs
  >;
  export type ConsultantOpportunityStatsByTeamArgs =
    QueryConsultantOpportunityStatsByTeamArgs;

  export type ConsultantOpportunityStatsByUserResolver<Parent = never> = Resolver<
    ConsultantOpportunityStats | Parent,
    Parent,
    QueryConsultantOpportunityStatsByUserArgs
  >;
  export type ConsultantOpportunityStatsByUserArgs =
    QueryConsultantOpportunityStatsByUserArgs;

  export type ConsultantReferenceDocumentsResolver<Parent = never> = Resolver<
    Array<ConsultantReferenceDocument> | Parent,
    Parent,
    QueryConsultantReferenceDocumentsArgs
  >;
  export type ConsultantReferenceDocumentsArgs = QueryConsultantReferenceDocumentsArgs;

  export type ConsultantReferencesResolver<Parent = never> = Resolver<
    Array<ConsultantReferenceNew> | Parent,
    Parent,
    QueryConsultantReferencesArgs
  >;
  export type ConsultantReferencesArgs = QueryConsultantReferencesArgs;

  export type ConsultantServicePreferenceResolver<Parent = never> = Resolver<
    ConsultantServicePreference | Parent,
    Parent,
    QueryConsultantServicePreferenceArgs
  >;
  export type ConsultantServicePreferenceArgs = QueryConsultantServicePreferenceArgs;

  export type ConsultantServicePreferenceFormResolver<Parent = never> = Resolver<
    ConsultantServicePreferenceForm | Parent,
    Parent,
    QueryConsultantServicePreferenceFormArgs
  >;
  export type ConsultantServicePreferenceFormArgs =
    QueryConsultantServicePreferenceFormArgs;

  export type ConsultantServicePreferencesResolver<Parent = never> = Resolver<
    Array<ConsultantServicePreference> | Parent,
    Parent,
    QueryConsultantServicePreferencesArgs
  >;
  export type ConsultantServicePreferencesArgs = QueryConsultantServicePreferencesArgs;

  export type ConsultantServicePreferencesForBookingResolver<Parent = never> = Resolver<
    Array<ConsultantServicePreference> | Parent,
    Parent,
    QueryConsultantServicePreferencesForBookingArgs
  >;
  export type ConsultantServicePreferencesForBookingArgs =
    QueryConsultantServicePreferencesForBookingArgs;

  export type ConsultantUpcomingWorkplacesResolver<Parent = never> = Resolver<
    Array<ConsultantUpcomingWorkplace> | Parent,
    Parent,
    QueryConsultantUpcomingWorkplacesArgs
  >;
  export type ConsultantUpcomingWorkplacesArgs = QueryConsultantUpcomingWorkplacesArgs;

  export type ConsultantWorkStatusesResolver<Parent = never> = Resolver<
    Array<ConsultantWorkStatus> | Parent,
    Parent,
    QueryConsultantWorkStatusesArgs
  >;
  export type ConsultantWorkStatusesArgs = QueryConsultantWorkStatusesArgs;

  export type ConsultantsResolver<Parent = never> = Resolver<
    ConsultantsResult | Parent,
    Parent,
    QueryConsultantsArgs
  >;
  export type ConsultantsArgs = QueryConsultantsArgs;

  export type ConsultantsByWeeksResolver<Parent = never> = Resolver<
    Array<ConsultantAvailableOnWeek> | Parent,
    Parent,
    QueryConsultantsByWeeksArgs
  >;
  export type ConsultantsByWeeksArgs = QueryConsultantsByWeeksArgs;

  export type ConsultantsCSVResolver<Parent = never> = Resolver<
    ConsultantExportCSVResult | Parent,
    Parent,
    QueryConsultantsCSVArgs
  >;
  export type ConsultantsCSVArgs = QueryConsultantsCSVArgs;

  export type ConsultantsFastResolver<Parent = never> = Resolver<
    ConsultantsResult | Parent,
    Parent,
    QueryConsultantsFastArgs
  >;
  export type ConsultantsFastArgs = QueryConsultantsFastArgs;

  export type ConsultantsTotalResolver<Parent = never> = Resolver<
    ConsultantTotalResult | Parent,
    Parent,
    QueryConsultantsTotalArgs
  >;
  export type ConsultantsTotalArgs = QueryConsultantsTotalArgs;

  export type ContactPersonByIdResolver<Parent = never> = Resolver<
    ContactPerson | Parent,
    Parent,
    QueryContactPersonByIdArgs
  >;
  export type ContactPersonByIdArgs = QueryContactPersonByIdArgs;

  export type ContactPersonsResolver<Parent = never> = Resolver<
    ContactPersonsResult | Parent,
    Parent,
    QueryContactPersonsArgs
  >;
  export type ContactPersonsArgs = QueryContactPersonsArgs;

  export type ContractResolver<Parent = never> = Resolver<
    BookingContractInfo | Parent,
    Parent,
    QueryContractArgs
  >;
  export type ContractArgs = QueryContractArgs;

  export type ContractsPriceTemplateByIdResolver<Parent = never> = Resolver<
    ContractsPriceTemplate | Parent,
    Parent,
    QueryContractsPriceTemplateByIdArgs
  >;
  export type ContractsPriceTemplateByIdArgs = QueryContractsPriceTemplateByIdArgs;

  export type ContractsPriceTemplatesResolver<Parent = never> = Resolver<
    ContractPriceTemplateSearchResult | Parent,
    Parent,
    QueryContractsPriceTemplatesArgs
  >;
  export type ContractsPriceTemplatesArgs = QueryContractsPriceTemplatesArgs;

  export type CostCenterConfigItemsResolver<Parent = never> = Resolver<
    Array<CostCenterConfigItem> | Parent,
    Parent,
    QueryCostCenterConfigItemsArgs
  >;
  export type CostCenterConfigItemsArgs = QueryCostCenterConfigItemsArgs;

  export type CustomerByIdResolver<Parent = never> = Resolver<
    Customer | Parent,
    Parent,
    QueryCustomerByIdArgs
  >;
  export type CustomerByIdArgs = QueryCustomerByIdArgs;

  export type CustomerContractByIdResolver<Parent = never> = Resolver<
    CustomerContract | Parent,
    Parent,
    QueryCustomerContractByIdArgs
  >;
  export type CustomerContractByIdArgs = QueryCustomerContractByIdArgs;

  export type CustomerContractPriceListByIdResolver<Parent = never> = Resolver<
    CustomerContractPriceList | Parent,
    Parent,
    QueryCustomerContractPriceListByIdArgs
  >;
  export type CustomerContractPriceListByIdArgs = QueryCustomerContractPriceListByIdArgs;

  export type CustomerContractSnapshotByIdResolver<Parent = never> = Resolver<
    CustomerContractSnapshot | Parent,
    Parent,
    QueryCustomerContractSnapshotByIdArgs
  >;
  export type CustomerContractSnapshotByIdArgs = QueryCustomerContractSnapshotByIdArgs;

  export type CustomerContractSubVersionByIdResolver<Parent = never> = Resolver<
    CustomerContractSubVersion | Parent,
    Parent,
    QueryCustomerContractSubVersionByIdArgs
  >;
  export type CustomerContractSubVersionByIdArgs =
    QueryCustomerContractSubVersionByIdArgs;

  export type CustomerContractsResolver<Parent = never> = Resolver<
    CustomerContractSearchResult | Parent,
    Parent,
    QueryCustomerContractsArgs
  >;
  export type CustomerContractsArgs = QueryCustomerContractsArgs;

  export type CustomerContractsByBookingResolver<Parent = never> = Resolver<
    Array<CustomerContractListItem> | Parent,
    Parent,
    QueryCustomerContractsByBookingArgs
  >;
  export type CustomerContractsByBookingArgs = QueryCustomerContractsByBookingArgs;

  export type CustomerContractsTotalResolver<Parent = never> = Resolver<
    Total | Parent,
    Parent,
    QueryCustomerContractsTotalArgs
  >;
  export type CustomerContractsTotalArgs = QueryCustomerContractsTotalArgs;

  export type CustomerEventsResolver<Parent = never> = Resolver<
    Array<CustomerEvent> | Parent,
    Parent,
    QueryCustomerEventsArgs
  >;
  export type CustomerEventsArgs = QueryCustomerEventsArgs;

  export type CustomerNumberByAOEResolver<Parent = never> = Resolver<
    string | Parent,
    Parent,
    QueryCustomerNumberByAOEArgs
  >;
  export type CustomerNumberByAOEArgs = QueryCustomerNumberByAOEArgs;

  export type CustomersResolver<Parent = never> = Resolver<
    CustomersResult | Parent,
    Parent,
    QueryCustomersArgs
  >;
  export type CustomersArgs = QueryCustomersArgs;

  export type CustomersPickerResolver<Parent = never> = Resolver<
    CustomersResult | Parent,
    Parent,
    QueryCustomersPickerArgs
  >;
  export type CustomersPickerArgs = QueryCustomersPickerArgs;

  export type CustomersTotalResolver<Parent = never> = Resolver<
    CustomersTotalResult | Parent,
    Parent,
    QueryCustomersTotalArgs
  >;
  export type CustomersTotalArgs = QueryCustomersTotalArgs;

  export type FindConsultantDuplicateResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    QueryFindConsultantDuplicateArgs
  >;
  export type FindConsultantDuplicateArgs = QueryFindConsultantDuplicateArgs;

  export type FindConsultantSimilarResolver<Parent = never> = Resolver<
    Consultant | Parent,
    Parent,
    QueryFindConsultantSimilarArgs
  >;
  export type FindConsultantSimilarArgs = QueryFindConsultantSimilarArgs;

  export type FindContractResolver<Parent = never> = Resolver<
    BookingContractInfo | Parent,
    Parent,
    QueryFindContractArgs
  >;
  export type FindContractArgs = QueryFindContractArgs;

  export type FreshdeskOpenTicketsCountByConsultantResolver<Parent = never> = Resolver<
    number | Parent,
    Parent,
    QueryFreshdeskOpenTicketsCountByConsultantArgs
  >;
  export type FreshdeskOpenTicketsCountByConsultantArgs =
    QueryFreshdeskOpenTicketsCountByConsultantArgs;

  export type FreshdeskTicketsByConsultantResolver<Parent = never> = Resolver<
    Array<FreshdeskTicket> | Parent,
    Parent,
    QueryFreshdeskTicketsByConsultantArgs
  >;
  export type FreshdeskTicketsByConsultantArgs = QueryFreshdeskTicketsByConsultantArgs;

  export type GetAccommodationDetailsResolver<Parent = never> = Resolver<
    Accommodation | Parent,
    Parent,
    QueryGetAccommodationDetailsArgs
  >;
  export type GetAccommodationDetailsArgs = QueryGetAccommodationDetailsArgs;

  export type GetAccommodationsResolver<Parent = never> = Resolver<
    Array<AccommodationListItem> | Parent,
    Parent,
    QueryGetAccommodationsArgs
  >;
  export type GetAccommodationsArgs = QueryGetAccommodationsArgs;

  export type GetAccommodationsCountResolver<Parent = never> = Resolver<
    Count | Parent,
    Parent,
    QueryGetAccommodationsCountArgs
  >;
  export type GetAccommodationsCountArgs = QueryGetAccommodationsCountArgs;

  export type GetAllConsultantTagsResolver<Parent = never> = Resolver<
    AllConsultantTagsResult | Parent,
    Parent
  >;

  export type GetBookingAssignedToTotalResolver<Parent = never> = Resolver<
    BookingWeeksTotalResult | Parent,
    Parent
  >;

  export type GetBookingCustomerContactsResolver<Parent = never> = Resolver<
    Array<CustomerContact> | Parent,
    Parent,
    QueryGetBookingCustomerContactsArgs
  >;
  export type GetBookingCustomerContactsArgs = QueryGetBookingCustomerContactsArgs;

  export type GetBookingGroupResolver<Parent = never> = Resolver<
    BookingGroup | Parent,
    Parent,
    QueryGetBookingGroupArgs
  >;
  export type GetBookingGroupArgs = QueryGetBookingGroupArgs;

  export type GetBookingKitAssignedToTotalResolver<Parent = never> = Resolver<
    BookingKitSearchTotalResult | Parent,
    Parent,
    QueryGetBookingKitAssignedToTotalArgs
  >;
  export type GetBookingKitAssignedToTotalArgs = QueryGetBookingKitAssignedToTotalArgs;

  export type GetChecksForBookingResolver<Parent = never> = Resolver<
    BookingChecks | Parent,
    Parent,
    QueryGetChecksForBookingArgs
  >;
  export type GetChecksForBookingArgs = QueryGetChecksForBookingArgs;

  export type GetConsultantBookingContractDetailInfoResolver<Parent = never> = Resolver<
    ConsultantBookingContract | Parent,
    Parent,
    QueryGetConsultantBookingContractDetailInfoArgs
  >;
  export type GetConsultantBookingContractDetailInfoArgs =
    QueryGetConsultantBookingContractDetailInfoArgs;

  export type GetConsultantBookingContractsResolver<Parent = never> = Resolver<
    Array<ConsultantBookingContractListItem> | Parent,
    Parent,
    QueryGetConsultantBookingContractsArgs
  >;
  export type GetConsultantBookingContractsArgs = QueryGetConsultantBookingContractsArgs;

  export type GetConsultantBookingContractsByCustomerIdResolver<Parent = never> =
    Resolver<
      Array<ConsultantBookingContract> | Parent,
      Parent,
      QueryGetConsultantBookingContractsByCustomerIdArgs
    >;
  export type GetConsultantBookingContractsByCustomerIdArgs =
    QueryGetConsultantBookingContractsByCustomerIdArgs;

  export type GetConsultantContractDetailInfoResolver<Parent = never> = Resolver<
    ConsultantContract | Parent,
    Parent,
    QueryGetConsultantContractDetailInfoArgs
  >;
  export type GetConsultantContractDetailInfoArgs =
    QueryGetConsultantContractDetailInfoArgs;

  export type GetConsultantContractsResolver<Parent = never> = Resolver<
    Array<ConsultantContractListItem> | Parent,
    Parent,
    QueryGetConsultantContractsArgs
  >;
  export type GetConsultantContractsArgs = QueryGetConsultantContractsArgs;

  export type GetConsultantContractsByBookingResolver<Parent = never> = Resolver<
    Array<ConsultantContractListItem> | Parent,
    Parent,
    QueryGetConsultantContractsByBookingArgs
  >;
  export type GetConsultantContractsByBookingArgs =
    QueryGetConsultantContractsByBookingArgs;

  export type GetConsultantPayoutByYearResolver<Parent = never> = Resolver<
    Array<ConsultantPayoutByYear> | Parent,
    Parent,
    QueryGetConsultantPayoutByYearArgs
  >;
  export type GetConsultantPayoutByYearArgs = QueryGetConsultantPayoutByYearArgs;

  export type GetConsultantQualityItemResolver<Parent = never> = Resolver<
    ConsultantQualityItem | Parent,
    Parent,
    QueryGetConsultantQualityItemArgs
  >;
  export type GetConsultantQualityItemArgs = QueryGetConsultantQualityItemArgs;

  export type GetConsultantSearchQualityItemsResolver<Parent = never> = Resolver<
    Array<ConsultantSearchQualityItem> | Parent,
    Parent
  >;

  export type GetContactPersonsByCustomerIdsResolver<Parent = never> = Resolver<
    Array<ContactPerson> | Parent,
    Parent,
    QueryGetContactPersonsByCustomerIdsArgs
  >;
  export type GetContactPersonsByCustomerIdsArgs =
    QueryGetContactPersonsByCustomerIdsArgs;

  export type GetCustomerContractPriceListsResolver<Parent = never> = Resolver<
    Array<CustomerContract> | Parent,
    Parent,
    QueryGetCustomerContractPriceListsArgs
  >;
  export type GetCustomerContractPriceListsArgs = QueryGetCustomerContractPriceListsArgs;

  export type GetCustomerContractSnapshotsResolver<Parent = never> = Resolver<
    Array<CustomerContractSnapshot> | Parent,
    Parent,
    QueryGetCustomerContractSnapshotsArgs
  >;
  export type GetCustomerContractSnapshotsArgs = QueryGetCustomerContractSnapshotsArgs;

  export type GetFortnoxSalaryCacheResolver<Parent = never> = Resolver<
    FortnoxSalaryCache | Parent,
    Parent,
    QueryGetFortnoxSalaryCacheArgs
  >;
  export type GetFortnoxSalaryCacheArgs = QueryGetFortnoxSalaryCacheArgs;

  export type GetFreeTimereportsResolver<Parent = never> = Resolver<
    FreeTimereportResult | Parent,
    Parent,
    QueryGetFreeTimereportsArgs
  >;
  export type GetFreeTimereportsArgs = QueryGetFreeTimereportsArgs;

  export type GetHighHolidaysResolver<Parent = never> = Resolver<
    Array<HighHolidayOption> | Parent,
    Parent
  >;

  export type GetInvoiceStatusForBookingResolver<Parent = never> = Resolver<
    BookingInvoicePaymentStatusesResult | Parent,
    Parent,
    QueryGetInvoiceStatusForBookingArgs
  >;
  export type GetInvoiceStatusForBookingArgs = QueryGetInvoiceStatusForBookingArgs;

  export type GetLastAccommodationRequestResolver<Parent = never> = Resolver<
    AccommodationRequest | Parent,
    Parent,
    QueryGetLastAccommodationRequestArgs
  >;
  export type GetLastAccommodationRequestArgs = QueryGetLastAccommodationRequestArgs;

  export type GetLastSignedConsultantContractResolver<Parent = never> = Resolver<
    ConsultantContractListItem | Parent,
    Parent,
    QueryGetLastSignedConsultantContractArgs
  >;
  export type GetLastSignedConsultantContractArgs =
    QueryGetLastSignedConsultantContractArgs;

  export type GetLastWorkflowRunResolver<Parent = never> = Resolver<
    WorkflowRun | Parent,
    Parent,
    QueryGetLastWorkflowRunArgs
  >;
  export type GetLastWorkflowRunArgs = QueryGetLastWorkflowRunArgs;

  export type GetSystemsByProfessionResolver<Parent = never> = Resolver<
    Array<string> | Parent,
    Parent,
    QueryGetSystemsByProfessionArgs
  >;
  export type GetSystemsByProfessionArgs = QueryGetSystemsByProfessionArgs;

  export type GetTimereportByBookingIdResolver<Parent = never> = Resolver<
    TimereportResult | Parent,
    Parent,
    QueryGetTimereportByBookingIdArgs
  >;
  export type GetTimereportByBookingIdArgs = QueryGetTimereportByBookingIdArgs;

  export type GetTimereportSendFailuresResolver<Parent = never> = Resolver<
    TimereportSendFailuresResult | Parent,
    Parent,
    QueryGetTimereportSendFailuresArgs
  >;
  export type GetTimereportSendFailuresArgs = QueryGetTimereportSendFailuresArgs;

  export type GetTimereportStatusHistoryResolver<Parent = never> = Resolver<
    TimereportStatusHistoryResult | Parent,
    Parent,
    QueryGetTimereportStatusHistoryArgs
  >;
  export type GetTimereportStatusHistoryArgs = QueryGetTimereportStatusHistoryArgs;

  export type GetTimereportToCustomerEmailResolver<Parent = never> = Resolver<
    GetTimereportToCustomerEmailResult | Parent,
    Parent,
    QueryGetTimereportToCustomerEmailArgs
  >;
  export type GetTimereportToCustomerEmailArgs = QueryGetTimereportToCustomerEmailArgs;

  export type GetWorkflowRunsResolver<Parent = never> = Resolver<
    Array<WorkflowRun> | Parent,
    Parent,
    QueryGetWorkflowRunsArgs
  >;
  export type GetWorkflowRunsArgs = QueryGetWorkflowRunsArgs;

  export type GetWorkflowRunsByOwnerResolver<Parent = never> = Resolver<
    WorkflowRunsPaginatedResult | Parent,
    Parent,
    QueryGetWorkflowRunsByOwnerArgs
  >;
  export type GetWorkflowRunsByOwnerArgs = QueryGetWorkflowRunsByOwnerArgs;

  export type InvoiceByNumberResolver<Parent = never> = Resolver<
    Invoice | Parent,
    Parent,
    QueryInvoiceByNumberArgs
  >;
  export type InvoiceByNumberArgs = QueryInvoiceByNumberArgs;

  export type KanbanBoardResolver<Parent = never> = Resolver<
    KanbanBoard | Parent,
    Parent,
    QueryKanbanBoardArgs
  >;
  export type KanbanBoardArgs = QueryKanbanBoardArgs;

  export type KanbanCardResolver<Parent = never> = Resolver<
    KanbanCard | Parent,
    Parent,
    QueryKanbanCardArgs
  >;
  export type KanbanCardArgs = QueryKanbanCardArgs;

  export type KanbanCardsResolver<Parent = never> = Resolver<
    Array<KanbanCard> | Parent,
    Parent,
    QueryKanbanCardsArgs
  >;
  export type KanbanCardsArgs = QueryKanbanCardsArgs;

  export type MeResolver<Parent = never> = Resolver<Me | Parent, Parent>;

  export type MunicipalitiesResolver<Parent = never> = Resolver<
    Array<Municipality> | Parent,
    Parent
  >;

  export type MyApiTokensResolver<Parent = never> = Resolver<
    Array<ApiToken> | Parent,
    Parent
  >;

  export type NpDirectRequestAvailableResolver<Parent = never> = Resolver<
    boolean | Parent,
    Parent,
    QueryNpDirectRequestAvailableArgs
  >;
  export type NpDirectRequestAvailableArgs = QueryNpDirectRequestAvailableArgs;

  export type ProfessionsByCountryResolver<Parent = never> = Resolver<
    Array<ProfessionsByCountry> | Parent,
    Parent
  >;

  export type ProjectsResolver<Parent = never> = Resolver<
    Array<Project> | Parent,
    Parent,
    QueryProjectsArgs
  >;
  export type ProjectsArgs = QueryProjectsArgs;

  export type SearchProfileByIdResolver<Parent = never> = Resolver<
    SearchProfile | Parent,
    Parent,
    QuerySearchProfileByIdArgs
  >;
  export type SearchProfileByIdArgs = QuerySearchProfileByIdArgs;

  export type SearchProfilesByCustomerIdResolver<Parent = never> = Resolver<
    Array<SearchProfile> | Parent,
    Parent,
    QuerySearchProfilesByCustomerIdArgs
  >;
  export type SearchProfilesByCustomerIdArgs = QuerySearchProfilesByCustomerIdArgs;

  export type SharedFileByIdResolver<Parent = never> = Resolver<
    SharedFile | Parent,
    Parent,
    QuerySharedFileByIdArgs
  >;
  export type SharedFileByIdArgs = QuerySharedFileByIdArgs;

  export type SharedFilesResolver<Parent = never> = Resolver<
    SharedFilesResult | Parent,
    Parent,
    QuerySharedFilesArgs
  >;
  export type SharedFilesArgs = QuerySharedFilesArgs;

  export type SubcontractorInvoiceByNumberResolver<Parent = never> = Resolver<
    SubcontractorInvoice | Parent,
    Parent,
    QuerySubcontractorInvoiceByNumberArgs
  >;
  export type SubcontractorInvoiceByNumberArgs = QuerySubcontractorInvoiceByNumberArgs;

  export type TeamsResolver<Parent = never> = Resolver<
    Array<Team> | Parent,
    Parent,
    QueryTeamsArgs
  >;
  export type TeamsArgs = QueryTeamsArgs;

  export type TgRequirementsResolver<Parent = never> = Resolver<
    Array<TgRequirement> | Parent,
    Parent,
    QueryTgRequirementsArgs
  >;
  export type TgRequirementsArgs = QueryTgRequirementsArgs;

  export type TodoResolver<Parent = never> = Resolver<
    TodoItem | Parent,
    Parent,
    QueryTodoArgs
  >;
  export type TodoArgs = QueryTodoArgs;

  export type TodoEventsResolver<Parent = never> = Resolver<
    Array<TodoEvent> | Parent,
    Parent,
    QueryTodoEventsArgs
  >;
  export type TodoEventsArgs = QueryTodoEventsArgs;

  export type TodoSearchResolver<Parent = never> = Resolver<
    Array<TodoSearchItem> | Parent,
    Parent,
    QueryTodoSearchArgs
  >;
  export type TodoSearchArgs = QueryTodoSearchArgs;

  export type TodoTotalResolver<Parent = never> = Resolver<
    TodoTotalResult | Parent,
    Parent,
    QueryTodoTotalArgs
  >;
  export type TodoTotalArgs = QueryTodoTotalArgs;

  export type TravelConfirmationByIdResolver<Parent = never> = Resolver<
    TravelConfirmation | Parent,
    Parent,
    QueryTravelConfirmationByIdArgs
  >;
  export type TravelConfirmationByIdArgs = QueryTravelConfirmationByIdArgs;

  export type TravelRequestByIdResolver<Parent = never> = Resolver<
    TravelRequest | Parent,
    Parent,
    QueryTravelRequestByIdArgs
  >;
  export type TravelRequestByIdArgs = QueryTravelRequestByIdArgs;

  export type TravelRequestSearchResolver<Parent = never> = Resolver<
    TravelRequestSearchResult | Parent,
    Parent,
    QueryTravelRequestSearchArgs
  >;
  export type TravelRequestSearchArgs = QueryTravelRequestSearchArgs;

  export type TravelRequestSearchTotalResolver<Parent = never> = Resolver<
    TravelRequestSearchTotalResult | Parent,
    Parent,
    QueryTravelRequestSearchTotalArgs
  >;
  export type TravelRequestSearchTotalArgs = QueryTravelRequestSearchTotalArgs;

  export type UserByIdResolver<Parent = never> = Resolver<
    User | Parent,
    Parent,
    QueryUserByIdArgs
  >;
  export type UserByIdArgs = QueryUserByIdArgs;

  export type UserPermissionsResolver<Parent = never> = Resolver<
    Array<string> | Parent,
    Parent,
    QueryUserPermissionsArgs
  >;
  export type UserPermissionsArgs = QueryUserPermissionsArgs;

  export type UsersResolver<Parent = never> = Resolver<
    Array<User> | Parent,
    Parent,
    QueryUsersArgs
  >;
  export type UsersArgs = QueryUsersArgs;

  export type WorkflowRunByIdResolver<Parent = never> = Resolver<
    WorkflowRun | Parent,
    Parent,
    QueryWorkflowRunByIdArgs
  >;
  export type WorkflowRunByIdArgs = QueryWorkflowRunByIdArgs;

  export type WorkflowRunByWorkflowIdResolver<Parent = never> = Resolver<
    WorkflowRun | Parent,
    Parent,
    QueryWorkflowRunByWorkflowIdArgs
  >;
  export type WorkflowRunByWorkflowIdArgs = QueryWorkflowRunByWorkflowIdArgs;
  export type Resolvers<Parent = never> = {
    SearchProfiles?: SearchProfilesResolver<Parent>;
    accommodationConfirmationById?: AccommodationConfirmationByIdResolver<Parent>;
    accommodationEvents?: AccommodationEventsResolver<Parent>;
    accommodationRequestById?: AccommodationRequestByIdResolver<Parent>;
    accommodationRequestSearch?: AccommodationRequestSearchResolver<Parent>;
    accommodationRequestSearchTotal?: AccommodationRequestSearchTotalResolver<Parent>;
    attestContactPersons?: AttestContactPersonsResolver<Parent>;
    bisnodeLookupByPhone?: BisnodeLookupByPhoneResolver<Parent>;
    bisnodeLookupBySSN?: BisnodeLookupBySSNResolver<Parent>;
    bookingById?: BookingByIdResolver<Parent>;
    bookingEvents?: BookingEventsResolver<Parent>;
    bookingHospitality?: BookingHospitalityResolver<Parent>;
    bookingKit?: BookingKitResolver<Parent>;
    bookingKitApprovalConfig?: BookingKitApprovalConfigResolver<Parent>;
    bookingKitDraft?: BookingKitDraftResolver<Parent>;
    bookingKitEvents?: BookingKitEventsResolver<Parent>;
    bookingKitFormConfig?: BookingKitFormConfigResolver<Parent>;
    bookingKitSearch?: BookingKitSearchResolver<Parent>;
    bookingKitSearchTotal?: BookingKitSearchTotalResolver<Parent>;
    bookingKits?: BookingKitsResolver<Parent>;
    bookingSyncReport?: BookingSyncReportResolver<Parent>;
    bookingWeeks?: BookingWeeksResolver<Parent>;
    bookingWeeksByConsultant?: BookingWeeksByConsultantResolver<Parent>;
    bookingWeeksCSV?: BookingWeeksCSVResolver<Parent>;
    bookingWeeksCSVBackground?: BookingWeeksCSVBackgroundResolver<Parent>;
    bookingWeeksKitSupport?: BookingWeeksKitSupportResolver<Parent>;
    bookingWeeksTotal?: BookingWeeksTotalResolver<Parent>;
    bulkSmsTextMaxLength?: BulkSmsTextMaxLengthResolver<Parent>;
    callListById?: CallListByIdResolver<Parent>;
    checkBookingCancellable?: CheckBookingCancellableResolver<Parent>;
    checkBookingGroupCancellable?: CheckBookingGroupCancellableResolver<Parent>;
    checkBookingGroupCancellableByBookingId?: CheckBookingGroupCancellableByBookingIdResolver<Parent>;
    checkConsultantExists?: CheckConsultantExistsResolver<Parent>;
    checkFortnoxSalaryForWeek?: CheckFortnoxSalaryForWeekResolver<Parent>;
    config?: ConfigResolver<Parent>;
    consultantById?: ConsultantByIdResolver<Parent>;
    consultantByWorkExperience?: ConsultantByWorkExperienceResolver<Parent>;
    consultantCanDuplicateToTenants?: ConsultantCanDuplicateToTenantsResolver<Parent>;
    consultantEvents?: ConsultantEventsResolver<Parent>;
    consultantFormById?: ConsultantFormByIdResolver<Parent>;
    consultantHealthDeclarations?: ConsultantHealthDeclarationsResolver<Parent>;
    consultantKarensById?: ConsultantKarensByIdResolver<Parent>;
    consultantMatching?: ConsultantMatchingResolver<Parent>;
    consultantOpportunityByConsultantId?: ConsultantOpportunityByConsultantIdResolver<Parent>;
    consultantOpportunityById?: ConsultantOpportunityByIdResolver<Parent>;
    consultantOpportunityIssueWeeks?: ConsultantOpportunityIssueWeeksResolver<Parent>;
    consultantOpportunityStatsByTeam?: ConsultantOpportunityStatsByTeamResolver<Parent>;
    consultantOpportunityStatsByUser?: ConsultantOpportunityStatsByUserResolver<Parent>;
    consultantReferenceDocuments?: ConsultantReferenceDocumentsResolver<Parent>;
    consultantReferences?: ConsultantReferencesResolver<Parent>;
    consultantServicePreference?: ConsultantServicePreferenceResolver<Parent>;
    consultantServicePreferenceForm?: ConsultantServicePreferenceFormResolver<Parent>;
    consultantServicePreferences?: ConsultantServicePreferencesResolver<Parent>;
    consultantServicePreferencesForBooking?: ConsultantServicePreferencesForBookingResolver<Parent>;
    consultantUpcomingWorkplaces?: ConsultantUpcomingWorkplacesResolver<Parent>;
    consultantWorkStatuses?: ConsultantWorkStatusesResolver<Parent>;
    consultants?: ConsultantsResolver<Parent>;
    consultantsByWeeks?: ConsultantsByWeeksResolver<Parent>;
    consultantsCSV?: ConsultantsCSVResolver<Parent>;
    consultantsFast?: ConsultantsFastResolver<Parent>;
    consultantsTotal?: ConsultantsTotalResolver<Parent>;
    contactPersonById?: ContactPersonByIdResolver<Parent>;
    contactPersons?: ContactPersonsResolver<Parent>;
    contract?: ContractResolver<Parent>;
    contractsPriceTemplateById?: ContractsPriceTemplateByIdResolver<Parent>;
    contractsPriceTemplates?: ContractsPriceTemplatesResolver<Parent>;
    costCenterConfigItems?: CostCenterConfigItemsResolver<Parent>;
    customerById?: CustomerByIdResolver<Parent>;
    customerContractById?: CustomerContractByIdResolver<Parent>;
    customerContractPriceListById?: CustomerContractPriceListByIdResolver<Parent>;
    customerContractSnapshotById?: CustomerContractSnapshotByIdResolver<Parent>;
    customerContractSubVersionById?: CustomerContractSubVersionByIdResolver<Parent>;
    customerContracts?: CustomerContractsResolver<Parent>;
    customerContractsByBooking?: CustomerContractsByBookingResolver<Parent>;
    customerContractsTotal?: CustomerContractsTotalResolver<Parent>;
    customerEvents?: CustomerEventsResolver<Parent>;
    customerNumberByAOE?: CustomerNumberByAOEResolver<Parent>;
    customers?: CustomersResolver<Parent>;
    customersPicker?: CustomersPickerResolver<Parent>;
    customersTotal?: CustomersTotalResolver<Parent>;
    findConsultantDuplicate?: FindConsultantDuplicateResolver<Parent>;
    findConsultantSimilar?: FindConsultantSimilarResolver<Parent>;
    findContract?: FindContractResolver<Parent>;
    freshdeskOpenTicketsCountByConsultant?: FreshdeskOpenTicketsCountByConsultantResolver<Parent>;
    freshdeskTicketsByConsultant?: FreshdeskTicketsByConsultantResolver<Parent>;
    getAccommodationDetails?: GetAccommodationDetailsResolver<Parent>;
    getAccommodations?: GetAccommodationsResolver<Parent>;
    getAccommodationsCount?: GetAccommodationsCountResolver<Parent>;
    getAllConsultantTags?: GetAllConsultantTagsResolver<Parent>;
    getBookingAssignedToTotal?: GetBookingAssignedToTotalResolver<Parent>;
    getBookingCustomerContacts?: GetBookingCustomerContactsResolver<Parent>;
    getBookingGroup?: GetBookingGroupResolver<Parent>;
    getBookingKitAssignedToTotal?: GetBookingKitAssignedToTotalResolver<Parent>;
    getChecksForBooking?: GetChecksForBookingResolver<Parent>;
    getConsultantBookingContractDetailInfo?: GetConsultantBookingContractDetailInfoResolver<Parent>;
    getConsultantBookingContracts?: GetConsultantBookingContractsResolver<Parent>;
    getConsultantBookingContractsByCustomerId?: GetConsultantBookingContractsByCustomerIdResolver<Parent>;
    getConsultantContractDetailInfo?: GetConsultantContractDetailInfoResolver<Parent>;
    getConsultantContracts?: GetConsultantContractsResolver<Parent>;
    getConsultantContractsByBooking?: GetConsultantContractsByBookingResolver<Parent>;
    getConsultantPayoutByYear?: GetConsultantPayoutByYearResolver<Parent>;
    getConsultantQualityItem?: GetConsultantQualityItemResolver<Parent>;
    getConsultantSearchQualityItems?: GetConsultantSearchQualityItemsResolver<Parent>;
    getContactPersonsByCustomerIds?: GetContactPersonsByCustomerIdsResolver<Parent>;
    getCustomerContractPriceLists?: GetCustomerContractPriceListsResolver<Parent>;
    getCustomerContractSnapshots?: GetCustomerContractSnapshotsResolver<Parent>;
    getFortnoxSalaryCache?: GetFortnoxSalaryCacheResolver<Parent>;
    getFreeTimereports?: GetFreeTimereportsResolver<Parent>;
    getHighHolidays?: GetHighHolidaysResolver<Parent>;
    getInvoiceStatusForBooking?: GetInvoiceStatusForBookingResolver<Parent>;
    getLastAccommodationRequest?: GetLastAccommodationRequestResolver<Parent>;
    getLastSignedConsultantContract?: GetLastSignedConsultantContractResolver<Parent>;
    getLastWorkflowRun?: GetLastWorkflowRunResolver<Parent>;
    getSystemsByProfession?: GetSystemsByProfessionResolver<Parent>;
    getTimereportByBookingId?: GetTimereportByBookingIdResolver<Parent>;
    getTimereportSendFailures?: GetTimereportSendFailuresResolver<Parent>;
    getTimereportStatusHistory?: GetTimereportStatusHistoryResolver<Parent>;
    getTimereportToCustomerEmail?: GetTimereportToCustomerEmailResolver<Parent>;
    getWorkflowRuns?: GetWorkflowRunsResolver<Parent>;
    getWorkflowRunsByOwner?: GetWorkflowRunsByOwnerResolver<Parent>;
    invoiceByNumber?: InvoiceByNumberResolver<Parent>;
    kanbanBoard?: KanbanBoardResolver<Parent>;
    kanbanCard?: KanbanCardResolver<Parent>;
    kanbanCards?: KanbanCardsResolver<Parent>;
    me?: MeResolver<Parent>;
    municipalities?: MunicipalitiesResolver<Parent>;
    myApiTokens?: MyApiTokensResolver<Parent>;
    npDirectRequestAvailable?: NpDirectRequestAvailableResolver<Parent>;
    professionsByCountry?: ProfessionsByCountryResolver<Parent>;
    projects?: ProjectsResolver<Parent>;
    searchProfileById?: SearchProfileByIdResolver<Parent>;
    searchProfilesByCustomerId?: SearchProfilesByCustomerIdResolver<Parent>;
    sharedFileById?: SharedFileByIdResolver<Parent>;
    sharedFiles?: SharedFilesResolver<Parent>;
    subcontractorInvoiceByNumber?: SubcontractorInvoiceByNumberResolver<Parent>;
    teams?: TeamsResolver<Parent>;
    tgRequirements?: TgRequirementsResolver<Parent>;
    todo?: TodoResolver<Parent>;
    todoEvents?: TodoEventsResolver<Parent>;
    todoSearch?: TodoSearchResolver<Parent>;
    todoTotal?: TodoTotalResolver<Parent>;
    travelConfirmationById?: TravelConfirmationByIdResolver<Parent>;
    travelRequestById?: TravelRequestByIdResolver<Parent>;
    travelRequestSearch?: TravelRequestSearchResolver<Parent>;
    travelRequestSearchTotal?: TravelRequestSearchTotalResolver<Parent>;
    userById?: UserByIdResolver<Parent>;
    userPermissions?: UserPermissionsResolver<Parent>;
    users?: UsersResolver<Parent>;
    workflowRunById?: WorkflowRunByIdResolver<Parent>;
    workflowRunByWorkflowId?: WorkflowRunByWorkflowIdResolver<Parent>;
  };
}

export type RadioNurseProfessionResolver<Parent> = ReturnTypeResolver<
  Parent,
  RadioNurseProfession
>;
export type RadioNurseProfession__Fields = {
  certifiedFrom: boolean;
  machines: boolean;
  professionName: boolean;
  specializations: RadioNurseSpecialization__Fields;
  systems: boolean;
};

export type RadioNurseSpecializationResolver<Parent> = ReturnTypeResolver<
  Parent,
  RadioNurseSpecialization
>;
export type RadioNurseSpecialization__Fields = {
  comment: boolean;
  interested: boolean;
  name: boolean;
  qualified: boolean;
  yearFrom: boolean;
};

export type RegionResolver<Parent> = ReturnTypeResolver<Parent, Region>;
export type Region__Fields = {
  countryCouncilId: boolean;
  name: boolean;
};

export type RequestReceivedNotProcessedQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  RequestReceivedNotProcessedQualityStatus
>;
export type RequestReceivedNotProcessedQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
  params: boolean;
};

export type RequestSentQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  RequestSentQualityStatus
>;
export type RequestSentQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
  params: boolean;
};

export type RoleResolver<Parent> = ReturnTypeResolver<Parent, Role>;
export type Role__Fields = {
  IsStaffing: boolean;
  Name: boolean;
};

export type SMSMessageResolver<Parent> = ReturnTypeResolver<Parent, SMSMessage>;
export type SMSMessage__Fields = {
  From: boolean;
  IsFailed: boolean;
  IsOk: boolean;
  IsStatusFinal: boolean;
  Message: boolean;
  SentBy: User__Fields;
  SentByRef: UserRef__Fields;
  SentOn: boolean;
  Status: boolean;
  StatusUpdatedOn: boolean;
  To: boolean;
  _id: boolean;
};

export type SalaryResolver<Parent> = ReturnTypeResolver<Parent, Salary>;
export type Salary__Fields = {
  Compensation: Compensation__Fields;
  Workhours: boolean;
};

export type SaveConsultantsResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  SaveConsultantsResult
>;
export type SaveConsultantsResult__Fields =
  | SaveConsultantsResultInvalid__Fields
  | SaveConsultantsResultOK__Fields;

export type SaveConsultantsResultInvalidResolver<Parent> = ReturnTypeResolver<
  Parent,
  SaveConsultantsResultInvalid
>;
export type SaveConsultantsResultInvalid__Fields = {
  IsValid: boolean;
  Rows: ConsultantImportRow__Fields;
};

export type SaveConsultantsResultOKResolver<Parent> = ReturnTypeResolver<
  Parent,
  SaveConsultantsResultOK
>;
export type SaveConsultantsResultOK__Fields = {
  Consultants: Consultant__Fields;
  IsValid: boolean;
  Msg: boolean;
  Rows: ConsultantImportRow__Fields;
};

export type SearchProfileResolver<Parent> = ReturnTypeResolver<Parent, SearchProfile>;
export type SearchProfile__Fields = {
  _id: boolean;
  customerRefs: CustomerRef__Fields;
  fields: boolean;
  name: boolean;
  type: boolean;
};

export type SearchProfilesSearchResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  SearchProfilesSearchResult
>;
export type SearchProfilesSearchResult__Fields = {
  items: SearchProfile__Fields;
  limit: boolean;
  skip: boolean;
};

export type SendConsultantToMedloResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  SendConsultantToMedloResult
>;
export type SendConsultantToMedloResult__Fields = {
  message: boolean;
  success: boolean;
};

export type SendEmailToConsultantResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  SendEmailToConsultantResult
>;
export type SendEmailToConsultantResult__Fields = {
  Body: boolean;
  Subject: boolean;
};

export type SendMassEmailResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  SendMassEmailResult
>;
export type SendMassEmailResult__Fields = {
  Body: boolean;
  Subject: boolean;
};

export type SendMassSMSToConsultantsResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  SendMassSMSToConsultantsResult
>;
export type SendMassSMSToConsultantsResult__Fields = {
  result: ConsultantSMS__Fields;
};

export type SendToKvkConsultantReferencePayloadResolver<Parent> = ReturnTypeResolver<
  Parent,
  SendToKvkConsultantReferencePayload
>;
export type SendToKvkConsultantReferencePayload__Fields = {
  consultantReference: ConsultantReferenceNew__Fields;
};

export type SharedFileResolver<Parent> = ReturnTypeResolver<Parent, SharedFile>;
export type SharedFile__Fields = {
  Deleted: boolean;
  ExpiresOn: boolean;
  FileRef: FileRef__Fields;
  FileStats: SharedFileStats__Fields;
  Name: boolean;
  ShareURL: boolean;
  SharedBy: UserRef__Fields;
  SharedOn: boolean;
  ThumbURL: boolean;
  _id: boolean;
};

export type SharedFileAccessRecordResolver<Parent> = ReturnTypeResolver<
  Parent,
  SharedFileAccessRecord
>;
export type SharedFileAccessRecord__Fields = {
  AccessedOn: boolean;
  IP: boolean;
};

export type SharedFileStatsResolver<Parent> = ReturnTypeResolver<Parent, SharedFileStats>;
export type SharedFileStats__Fields = {
  AccessRecords: SharedFileAccessRecord__Fields;
  AccessedTotal: boolean;
};

export type SharedFilesResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  SharedFilesResult
>;
export type SharedFilesResult__Fields = {
  files: SharedFile__Fields;
  limit: boolean;
  skip: boolean;
};

export type SigningPeriodExpiredQualityStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  SigningPeriodExpiredQualityStatus
>;
export type SigningPeriodExpiredQualityStatus__Fields = {
  Comment: boolean;
  DocumentRequired: boolean;
  ExpiresOn: boolean;
  Name: boolean;
  SetBy: UserRef__Fields;
  SetOn: boolean;
};

export type SocionomAreasOfExpertiseResolver<Parent> = ReturnTypeResolver<
  Parent,
  SocionomAreasOfExpertise
>;
export type SocionomAreasOfExpertise__Fields = {
  comment: boolean;
  interested: boolean;
  name: boolean;
  open: boolean;
  qualified: boolean;
  specializations: SocionomSpecialization__Fields;
  yearFrom: boolean;
};

export type SocionomProfessionResolver<Parent> = ReturnTypeResolver<
  Parent,
  SocionomProfession
>;
export type SocionomProfession__Fields = {
  areasOfExpertise: SocionomAreasOfExpertise__Fields;
  certifiedFrom: boolean;
  educations: boolean;
  professionName: boolean;
  systems: boolean;
};

export type SocionomSpecializationResolver<Parent> = ReturnTypeResolver<
  Parent,
  SocionomSpecialization
>;
export type SocionomSpecialization__Fields = {
  comment: boolean;
  interested: boolean;
  name: boolean;
  qualified: boolean;
};

export type SpecificPeriodPriceResolver<Parent> = ReturnTypeResolver<
  Parent,
  SpecificPeriodPrice
>;
export type SpecificPeriodPrice__Fields = {
  _id: boolean;
  endDate: boolean;
  price: boolean;
  startDate: boolean;
  title: boolean;
};

export type SubcontractorInfoResolver<Parent> = ReturnTypeResolver<
  Parent,
  SubcontractorInfo
>;
export type SubcontractorInfo__Fields = {
  Address: Address__Fields;
  BusinessNo: boolean;
  Name: boolean;
};

export type SubcontractorInvoiceResolver<Parent> = ReturnTypeResolver<
  Parent,
  SubcontractorInvoice
>;
export type SubcontractorInvoice__Fields = {
  Balance: boolean;
  Booked: boolean;
  CostCenter: boolean;
  Credit: boolean;
  Currency: boolean;
  DueDate: boolean;
  FinalPayDate: boolean;
  GivenNumber: boolean;
  InvoiceDate: boolean;
  InvoiceNumber: boolean;
  Total: boolean;
};
export namespace Subscription {
  export type SubscriptionMap = {
    kanbanCardAdded: { arg: KanbanCardAddedArgs; r: KanbanCardActionPayload };
    kanbanCardDeleted: { arg: KanbanCardDeletedArgs; r: KanbanCardActionPayload };
    kanbanCardMoved: { arg: KanbanCardMovedArgs; r: KanbanCardActionPayload };
    myProfileUpdated: { arg: never; r: MePartial };
    smsMessageUpdated: { arg: SmsMessageUpdatedArgs; r: SMSMessage };
  };

  export type KanbanCardAddedResolver<Parent = never> = SubscriptionResolver<
    KanbanCardActionPayload | Parent,
    Parent,
    SubscriptionKanbanCardAddedArgs
  >;
  export type KanbanCardAddedArgs = SubscriptionKanbanCardAddedArgs;

  export type KanbanCardDeletedResolver<Parent = never> = SubscriptionResolver<
    KanbanCardActionPayload | Parent,
    Parent,
    SubscriptionKanbanCardDeletedArgs
  >;
  export type KanbanCardDeletedArgs = SubscriptionKanbanCardDeletedArgs;

  export type KanbanCardMovedResolver<Parent = never> = SubscriptionResolver<
    KanbanCardActionPayload | Parent,
    Parent,
    SubscriptionKanbanCardMovedArgs
  >;
  export type KanbanCardMovedArgs = SubscriptionKanbanCardMovedArgs;

  export type MyProfileUpdatedResolver<Parent = never> = SubscriptionResolver<
    MePartial | Parent,
    Parent
  >;

  export type SmsMessageUpdatedResolver<Parent = never> = SubscriptionResolver<
    SMSMessage | Parent,
    Parent,
    SubscriptionSmsMessageUpdatedArgs
  >;
  export type SmsMessageUpdatedArgs = SubscriptionSmsMessageUpdatedArgs;
  export type Resolvers<Parent = never> = {
    kanbanCardAdded?: KanbanCardAddedResolver<Parent>;
    kanbanCardDeleted?: KanbanCardDeletedResolver<Parent>;
    kanbanCardMoved?: KanbanCardMovedResolver<Parent>;
    myProfileUpdated?: MyProfileUpdatedResolver<Parent>;
    smsMessageUpdated?: SmsMessageUpdatedResolver<Parent>;
  };
}

export type TeacherAreasOfExpertiseResolver<Parent> = ReturnTypeResolver<
  Parent,
  TeacherAreasOfExpertise
>;
export type TeacherAreasOfExpertise__Fields = {
  certifiedFrom: boolean;
  name: boolean;
  selected: boolean;
  specializations: TeacherSpecialization__Fields;
};

export type TeacherProfessionResolver<Parent> = ReturnTypeResolver<
  Parent,
  TeacherProfession
>;
export type TeacherProfession__Fields = {
  areasOfExpertise: TeacherAreasOfExpertise__Fields;
  certifiedFrom: boolean;
  digitalCompetence: boolean;
  professionName: boolean;
  schoolPlatforms: boolean;
  systems: boolean;
};

export type TeacherSpecializationResolver<Parent> = ReturnTypeResolver<
  Parent,
  TeacherSpecialization
>;
export type TeacherSpecialization__Fields = {
  experience: boolean;
  interestedIn: boolean;
  name: boolean;
  qualified: boolean;
};

export type TeamResolver<Parent> = ReturnTypeResolver<Parent, Team>;
export type Team__Fields = {
  ADGroups: boolean;
  AreasOfExpertise: boolean;
  Email: boolean;
  KnownSystems: boolean;
  Name: boolean;
  Tags: boolean;
  TodoGroup: boolean;
  _id: boolean;
  workrequestTeamName: boolean;
};

export type TgRequirementResolver<Parent> = ReturnTypeResolver<Parent, TgRequirement>;
export type TgRequirement__Fields = {
  _id: boolean;
  costCenterId: boolean;
  createdByName: boolean;
  createdOn: boolean;
  deleted: boolean;
  minRequiredTG: boolean;
  profession: boolean;
  tenant: boolean;
  updatedByName: boolean;
  updatedOn: boolean;
  validFrom: boolean;
  validTo: boolean;
};

export type TimereportResolver<Parent> = ReturnTypeResolver<Parent, Timereport>;
export type Timereport__Fields = {
  bookingId: boolean;
  consultantId: boolean;
  days: TimereportDay__Fields;
  department: boolean;
  endsOnUtc: boolean;
  id: boolean;
  isAssignedToBooking: boolean;
  startsOnUtc: boolean;
  status: boolean;
  timereportId: boolean;
  totalExpenses: boolean;
  totalMileage: boolean;
  workplace: boolean;
};

export type TimereportDayResolver<Parent> = ReturnTypeResolver<Parent, TimereportDay>;
export type TimereportDay__Fields = {
  comment: boolean;
  date: boolean;
  dayIndex: boolean;
  expenses: TimereportExpense__Fields;
  isLunchModified: boolean;
  lunch: boolean;
  mileage: boolean;
  onCallShifts: TimereportOnCallShift__Fields;
  preparednessAShifts: TimereportPreparednessShift__Fields;
  preparednessBShifts: TimereportPreparednessShift__Fields;
  sickTimeShifts: TimereportSickOrVabShift__Fields;
  vabTimeShifts: TimereportSickOrVabShift__Fields;
  workTimeRange: TimereportDayTimeRange__Fields;
  workTimeRanges: TimereportDayTimeRange__Fields;
};

export type TimereportDayTimeRangeResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportDayTimeRange
>;
export type TimereportDayTimeRange__Fields = {
  from: boolean;
  to: boolean;
};

export type TimereportExpenseResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportExpense
>;
export type TimereportExpense__Fields = {
  amount: boolean;
  attachments: TimereportExpenseAttachment__Fields;
  comment: boolean;
};

export type TimereportExpenseAttachmentResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportExpenseAttachment
>;
export type TimereportExpenseAttachment__Fields = {
  path: boolean;
  previewPath: boolean;
};

export type TimereportOnCallShiftResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportOnCallShift
>;
export type TimereportOnCallShift__Fields = {
  passivePeriods: TimereportDayTimeRange__Fields;
  period: TimereportDayTimeRange__Fields;
};

export type TimereportPreparednessShiftResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportPreparednessShift
>;
export type TimereportPreparednessShift__Fields = {
  activePeriods: TimereportDayTimeRange__Fields;
  period: TimereportDayTimeRange__Fields;
};

export type TimereportResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportResult
>;
export type TimereportResult__Fields = {
  timereport: boolean;
};

export type TimereportSendFailureResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportSendFailure
>;
export type TimereportSendFailure__Fields = {
  failedOn: boolean;
  reason: boolean;
  recipient: boolean;
};

export type TimereportSendFailuresResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportSendFailuresResult
>;
export type TimereportSendFailuresResult__Fields = {
  failures: TimereportSendFailure__Fields;
  partiallySent: boolean;
};

export type TimereportSickOrVabShiftResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportSickOrVabShift
>;
export type TimereportSickOrVabShift__Fields = {
  from: boolean;
  to: boolean;
  type: boolean;
};

export type TimereportStatusHistoryResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportStatusHistoryResult
>;
export type TimereportStatusHistoryResult__Fields = {
  history: boolean;
};

export type TimereportTemplateSettingsResolver<Parent> = ReturnTypeResolver<
  Parent,
  TimereportTemplateSettings
>;
export type TimereportTemplateSettings__Fields = {
  professions: boolean;
  type: boolean;
};

export type TodoBadgesResolver<Parent> = ReturnTypeResolver<Parent, TodoBadges>;
export type TodoBadges__Fields = {
  Badges: CategoryBadge__Fields;
  TotalUnread: boolean;
};

export type TodoEventResolver<Parent> = ReturnTypeResolver<Parent, TodoEvent>;
export type TodoEvent__Fields = {
  Audit: Audit__Fields;
  CanDelete: boolean;
  CanEdit: boolean;
  CanPin: boolean;
  CreatedBy: WeakUserRef__Fields;
  CreatedOn: boolean;
  Deleted: boolean;
  DeletedBy: WeakUserRef__Fields;
  Description: boolean;
  DescriptionHtml: boolean;
  Links: boolean;
  Sticky: boolean;
  TodoItem: TodoItem__Fields;
  TodoRef: NodeRef__Fields;
  Type: boolean;
  UpdatedBy: WeakUserRef__Fields;
  Warning: boolean;
  _id: boolean;
};

export type TodoItemResolver<Parent> = ReturnTypeResolver<Parent, TodoItem>;
export type TodoItem__Fields = {
  Accepted: boolean;
  AssignedBy: UserRef__Fields;
  AssignedOn: boolean;
  AssignedTeam: boolean;
  AssignedTo: UserRef__Fields;
  CanAccept: boolean;
  CanDelete: boolean;
  Comments: TodoEvent__Fields;
  Completed: boolean;
  DelegatedBy: UserRef__Fields;
  Deleted: boolean;
  Description: boolean;
  Due: boolean;
  LinkedItems: NodeRef__Fields;
  NodeName: boolean;
  NodeType: boolean;
  Priority: boolean;
  RelatedTo: NodeRef__Fields;
  SecondaryText: boolean;
  Status: boolean;
  Tags: boolean;
  Type: boolean;
  URL: boolean;
  ViewMode: boolean;
  WhoWatched: UserRef__Fields;
  _id: boolean;
  type: boolean;
};

export type TodoLinkedItemResolver<Parent> = ReturnTypeResolver<Parent, TodoLinkedItem>;
export type TodoLinkedItem__Fields = {
  Name: boolean;
  NodeID: boolean;
  NodeType: boolean;
  Uri: boolean;
};

export type TodoSearchItemResolver<Parent> = ReturnTypeResolver<Parent, TodoSearchItem>;
export type TodoSearchItem__Fields = {
  _id: boolean;
  assignedBy: boolean;
  assignedTo: boolean;
  canAccept: boolean;
  canComplete: boolean;
  canDecline: boolean;
  category: boolean;
  completedOn: boolean;
  createdBy: boolean;
  createdOn: boolean;
  delegatedBy: boolean;
  dueDate: boolean;
  managedBy: boolean;
  priority: boolean;
  relatedTo: NodeRef__Fields;
  search: TodoSearchMeta__Fields;
  status: boolean;
  tags: boolean;
  teamIds: boolean;
  title: boolean;
  unreadStatuses: TodoUnreadUserStatus__Fields;
};

export type TodoSearchMetaResolver<Parent> = ReturnTypeResolver<Parent, TodoSearchMeta>;
export type TodoSearchMeta__Fields = {
  searchText: boolean;
  showTop: boolean;
  unreadComments: boolean;
  unreadNew: boolean;
};

export type TodoTeamBadgesResolver<Parent> = ReturnTypeResolver<Parent, TodoTeamBadges>;
export type TodoTeamBadges__Fields = {
  Badges: CategoryBadge__Fields;
  TeamRef: NodeRef__Fields;
  TotalUnread: boolean;
};

export type TodoTotalResultResolver<Parent> = ReturnTypeResolver<Parent, TodoTotalResult>;
export type TodoTotalResult__Fields = {
  dbTime: boolean;
  total: boolean;
};

export type TodoUnreadUserStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  TodoUnreadUserStatus
>;
export type TodoUnreadUserStatus__Fields = {
  count: boolean;
  type: boolean;
};

export type TodoUserBadgesResolver<Parent> = ReturnTypeResolver<Parent, TodoUserBadges>;
export type TodoUserBadges__Fields = {
  TeamBadges: TodoTeamBadges__Fields;
  TotalUnread: boolean;
};

export type TotalResolver<Parent> = ReturnTypeResolver<Parent, Total>;
export type Total__Fields = {
  total: boolean;
};

export type TravelConfirmationResolver<Parent> = ReturnTypeResolver<
  Parent,
  TravelConfirmation
>;
export type TravelConfirmation__Fields = {
  _id: boolean;
  allWeeks: TravelConfirmationWeek__Fields;
  confirmedBy: UserRef__Fields;
  confirmedOn: boolean;
  deleted: boolean;
  documents: Document__Fields;
  taxWeeks: TravelConfirmationWeek__Fields;
  totalCost: boolean;
  totalExVAT: boolean;
  weeks: boolean;
};

export type TravelConfirmationWeekResolver<Parent> = ReturnTypeResolver<
  Parent,
  TravelConfirmationWeek
>;
export type TravelConfirmationWeek__Fields = {
  cost: boolean;
  description: boolean;
  endDate: boolean;
  isTravel: boolean;
  note: boolean;
  startDate: boolean;
  weekYear: WeekYear__Fields;
};

export type TravelRequestResolver<Parent> = ReturnTypeResolver<Parent, TravelRequest>;
export type TravelRequest__Fields = {
  _id: boolean;
  bookingGroup: boolean;
  consultantId: boolean;
  costCenterId: boolean;
  createdById: boolean;
  createdByName: boolean;
  createdOn: boolean;
  deadline: boolean;
  isCancelable: boolean;
  isFlexible: boolean;
  isReschedule: boolean;
  luggage: boolean;
  luggageType: boolean;
  projectId: boolean;
  rescheduleComment: boolean;
  rides: TravelRequestReturnRide__Fields;
  ticketDifficultyLevel: boolean;
  transportationType: boolean;
  travelPreferences: boolean;
  travelSuggestion: boolean;
};

export type TravelRequestInfoResolver<Parent> = ReturnTypeResolver<
  Parent,
  TravelRequestInfo
>;
export type TravelRequestInfo__Fields = {
  confirmations: TravelConfirmation__Fields;
  travelIsOk: boolean;
  travelRequest: TravelRequest__Fields;
  travelRequested: boolean;
};

export type TravelRequestReturnRideResolver<Parent> = ReturnTypeResolver<
  Parent,
  TravelRequestReturnRide
>;
export type TravelRequestReturnRide__Fields = {
  dir1: TravelRequestRide__Fields;
  dir2: TravelRequestRide__Fields;
  rideType: boolean;
  transportationType: boolean;
};

export type TravelRequestRideResolver<Parent> = ReturnTypeResolver<
  Parent,
  TravelRequestRide
>;
export type TravelRequestRide__Fields = {
  city: boolean;
  comment: boolean;
  country: boolean;
  date: boolean;
  time: boolean;
};

export type TravelRequestSearchResolver<Parent> = ReturnTypeResolver<
  Parent,
  TravelRequestSearch
>;
export type TravelRequestSearch__Fields = {
  _id: boolean;
  city: boolean;
  consultantName: boolean;
  createdBy: UserRef__Fields;
  createdOn: boolean;
  firstDeparture: boolean;
  status: TravelRequestStatus__Fields;
  weeks: BookingLinks__Fields;
};

export type TravelRequestSearchResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  TravelRequestSearchResult
>;
export type TravelRequestSearchResult__Fields = {
  dbTime: boolean;
  items: TravelRequestSearch__Fields;
  limit: boolean;
  skip: boolean;
};

export type TravelRequestSearchTotalResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  TravelRequestSearchTotalResult
>;
export type TravelRequestSearchTotalResult__Fields = {
  dbTime: boolean;
  total: boolean;
};

export type TravelRequestStatusResolver<Parent> = ReturnTypeResolver<
  Parent,
  TravelRequestStatus
>;
export type TravelRequestStatus__Fields = {
  setBy: UserRef__Fields;
  setOn: boolean;
  status: boolean;
};

export type TravelZoneResolver<Parent> = ReturnTypeResolver<Parent, TravelZone>;
export type TravelZone__Fields = {
  articleNumber: boolean;
  name: boolean;
};

export type TravelsAltResolver<Parent> = ReturnTypeResolver<Parent, TravelsAlt>;
export type TravelsAlt__Fields = {
  MaxCost: ConsultantContractTravelsMaxCost__Fields;
  PossibleSupplement: boolean;
  TravelTemplateValue: boolean;
  Type: boolean;
};

export type UnlockFormsResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  UnlockFormsResult
>;
export type UnlockFormsResult__Fields = {
  unlockForms: boolean;
};

export type UpdateBookingResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  UpdateBookingResult
>;
export type UpdateBookingResult__Fields = {
  Booking: Booking__Fields;
};

export type UpdateContactPersonResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  UpdateContactPersonResult
>;
export type UpdateContactPersonResult__Fields = {
  contactPerson: ContactPerson__Fields;
  validationErrors: ValidationError__Fields;
};

export type UpdateCustomerResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  UpdateCustomerResult
>;
export type UpdateCustomerResult__Fields = {
  customer: Customer__Fields;
  validationErrors: ValidationError__Fields;
};

export type UpdateMoveCustomerResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  UpdateMoveCustomerResult
>;
export type UpdateMoveCustomerResult__Fields = {
  customer: Customer__Fields;
  validationErrors: boolean;
};

export type UploadBookingDocumentResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  UploadBookingDocumentResult
>;
export type UploadBookingDocumentResult__Fields = {
  fileRef: FileRef__Fields;
};

export type UploadConsultantDocumentResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  UploadConsultantDocumentResult
>;
export type UploadConsultantDocumentResult__Fields = {
  Consultant: Consultant__Fields;
  FileRef: FileRef__Fields;
};

export type UploadSharedDocumentResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  UploadSharedDocumentResult
>;
export type UploadSharedDocumentResult__Fields = {
  FileRef: FileRef__Fields;
};

export type UserResolver<Parent> = ReturnTypeResolver<Parent, User>;
export type User__Fields = {
  AvatarPic: boolean;
  AzureGroups: boolean;
  AzureId: boolean;
  BirthDate: boolean;
  CellPhone: boolean;
  Deleted: boolean;
  Email: boolean;
  Enabled: boolean;
  ManagerId: boolean;
  Name: boolean;
  NodeID: boolean;
  NodeType: boolean;
  Phone: boolean;
  Teams: boolean;
  Title: boolean;
  _id: boolean;
};

export type UserCallListResolver<Parent> = ReturnTypeResolver<Parent, UserCallList>;
export type UserCallList__Fields = {
  _id: boolean;
  name: boolean;
};

export type UserPermissionsResolver<Parent> = ReturnTypeResolver<Parent, UserPermissions>;
export type UserPermissions__Fields = {
  AllowInProduction: boolean;
  CanAccessCustomers: boolean;
  CanAccessReports: boolean;
  CanAddAccommodation: boolean;
  CanAddCustomer: boolean;
  CanDeleteConsultantBookingContract: boolean;
  CanDeleteConsultantContract: boolean;
  CanDeleteConsultants: boolean;
  CanDeleteCustomers: boolean;
  CanImportConsultants: boolean;
  CanMoveCustomers: boolean;
  CanPose: boolean;
  CanSelectAllInMassActions: boolean;
  CanUpdateConsultantGDPR: boolean;
  CanUpdateConsultantInitialContact: boolean;
  CanUpdateCustomerNumber: boolean;
};

export type UserRefResolver<Parent> = ReturnTypeResolver<Parent, UserRef>;
export type UserRef__Fields = {
  Name: boolean;
  PersonId: boolean;
};

export type UserSettingsResolver<Parent> = ReturnTypeResolver<Parent, UserSettings>;
export type UserSettings__Fields = {
  Enabled: boolean;
};

export type ValidationErrorResolver<Parent> = ReturnTypeResolver<Parent, ValidationError>;
export type ValidationError__Fields = {
  Message: boolean;
  Path: boolean;
};

export type WeakUserRefResolver<Parent> = ReturnTypeResolver<Parent, WeakUserRef>;
export type WeakUserRef__Fields = {
  Name: boolean;
  PersonId: boolean;
};

export type WeekYearResolver<Parent> = ReturnTypeResolver<Parent, WeekYear>;
export type WeekYear__Fields = {
  Week: boolean;
  Year: boolean;
};

export type WorkflowRunResolver<Parent> = ReturnTypeResolver<Parent, WorkflowRun>;
export type WorkflowRun__Fields = {
  _id: boolean;
  completedAt: boolean;
  entityId: boolean;
  entityType: boolean;
  errorMessage: boolean;
  metadata: boolean;
  result: boolean;
  scheduledAt: boolean;
  startedAt: boolean;
  status: boolean;
  steps: WorkflowStep__Fields;
  workflowId: boolean;
  workflowType: boolean;
};

export type WorkflowRunsPaginatedResultResolver<Parent> = ReturnTypeResolver<
  Parent,
  WorkflowRunsPaginatedResult
>;
export type WorkflowRunsPaginatedResult__Fields = {
  items: WorkflowRun__Fields;
  total: boolean;
};

export type WorkflowStepResolver<Parent> = ReturnTypeResolver<Parent, WorkflowStep>;
export type WorkflowStep__Fields = {
  _id: boolean;
  completedAt: boolean;
  description: boolean;
  failedAt: boolean;
  startedAt: boolean;
  title: boolean;
};
